import { _ as __makeTemplateObject, e as __rest, a as _assign, o as onCheckHandler, k as _typeof, b as __spreadArray, Z as ZINDEX, h as OverlayPortal, I as IntersectionObserver, j as onValueHandler, c as __awaiter, d as __generator, B as BodyPortal } from './common.js';
import { jsx, jsxs, Fragment as Fragment$1 } from '@emotion/react/jsx-runtime';
import { css, useTheme, keyframes } from '@emotion/react';
import { p as pxToRem, h as hexToRgba, F as FONT_STYLE, R as RESET_BUTTON, H as HOVER, S as SHADOW_STYLE, M as MEDIA_QUERY, B as BREAK_POINT, g as FOCUS, s as safeAreaInset, a as RESET_INPUT } from './foundation.js';
export { j as ReactComponent } from './foundation.js';
import * as React from 'react';
import React__default, { Fragment, useState, useEffect, useCallback, createContext, useContext, useRef, forwardRef, useMemo, useImperativeHandle, memo, useLayoutEffect, Children } from 'react';
import _styled from '@emotion/styled/base';
import { Sticky, useNodeHeight, useScrollDirection, DEFAULT_STICKY_STATE, ScrollLock, ResizeImage, useNodeSize } from '@bucketplace/ui';
export { BaseSticky, DEFAULT_STICKY_STATE, ScrollSticky, Sticky, StickyControlContext, StickyProvider, StickyValueContext, assertStickyParentPosition, getStickyChildStyle, getStickyContainerStyle, getUpdatedStickyState, hasStickyStateChanged, useBaseSticky, useGetStickyHeight, useNodeHeight, useScrollAppear, useScrollDirection, useSticky } from '@bucketplace/ui';
import { h as useMedia, m as useResponsive, j as useResize, u as useAutoComplete, e as useIsInApp, k as useWindowsOSDetector, l as useKakaoChat, g as useMatchMedia, a as useChanged } from './hooks.js';
import isPropValid from '@emotion/is-prop-valid';
import throttle from 'lodash/throttle';
import { useInView } from 'react-intersection-observer';
import { CSSTransition, SwitchTransition, Transition } from 'react-transition-group';
import { parse } from 'qs';
import 'lodash';
import '@bucketplace/lib';
import { usePopper } from 'react-popper';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { R as ResizeImage$1, L as Loading, m as makeIndicatorDots } from './Loading.js';
import { aQ as StarFilledIcon, T as DismissIcon, U as DismissCircleIcon } from './icons.js';
import { A as APP_BANNER_PATHNAME_BLACKLIST, e as APP_BANNER_SEARCH_BLACKLIST, g as getDeviceInfo, i as isHigherAppVersion } from './utils.js';
import interact from 'interactjs';
import { quadInOut } from 'eases';
import isEqual from 'lodash/isEqual';
import findLastKey from 'lodash/findLastKey';
import omit from 'lodash/omit';
import findLast from 'lodash/findLast';
import size from 'lodash/size';
import { Virtuoso } from 'react-virtuoso';
import 'react-dom';

function cssBaseBadge(theme, props) {
  return /*#__PURE__*/css(templateObject_1$28 || (templateObject_1$28 = __makeTemplateObject(["\n    ", "\n    display: inline-block;\n    font-weight: 700;\n    height: ", ";\n    line-height: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssBaseBadge;")], ["\n    ", "\n    display: inline-block;\n    font-weight: 700;\n    height: ", ";\n    line-height: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssBaseBadge;")])), cssBadgeVariant$1(theme, props), pxToRem(props.size), pxToRem(props.size));
}
function cssBadgeVariant$1(theme, props) {
  if (props.disabled) {
    return cssDisabledBadge(theme, props.variant);
  }
  switch (props.type) {
    case 'fill':
      return cssFillBadge(theme, props.variant);
    case 'weak':
      return cssWeakBadge(theme, props.variant);
  }
}
function cssDisabledBadge(theme, variant) {
  switch (variant) {
    case 'dim':
      return /*#__PURE__*/css(templateObject_2$1F || (templateObject_2$1F = __makeTemplateObject(["\n        color: ", ";\n        background-color: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:cssDisabledBadge;")], ["\n        color: ", ";\n        background-color: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:cssDisabledBadge;")])), theme.content.base2, theme.dim.disabled);
    case 'base2Outline':
      return /*#__PURE__*/css(templateObject_3$1o || (templateObject_3$1o = __makeTemplateObject(["\n        color: ", ";\n        background-color: ", ";\n        border: ", " solid ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssDisabledBadge;")], ["\n        color: ", ";\n        background-color: ", ";\n        border: ", " solid ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssDisabledBadge;")])), theme.content.base3, hexToRgba(theme.content.base5, 0.7), pxToRem(1), theme.outline);
    default:
      return /*#__PURE__*/css(templateObject_4$17 || (templateObject_4$17 = __makeTemplateObject(["\n        color: ", ";\n        background-color: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssDisabledBadge;")], ["\n        color: ", ";\n        background-color: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssDisabledBadge;")])), theme.content.base3, theme.content.base4);
  }
}
function cssFillBadge(theme, variant) {
  switch (variant) {
    case 'dim':
      return /*#__PURE__*/css(templateObject_5$W || (templateObject_5$W = __makeTemplateObject(["\n        color: ", ";\n        background-color: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssFillBadge;")], ["\n        color: ", ";\n        background-color: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssFillBadge;")])), theme.content.white, theme.dim.thick);
    case 'base2':
      return /*#__PURE__*/css(templateObject_6$L || (templateObject_6$L = __makeTemplateObject(["\n        color: ", ";\n        background-color: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssFillBadge;")], ["\n        color: ", ";\n        background-color: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssFillBadge;")])), theme.content.base6, theme.content.base2);
    case 'primary1':
    case 'primary2':
    case 'primary3':
    case 'primary4':
      return /*#__PURE__*/css(templateObject_7$A || (templateObject_7$A = __makeTemplateObject(["\n        color: ", ";\n        background-color: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssFillBadge;")], ["\n        color: ", ";\n        background-color: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssFillBadge;")])), theme.content.white, theme.content[variant].basic);
  }
}
function cssWeakBadge(theme, variant) {
  switch (variant) {
    case 'base2Outline':
      return /*#__PURE__*/css(templateObject_8$s || (templateObject_8$s = __makeTemplateObject(["\n        color: ", ";\n        background-color: ", ";\n        border: ", " solid ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssWeakBadge;")], ["\n        color: ", ";\n        background-color: ", ";\n        border: ", " solid ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssWeakBadge;")])), theme.content.base2, hexToRgba(theme.content.base6, 0.7), pxToRem(1), theme.outline);
    case 'primary1':
    case 'primary3':
      return /*#__PURE__*/css(templateObject_9$k || (templateObject_9$k = __makeTemplateObject(["\n        color: ", ";\n        background-color: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssWeakBadge;")], ["\n        color: ", ";\n        background-color: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssWeakBadge;")])), theme.content[variant].basic, theme.content[variant].thin);
    case 'primary2':
    case 'primary4':
      return /*#__PURE__*/css(templateObject_10$h || (templateObject_10$h = __makeTemplateObject(["\n        color: ", ";\n        background-color: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssWeakBadge;")], ["\n        color: ", ";\n        background-color: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssWeakBadge;")])), theme.content[variant].thick, theme.content[variant].thin);
    case 'base2':
      return /*#__PURE__*/css(templateObject_11$a || (templateObject_11$a = __makeTemplateObject(["\n        color: ", ";\n        background-color: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssWeakBadge;")], ["\n        color: ", ";\n        background-color: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssWeakBadge;")])), theme.content.base2, theme.content.base4);
  }
}
var templateObject_1$28, templateObject_2$1F, templateObject_3$1o, templateObject_4$17, templateObject_5$W, templateObject_6$L, templateObject_7$A, templateObject_8$s, templateObject_9$k, templateObject_10$h, templateObject_11$a;

function cssSize$6(size) {
  switch (size) {
    case 16:
      return /*#__PURE__*/css(templateObject_1$27 || (templateObject_1$27 = __makeTemplateObject(["\n        ", "\n        padding: 0 ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;")], ["\n        ", "\n        padding: 0 ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;")])), FONT_STYLE.caption2, pxToRem(4));
    case 20:
      return /*#__PURE__*/css(templateObject_2$1E || (templateObject_2$1E = __makeTemplateObject(["\n        ", "\n        padding: 0 ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;")], ["\n        ", "\n        padding: 0 ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;")])), FONT_STYLE.caption2, pxToRem(6));
    case 24:
      return /*#__PURE__*/css(templateObject_3$1n || (templateObject_3$1n = __makeTemplateObject(["\n        ", "\n        padding: 0 ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;")], ["\n        ", "\n        padding: 0 ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;")])), FONT_STYLE.caption1, pxToRem(6));
    case 28:
      return /*#__PURE__*/css(templateObject_4$16 || (templateObject_4$16 = __makeTemplateObject(["\n        ", "\n        padding: 0 ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;")], ["\n        ", "\n        padding: 0 ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;")])), FONT_STYLE.subTitle1, pxToRem(8));
  }
}
/**
 * @deprecated ODS의 SquareBadge를 사용해주세요.
 */
function SquareBadge(props) {
  var size = props.size,
    children = props.children,
    rest = __rest(props, ["size", "children"]);
  var theme = useTheme();
  return jsx("span", _assign({}, rest, {
    css: [cssSize$6(size), cssBaseBadge(theme, props), /*#__PURE__*/css(templateObject_5$V || (templateObject_5$V = __makeTemplateObject(["\n          border-radius: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          border-radius: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(4))]
  }, {
    children: children
  }));
}
var templateObject_1$27, templateObject_2$1E, templateObject_3$1n, templateObject_4$16, templateObject_5$V;

function cssSize$5(size) {
  switch (size) {
    case 16:
      return /*#__PURE__*/css(templateObject_1$26 || (templateObject_1$26 = __makeTemplateObject(["\n        ", "\n        padding: 0 ", ";\n        border-radius: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;")], ["\n        ", "\n        padding: 0 ", ";\n        border-radius: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;")])), FONT_STYLE.caption2, pxToRem(6), pxToRem(9));
    case 20:
      return /*#__PURE__*/css(templateObject_2$1D || (templateObject_2$1D = __makeTemplateObject(["\n        ", "\n        padding: 0 ", ";\n        border-radius: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;")], ["\n        ", "\n        padding: 0 ", ";\n        border-radius: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;")])), FONT_STYLE.caption1, pxToRem(6), pxToRem(10));
    case 24:
      return /*#__PURE__*/css(templateObject_3$1m || (templateObject_3$1m = __makeTemplateObject(["\n        ", "\n        padding: 0 ", ";\n        border-radius: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;")], ["\n        ", "\n        padding: 0 ", ";\n        border-radius: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;")])), FONT_STYLE.body3, pxToRem(8), pxToRem(12));
  }
}
/**
 * @deprecated ODS의 PillBadge를 사용해주세요.
 */
function PillBadge(props) {
  var size = props.size,
    children = props.children,
    rest = __rest(props, ["size", "children"]);
  var theme = useTheme();
  return jsx("span", _assign({}, rest, {
    css: [cssSize$5(size), cssBaseBadge(theme, props)]
  }, {
    children: children
  }));
}
var templateObject_1$26, templateObject_2$1D, templateObject_3$1m;

function cssSize$4(size) {
  switch (size) {
    case 16:
      return /*#__PURE__*/css(templateObject_1$25 || (templateObject_1$25 = __makeTemplateObject(["\n        ", "\n        padding: 0 ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;")], ["\n        ", "\n        padding: 0 ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;")])), FONT_STYLE.caption2, pxToRem(5));
    case 20:
      return /*#__PURE__*/css(templateObject_2$1C || (templateObject_2$1C = __makeTemplateObject(["\n        ", "\n        padding: 0 ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;")], ["\n        ", "\n        padding: 0 ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;")])), FONT_STYLE.caption2, pxToRem(7));
    case 24:
      return /*#__PURE__*/css(templateObject_3$1l || (templateObject_3$1l = __makeTemplateObject(["\n        ", "\n        padding: 0 ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;")], ["\n        ", "\n        padding: 0 ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;")])), FONT_STYLE.caption1, pxToRem(8));
  }
}
/**
 * @deprecated ODS의 CircleBadge 컴포넌트를 사용해 주세요.
 */
function CircleBadge(props) {
  var size = props.size,
    children = props.children,
    rest = __rest(props, ["size", "children"]);
  var theme = useTheme();
  return jsx("span", _assign({}, rest, {
    css: [cssSize$4(size), cssBaseBadge(theme, props), /*#__PURE__*/css(templateObject_4$15 || (templateObject_4$15 = __makeTemplateObject(["\n          border-radius: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          border-radius: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(size / 2))]
  }, {
    children: children
  }));
}
var templateObject_1$25, templateObject_2$1C, templateObject_3$1l, templateObject_4$15;

/**
 * @author TroyTae
 * @version 1.3.8
 * @license MIT
 * @name one-spaces
 */
function n(r) {
  for (var t, e = 0, o = ""; e < r.length;) (t = r[e++]) && (t.pop && !(t = n(t)) || (o && (o += " "), o += t));
  return o;
}
function spaces () {
  return n(arguments);
}

/**
 * @deprecated ODS의 Icon 컴포넌트를 사용해 주세요.
 */
function Icon(_a) {
  var fill = _a.fill,
    name = _a.name,
    size = _a.size,
    className = _a.className,
    rest = __rest(_a, ["fill", "name", "size", "className"]);
  var theme = useTheme();
  return jsx("span", _assign({}, rest, {
    css: [/*#__PURE__*/css(templateObject_1$24 || (templateObject_1$24 = __makeTemplateObject(["\n          display: inline-block;\n          font-size: ", ";\n          line-height: 1;\n          &::before {\n            font-family: OhouseIcon;\n            vertical-align: top;\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          display: inline-block;\n          font-size: ", ";\n          line-height: 1;\n          &::before {\n            font-family: OhouseIcon;\n            vertical-align: top;\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(size)), fill && /*#__PURE__*/css(templateObject_2$1B || (templateObject_2$1B = __makeTemplateObject(["\n          color: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          color: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), fill(theme))],
    className: spaces(className, "_".concat(name, "_").concat(size))
  }));
}
var templateObject_1$24, templateObject_2$1B;

function Crumb(_a) {
  var text = _a.text,
    isActive = _a.isActive,
    rest = __rest(_a, ["text", "isActive"]);
  var theme = useTheme();
  return jsx("button", _assign({
    type: "button"
  }, rest, {
    css: /*#__PURE__*/css(templateObject_1$23 || (templateObject_1$23 = __makeTemplateObject(["\n        ", "\n        font: inherit;\n        vertical-align: top;\n        color: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        ", "\n        font: inherit;\n        vertical-align: top;\n        color: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), RESET_BUTTON, isActive ? theme.content.base1 : theme.content.base2)
  }, {
    children: text
  }));
}
var templateObject_1$23;

function Breadcrumb(_a) {
  var activeIndex = _a.activeIndex,
    onChangeIndex = _a.onChangeIndex,
    crumbs = _a.crumbs,
    rest = __rest(_a, ["activeIndex", "onChangeIndex", "crumbs"]);
  var theme = useTheme();
  return jsx("nav", _assign({}, rest, {
    css: [FONT_STYLE.subTitle2, /*#__PURE__*/css(templateObject_1$22 || (templateObject_1$22 = __makeTemplateObject(["\n          overflow-x: auto;\n          white-space: nowrap;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          overflow-x: auto;\n          white-space: nowrap;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))]
  }, {
    children: crumbs.map(function (_a, index) {
      var text = _a.text,
        rest = __rest(_a, ["text"]);
      return jsxs(Fragment, {
        children: [jsx(Crumb, _assign({}, rest, {
          text: text,
          isActive: index === activeIndex,
          onClick: function onClick() {
            return onChangeIndex(index);
          }
        })), index + 1 < crumbs.length && jsx(Icon, {
          size: 18,
          name: "chevron_right",
          css: /*#__PURE__*/css(templateObject_2$1A || (templateObject_2$1A = __makeTemplateObject(["\n                vertical-align: top;\n                margin: 0 ", ";\n                color: ", ";\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                vertical-align: top;\n                margin: 0 ", ";\n                color: ", ";\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(4), theme.content.base2)
        })]
      }, text);
    })
  }));
}
var templateObject_1$22, templateObject_2$1A;

function getWithIconOptions(size, iconSize) {
  return {
    gap: {
      32: 4,
      40: 6,
      44: 6,
      50: 6
    }[size],
    iconSize: iconSize !== null && iconSize !== void 0 ? iconSize : 18
  };
}
function cssBaseButton(size, full) {
  return /*#__PURE__*/css(templateObject_1$21 || (templateObject_1$21 = __makeTemplateObject(["\n    ", "\n    ", "\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    width: ", ";\n    height: ", ";\n    border-radius: ", ";\n    padding: 0 ", ";\n    font-weight: ", ";\n    box-sizing: border-box;\n    text-align: center;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssBaseButton;")], ["\n    ", "\n    ", "\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    width: ", ";\n    height: ", ";\n    border-radius: ", ";\n    padding: 0 ", ";\n    font-weight: ", ";\n    box-sizing: border-box;\n    text-align: center;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssBaseButton;")])), RESET_BUTTON, {
    32: FONT_STYLE.body2,
    40: FONT_STYLE.subTitle2,
    44: FONT_STYLE.subTitle2,
    50: FONT_STYLE.subTitle1
  }[size], full ? '100%' : 'auto', pxToRem(size), pxToRem(4), pxToRem(size === 32 ? 8 : 16), size === 50 ? 700 : 400);
}
function FileInputLabel(_a) {
  var id = _a.id,
    _onClick = _a.onClick,
    forwardedRef = _a.forwardedRef,
    className = _a.className,
    size = _a.size,
    full = _a.full,
    disabled = _a.disabled,
    children = _a.children,
    rest = __rest(_a, ["id", "onClick", "forwardedRef", "className", "size", "full", "disabled", "children"]);
  return jsxs("label", _assign({
    className: className,
    htmlFor: id,
    css: [cssBaseButton(size, full), /*#__PURE__*/css(templateObject_2$1z || (templateObject_2$1z = __makeTemplateObject(["\n          cursor: pointer;\n          position: relative;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          cursor: pointer;\n          position: relative;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")]))), full && /*#__PURE__*/css(templateObject_3$1k || (templateObject_3$1k = __makeTemplateObject(["text-align: center;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["text-align: center;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))]
  }, {
    children: [jsx("span", _assign({
      css: /*#__PURE__*/css(templateObject_4$14 || (templateObject_4$14 = __makeTemplateObject(["vertical-align: middle;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["vertical-align: middle;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
    }, {
      children: children
    })), jsx("input", _assign({}, rest, {
      id: id,
      ref: forwardedRef,
      type: "file",
      css: /*#__PURE__*/css(templateObject_5$U || (templateObject_5$U = __makeTemplateObject(["\n          position: absolute;\n          top: 0;\n          left: 0;\n          width: 0;\n          height: 0;\n          opacity: 0;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          position: absolute;\n          top: 0;\n          left: 0;\n          width: 0;\n          height: 0;\n          opacity: 0;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")]))),
      onClick: function onClick(e) {
        if (disabled) {
          e.preventDefault();
        }
        if (_onClick) {
          _onClick(e);
        }
      }
    }))]
  }));
}
var templateObject_1$21, templateObject_2$1z, templateObject_3$1k, templateObject_4$14, templateObject_5$U;

function cssDisabled$1(theme, variant) {
  switch (variant) {
    case 'dim':
      return /*#__PURE__*/css(templateObject_1$20 || (templateObject_1$20 = __makeTemplateObject(["\n        color: ", ";\n        background-color: ", ";\n        pointer-events: none;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssDisabled;")], ["\n        color: ", ";\n        background-color: ", ";\n        pointer-events: none;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssDisabled;")])), theme.content.base2, theme.dim.disabled);
    case 'primary1':
    case 'primary2':
    case 'primary3':
    case 'base1':
      return /*#__PURE__*/css(templateObject_2$1y || (templateObject_2$1y = __makeTemplateObject(["\n        color: ", ";\n        background-color: ", ";\n        pointer-events: none;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssDisabled;")], ["\n        color: ", ";\n        background-color: ", ";\n        pointer-events: none;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssDisabled;")])), theme.content.base3, theme.content.base4);
  }
}
function cssVariant$7(theme, variant) {
  switch (variant) {
    case 'primary1':
    case 'primary2':
    case 'primary3':
      return /*#__PURE__*/css(templateObject_4$13 || (templateObject_4$13 = __makeTemplateObject(["\n        color: ", ";\n        background-color: ", ";\n        ", "\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")], ["\n        color: ", ";\n        background-color: ", ";\n        ", "\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")])), theme.content.white, theme.content[variant].basic, HOVER(templateObject_3$1j || (templateObject_3$1j = __makeTemplateObject(["\n          background-color: ", ";\n        "], ["\n          background-color: ", ";\n        "])), theme.interactive[variant].basic));
    case 'base1':
      return /*#__PURE__*/css(templateObject_6$K || (templateObject_6$K = __makeTemplateObject(["\n        color: ", ";\n        background-color: ", ";\n        ", "\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")], ["\n        color: ", ";\n        background-color: ", ";\n        ", "\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")])), theme.content.base6, theme.content.base1, HOVER(templateObject_5$T || (templateObject_5$T = __makeTemplateObject(["\n          background-color: ", ";\n        "], ["\n          background-color: ", ";\n        "])), theme.interactive.base1));
    case 'dim':
      return /*#__PURE__*/css(templateObject_8$r || (templateObject_8$r = __makeTemplateObject(["\n        color: ", ";\n        background-color: ", ";\n        ", "\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")], ["\n        color: ", ";\n        background-color: ", ";\n        ", "\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")])), theme.content.white, theme.dim.thick, HOVER(templateObject_7$z || (templateObject_7$z = __makeTemplateObject(["\n          background-color: ", ";\n        "], ["\n          background-color: ", ";\n        "])), theme.interactive.dim.thick));
  }
}
/**
 * @deprecated ODS의 BoxButton 컴포넌트를 사용해 주세요.
 */
function Button$2(_a) {
  var forwardedRef = _a.forwardedRef,
    full = _a.full,
    size = _a.size,
    variant = _a.variant,
    disabled = _a.disabled,
    children = _a.children,
    rest = __rest(_a, ["forwardedRef", "full", "size", "variant", "disabled", "children"]);
  var theme = useTheme();
  return jsx("button", _assign({}, rest, {
    ref: forwardedRef,
    disabled: disabled,
    css: [cssBaseButton(size, full), (disabled ? cssDisabled$1 : cssVariant$7)(theme, variant)]
  }, {
    children: children
  }));
}
function AnchorButton(_a) {
  var forwardedRef = _a.forwardedRef,
    full = _a.full,
    size = _a.size,
    variant = _a.variant,
    children = _a.children,
    disabled = _a.disabled,
    rest = __rest(_a, ["forwardedRef", "full", "size", "variant", "children", "disabled"]);
  var theme = useTheme();
  return jsx("a", _assign({}, rest, {
    ref: forwardedRef,
    css: [cssBaseButton(size, full), (disabled ? cssDisabled$1 : cssVariant$7)(theme, variant)]
  }, {
    children: children
  }));
}
function FileButton(_a) {
  var full = _a.full,
    size = _a.size,
    variant = _a.variant,
    disabled = _a.disabled,
    rest = __rest(_a, ["full", "size", "variant", "disabled"]);
  var theme = useTheme();
  return jsx(FileInputLabel, _assign({}, rest, {
    size: size,
    full: full,
    disabled: disabled,
    css: (disabled ? cssDisabled$1 : cssVariant$7)(theme, variant)
  }));
}
var templateObject_1$20, templateObject_2$1y, templateObject_3$1j, templateObject_4$13, templateObject_5$T, templateObject_6$K, templateObject_7$z, templateObject_8$r;

function MiddleIcon(props) {
  return jsx(Icon, _assign({}, props, {
    css: /*#__PURE__*/css(templateObject_1$1$ || (templateObject_1$1$ = __makeTemplateObject(["vertical-align: middle;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["vertical-align: middle;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
  }));
}
function withIcon(Component, getOptions) {
  return function (_a) {
    var text = _a.text,
      icon = _a.icon,
      isTrailing = _a.isTrailing,
      rest = __rest(_a, ["text", "icon", "isTrailing"]);
    var _b = getOptions(rest),
      gap = _b.gap,
      iconSize = _b.iconSize;
    var middleIcon = jsx(MiddleIcon, {
      name: icon,
      size: iconSize
    });
    return jsxs(Component, _assign({}, rest, {
      children: [!isTrailing && middleIcon, jsx("span", _assign({
        css: /*#__PURE__*/css(templateObject_2$1x || (templateObject_2$1x = __makeTemplateObject(["\n            vertical-align: middle;\n            margin-", ": ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            vertical-align: middle;\n            margin-", ": ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), isTrailing ? 'right' : 'left', pxToRem(gap))
      }, {
        children: text
      })), isTrailing && middleIcon]
    }));
  };
}
var templateObject_1$1$, templateObject_2$1x;

/**
 * @deprecated ODS의 BoxButton 컴포넌트를 사용해 주세요.
 */
var ButtonWithIcon = withIcon(Button$2, function (_a) {
  var size = _a.size,
    iconSize = _a.iconSize;
  return getWithIconOptions(size, iconSize);
});
/**
 * @deprecated ODS의 BoxButton 컴포넌트를 사용해 주세요.
 */
var AnchorButtonWithIcon = withIcon(AnchorButton, function (_a) {
  var size = _a.size,
    iconSize = _a.iconSize;
  return getWithIconOptions(size, iconSize);
});
/**
 * @deprecated ODS의 BoxButton 컴포넌트를 사용해 주세요.
 */
var FileButtonWithIcon = withIcon(FileButton, function (_a) {
  var size = _a.size,
    iconSize = _a.iconSize;
  return getWithIconOptions(size, iconSize);
});

function cssVariant$6(theme, variant, filled) {
  switch (variant) {
    case 'primary1':
    case 'primary2':
    case 'primary3':
      return /*#__PURE__*/css(templateObject_3$1i || (templateObject_3$1i = __makeTemplateObject(["\n        color: ", ";\n        border: ", " solid ", ";\n        ", "\n        ", "\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")], ["\n        color: ", ";\n        border: ", " solid ", ";\n        ", "\n        ", "\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")])), theme.content[variant].basic, pxToRem(1), theme.content[variant].basic, filled && /*#__PURE__*/css(templateObject_1$1_ || (templateObject_1$1_ = __makeTemplateObject(["background-color: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")], ["background-color: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")])), theme.content.base6), HOVER(templateObject_2$1w || (templateObject_2$1w = __makeTemplateObject(["\n          background-color: ", ";\n        "], ["\n          background-color: ", ";\n        "])), theme.interactive[variant].transparent));
    case 'base1':
      return /*#__PURE__*/css(templateObject_6$J || (templateObject_6$J = __makeTemplateObject(["\n        color: ", ";\n        border: ", " solid ", ";\n        ", "\n        ", "\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")], ["\n        color: ", ";\n        border: ", " solid ", ";\n        ", "\n        ", "\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")])), theme.content.base1, pxToRem(1), theme.border, filled && /*#__PURE__*/css(templateObject_4$12 || (templateObject_4$12 = __makeTemplateObject(["background-color: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")], ["background-color: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")])), theme.content.base6), HOVER(templateObject_5$S || (templateObject_5$S = __makeTemplateObject(["\n          background-color: ", ";\n        "], ["\n          background-color: ", ";\n        "])), theme.interactive.transparent));
    case 'onDark':
      return /*#__PURE__*/css(templateObject_9$j || (templateObject_9$j = __makeTemplateObject(["\n        color: ", ";\n        border: ", " solid ", ";\n        ", "\n        ", "\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")], ["\n        color: ", ";\n        border: ", " solid ", ";\n        ", "\n        ", "\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")])), theme.content.white, pxToRem(1), theme.content.white, filled && /*#__PURE__*/css(templateObject_7$y || (templateObject_7$y = __makeTemplateObject(["background-color: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")], ["background-color: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")])), theme.dim.thin), HOVER(templateObject_8$q || (templateObject_8$q = __makeTemplateObject(["\n          background-color: ", ";\n        "], ["\n          background-color: ", ";\n        "])), theme.interactive.onDark));
  }
}
function cssDisabled(theme) {
  return /*#__PURE__*/css(templateObject_10$g || (templateObject_10$g = __makeTemplateObject(["\n    color: ", ";\n    border: ", " solid ", ";\n    background-color: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssDisabled;")], ["\n    color: ", ";\n    border: ", " solid ", ";\n    background-color: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssDisabled;")])), theme.content.base3, pxToRem(1), theme.content.base4, theme.content.base5);
}
/**
 * @deprecated ODS의 BoxButton 컴포넌트를 사용해 주세요.
 */
function OutlineButton(_a) {
  var forwardedRef = _a.forwardedRef,
    full = _a.full,
    size = _a.size,
    variant = _a.variant,
    disabled = _a.disabled,
    children = _a.children,
    _b = _a.filled,
    filled = _b === void 0 ? false : _b,
    rest = __rest(_a, ["forwardedRef", "full", "size", "variant", "disabled", "children", "filled"]);
  var theme = useTheme();
  return jsx("button", _assign({}, rest, {
    ref: forwardedRef,
    disabled: disabled,
    css: [cssBaseButton(size, full), disabled ? cssDisabled(theme) : cssVariant$6(theme, variant, filled)]
  }, {
    children: children
  }));
}
/**
 * @deprecated ODS의 BoxButton 컴포넌트를 사용해 주세요.
 */
function OutlineAnchorButton(_a) {
  var forwardedRef = _a.forwardedRef,
    full = _a.full,
    size = _a.size,
    variant = _a.variant,
    children = _a.children,
    disabled = _a.disabled,
    _b = _a.filled,
    filled = _b === void 0 ? false : _b,
    rest = __rest(_a, ["forwardedRef", "full", "size", "variant", "children", "disabled", "filled"]);
  var theme = useTheme();
  return jsx("a", _assign({}, rest, {
    ref: forwardedRef,
    css: [cssBaseButton(size, full), disabled ? cssDisabled(theme) : cssVariant$6(theme, variant, filled)]
  }, {
    children: children
  }));
}
/**
 * @deprecated ODS의 BoxButton 컴포넌트를 사용해 주세요.
 */
function OutlineFileButton(_a) {
  var full = _a.full,
    size = _a.size,
    variant = _a.variant,
    disabled = _a.disabled,
    _b = _a.filled,
    filled = _b === void 0 ? false : _b,
    rest = __rest(_a, ["full", "size", "variant", "disabled", "filled"]);
  var theme = useTheme();
  return jsx(FileInputLabel, _assign({}, rest, {
    size: size,
    full: full,
    disabled: disabled,
    css: disabled ? cssDisabled(theme) : cssVariant$6(theme, variant, filled)
  }));
}
var templateObject_1$1_, templateObject_2$1w, templateObject_3$1i, templateObject_4$12, templateObject_5$S, templateObject_6$J, templateObject_7$y, templateObject_8$q, templateObject_9$j, templateObject_10$g;

/**
 * @deprecated ODS의 BoxButton 컴포넌트를 사용해 주세요.
 */
var OutlineButtonWithIcon = withIcon(OutlineButton, function (_a) {
  var size = _a.size,
    iconSize = _a.iconSize;
  return getWithIconOptions(size, iconSize);
});
/**
 * @deprecated ODS의 BoxButton 컴포넌트를 사용해 주세요.
 */
var OutlineAnchorButtonWithIcon = withIcon(OutlineAnchorButton, function (_a) {
  var size = _a.size,
    iconSize = _a.iconSize;
  return getWithIconOptions(size, iconSize);
});
/**
 * @deprecated ODS의 BoxButton 컴포넌트를 사용해 주세요.
 */
var OutlineFileButtonWithIcon = withIcon(OutlineFileButton, function (_a) {
  var size = _a.size,
    iconSize = _a.iconSize;
  return getWithIconOptions(size, iconSize);
});

function cssVariant$5(theme, checked, variant) {
  if (checked) {
    switch (variant) {
      case 'primary1':
      case 'primary3':
        return /*#__PURE__*/css(templateObject_1$1Z || (templateObject_1$1Z = __makeTemplateObject(["\n          color: ", ";\n          border-color: ", ";\n          &:hover,\n          &:active {\n            background-color: ", ";\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")], ["\n          color: ", ";\n          border-color: ", ";\n          &:hover,\n          &:active {\n            background-color: ", ";\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")])), theme.content[variant].basic, theme.content[variant].basic, theme.interactive[variant].transparent);
      case 'primary2':
      case 'primary4':
        return /*#__PURE__*/css(templateObject_2$1v || (templateObject_2$1v = __makeTemplateObject(["\n          color: ", ";\n          border-color: ", ";\n          &:hover,\n          &:active {\n            background-color: ", ";\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")], ["\n          color: ", ";\n          border-color: ", ";\n          &:hover,\n          &:active {\n            background-color: ", ";\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")])), theme.content[variant].thick, theme.content[variant].thick, theme.interactive[variant].transparent);
    }
  }
  return /*#__PURE__*/css(templateObject_3$1h || (templateObject_3$1h = __makeTemplateObject(["\n    color: ", ";\n    border-color: ", ";\n    &:hover,\n    &:active {\n      background-color: ", ";\n    }\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")], ["\n    color: ", ";\n    border-color: ", ";\n    &:hover,\n    &:active {\n      background-color: ", ";\n    }\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")])), theme.content.base2, theme.border, theme.interactive.transparent);
}
function SelectButton(_a) {
  var forwardedRef = _a.forwardedRef,
    error = _a.error,
    disabled = _a.disabled,
    grid = _a.grid,
    size = _a.size,
    variant = _a.variant,
    options = _a.options,
    onChange = _a.onChange,
    rest = __rest(_a, ["forwardedRef", "error", "disabled", "grid", "size", "variant", "options", "onChange"]);
  var theme = useTheme();
  var getMsGridColums = function getMsGridColums(grid) {
    if (grid === 1) return '1fr';
    return new Array(grid).fill('1fr').join(" ".concat(pxToRem(6), " "));
  };
  var getMsGridRows = function getMsGridRows(grid, buttonCount) {
    return new Array(Math.ceil(buttonCount / grid)).fill('1fr').join(" ".concat(pxToRem(6), " "));
  };
  return jsx("div", _assign({}, rest, {
    css: /*#__PURE__*/css(templateObject_4$11 || (templateObject_4$11 = __makeTemplateObject(["\n        overflow: hidden;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        overflow: hidden;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
  }, {
    children: jsx("div", _assign({
      css: /*#__PURE__*/css(templateObject_5$R || (templateObject_5$R = __makeTemplateObject(["\n          display: grid;\n          grid-template-columns: repeat(", ", 1fr);\n          grid-gap: ", ";\n          display: -ms-grid;\n          -ms-grid-columns: ", ";\n          -ms-grid-columns: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          display: grid;\n          grid-template-columns: repeat(", ", 1fr);\n          grid-gap: ", ";\n          display: -ms-grid;\n          -ms-grid-columns: ", ";\n          -ms-grid-columns: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), grid, pxToRem(6), getMsGridColums(grid), getMsGridRows(grid, options.length))
    }, {
      children: options.map(function (option) {
        return _assign(_assign({}, option), {
          disabled: option.disabled || disabled
        });
      }).map(function (_a, index) {
        var text = _a.text,
          checked = _a.checked,
          disabled = _a.disabled;
        return jsx("div", _assign({
          css: /*#__PURE__*/css(templateObject_6$I || (templateObject_6$I = __makeTemplateObject(["\n                display: inline-block;\n                vertical-align: top;\n                -ms-grid-column: ", ";\n                -ms-grid-row: ", ";\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                display: inline-block;\n                vertical-align: top;\n                -ms-grid-column: ", ";\n                -ms-grid-row: ", ";\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), Math.floor(index % grid) * 2 + 1, Math.floor(index / grid) * 2 + 1)
        }, {
          children: jsx("button", _assign({
            type: "button",
            disabled: disabled,
            ref: index === 0 ? forwardedRef : null,
            css: [cssBaseButton(size), disabled ? /*#__PURE__*/css(templateObject_7$x || (templateObject_7$x = __makeTemplateObject(["\n                      color: ", ";\n                      border-color: ", ";\n                      background-color: ", ";\n                    " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                      color: ", ";\n                      border-color: ", ";\n                      background-color: ", ";\n                    " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), theme.content.base3, theme.content.base4, theme.content.base5) : cssVariant$5(theme, checked, variant), /*#__PURE__*/css(templateObject_8$p || (templateObject_8$p = __makeTemplateObject(["\n                    width: 100%;\n                    border-width: ", ";\n                    border-style: solid;\n                    font-weight: ", ";\n                  " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                    width: 100%;\n                    border-width: ", ";\n                    border-style: solid;\n                    font-weight: ", ";\n                  " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(1), checked ? 700 : 400), error && /*#__PURE__*/css(templateObject_9$i || (templateObject_9$i = __makeTemplateObject(["border-color: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["border-color: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), theme.content.primary2.basic)],
            onClick: function onClick() {
              return onChange(index, !checked);
            }
          }, {
            children: text
          }))
        }), text);
      })
    }))
  }));
}
var templateObject_1$1Z, templateObject_2$1v, templateObject_3$1h, templateObject_4$11, templateObject_5$R, templateObject_6$I, templateObject_7$x, templateObject_8$p, templateObject_9$i;

var _g$2, _defs$1;
function _extends$6() { _extends$6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
var SvgInactiveScrap24 = function SvgInactiveScrap24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g$2 || (_g$2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#inactiveScrap24_svg__a)",
    filter: "url(#inactiveScrap24_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.3 4.05V19.5l6.63-3.482a2.3 2.3 0 0 1 2.14 0l6.63 3.481V4.05zM4 2.75h16a1 1 0 0 1 1 1v17.073a.5.5 0 0 1-.732.442l-7.803-4.096a1 1 0 0 0-.93 0l-7.803 4.096A.5.5 0 0 1 3 20.824V3.75a1 1 0 0 1 1-1"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.5,
    d: "M4.3 4.05V19.5l6.63-3.482a2.3 2.3 0 0 1 2.14 0l6.63 3.481V4.05z"
  }))), _defs$1 || (_defs$1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "inactiveScrap24_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "inactiveScrap24_svg__b",
    width: 28,
    height: 28.573,
    x: -2,
    y: -0.25,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.247059 0 0 0 0 0.278431 0 0 0 0 0.301961 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15409_67579"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_15409_67579",
    result: "shape"
  })))));
};
var InactiveScrapIcon24 = SvgInactiveScrap24;

var _g$1, _defs;
function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
var SvgInactiveScrap32 = function SvgInactiveScrap32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g$1 || (_g$1 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "evenodd",
    clipPath: "url(#inactiveScrap32_svg__a)",
    clipRule: "evenodd",
    filter: "url(#inactiveScrap32_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.3 5.3v21.55l9.536-5.007a2.3 2.3 0 0 1 2.138 0l9.535 5.006V5.3zM5 4a1 1 0 0 0-1 1v23.173a.5.5 0 0 0 .732.443l10.708-5.622a1 1 0 0 1 .93 0l10.707 5.622a.5.5 0 0 0 .732-.443V5a1 1 0 0 0-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.5,
    d: "M5.3 5.3v21.55l9.536-5.007a2.3 2.3 0 0 1 2.138 0l9.535 5.006V5.3z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "inactiveScrap32_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "inactiveScrap32_svg__b",
    width: 33.81,
    height: 34.673,
    x: -1,
    y: 1,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.247059 0 0 0 0 0.278431 0 0 0 0 0.301961 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15409_67578"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_15409_67578",
    result: "shape"
  })))));
};
var InactiveScrapIcon32 = SvgInactiveScrap32;

var _path$3;
function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
var SvgActiveScrap24 = function SvgActiveScrap24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
    fill: "#35C5F0",
    fillRule: "evenodd",
    d: "M20 2.75H4a1 1 0 0 0-1 1v17.073a.5.5 0 0 0 .732.442l7.803-4.096a1 1 0 0 1 .93 0l7.803 4.096a.5.5 0 0 0 .732-.442V3.75a1 1 0 0 0-1-1",
    clipRule: "evenodd"
  })));
};
var ActiveScrapIcon24 = SvgActiveScrap24;

var _path$2;
function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
var SvgActiveScrap32 = function SvgActiveScrap32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
    fill: "#35C5F0",
    fillRule: "evenodd",
    d: "M4 5a1 1 0 0 1 1-1h21.81a1 1 0 0 1 1 1v23.173a.5.5 0 0 1-.733.443L16.37 22.994a1 1 0 0 0-.93 0L4.732 28.616A.5.5 0 0 1 4 28.173z",
    clipRule: "evenodd"
  })));
};
var ActiveScrapIcon32 = SvgActiveScrap32;

var SCRAP = {
  inactive: {
    24: InactiveScrapIcon24,
    32: InactiveScrapIcon32
  },
  active: {
    24: ActiveScrapIcon24,
    32: ActiveScrapIcon32
  }
};
var ScrapButtonSet = function ScrapButtonSet(_a) {
  var size = _a.size,
    isActive = _a.isActive;
  var InactiveIcon = SCRAP['inactive'][size];
  var ActiveIcon = SCRAP['active'][size];
  return jsxs(Fragment$1, {
    children: [jsx(ActiveIcon, {
      css: /*#__PURE__*/css(templateObject_1$1Y || (templateObject_1$1Y = __makeTemplateObject([" opacity: ", "" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], [" opacity: ", "" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), isActive ? 1 : 0)
    }), jsx(InactiveIcon, {
      css: /*#__PURE__*/css(templateObject_2$1u || (templateObject_2$1u = __makeTemplateObject([" opacity: ", "" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], [" opacity: ", "" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), isActive ? 0 : 1)
    })]
  });
};
var ICONS_MAP = {
  scrap: ScrapButtonSet
};
var templateObject_1$1Y, templateObject_2$1u;

function ToggleButton(_a) {
  var name = _a.name,
    size = _a.size,
    active = _a.active,
    onActive = _a.onActive,
    onInactive = _a.onInactive,
    _b = _a.initialActive,
    initialActive = _b === void 0 ? false : _b,
    rest = __rest(_a, ["name", "size", "active", "onActive", "onInactive", "initialActive"]);
  var theme = useTheme();
  var _c = useState(initialActive),
    isActive = _c[0],
    setActive = _c[1];
  useEffect(function () {
    if (active === undefined) return;
    setActive(active);
  }, [active]);
  var Icons = ICONS_MAP[name];
  var handleClick = useCallback(function () {
    var _a;
    (_a = isActive ? onInactive : onActive) === null || _a === void 0 ? void 0 : _a();
    if (active !== undefined) return;
    setActive(!isActive);
  }, [onActive, onInactive, active, isActive]);
  return jsx("button", _assign({
    type: "button",
    onClick: handleClick,
    "aria-label": "".concat(name, " \uD1A0\uAE00 \uBC84\uD2BC"),
    css: [RESET_BUTTON, /*#__PURE__*/css(templateObject_1$1X || (templateObject_1$1X = __makeTemplateObject(["\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          width: ", ";\n          height: ", ";\n          position: relative;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          width: ", ";\n          height: ", ";\n          position: relative;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(size + 12), pxToRem(size + 12))]
  }, rest, {
    children: jsx("span", _assign({
      css: [/*#__PURE__*/css(templateObject_2$1t || (templateObject_2$1t = __makeTemplateObject(["\n          display: inline-block;\n          font-size: ", ";\n          line-height: 1;\n          transform: translateZ(0);\n          & > svg {\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%, -50%);\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          display: inline-block;\n          font-size: ", ";\n          line-height: 1;\n          transform: translateZ(0);\n          & > svg {\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%, -50%);\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(size)), !isActive && name === 'scrap' && /*#__PURE__*/css(templateObject_3$1g || (templateObject_3$1g = __makeTemplateObject(["\n          & > svg {\n            filter: drop-shadow(0 ", " ", " ", ");\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          & > svg {\n            filter: drop-shadow(0 ", " ", " ", ");\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(2), pxToRem(5), theme.shadow.thick)]
    }, {
      children: jsx(Icons, {
        size: size,
        isActive: isActive
      })
    }))
  }));
}
var templateObject_1$1X, templateObject_2$1t, templateObject_3$1g;

function getTextButtonWithIconOptions(size, iconSize) {
  return {
    gap: {
      30: 4,
      32: 2
    }[size],
    iconSize: iconSize !== null && iconSize !== void 0 ? iconSize : 18
  };
}
function cssSize$3(size) {
  switch (size) {
    case 30:
      return /*#__PURE__*/css(templateObject_1$1W || (templateObject_1$1W = __makeTemplateObject(["\n        ", "\n        padding: 0 ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;")], ["\n        ", "\n        padding: 0 ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;")])), FONT_STYLE.subTitle1, pxToRem(8));
    case 32:
      return /*#__PURE__*/css(templateObject_2$1s || (templateObject_2$1s = __makeTemplateObject(["\n        ", "\n        padding: 0 ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;")], ["\n        ", "\n        padding: 0 ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;")])), FONT_STYLE.subTitle2, pxToRem(6));
  }
}
function cssVariant$4(theme, variant) {
  switch (variant) {
    case 'primary1':
      return /*#__PURE__*/css(templateObject_3$1f || (templateObject_3$1f = __makeTemplateObject(["\n        color: ", ";\n        font-weight: 700;\n\n        &:active {\n          background-color: ", ";\n        }\n\n        @media (hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")], ["\n        color: ", ";\n        font-weight: 700;\n\n        &:active {\n          background-color: ", ";\n        }\n\n        @media (hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")])), theme.content.primary1.basic, theme.interactive.transparent, theme.interactive.transparent);
    case 'base1':
      return /*#__PURE__*/css(templateObject_4$10 || (templateObject_4$10 = __makeTemplateObject(["\n        color: ", ";\n        font-weight: 500;\n        &:active {\n          background-color: ", ";\n        }\n\n        @media (hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")], ["\n        color: ", ";\n        font-weight: 500;\n        &:active {\n          background-color: ", ";\n        }\n\n        @media (hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")])), theme.content.base1, theme.interactive.transparent, theme.interactive.transparent);
    case 'onDark':
      return /*#__PURE__*/css(templateObject_5$Q || (templateObject_5$Q = __makeTemplateObject(["\n        color: ", ";\n        font-weight: 500;\n        &:active {\n          background-color: ", ";\n        }\n\n        @media (hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")], ["\n        color: ", ";\n        font-weight: 500;\n        &:active {\n          background-color: ", ";\n        }\n\n        @media (hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")])), theme.content.white, theme.interactive.onDark, theme.interactive.onDark);
  }
}
/**
 * @deprecated ODS의 TextButton 컴포넌트를 사용해 주세요.
 */
function TextButton(_a) {
  var forwardedRef = _a.forwardedRef,
    size = _a.size,
    variant = _a.variant,
    disabled = _a.disabled,
    children = _a.children,
    rest = __rest(_a, ["forwardedRef", "size", "variant", "disabled", "children"]);
  var theme = useTheme();
  return jsx("button", _assign({
    type: "button"
  }, rest, {
    ref: forwardedRef,
    disabled: disabled,
    css: [/*#__PURE__*/css(templateObject_6$H || (templateObject_6$H = __makeTemplateObject(["\n          ", "\n          height: ", ";\n          border-radius: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          ", "\n          height: ", ";\n          border-radius: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), RESET_BUTTON, pxToRem(size), pxToRem(4)), cssSize$3(size), disabled ? /*#__PURE__*/css(templateObject_7$w || (templateObject_7$w = __makeTemplateObject(["\n              color: ", ";\n              background-color: transparent;\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              color: ", ";\n              background-color: transparent;\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), theme.content.base3) : cssVariant$4(theme, variant)]
  }, {
    children: children
  }));
}
var templateObject_1$1W, templateObject_2$1s, templateObject_3$1f, templateObject_4$10, templateObject_5$Q, templateObject_6$H, templateObject_7$w;

/**
 * @deprecated ODS의 TextButton 컴포넌트를 사용해 주세요.
 */
var TextButtonWithIcon = withIcon(TextButton, function (_a) {
  var size = _a.size,
    iconSize = _a.iconSize;
  return getTextButtonWithIconOptions(size, iconSize);
});

function cssBaseFab(theme, size) {
  return /*#__PURE__*/css(templateObject_1$1V || (templateObject_1$1V = __makeTemplateObject(["\n    ", "\n    ", "\n    height: ", ";\n    line-height: 0;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssBaseFab;")], ["\n    ", "\n    ", "\n    height: ", ";\n    line-height: 0;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssBaseFab;")])), RESET_BUTTON, SHADOW_STYLE.depth30(theme), pxToRem(size));
}
function cssFabVariant(theme, variant) {
  switch (variant) {
    case 'white':
      return /*#__PURE__*/css(templateObject_2$1r || (templateObject_2$1r = __makeTemplateObject(["\n        color: ", ";\n        background-color: ", ";\n        &:hover,\n        &:active {\n          background-color: ", ";\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssFabVariant;")], ["\n        color: ", ";\n        background-color: ", ";\n        &:hover,\n        &:active {\n          background-color: ", ";\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssFabVariant;")])), theme.content.base1, theme.background.elevated, theme.interactive.transparent);
    case 'primary1':
    case 'primary3':
    case 'primary4':
      return /*#__PURE__*/css(templateObject_3$1e || (templateObject_3$1e = __makeTemplateObject(["\n        color: ", ";\n        background-color: ", ";\n        &:hover,\n        &:active {\n          background-color: ", ";\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssFabVariant;")], ["\n        color: ", ";\n        background-color: ", ";\n        &:hover,\n        &:active {\n          background-color: ", ";\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssFabVariant;")])), theme.content.white, theme.content[variant].basic, theme.interactive[variant].basic);
  }
}
var templateObject_1$1V, templateObject_2$1r, templateObject_3$1e;

function Fab(_a) {
  var forwardedRef = _a.forwardedRef,
    size = _a.size,
    variant = _a.variant,
    children = _a.children,
    rest = __rest(_a, ["forwardedRef", "size", "variant", "children"]);
  var theme = useTheme();
  return jsx("button", _assign({}, rest, {
    type: "button",
    ref: forwardedRef,
    css: [cssBaseFab(theme, size), cssFabVariant(theme, variant), /*#__PURE__*/css(templateObject_1$1U || (templateObject_1$1U = __makeTemplateObject(["\n          border-radius: 50%;\n          width: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          border-radius: 50%;\n          width: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(size))]
  }, {
    children: children
  }));
}
var templateObject_1$1U;

function IconFab(_a) {
  var icon = _a.icon,
    rest = __rest(_a, ["icon"]);
  return jsx(Fab, _assign({}, rest, {
    children: jsx(Icon, {
      size: 24,
      name: icon
    })
  }));
}

function ExtendedFab(_a) {
  var forwardedRef = _a.forwardedRef,
    size = _a.size,
    variant = _a.variant,
    children = _a.children,
    rest = __rest(_a, ["forwardedRef", "size", "variant", "children"]);
  var theme = useTheme();
  return jsx("button", _assign({}, rest, {
    type: "button",
    ref: forwardedRef,
    css: [cssBaseFab(theme, size), cssFabVariant(theme, variant), /*#__PURE__*/css(templateObject_1$1T || (templateObject_1$1T = __makeTemplateObject(["\n          ", "\n          font-weight: 700;\n          padding: 0 ", ";\n          border-radius: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          ", "\n          font-weight: 700;\n          padding: 0 ", ";\n          border-radius: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), FONT_STYLE.subTitle1, pxToRem(16), pxToRem(size / 2))]
  }, {
    children: children
  }));
}
var templateObject_1$1T;

var ExtendedFabWithIcon = withIcon(ExtendedFab, function () {
  return {
    gap: 8,
    iconSize: 24
  };
});

function HiddenInput(_a) {
  var forwardedRef = _a.forwardedRef,
    onCheck = _a.onCheck,
    _onChange = _a.onChange,
    rest = __rest(_a, ["forwardedRef", "onCheck", "onChange"]);
  return jsx("input", _assign({}, rest, {
    ref: forwardedRef,
    type: "checkbox",
    onChange: function onChange(e) {
      return onCheckHandler(e, {
        onChange: _onChange,
        onCheck: onCheck
      });
    },
    css: /*#__PURE__*/css(templateObject_1$1S || (templateObject_1$1S = __makeTemplateObject(["\n        position: absolute;\n        top: 0;\n        left: 0;\n        opacity: 0;\n        width: 100%;\n        height: 100%;\n        margin: 0;\n        cursor: pointer;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        position: absolute;\n        top: 0;\n        left: 0;\n        opacity: 0;\n        width: 100%;\n        height: 100%;\n        margin: 0;\n        cursor: pointer;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
  }));
}
var templateObject_1$1S;

var TOGGLE_SIZE = {
  sm: function sm() {
    return {
      toggle: {
        width: 42,
        height: 24
      },
      knob: {
        width: 20,
        height: 20
      }
    };
  },
  md: function md() {
    return {
      toggle: {
        width: 50,
        height: 30
      },
      knob: {
        width: 26,
        height: 26
      }
    };
  }
};
function Toggle(_a) {
  var className = _a.className,
    checked = _a.checked,
    _b = _a.size,
    size = _b === void 0 ? 'md' : _b,
    rest = __rest(_a, ["className", "checked", "size"]);
  var theme = useTheme();
  var _c = TOGGLE_SIZE[size](),
    toggle = _c.toggle,
    knob = _c.knob;
  var x = checked ? toggle.width - knob.width - 4 : 0;
  return jsx("div", _assign({
    className: className,
    css: /*#__PURE__*/css(templateObject_1$1R || (templateObject_1$1R = __makeTemplateObject(["\n        position: relative;\n        display: inline-block;\n        width: ", "px;\n        height: ", "px;\n        border-radius: 25px;\n        background-color: ", ";\n            &::before {\n              ", "\n              content: \"\";\n              position: absolute;\n              top: 2px;\n              left: 2px;\n              width: ", "px;\n              height: ", "px;\n              border-radius: 50%;\n              background-color: ", ";\n              transform: translateX(", "px);\n              transition: transform 0.2s ease;\n            }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        position: relative;\n        display: inline-block;\n        width: ", "px;\n        height: ", "px;\n        border-radius: 25px;\n        background-color: ", ";\n            &::before {\n              ", "\n              content: \"\";\n              position: absolute;\n              top: 2px;\n              left: 2px;\n              width: ", "px;\n              height: ", "px;\n              border-radius: 50%;\n              background-color: ", ";\n              transform: translateX(", "px);\n              transition: transform 0.2s ease;\n            }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), toggle.width, toggle.height, checked ? theme.content.primary1.basic : theme.content.base3, SHADOW_STYLE.depth20(theme), knob.width, knob.height, theme.content.white, checked ? x : 0)
  }, {
    children: jsx(HiddenInput, _assign({}, rest, {
      checked: checked
    }))
  }));
}
var templateObject_1$1R;

function Checkbox$1(_a) {
  var className = _a.className,
    _b = _a.icon,
    icon = _b === void 0 ? 'check' : _b,
    disabled = _a.disabled,
    checked = _a.checked,
    rest = __rest(_a, ["className", "icon", "disabled", "checked"]);
  var theme = useTheme();
  return jsxs("div", _assign({
    className: className,
    css: [/*#__PURE__*/css(templateObject_1$1Q || (templateObject_1$1Q = __makeTemplateObject(["\n          display: inline-block;\n          position: relative;\n          width: ", ";\n          height: ", ";\n          border: ", " solid;\n          border-radius: ", ";\n          box-sizing: border-box;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          display: inline-block;\n          position: relative;\n          width: ", ";\n          height: ", ";\n          border: ", " solid;\n          border-radius: ", ";\n          box-sizing: border-box;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(20), pxToRem(20), pxToRem(1), pxToRem(4)), disabled ? /*#__PURE__*/css(templateObject_2$1q || (templateObject_2$1q = __makeTemplateObject(["\n              border-color: ", ";\n              background-color: ", ";\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              border-color: ", ";\n              background-color: ", ";\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), theme.content.base3, theme.content.base3) : /*#__PURE__*/css(templateObject_4$$ || (templateObject_4$$ = __makeTemplateObject(["\n              border-color: ", ";\n              background-color: ", ";\n              transition: border-color 0.1s, background-color 0.1s;\n              ", "\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              border-color: ", ";\n              background-color: ", ";\n              transition: border-color 0.1s, background-color 0.1s;\n              ", "\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), checked ? theme.content.primary1.basic : theme.border, checked ? theme.content.primary1.basic : theme.content.white, HOVER(templateObject_3$1d || (templateObject_3$1d = __makeTemplateObject(["\n                background-color: ", ";\n                border-color: ", ";\n              "], ["\n                background-color: ", ";\n                border-color: ", ";\n              "])), checked ? theme.interactive.primary1.basic : theme.interactive.transparent, checked ? theme.interactive.primary1.basic : theme.border))]
  }, {
    children: [jsx("div", _assign({
      css: /*#__PURE__*/css(templateObject_5$P || (templateObject_5$P = __makeTemplateObject(["\n          position: absolute;\n          overflow: hidden;\n          top: ", ";\n          left: ", ";\n          width: ", ";\n          height: ", ";\n          transition: width 0.2s 0.1s;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          position: absolute;\n          overflow: hidden;\n          top: ", ";\n          left: ", ";\n          width: ", ";\n          height: ", ";\n          transition: width 0.2s 0.1s;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(3.6), pxToRem(3), pxToRem(checked ? 12 : 0), pxToRem(12))
    }, {
      children: jsx(Icon, {
        size: 12,
        name: icon,
        css: /*#__PURE__*/css(templateObject_6$G || (templateObject_6$G = __makeTemplateObject(["\n            vertical-align: top;\n            color: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            vertical-align: top;\n            color: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), theme.content.base6)
      })
    })), jsx(HiddenInput, _assign({}, rest, {
      checked: checked,
      disabled: disabled
    }))]
  }));
}
var templateObject_1$1Q, templateObject_2$1q, templateObject_3$1d, templateObject_4$$, templateObject_5$P, templateObject_6$G;

function CheckboxWithText(_a) {
  var id = _a.id,
    className = _a.className,
    children = _a.children,
    rest = __rest(_a, ["id", "className", "children"]);
  var theme = useTheme();
  return jsxs("label", _assign({
    css: /*#__PURE__*/css(templateObject_1$1P || (templateObject_1$1P = __makeTemplateObject(["\n        display: inline-flex;\n        align-items: center;\n        cursor: pointer;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        display: inline-flex;\n        align-items: center;\n        cursor: pointer;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")]))),
    className: className,
    htmlFor: id
  }, {
    children: [jsx(Checkbox$1, _assign({}, rest, {
      id: id,
      css: /*#__PURE__*/css(templateObject_2$1p || (templateObject_2$1p = __makeTemplateObject(["\n          flex-shrink: 0;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          flex-shrink: 0;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
    })), jsx("span", _assign({
      css: /*#__PURE__*/css(templateObject_3$1c || (templateObject_3$1c = __makeTemplateObject(["\n          flex: 1;\n          ", "\n          margin-left: ", ";\n          color: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          flex: 1;\n          ", "\n          margin-left: ", ";\n          color: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), FONT_STYLE.subTitle1, pxToRem(6), theme.content.base1)
    }, {
      children: children
    }))]
  }));
}
var templateObject_1$1P, templateObject_2$1p, templateObject_3$1c;

function Radio(_a) {
  var forwardedRef = _a.forwardedRef,
    className = _a.className,
    disabled = _a.disabled,
    checked = _a.checked,
    rest = __rest(_a, ["forwardedRef", "className", "disabled", "checked"]);
  var theme = useTheme();
  return jsx("div", _assign({
    className: className,
    css: [/*#__PURE__*/css(templateObject_1$1O || (templateObject_1$1O = __makeTemplateObject(["\n          display: inline-block;\n          position: relative;\n          width: ", ";\n          height: ", ";\n          border: ", " solid;\n          border-radius: 50%;\n          box-sizing: border-box;\n          &::before {\n            content: \"\";\n            position: absolute;\n            border-radius: 50%;\n            top: ", ";\n            left: ", ";\n            width: ", ";\n            height: ", ";\n            transform: scale(", ");\n            transition: transform 0.4s cubic-bezier(0.5, 2, 0.5, 0.5);\n            background-color: ", ";\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          display: inline-block;\n          position: relative;\n          width: ", ";\n          height: ", ";\n          border: ", " solid;\n          border-radius: 50%;\n          box-sizing: border-box;\n          &::before {\n            content: \"\";\n            position: absolute;\n            border-radius: 50%;\n            top: ", ";\n            left: ", ";\n            width: ", ";\n            height: ", ";\n            transform: scale(", ");\n            transition: transform 0.4s cubic-bezier(0.5, 2, 0.5, 0.5);\n            background-color: ", ";\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(20), pxToRem(20), pxToRem(1), pxToRem(5), pxToRem(5), pxToRem(8), pxToRem(8), checked ? 1 : 0, theme.content.base6), disabled ? /*#__PURE__*/css(templateObject_2$1o || (templateObject_2$1o = __makeTemplateObject(["\n              border-color: ", ";\n              background-color: ", ";\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              border-color: ", ";\n              background-color: ", ";\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), theme.content.base3, theme.content.base3) : /*#__PURE__*/css(templateObject_4$_ || (templateObject_4$_ = __makeTemplateObject(["\n              border-color: ", ";\n              background-color: ", ";\n              transition: border-color 0.1s, background-color 0.1s;\n              ", "\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              border-color: ", ";\n              background-color: ", ";\n              transition: border-color 0.1s, background-color 0.1s;\n              ", "\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), checked ? theme.content.primary1.basic : theme.content.base3, checked ? theme.content.primary1.basic : theme.content.white, HOVER(templateObject_3$1b || (templateObject_3$1b = __makeTemplateObject(["\n                background-color: ", ";\n                border-color: ", ";\n              "], ["\n                background-color: ", ";\n                border-color: ", ";\n              "])), checked ? theme.interactive.primary1.basic : theme.interactive.transparent, checked ? theme.interactive.primary1.basic : theme.content.base3))]
  }, {
    children: jsx("input", _assign({}, rest, {
      ref: forwardedRef,
      type: "radio",
      checked: checked,
      disabled: disabled,
      css: /*#__PURE__*/css(templateObject_5$O || (templateObject_5$O = __makeTemplateObject(["\n          cursor: pointer;\n          position: absolute;\n          top: 0;\n          left: 0;\n          opacity: 0;\n          width: 100%;\n          height: 100%;\n          margin: 0;\n          &:disabled {\n            cursor: default;\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          cursor: pointer;\n          position: absolute;\n          top: 0;\n          left: 0;\n          opacity: 0;\n          width: 100%;\n          height: 100%;\n          margin: 0;\n          &:disabled {\n            cursor: default;\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
    }))
  }));
}
var templateObject_1$1O, templateObject_2$1o, templateObject_3$1b, templateObject_4$_, templateObject_5$O;

function RadioWithText(_a) {
  var id = _a.id,
    className = _a.className,
    children = _a.children,
    rest = __rest(_a, ["id", "className", "children"]);
  var theme = useTheme();
  return jsxs("label", _assign({
    css: /*#__PURE__*/css(templateObject_1$1N || (templateObject_1$1N = __makeTemplateObject(["\n        display: inline-block;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        display: inline-block;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")]))),
    className: className,
    htmlFor: id
  }, {
    children: [jsx(Radio, _assign({}, rest, {
      id: id,
      css: /*#__PURE__*/css(templateObject_2$1n || (templateObject_2$1n = __makeTemplateObject(["\n          vertical-align: middle;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          vertical-align: middle;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
    })), jsx("span", _assign({
      css: /*#__PURE__*/css(templateObject_3$1a || (templateObject_3$1a = __makeTemplateObject(["\n          ", "\n          vertical-align: middle;\n          margin-left: ", ";\n          color: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          ", "\n          vertical-align: middle;\n          margin-left: ", ";\n          color: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), FONT_STYLE.subTitle1, pxToRem(6), theme.content.base1)
    }, {
      children: children
    }))]
  }));
}
var templateObject_1$1N, templateObject_2$1n, templateObject_3$1a;

var GRID_ITEM_CLASS_NAME = 'bucketplace-grid-item';
var COLUMN_CLASS_NAME = 'bucketplace-column';
function cssBaseGap(gap, className) {
  var _a = "".concat(gap).split(' ').map(Number),
    vertical = _a[0],
    horizontal = _a[1];
  if (horizontal) {
    var verticalGap = pxToRem(vertical / 2);
    var horizontalGap = pxToRem(horizontal / 2);
    return "\n      margin: -".concat(verticalGap, " -").concat(horizontalGap, ";\n      > .").concat(className, " {\n        padding: ").concat(verticalGap, " ").concat(horizontalGap, ";\n      }\n    ");
  }
  var halfGap = pxToRem(vertical / 2);
  return "\n    margin: -".concat(halfGap, ";\n    > .").concat(className, " {\n      padding: ").concat(halfGap, ";\n    }\n  ");
}
function cssGap(gap, className) {
  if (_typeof(gap) === 'object') {
    var _a = gap.mobile,
      mobile = _a === void 0 ? 0 : _a,
      _b = gap.tablet,
      tablet = _b === void 0 ? mobile : _b,
      _c = gap.laptop,
      laptop = _c === void 0 ? tablet : _c;
    return /*#__PURE__*/css(templateObject_1$1M || (templateObject_1$1M = __makeTemplateObject(["\n      ", "\n      ", "\n      ", "\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:cssGap;")], ["\n      ", "\n      ", "\n      ", "\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:cssGap;")])), cssBaseGap(mobile, className), MEDIA_QUERY.min('tablet', cssBaseGap(tablet, className)), MEDIA_QUERY.min('laptop', cssBaseGap(laptop, className)));
  }
  return /*#__PURE__*/css(templateObject_2$1m || (templateObject_2$1m = __makeTemplateObject(["", "" + (process.env.NODE_ENV === "production" ? "" : ";label:cssGap;")], ["", "" + (process.env.NODE_ENV === "production" ? "" : ";label:cssGap;")])), cssBaseGap(gap, className));
}
var templateObject_1$1M, templateObject_2$1m;

var DEFAULT_GAP = {
  mobile: 12,
  tablet: 16,
  laptop: 20,
  // FIXME:
  // at this point, we do not have a grid-gap specification for `desktop` size, deriving `laptop` size for now.
  // revisit later to fix this: https://ohou-se.slack.com/archives/C017TF9FQUV/p1650524602037409
  desktop: 20
};
function Grid(_a) {
  var _b = _a.gap,
    gap = _b === void 0 ? DEFAULT_GAP : _b,
    children = _a.children,
    rest = __rest(_a, ["gap", "children"]);
  return jsx("div", _assign({}, rest, {
    css: /*#__PURE__*/css(templateObject_1$1L || (templateObject_1$1L = __makeTemplateObject(["overflow: hidden;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["overflow: hidden;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
  }, {
    children: jsx("div", _assign({
      css: cssGap(gap, GRID_ITEM_CLASS_NAME)
    }, {
      children: children
    }))
  }));
}
var templateObject_1$1L;

var TOTAL_COLUMN = {
  mobile: 4,
  tablet: 8,
  laptop: 12,
  // FIXME:
  // at this point, we do not have a grid-gap specification for `desktop` size, deriving `laptop` size for now.
  // revisit later to fix this: https://ohou-se.slack.com/archives/C017TF9FQUV/p1650524602037409
  desktop: 12
};
var COLUMN_PRESET = {
  full: {
    mobile: 4,
    tablet: 8,
    laptop: 12,
    desktop: 12
  },
  half: {
    mobile: 2,
    tablet: 4,
    laptop: 6,
    desktop: 6
  },
  quarter: {
    mobile: 1,
    tablet: 2,
    laptop: 3,
    desktop: 3
  }
};
function cssColumn$1(breakPoint, column) {
  return /*#__PURE__*/css(templateObject_1$1K || (templateObject_1$1K = __makeTemplateObject(["\n    ", "\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssColumn;")], ["\n    ", "\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssColumn;")])), MEDIA_QUERY.min(breakPoint, "\n      width: ".concat(100 / TOTAL_COLUMN[breakPoint] * (typeof column === 'number' ? column : COLUMN_PRESET[column][breakPoint]), "%;\n    ")));
}
function GridItem(_a) {
  var column = _a.column,
    className = _a.className,
    children = _a.children,
    rest = __rest(_a, ["column", "className", "children"]);
  var _b = _typeof(column) === 'object' ? column : COLUMN_PRESET[column],
    _c = _b.mobile,
    mobile = _c === void 0 ? 1 : _c,
    _d = _b.tablet,
    tablet = _d === void 0 ? mobile : _d,
    _e = _b.laptop,
    laptop = _e === void 0 ? tablet : _e,
    _f = _b.desktop,
    desktop = _f === void 0 ? laptop : _f;
  return jsx("div", _assign({}, rest, {
    css: [/*#__PURE__*/css(templateObject_2$1l || (templateObject_2$1l = __makeTemplateObject(["\n          display: inline-block;\n          vertical-align: top;\n          box-sizing: border-box;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          display: inline-block;\n          vertical-align: top;\n          box-sizing: border-box;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")]))), cssColumn$1('mobile', mobile), cssColumn$1('tablet', tablet), cssColumn$1('laptop', laptop), cssColumn$1('desktop', desktop)],
    className: spaces(className, GRID_ITEM_CLASS_NAME)
  }, {
    children: children
  }));
}
var templateObject_1$1K, templateObject_2$1l;

function cssColumn(column) {
  var ratios = column.split(' ').map(Number);
  var total = ratios.reduce(function (v1, v2) {
    return v1 + v2;
  });
  return "\n    > .".concat(COLUMN_CLASS_NAME, " {\n      ").concat(ratios.map(function (ratio, index) {
    return "\n        &:nth-of-type(".concat(ratios.length, "n + ").concat(index + 1, ") {\n          width: ").concat(100 / total * ratio, "%;\n        }\n      ");
  }), "\n    }\n  ");
}
function cssColumns(columns) {
  if (_typeof(columns) === 'object') {
    var mobile = columns.mobile,
      _a = columns.tablet,
      tablet = _a === void 0 ? mobile : _a,
      _b = columns.laptop,
      laptop = _b === void 0 ? tablet : _b;
    return /*#__PURE__*/css(templateObject_1$1J || (templateObject_1$1J = __makeTemplateObject(["\n      ", "\n      ", "\n      ", "\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:cssColumns;")], ["\n      ", "\n      ", "\n      ", "\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:cssColumns;")])), cssColumn(mobile), MEDIA_QUERY.min('tablet', cssColumn(tablet)), MEDIA_QUERY.min('laptop', cssColumn(laptop)));
  }
  return /*#__PURE__*/css(templateObject_2$1k || (templateObject_2$1k = __makeTemplateObject(["", "" + (process.env.NODE_ENV === "production" ? "" : ";label:cssColumns;")], ["", "" + (process.env.NODE_ENV === "production" ? "" : ";label:cssColumns;")])), cssColumn(columns));
}
function Row$1(_a) {
  var gap = _a.gap,
    columns = _a.columns,
    children = _a.children,
    rest = __rest(_a, ["gap", "columns", "children"]);
  return jsx("div", _assign({}, rest, {
    css: /*#__PURE__*/css(templateObject_3$19 || (templateObject_3$19 = __makeTemplateObject(["overflow: hidden;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["overflow: hidden;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
  }, {
    children: jsx("div", _assign({
      css: [gap && cssGap(gap, COLUMN_CLASS_NAME), cssColumns(columns)]
    }, {
      children: children
    }))
  }));
}
var templateObject_1$1J, templateObject_2$1k, templateObject_3$19;

function Column(_a) {
  var children = _a.children,
    className = _a.className,
    rest = __rest(_a, ["children", "className"]);
  return jsx("div", _assign({}, rest, {
    className: spaces(className, COLUMN_CLASS_NAME),
    css: /*#__PURE__*/css(templateObject_1$1I || (templateObject_1$1I = __makeTemplateObject(["\n        display: inline-block;\n        vertical-align: top;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        display: inline-block;\n        vertical-align: top;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
  }, {
    children: children
  }));
}
var templateObject_1$1I;

function getActiveIds(menuSchema, fallbackMenuSchema) {
  // Check for fallback menu schema first
  if (fallbackMenuSchema != null) {
    var index = fallbackMenuSchema.findIndex(function (item) {
      return item.active;
    });
    if (index !== -1) {
      return [null, index];
    }
  }
  // Try to descend down to the matching entry
  for (var i = 0; i < menuSchema.length; i += 1) {
    var child = menuSchema[i];
    var childActiveIds = getActiveIdsEntry(child);
    // If the child has 'active' entry, merge all indices
    if (childActiveIds != null) {
      return __spreadArray([i], childActiveIds, true);
    }
  }
  // Nothing matched
  return [null];
}
function getActiveIdsEntry(entry) {
  if (entry.entries != null) {
    for (var i = 0; i < entry.entries.length; i += 1) {
      var child = entry.entries[i];
      var childActiveIds = getActiveIdsEntry(child);
      // If the child has 'active' entry, merge all indices
      if (childActiveIds != null) {
        return __spreadArray([i], childActiveIds, true);
      }
    }
  }
  if (entry.active) {
    // If the entry itself is active, return itself
    return [];
  }
  // Otherwise, it didn't match
  return null;
}

var LinkContext = /*#__PURE__*/createContext('a');
var useLinkContext = function useLinkContext() {
  return useContext(LinkContext);
};
function LinkProvider(_a) {
  var children = _a.children,
    linkComponent = _a.linkComponent;
  return jsx(LinkContext.Provider, _assign({
    value: linkComponent
  }, {
    children: children
  }));
}

function Container$4(_a) {
  var children = _a.children,
    rest = __rest(_a, ["children"]);
  return jsx("div", _assign({}, rest, {
    css: /*#__PURE__*/css(templateObject_1$1H || (templateObject_1$1H = __makeTemplateObject(["\n        width: 100%;\n        padding: 0 ", ";\n        box-sizing: border-box;\n        ", "\n        ", "\n        ", "\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        width: 100%;\n        padding: 0 ", ";\n        box-sizing: border-box;\n        ", "\n        ", "\n        ", "\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(16), MEDIA_QUERY.min('tablet', "\n          padding: 0 ".concat(pxToRem(40), ";\n        ")), MEDIA_QUERY.min('laptop', "\n          padding: 0 ".concat(pxToRem(60), ";\n        ")), MEDIA_QUERY.min('desktop', "\n          max-width: ".concat(BREAK_POINT.desktop, "px;\n          margin: 0 auto;\n          padding: 0 ").concat(pxToRem(60), ";\n        ")))
  }, {
    children: children
  }));
}
var templateObject_1$1H;

var LogContext = /*#__PURE__*/createContext(function () {});
var useLogContext = function useLogContext() {
  return useContext(LogContext);
};
function LogProvider(_a) {
  var children = _a.children,
    onLog = _a.onLog;
  return jsx(LogContext.Provider, _assign({
    value: onLog
  }, {
    children: children
  }));
}

function useHover(onHover) {
  var onHoverRef = useRef(onHover);
  onHoverRef.current = onHover;
  var timeoutRef = useRef(null);
  var handleMouseTimeout = useCallback(function () {
    onHoverRef.current();
    timeoutRef.current = null;
  }, []);
  var handleMouseMove = useCallback(function () {
    if (timeoutRef.current != null) {
      window.clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = window.setTimeout(handleMouseTimeout, 50);
  }, [handleMouseTimeout]);
  var handleMouseEnter = useCallback(function () {
    window.addEventListener('mousemove', handleMouseMove);
    if (timeoutRef.current != null) {
      window.clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = window.setTimeout(handleMouseTimeout, 50);
  }, [handleMouseTimeout, handleMouseMove]);
  var handleMouseLeave = useCallback(function () {
    window.removeEventListener('mousemove', handleMouseMove);
    if (timeoutRef.current != null) {
      window.clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  }, [handleMouseMove]);
  useEffect(function () {
    return function () {
      window.removeEventListener('mousemove', handleMouseMove);
      if (timeoutRef.current != null) {
        window.clearTimeout(timeoutRef.current);
      }
    };
  }, [handleMouseMove]);
  return [handleMouseEnter, handleMouseLeave];
}

function NavigationBarPrimaryTabItem(props) {
  var _a = props.component,
    component = _a === void 0 ? 'button' : _a,
    index = props.index,
    isActive = props.isActive,
    isOpen = props.isOpen,
    children = props.children,
    onSelect = props.onSelect,
    forwardedRef = props.forwardedRef,
    onClick = props.onClick,
    rest = __rest(props, ["component", "index", "isActive", "isOpen", "children", "onSelect", "forwardedRef", "onClick"]);
  var theme = useTheme();
  var log = useLogContext();
  var handleClick = useCallback(function (e) {
    if (onClick) onClick(e);
    log({
      key: 'primary.item',
      category: 'click',
      params: {
        index: index
      }
    });
  }, [log, onClick, index]);
  var _b = useHover(onSelect),
    handleMouseEnter = _b[0],
    handleMouseLeave = _b[1];
  var Component = component;
  return jsx(Component, _assign({
    css: [/*#__PURE__*/css(templateObject_1$1G || (templateObject_1$1G = __makeTemplateObject(["\n          ", "\n          position: relative;\n          display: inline-block;\n          margin: 0 ", ";\n          padding: ", " ", " ", ";\n          font-size: ", ";\n          line-height: 1;\n          font-weight: bold;\n          color: ", ";\n          outline: none;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          ", "\n          position: relative;\n          display: inline-block;\n          margin: 0 ", ";\n          padding: ", " ", " ", ";\n          font-size: ", ";\n          line-height: 1;\n          font-weight: bold;\n          color: ", ";\n          outline: none;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), RESET_BUTTON, pxToRem(10), pxToRem(21), pxToRem(5), pxToRem(15), pxToRem(18), theme.content.base1), isActive && /*#__PURE__*/css(templateObject_2$1j || (templateObject_2$1j = __makeTemplateObject(["\n          color: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          color: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), theme.content.primary1.basic), isOpen && /*#__PURE__*/css(templateObject_3$18 || (templateObject_3$18 = __makeTemplateObject(["\n          color: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          color: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), theme.content.primary1.basic), HOVER(templateObject_4$Z || (templateObject_4$Z = __makeTemplateObject(["\n          color: ", ";\n        "], ["\n          color: ", ";\n        "])), theme.content.primary1.basic), FOCUS(templateObject_5$N || (templateObject_5$N = __makeTemplateObject(["\n          color: ", ";\n          & > span {\n            box-shadow: 0 0 0 ", " ", ";\n          }\n        "], ["\n          color: ", ";\n          & > span {\n            box-shadow: 0 0 0 ", " ", ";\n          }\n        "])), theme.content.primary1.basic, pxToRem(3), theme.interactive.primary1.thin)],
    ref: forwardedRef,
    onClick: handleClick,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, rest, {
    children: jsx("span", _assign({
      css: /*#__PURE__*/css(templateObject_6$F || (templateObject_6$F = __makeTemplateObject(["\n        display: inline-block;\n        margin: ", ";\n        padding: ", ";\n        border-radius: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        display: inline-block;\n        margin: ", ";\n        padding: ", ";\n        border-radius: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(-4), pxToRem(4), pxToRem(3))
    }, {
      children: children
    }))
  }));
}
var templateObject_1$1G, templateObject_2$1j, templateObject_3$18, templateObject_4$Z, templateObject_5$N, templateObject_6$F;

var INITIAL_NODE_HEIGHT$1 = 81;
function NavigationBarPrimary(props) {
  var leftmost = props.leftmost,
    left = props.left,
    right = props.right,
    menuEntries = props.menuEntries,
    activeId = props.activeId,
    selectedId = props.selectedId,
    onMouseEnter = props.onMouseEnter,
    onMouseLeave = props.onMouseLeave,
    _onSelect = props.onSelect;
  var LinkComponent = useLinkContext();
  var childRef = useRef(null);
  var isPc = useMedia("(min-width: ".concat(BREAK_POINT.tablet, "px)"), true);
  var nodeHeight = useNodeHeight(childRef, INITIAL_NODE_HEIGHT$1);
  var scrollDir = useScrollDirection();
  return jsx(StyledSticky$1, _assign({
    direction: "top",
    offset: !isPc && scrollDir === 'down' ? -nodeHeight : 0,
    offsetRange: isPc ? [0, 0] : [-nodeHeight, 0],
    type: "navigation",
    disableNativeSticky: true,
    disableBottom: true,
    zIndex: ZINDEX.appBar + 2,
    transition: 0.1,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    forwardRef: childRef
  }, {
    children: jsxs(StyledContainer$2, {
      children: [jsx(LeftMost, {
        children: leftmost
      }), jsx(Left, {
        children: left
      }), jsx(NavigationBarPrimaryTabList, {
        children: menuEntries.map(function (item, index) {
          return jsx(NavigationBarPrimaryTabItem, _assign({
            index: index,
            component: LinkComponent,
            href: item.href,
            isActive: activeId === index,
            isOpen: selectedId === index,
            onSelect: function onSelect() {
              return _onSelect(item, index);
            }
          }, {
            children: item.title
          }), index);
        })
      }), jsx(Right$1, {
        children: right
      })]
    })
  }));
}
var StyledSticky$1 = /*#__PURE__*/_styled(Sticky, process.env.NODE_ENV === "production" ? {
  target: "e1qjsy915"
} : {
  target: "e1qjsy915",
  label: "StyledSticky"
})(templateObject_1$1F || (templateObject_1$1F = __makeTemplateObject(["\n  background: ", ";\n  border-bottom: ", " solid ", ";\n"], ["\n  background: ", ";\n  border-bottom: ", " solid ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.background.base;
}, pxToRem(1), function (_a) {
  var theme = _a.theme;
  return theme.divider;
});
var StyledContainer$2 = /*#__PURE__*/_styled(Container$4, process.env.NODE_ENV === "production" ? {
  target: "e1qjsy914"
} : {
  target: "e1qjsy914",
  label: "StyledContainer"
})(templateObject_3$17 || (templateObject_3$17 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: ", ";\n  box-sizing: border-box;\n  line-height: 0;\n  ", "\n"], ["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: ", ";\n  box-sizing: border-box;\n  line-height: 0;\n  ", "\n"])), pxToRem(50), MEDIA_QUERY.min('tablet', /*#__PURE__*/css(templateObject_2$1i || (templateObject_2$1i = __makeTemplateObject(["\n    height: ", ";\n    padding-top: ", ";\n    padding-bottom: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:StyledContainer;")], ["\n    height: ", ";\n    padding-top: ", ";\n    padding-bottom: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:StyledContainer;")])), pxToRem(80), pxToRem(10), pxToRem(10))));
var LeftMost = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1qjsy913"
} : {
  target: "e1qjsy913",
  label: "LeftMost"
})(templateObject_5$M || (templateObject_5$M = __makeTemplateObject(["\n  flex: 0 0 auto;\n  display: block;\n  margin-left: ", ";\n  ", "\n  "], ["\n  flex: 0 0 auto;\n  display: block;\n  margin-left: ", ";\n  ", "\n  "])), pxToRem(-7), MEDIA_QUERY.min('tablet', /*#__PURE__*/css(templateObject_4$Y || (templateObject_4$Y = __makeTemplateObject(["\n  display: none;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:LeftMost;")], ["\n  display: none;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:LeftMost;")])))));
var Left = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1qjsy912"
} : {
  target: "e1qjsy912",
  label: "Left"
})(templateObject_8$o || (templateObject_8$o = __makeTemplateObject(["\n  position: absolute;\n  flex: 0 0 auto;\n  left: 50%;\n  top: 50%;\n  color: ", ";\n  transform: translate(-50%, -50%);\n  ", "\n  ", "\n"], ["\n  position: absolute;\n  flex: 0 0 auto;\n  left: 50%;\n  top: 50%;\n  color: ", ";\n  transform: translate(-50%, -50%);\n  ", "\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return theme.interactive.base1;
}, MEDIA_QUERY.min('tablet', /*#__PURE__*/css(templateObject_6$E || (templateObject_6$E = __makeTemplateObject(["\n    position: static;\n    margin-right: ", ";\n    left: none;\n    top: none;\n    transform: none;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:Left;")], ["\n    position: static;\n    margin-right: ", ";\n    left: none;\n    top: none;\n    transform: none;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:Left;")])), pxToRem(20))), MEDIA_QUERY.min('laptop', /*#__PURE__*/css(templateObject_7$v || (templateObject_7$v = __makeTemplateObject(["\n    margin-right: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:Left;")], ["\n    margin-right: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:Left;")])), pxToRem(35))));
var NavigationBarPrimaryTabList = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1qjsy911"
} : {
  target: "e1qjsy911",
  label: "NavigationBarPrimaryTabList"
})(templateObject_10$f || (templateObject_10$f = __makeTemplateObject(["\n  flex: 1 1 0px;\n  display: none;\n  white-space: nowrap;\n  ", "\n  "], ["\n  flex: 1 1 0px;\n  display: none;\n  white-space: nowrap;\n  ", "\n  "])), MEDIA_QUERY.min('tablet', /*#__PURE__*/css(templateObject_9$h || (templateObject_9$h = __makeTemplateObject(["\n  display: block;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationBarPrimaryTabList;")], ["\n  display: block;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationBarPrimaryTabList;")])))));
var Right$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1qjsy910"
} : {
  target: "e1qjsy910",
  label: "Right"
})(templateObject_14$3 || (templateObject_14$3 = __makeTemplateObject(["\n  flex: 0 0 auto;\n  ", "\n  ", "\n  ", "\n"], ["\n  flex: 0 0 auto;\n  ", "\n  ", "\n  ", "\n"])), MEDIA_QUERY.min('tablet', /*#__PURE__*/css(templateObject_11$9 || (templateObject_11$9 = __makeTemplateObject(["\n    flex: 0 1 ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:Right;")], ["\n    flex: 0 1 ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:Right;")])), pxToRem(476))), MEDIA_QUERY.min('desktop', /*#__PURE__*/css(templateObject_12$6 || (templateObject_12$6 = __makeTemplateObject(["\n    flex: 0 1 ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:Right;")], ["\n    flex: 0 1 ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:Right;")])), pxToRem(650))), MEDIA_QUERY.max('mobile', /*#__PURE__*/css(templateObject_13$6 || (templateObject_13$6 = __makeTemplateObject(["\n    margin-right: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:Right;")], ["\n    margin-right: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:Right;")])), pxToRem(-7))));
var templateObject_1$1F, templateObject_2$1i, templateObject_3$17, templateObject_4$Y, templateObject_5$M, templateObject_6$E, templateObject_7$v, templateObject_8$o, templateObject_9$h, templateObject_10$f, templateObject_11$9, templateObject_12$6, templateObject_13$6, templateObject_14$3;

var FixedTab = /*#__PURE__*/forwardRef(function (_a, ref) {
  var rest = __rest(_a, []);
  return jsx("nav", _assign({}, rest, {
    ref: ref,
    css: /*#__PURE__*/css(templateObject_1$1E || (templateObject_1$1E = __makeTemplateObject(["\n          display: flex;\n          align-items: stretch;\n          overflow-x: auto;\n          white-space: nowrap;\n          && > * {\n            flex: 1 0 0px;\n            min-width: 0;\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          display: flex;\n          align-items: stretch;\n          overflow-x: auto;\n          white-space: nowrap;\n          && > * {\n            flex: 1 0 0px;\n            min-width: 0;\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
  }));
});
var templateObject_1$1E;

var Tab = /*#__PURE__*/forwardRef(function (_a, ref) {
  var rest = __rest(_a, []);
  return jsx("nav", _assign({}, rest, {
    ref: ref,
    css: /*#__PURE__*/css(templateObject_1$1D || (templateObject_1$1D = __makeTemplateObject(["\n          display: flex;\n          align-items: stretch;\n          overflow-x: auto;\n          white-space: nowrap;\n          margin: 0 -5px;\n          && > * {\n            margin: 0 5px;\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          display: flex;\n          align-items: stretch;\n          overflow-x: auto;\n          white-space: nowrap;\n          margin: 0 -5px;\n          && > * {\n            margin: 0 5px;\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
  }));
});
var templateObject_1$1D;

var _path$1, _path2$1;
function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
var SvgIcNew18 = function SvgIcNew18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 9a9 9 0 1 1 18 0A9 9 0 0 1 0 9"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/React.createElement("path", {
    fill: "#F77",
    fillRule: "evenodd",
    d: "M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18m-1.7-5.25H5.26v-7.5h2.61l2.8 4.2h.03v-4.2h2.06v7.5h-2.3l-3.1-4.68h-.05v4.68z",
    clipRule: "evenodd"
  })));
};
var NewIcon = SvgIcNew18;

/**
 * @deprecated ODS의 DotBadge 컴포넌트를 사용해 주세요.
 */
function DotNotification(props) {
  var theme = useTheme();
  return jsx("span", _assign({}, props, {
    css: /*#__PURE__*/css(templateObject_1$1C || (templateObject_1$1C = __makeTemplateObject(["\n        position: absolute;\n        border-radius: 50%;\n        width: ", ";\n        height: ", ";\n        background-color: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        position: absolute;\n        border-radius: 50%;\n        width: ", ";\n        height: ", ";\n        background-color: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(4), pxToRem(4), theme.content.primary2.basic)
  }));
}
var templateObject_1$1C;

function TabItem(_a) {
  var _b = _a.component,
    component = _b === void 0 ? 'button' : _b,
    isActive = _a.isActive,
    children = _a.children,
    subText = _a.subText,
    bullet = _a.bullet,
    forwardedRef = _a.forwardedRef,
    _onClick = _a.onClick,
    badge = _a.badge,
    className = _a.className,
    rest = __rest(_a, ["component", "isActive", "children", "subText", "bullet", "forwardedRef", "onClick", "badge", "className"]);
  var theme = useTheme();
  var Component = component;
  return jsx(Component, _assign({
    className: className,
    css: [/*#__PURE__*/css(templateObject_1$1B || (templateObject_1$1B = __makeTemplateObject(["\n          ", "\n          position: relative;\n          display: inline-flex;\n          flex-direction: column;\n          justify-content: center;\n          vertical-align: top;\n          text-align: center;\n          box-sizing: border-box;\n          &:after {\n            content: '';\n            display: block;\n            position: absolute;\n            left: 0;\n            bottom: 0;\n            width: 100%;\n            height: ", ";\n            background-color: ", ";\n            transition: transform 0.2s;\n            transform: scale(", ");\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          ", "\n          position: relative;\n          display: inline-flex;\n          flex-direction: column;\n          justify-content: center;\n          vertical-align: top;\n          text-align: center;\n          box-sizing: border-box;\n          &:after {\n            content: '';\n            display: block;\n            position: absolute;\n            left: 0;\n            bottom: 0;\n            width: 100%;\n            height: ", ";\n            background-color: ", ";\n            transition: transform 0.2s;\n            transform: scale(", ");\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), RESET_BUTTON, pxToRem(2), theme.content.primary1.basic, isActive ? 1 : 0), HOVER(templateObject_2$1h || (templateObject_2$1h = __makeTemplateObject(["\n          & > div > p:first-of-type {\n            color: ", ";\n          }\n        "], ["\n          & > div > p:first-of-type {\n            color: ", ";\n          }\n        "])), theme.content.primary1.basic), FOCUS(templateObject_3$16 || (templateObject_3$16 = __makeTemplateObject(["\n          & > div {\n            box-shadow: 0 0 0 3px ", ";\n            border-radius: 3px;\n          }\n        "], ["\n          & > div {\n            box-shadow: 0 0 0 3px ", ";\n            border-radius: 3px;\n          }\n        "])), theme.content.primary1.basic), subText ? /*#__PURE__*/css(templateObject_4$X || (templateObject_4$X = __makeTemplateObject(["\n            padding: ", " ", " ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            padding: ", " ", " ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(11), pxToRem(6), pxToRem(5)) : /*#__PURE__*/css(templateObject_5$L || (templateObject_5$L = __makeTemplateObject(["\n            padding: ", " ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            padding: ", " ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(12), pxToRem(6))],
    ref: forwardedRef,
    onClick: function onClick() {
      if (_onClick) {
        _onClick();
      }
    }
  }, rest, {
    children: jsxs("div", _assign({
      css: /*#__PURE__*/css(templateObject_6$D || (templateObject_6$D = __makeTemplateObject(["\n          padding: ", ";\n          margin: -", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          padding: ", ";\n          margin: -", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(4), pxToRem(4))
    }, {
      children: [jsxs("p", _assign({
        css: [FONT_STYLE.subTitle1, /*#__PURE__*/css(templateObject_7$u || (templateObject_7$u = __makeTemplateObject(["\n              position: relative;\n              font-weight: ", ";\n              color: ", ";\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              position: relative;\n              font-weight: ", ";\n              color: ", ";\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), isActive ? 700 : 500, isActive ? theme.content.primary1.basic : theme.content.base1)]
      }, {
        children: [children, badge && jsx(SquareBadge, _assign({
          size: 16,
          type: badge.type,
          variant: badge.variant,
          css: /*#__PURE__*/css(templateObject_8$n || (templateObject_8$n = __makeTemplateObject(["\n                vertical-align: middle;\n                margin-left: ", ";\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                vertical-align: middle;\n                margin-left: ", ";\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(3))
        }, {
          children: badge.text
        })), bullet === 'dot' && jsx(DotNotification, {
          css: /*#__PURE__*/css(templateObject_9$g || (templateObject_9$g = __makeTemplateObject(["\n                top: 0;\n                right: ", ";\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                top: 0;\n                right: ", ";\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(-6))
        }), bullet === 'new' && jsx(NewIcon, {
          css: /*#__PURE__*/css(templateObject_10$e || (templateObject_10$e = __makeTemplateObject(["\n                vertical-align: middle;\n                margin: 0 ", " ", " ", ";\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                vertical-align: middle;\n                margin: 0 ", " ", " ", ";\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(1.5), pxToRem(1.5), pxToRem(1.5))
        })]
      })), subText && jsx("p", _assign({
        css: [FONT_STYLE.caption2, /*#__PURE__*/css(templateObject_11$8 || (templateObject_11$8 = __makeTemplateObject(["\n                color: ", ";\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                color: ", ";\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), theme.content.base2)]
      }, {
        children: subText
      }))]
    }))
  }));
}
var templateObject_1$1B, templateObject_2$1h, templateObject_3$16, templateObject_4$X, templateObject_5$L, templateObject_6$D, templateObject_7$u, templateObject_8$n, templateObject_9$g, templateObject_10$e, templateObject_11$8;

var useNavigationLog = function useNavigationLog() {
  var log = useLogContext();
  var logTabImpression = useCallback(function (menu, index) {
    log({
      key: 'secondary.item',
      category: 'impression',
      params: {
        index: index,
        id: menu.logId,
        type: 'topic',
        section: '서브 메뉴',
        section_id: 'LNB'
      }
    });
  }, [log]);
  var logTabClick = useCallback(function (menu, index, isHncTopicTab) {
    var _a;
    var defaultParams = {
      index: index,
      section: '서브 메뉴',
      type: 'tab',
      id: (_a = menu.logId) !== null && _a !== void 0 ? _a : menu.title
    };
    var params = isHncTopicTab ? _assign(_assign({}, defaultParams), {
      type: 'topic',
      section_id: 'LNB'
    }) : defaultParams;
    log({
      key: 'secondary.item',
      category: 'click',
      params: params
    });
  }, [log]);
  var logMoreButtonClick = useCallback(function () {
    log({
      key: 'secondary.more.button',
      category: 'click'
    });
  }, [log]);
  return {
    logTabClick: logTabClick,
    logTabImpression: logTabImpression,
    logMoreButtonClick: logMoreButtonClick
  };
};

function PopperContent(_a) {
  var referenceRef = _a.referenceRef,
    isOpen = _a.isOpen,
    onClose = _a.onClose,
    onExited = _a.onExited,
    children = _a.children,
    _b = _a.placement,
    placement = _b === void 0 ? 'bottom' : _b,
    size = _a.size,
    className = _a.className,
    style = _a.style;
  var theme = useTheme();
  var _c = useState(null),
    popperRef = _c[0],
    setPopperRef = _c[1];
  var _d = usePopper(referenceRef, popperRef, {
      placement: placement,
      modifiers: [{
        name: 'offset',
        enabled: true,
        options: {
          offset: [0, 10]
        }
      }]
    }),
    styles = _d.styles,
    attributes = _d.attributes,
    state = _d.state;
  useEffect(function () {
    var handleClick = function handleClick(e) {
      var target = e.target;
      // Chrome regression
      if (e.target === document.body) return;
      if (e.defaultPrevented || target == null || target.parentElement == null) {
        return;
      }
      // If the user clicked somewhere else, close the popper
      while (target != null) {
        if (referenceRef === target || popperRef === target || target instanceof HTMLElement && target.hasAttribute('data-popout')) {
          return;
        }
        target = target.parentElement;
      }
      onClose();
    };
    window.addEventListener('click', handleClick);
    return function () {
      window.removeEventListener('click', handleClick);
    };
  }, [onClose, referenceRef, popperRef]);
  return jsx(CSSTransition
  // NOTE: This is a quirky workaround happening due to 'setPopperRef' -
  // which will confuse CSSTransition.
  // In order to workaround this, the timeout is set to 0 until the user
  // decides to close the popper.
  // https://github.com/reactjs/react-transition-group/issues/284
  , _assign({
    // NOTE: This is a quirky workaround happening due to 'setPopperRef' -
    // which will confuse CSSTransition.
    // In order to workaround this, the timeout is set to 0 until the user
    // decides to close the popper.
    // https://github.com/reactjs/react-transition-group/issues/284
    "in": popperRef != null && isOpen,
    timeout: isOpen ? 0 : 200,
    classNames: {
      enterActive: 'open',
      enterDone: 'open open-active',
      appearActive: 'open',
      exitActive: 'exiting',
      exit: 'exiting',
      exitDone: 'exiting'
    },
    onExited: onExited
  }, {
    children: jsx("div", _assign({
      ref: setPopperRef,
      style: _assign(_assign({}, styles.popper), style)
    }, attributes.popper, {
      className: classNames("placement-".concat((state || {}).placement), className),
      css: /*#__PURE__*/css(templateObject_1$1A || (templateObject_1$1A = __makeTemplateObject(["\n          opacity: 1;\n          visibility: visible;\n          pointer-events: none;\n          z-index: ", ";\n\n          &.placement-top .popper-item {\n            transform: translate(0, 10px);\n          }\n\n          &.placement-bottom .popper-item {\n            transform: translate(0, -10px);\n          }\n\n          &.open {\n            transform: none;\n            transition: .2s opacity;\n          }\n\n          &.open .popper-item {\n            transform: none;\n            transition: .2s transform;\n          }\n\n          &.open-active {\n            pointer-events: auto;\n            transition: .2s opacity;\n          }\n\n          &.exiting {\n            opacity: 0;\n            visibility: hidden;\n            transition: 0s visibility .2s, .2s opacity;\n          }\n\n          &.exiting .popper-item {\n            transition: .2s transform;\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          opacity: 1;\n          visibility: visible;\n          pointer-events: none;\n          z-index: ", ";\n\n          &.placement-top .popper-item {\n            transform: translate(0, 10px);\n          }\n\n          &.placement-bottom .popper-item {\n            transform: translate(0, -10px);\n          }\n\n          &.open {\n            transform: none;\n            transition: .2s opacity;\n          }\n\n          &.open .popper-item {\n            transform: none;\n            transition: .2s transform;\n          }\n\n          &.open-active {\n            pointer-events: auto;\n            transition: .2s opacity;\n          }\n\n          &.exiting {\n            opacity: 0;\n            visibility: hidden;\n            transition: 0s visibility .2s, .2s opacity;\n          }\n\n          &.exiting .popper-item {\n            transition: .2s transform;\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), ZINDEX.dropdown)
    }, {
      children: jsx("div", _assign({
        className: "popper-item",
        style: styles.offset,
        css: /*#__PURE__*/css(templateObject_2$1g || (templateObject_2$1g = __makeTemplateObject(["\n            position: relative;\n            padding: 8px;\n            background-color: ", ";\n            border: 1px solid ", ";\n            border-radius: 6px;\n            box-shadow: 0 4px 10px 0 rgb(63, 71, 77, 0.2);\n            width: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            position: relative;\n            padding: 8px;\n            background-color: ", ";\n            border: 1px solid ", ";\n            border-radius: 6px;\n            box-shadow: 0 4px 10px 0 rgb(63, 71, 77, 0.2);\n            width: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), theme.background.base, theme.interactive.base4, size ? pxToRem(size) : undefined)
      }, {
        children: children
      }))
    }))
  }));
}
function Popper(_a) {
  var renderButton = _a.renderButton,
    onChange = _a.onChange,
    _b = _a.usePortal,
    usePortal = _b === void 0 ? true : _b,
    _c = _a.isForceClosed,
    isForceClosed = _c === void 0 ? false : _c,
    children = _a.children,
    other = __rest(_a, ["renderButton", "onChange", "usePortal", "isForceClosed", "children"]);
  var _d = useState({
      isVisible: false,
      isOpen: false
    }),
    state = _d[0],
    setState = _d[1];
  var referenceRef = useRef(null);
  var handleClose = useCallback(function () {
    setState(function (v) {
      return _assign(_assign({}, v), {
        isOpen: false
      });
    });
  }, []);
  var handleExited = useCallback(function () {
    setState({
      isVisible: false,
      isOpen: false
    });
  }, []);
  var handleToggle = useCallback(function () {
    setState(function (v) {
      return {
        isOpen: !v.isOpen,
        // If the node is visible, keep it visible. But if we need to reveal it,
        // make it visible
        isVisible: v.isVisible || !v.isOpen
      };
    });
  }, []);
  useEffect(function () {
    onChange === null || onChange === void 0 ? void 0 : onChange(state.isOpen);
  }, [state.isOpen, onChange]);
  useEffect(function () {
    if (isForceClosed) {
      handleClose();
    }
  }, [isForceClosed, handleClose]);
  return jsxs(Fragment$1, {
    children: [jsx("span", _assign({
      ref: referenceRef,
      css: /*#__PURE__*/css(templateObject_3$15 || (templateObject_3$15 = __makeTemplateObject(["line-height: 0;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["line-height: 0;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
    }, {
      children: renderButton({
        onClick: handleToggle,
        isOpen: state.isOpen
      })
    })), state.isVisible && usePortal && jsx(OverlayPortal, {
      children: jsx(PopperContent, _assign({
        referenceRef: referenceRef.current,
        isOpen: state.isOpen,
        onClose: handleClose,
        onExited: handleExited
      }, other, {
        children: children
      }))
    }), state.isVisible && !usePortal && jsx(PopperContent, _assign({
      referenceRef: referenceRef.current,
      isOpen: state.isOpen,
      onClose: handleClose,
      onExited: handleExited
    }, other, {
      children: children
    }))]
  });
}
var templateObject_1$1A, templateObject_2$1g, templateObject_3$15;

var Dim = /*#__PURE__*/forwardRef(function (props, ref) {
  var onDark = props.onDark,
    variant = props.variant,
    children = props.children,
    rest = __rest(props, ["onDark", "variant", "children"]);
  var theme = useTheme();
  return jsx("div", _assign({
    "data-testid": "bds-dim"
  }, rest, {
    ref: ref,
    css: [/*#__PURE__*/css(templateObject_1$1z || (templateObject_1$1z = __makeTemplateObject(["\n          position: fixed;\n          top: 0;\n          left: 0;\n          width: 100%;\n          height: 100%;\n          text-align: center;\n          z-index: ", ";\n          &::before {\n            content: \"\";\n            height: 100%;\n            display: inline-block;\n            vertical-align: middle;\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          position: fixed;\n          top: 0;\n          left: 0;\n          width: 100%;\n          height: 100%;\n          text-align: center;\n          z-index: ", ";\n          &::before {\n            content: \"\";\n            height: 100%;\n            display: inline-block;\n            vertical-align: middle;\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), ZINDEX.modal), variant && /*#__PURE__*/css(templateObject_2$1f || (templateObject_2$1f = __makeTemplateObject(["\n          background-color: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          background-color: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), (onDark ? theme.dim.onDark : theme.dim)[variant])]
  }, {
    children: children
  }));
});
var templateObject_1$1z, templateObject_2$1f;

var GAP$1 = 10;
var ICON_SIZE$3 = 24;
function ModalHeader(_a) {
  var title = _a.title,
    onBack = _a.onBack,
    onClose = _a.onClose;
  var theme = useTheme();
  return jsxs("div", _assign({
    css: /*#__PURE__*/css(templateObject_1$1y || (templateObject_1$1y = __makeTemplateObject(["\n        padding: ", " ", " ", " ", ";\n        line-height: 0;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        padding: ", " ", " ", " ", ";\n        line-height: 0;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(16), pxToRem(16), pxToRem(10), pxToRem(16))
  }, {
    children: [onBack && jsx("button", _assign({
      type: "button",
      onClick: onBack,
      css: /*#__PURE__*/css(templateObject_2$1e || (templateObject_2$1e = __makeTemplateObject(["\n            ", "\n            vertical-align: middle;\n            width: ", ";\n            height: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            ", "\n            vertical-align: middle;\n            width: ", ";\n            height: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), RESET_BUTTON, pxToRem(ICON_SIZE$3), pxToRem(ICON_SIZE$3))
    }, {
      children: jsx(Icon, {
        size: ICON_SIZE$3,
        name: "arrow_left",
        css: /*#__PURE__*/css(templateObject_3$14 || (templateObject_3$14 = __makeTemplateObject(["\n              color: ", ";\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              color: ", ";\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), theme.content.base1)
      })
    })), jsx("span", _assign({
      css: [FONT_STYLE.title2, /*#__PURE__*/css(templateObject_4$W || (templateObject_4$W = __makeTemplateObject(["\n            display: inline-block;\n            vertical-align: middle;\n            font-weight: 700;\n            text-align: center;\n            width: calc(100% - ", ");\n            margin-left: ", ";\n            margin-right: ", ";\n            white-space: pre-line;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            display: inline-block;\n            vertical-align: middle;\n            font-weight: 700;\n            text-align: center;\n            width: calc(100% - ", ");\n            margin-left: ", ";\n            margin-right: ", ";\n            white-space: pre-line;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem((GAP$1 + ICON_SIZE$3) * 2), pxToRem(onBack ? GAP$1 : ICON_SIZE$3), pxToRem(onClose ? GAP$1 : ICON_SIZE$3))]
    }, {
      children: title
    })), onClose && jsx("button", _assign({
      type: "button",
      onClick: onClose,
      css: /*#__PURE__*/css(templateObject_5$K || (templateObject_5$K = __makeTemplateObject(["\n            ", "\n            vertical-align: middle;\n            width: ", ";\n            height: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            ", "\n            vertical-align: middle;\n            width: ", ";\n            height: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), RESET_BUTTON, pxToRem(ICON_SIZE$3), pxToRem(ICON_SIZE$3))
    }, {
      children: jsx(Icon, {
        size: ICON_SIZE$3,
        name: "dismiss",
        css: /*#__PURE__*/css(templateObject_6$C || (templateObject_6$C = __makeTemplateObject(["\n              color: ", ";\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              color: ", ";\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), theme.content.base1)
      })
    }))]
  }));
}
var templateObject_1$1y, templateObject_2$1e, templateObject_3$14, templateObject_4$W, templateObject_5$K, templateObject_6$C;

function ModalFooter(_a) {
  var _b, _c, _d;
  var action = _a.action,
    subAction = _a.subAction,
    style = _a.style;
  return jsxs("div", _assign({
    css: [style, /*#__PURE__*/css(templateObject_1$1x || (templateObject_1$1x = __makeTemplateObject(["\n          padding: ", " ", ";\n          line-height: 0;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          padding: ", " ", ";\n          line-height: 0;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(9), pxToRem(16))]
  }, {
    children: [action && jsxs("div", _assign({
      css: /*#__PURE__*/css(templateObject_2$1d || (templateObject_2$1d = __makeTemplateObject(["\n            padding-top: ", ";\n            padding-bottom: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            padding-top: ", ";\n            padding-bottom: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(1), pxToRem(subAction ? 9 : 7))
    }, {
      children: [action.secondary && (!Array.isArray(action.secondary) ? jsx(OutlineButton, _assign({
        size: 50,
        variant: "base1",
        onClick: action.secondary.onClick,
        disabled: (_b = action.secondary.disabled) !== null && _b !== void 0 ? _b : false,
        css: /*#__PURE__*/css(templateObject_3$13 || (templateObject_3$13 = __makeTemplateObject(["\n                  width: calc(50% - ", ");\n                  margin-right: ", ";\n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                  width: calc(50% - ", ");\n                  margin-right: ", ";\n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(5), pxToRem(10))
      }, {
        children: action.secondary.text
      })) : jsx(Fragment$1, {
        children: action.secondary.map(function (secondaryAction, index) {
          var _a;
          return jsx(OutlineButton, _assign({
            size: 50,
            variant: "base1",
            onClick: secondaryAction.onClick,
            disabled: (_a = secondaryAction.disabled) !== null && _a !== void 0 ? _a : false,
            css: [/*#__PURE__*/css(templateObject_4$V || (templateObject_4$V = __makeTemplateObject(["\n                        width: calc(50% - ", ");\n                      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                        width: calc(50% - ", ");\n                      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(5)), index === 0 && /*#__PURE__*/css(templateObject_5$J || (templateObject_5$J = __makeTemplateObject(["\n                        margin-right: ", ";\n                      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                        margin-right: ", ";\n                      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(10))]
          }, {
            children: secondaryAction.text
          }), index);
        })
      })), action.primary && jsx(Button$2, _assign({
        size: 50,
        variant: "primary1",
        onClick: action.primary.onClick,
        disabled: (_c = action.primary.disabled) !== null && _c !== void 0 ? _c : false,
        css: action.secondary ? /*#__PURE__*/css(templateObject_6$B || (templateObject_6$B = __makeTemplateObject(["\n                    width: calc(50% - ", ");\n                  " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                    width: calc(50% - ", ");\n                  " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(5)) : /*#__PURE__*/css(templateObject_7$t || (templateObject_7$t = __makeTemplateObject(["\n                    width: 100%;\n                  " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                    width: 100%;\n                  " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
      }, {
        children: action.primary.text
      }))]
    })), subAction && jsx(TextButton, _assign({
      size: 32,
      variant: "base1",
      onClick: subAction.onClick,
      disabled: (_d = subAction.disabled) !== null && _d !== void 0 ? _d : false
    }, {
      children: subAction.text
    }))]
  }));
}
var templateObject_1$1x, templateObject_2$1d, templateObject_3$13, templateObject_4$V, templateObject_5$J, templateObject_6$B, templateObject_7$t;

var LAPTOP_HEIGHT = {
  300: '48%',
  400: '78%',
  500: '84%',
  600: '90%',
  700: '96%',
  1200: '96%'
};
var MARGIN = {
  300: '0',
  400: '0',
  500: '0',
  600: '0',
  700: '0',
  1200: "0 ".concat(pxToRem(80))
};
function Modal(_a) {
  var width = _a.width,
    onBlur = _a.onBlur,
    header = _a.header,
    footer = _a.footer,
    _b = _a.isPopupInMobile,
    isPopupInMobile = _b === void 0 ? false : _b,
    _c = _a.isStretch,
    isStretch = _c === void 0 ? false : _c,
    stretch = _a.stretch,
    children = _a.children,
    _d = _a.hasInteraction,
    hasInteraction = _d === void 0 ? false : _d,
    _e = _a.height,
    height = _e === void 0 ? '' : _e,
    _f = _a.hasGrabber,
    hasGrabber = _f === void 0 ? false : _f,
    _g = _a.disableBackgroundScroll,
    disableBackgroundScroll = _g === void 0 ? false : _g,
    rest = __rest(_a, ["width", "onBlur", "header", "footer", "isPopupInMobile", "isStretch", "stretch", "children", "hasInteraction", "height", "hasGrabber", "disableBackgroundScroll"]);
  var theme = useTheme();
  var isMobile = useResponsive().breakpoint === 'mobile';
  var scrollAvailableRef = useRef(null);
  var modalRef = useRef(null);
  var grabberRef = useRef(null);
  var _h = useState(height),
    customHeight = _h[0],
    setCustomHeight = _h[1];
  var isPopup = isPopupInMobile && width === 300;
  useEffect(function () {
    if (height !== 'auto') {
      setCustomHeight(height);
      return;
    }
    if (!modalRef.current || hasGrabber && !grabberRef.current) return;
    setCustomHeight("".concat(modalRef.current.getBoundingClientRect().height, "px"));
  }, [height, hasGrabber, isMobile]);
  useEffect(function () {
    if (!disableBackgroundScroll) return;
    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    return function () {
      document.getElementsByTagName('body')[0].style.overflow = 'auto';
    };
  }, [disableBackgroundScroll]);
  return jsx(OverlayPortal, {
    children: jsx(Dim, _assign({}, rest, {
      ref: scrollAvailableRef,
      variant: "basic",
      onClick: onBlur,
      css: /*#__PURE__*/css(templateObject_2$1c || (templateObject_2$1c = __makeTemplateObject(["\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          ", " \n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          ", " \n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), !isPopup && MEDIA_QUERY.max('mobile', /*#__PURE__*/css(templateObject_1$1w || (templateObject_1$1w = __makeTemplateObject(["\n            align-items: flex-end;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            align-items: flex-end;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))))
    }, {
      children: jsxs("div", _assign({
        ref: modalRef,
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        css: /*#__PURE__*/css(templateObject_4$U || (templateObject_4$U = __makeTemplateObject(["\n            ", "\n            vertical-align: middle;\n            border-radius: ", ";\n            display: inline-flex;\n            flex-direction: column;\n            color: ", ";\n            background-color: ", ";\n            max-width: ", ";\n            width: 100%;\n\n            ", "\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            ", "\n            vertical-align: middle;\n            border-radius: ", ";\n            display: inline-flex;\n            flex-direction: column;\n            color: ", ";\n            background-color: ", ";\n            max-width: ", ";\n            width: 100%;\n\n            ", "\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), createSizeStyle({
          width: width,
          customHeight: customHeight,
          hasInteraction: hasInteraction,
          stretch: stretch !== null && stretch !== void 0 ? stretch : isStretch,
          isPopup: isPopup
        }), pxToRem(8), theme.content.base1, theme.background.elevated, pxToRem(width), !isPopup && MEDIA_QUERY.max('mobile', /*#__PURE__*/css(templateObject_3$12 || (templateObject_3$12 = __makeTemplateObject(["\n              max-width: none;\n              ", "\n              vertical-align: bottom;\n              border-bottom-left-radius: initial;\n              border-bottom-right-radius: initial;\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              max-width: none;\n              ", "\n              vertical-align: bottom;\n              border-bottom-left-radius: initial;\n              border-bottom-right-radius: initial;\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), safeAreaInset('bottom', 'padding-bottom'))))
      }, {
        children: [isMobile && hasGrabber && jsx(Grabber, {
          ref: grabberRef
        }), header && jsx(ModalHeader, _assign({}, header)), jsx("div", _assign({
          css: [FONT_STYLE.body1_1, /*#__PURE__*/css(templateObject_5$I || (templateObject_5$I = __makeTemplateObject(["\n                display: flex;\n                flex-direction: column;\n                width: 100%;\n                height: 100%;\n                word-break: break-all;\n                overflow-y: auto;\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                display: flex;\n                flex-direction: column;\n                width: 100%;\n                height: 100%;\n                word-break: break-all;\n                overflow-y: auto;\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")]))), !footer && /*#__PURE__*/css(templateObject_6$A || (templateObject_6$A = __makeTemplateObject(["padding-bottom: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["padding-bottom: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(9))]
        }, {
          children: children
        })), footer && jsx(ModalFooter, _assign({}, footer))]
      }))
    }))
  });
}
/**
 * 모달 사이즈 스타일을 생성합니다.
 */
function createSizeStyle(_a) {
  var width = _a.width,
    customHeight = _a.customHeight,
    hasInteraction = _a.hasInteraction,
    stretch = _a.stretch,
    isPopup = _a.isPopup;
  var height = LAPTOP_HEIGHT[width];
  var margin = MARGIN[width];
  var interactionCSS = /*#__PURE__*/css(templateObject_7$s || (templateObject_7$s = __makeTemplateObject(["\n    height: ", ";\n    transition: height 0.3s;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:interactionCSS;")], ["\n    height: ", ";\n    transition: height 0.3s;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:interactionCSS;")])), customHeight);
  if (stretch) {
    return createStretchStyle({
      stretch: stretch
    });
  }
  return /*#__PURE__*/css(templateObject_9$f || (templateObject_9$f = __makeTemplateObject(["\n    max-height: ", ";\n    margin: ", ";\n\n    ", "\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:createSizeStyle;")], ["\n    max-height: ", ";\n    margin: ", ";\n\n    ", "\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:createSizeStyle;")])), height, margin, !isPopup && MEDIA_QUERY.max('mobile', /*#__PURE__*/css(templateObject_8$m || (templateObject_8$m = __makeTemplateObject(["\n      max-height: 90%;\n      margin: 0;\n      ", "\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:createSizeStyle;")], ["\n      max-height: 90%;\n      margin: 0;\n      ", "\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:createSizeStyle;")])), hasInteraction && interactionCSS)));
}
function createStretchStyle(_a) {
  var stretch = _a.stretch;
  if (stretch === true) {
    return /*#__PURE__*/css(templateObject_11$7 || (templateObject_11$7 = __makeTemplateObject(["\n      height: 100%;\n\n      ", "\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:createStretchStyle;")], ["\n      height: 100%;\n\n      ", "\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:createStretchStyle;")])), MEDIA_QUERY.max('mobile', /*#__PURE__*/css(templateObject_10$d || (templateObject_10$d = __makeTemplateObject(["\n        height: 90%;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:createStretchStyle;")], ["\n        height: 90%;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:createStretchStyle;")])))));
  }
  if (_typeof(stretch) === 'object') {
    var mobile = stretch.mobile,
      tablet = stretch.tablet,
      laptop = stretch.laptop,
      desktop = stretch.desktop;
    return /*#__PURE__*/css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n      ", "\n      ", "\n      ", "\n      ", "\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:createStretchStyle;")], ["\n      ", "\n      ", "\n      ", "\n      ", "\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:createStretchStyle;")])), mobile && MEDIA_QUERY.min('mobile', /*#__PURE__*/css(templateObject_12$5 || (templateObject_12$5 = __makeTemplateObject(["height: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:createStretchStyle;")], ["height: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:createStretchStyle;")])), mobile)), tablet && MEDIA_QUERY.min('tablet', /*#__PURE__*/css(templateObject_13$5 || (templateObject_13$5 = __makeTemplateObject(["height: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:createStretchStyle;")], ["height: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:createStretchStyle;")])), tablet)), laptop && MEDIA_QUERY.min('laptop', /*#__PURE__*/css(templateObject_14$2 || (templateObject_14$2 = __makeTemplateObject(["height: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:createStretchStyle;")], ["height: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:createStretchStyle;")])), laptop)), desktop && MEDIA_QUERY.min('desktop', /*#__PURE__*/css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["height: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:createStretchStyle;")], ["height: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:createStretchStyle;")])), desktop)));
  }
  return /*#__PURE__*/css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["height: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:createStretchStyle;")], ["height: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:createStretchStyle;")])), stretch);
}
var Grabber = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eslvxdd0"
} : {
  target: "eslvxdd0",
  label: "Grabber"
})(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n  width: ", ";\n  min-height: ", ";\n  border-radius: ", ";\n  background-color: ", ";\n  margin: ", " auto 0;\n"], ["\n  width: ", ";\n  min-height: ", ";\n  border-radius: ", ";\n  background-color: ", ";\n  margin: ", " auto 0;\n"])), pxToRem(32), pxToRem(4), pxToRem(2), function (_a) {
  var theme = _a.theme;
  return theme.content.base4;
}, pxToRem(6));
var templateObject_1$1w, templateObject_2$1c, templateObject_3$12, templateObject_4$U, templateObject_5$I, templateObject_6$A, templateObject_7$s, templateObject_8$m, templateObject_9$f, templateObject_10$d, templateObject_11$7, templateObject_12$5, templateObject_13$5, templateObject_14$2, templateObject_15, templateObject_16, templateObject_17, templateObject_18;

var BUTTON_WIDTH = 100;
/**
 * scraollableEntries가 false일 경우
 * 메뉴 entries UI를 다른 UI로 보여주는 로직들을 포함합니다.
 */
var useMoreMenus = function useMoreMenus(_a) {
  var menus = _a.menus,
    scrollableEntries = _a.scrollableEntries,
    activeId = _a.activeId,
    primaryId = _a.primaryId;
  var menusWithIndex = useMemo(function () {
    return menus.map(function (menu, index) {
      return _assign(_assign({}, menu), {
        index: index
      });
    });
  }, [menus]);
  var _b = useState(menusWithIndex),
    moreMenus = _b[0],
    setMoreMenus = _b[1];
  /** moreButton + popper의 visible 여부 */
  var _c = useState(false),
    isVisible = _c[0],
    setIsVisible = _c[1];
  var _d = useState(true),
    isGradientVisible = _d[0],
    setIsGradientVisible = _d[1];
  /** popper를 강제로 닫을지 여부 */
  var _e = useState(false),
    isForcePopperClosed = _e[0],
    setIsForcePopperClosed = _e[1];
  /** popper의 open 여부 */
  var _f = useState(false),
    isPopperOpened = _f[0],
    setIsPopperOpened = _f[1];
  // TODO: bottomSheet 관련 공통 인터랙션 공통화
  var _g = useState('auto'),
    bottomSheetHeight = _g[0],
    setBottomSheetHeight = _g[1];
  var _h = useState(false),
    hasClosingInteraction = _h[0],
    setHasClosingInteraction = _h[1];
  var containerRef = useRef(null);
  var currentClientY = useRef(0);
  var isMobile = useResponsive().breakpoint === 'mobile';
  var theme = useTheme();
  var Link = useLinkContext();
  var _j = useNavigationLog(),
    logTabClick = _j.logTabClick,
    logTabImpression = _j.logTabImpression,
    logMoreButtonClick = _j.logMoreButtonClick;
  var isHncSecondaryTabItem = primaryId === 0;
  var handleIntersect = useCallback(function (menu, index) {
    if (!isHncSecondaryTabItem || !menu.logId) return;
    logTabImpression(menu, index);
  }, [logTabImpression, isHncSecondaryTabItem]);
  var handleClick = useCallback(function (menu, index) {
    logTabClick(menu, index, !!(isHncSecondaryTabItem && menu.logId));
  }, [logTabClick, isHncSecondaryTabItem]);
  var activeIdInMoreMenus = useMemo(function () {
    if (activeId == null) return null;
    return activeId - (menus.length - moreMenus.length);
  }, [activeId, menus.length, moreMenus.length]);
  var handleOpenBottomSheet = function handleOpenBottomSheet() {
    setHasClosingInteraction(false);
    setBottomSheetHeight('auto');
    setIsForcePopperClosed(false);
  };
  var handleCloseBottomSheet = function handleCloseBottomSheet() {
    setHasClosingInteraction(true);
    setBottomSheetHeight('0%');
  };
  var handleTouchMove = useCallback(function (event) {
    var scrollDown = currentClientY.current < event.changedTouches[0].clientY;
    if (scrollDown) {
      handleCloseBottomSheet();
    }
  }, []);
  var handleChangeVisibleMenu = useCallback(function (changedMenu, changedMenuIndex, visibleRatio) {
    if (isMobile) {
      setMoreMenus(menusWithIndex);
      return;
    }
    if (visibleRatio == null) return;
    if (visibleRatio < 1) {
      setMoreMenus(function (menus) {
        return menus.map(function (menu) {
          return menu.index;
        }).includes(changedMenuIndex) ? menus : __spreadArray(__spreadArray([], menus, true), [_assign(_assign({}, changedMenu), {
          index: changedMenuIndex
        })], false).sort(function (a, b) {
          return a.index - b.index;
        });
      });
    } else {
      setMoreMenus(function (menus) {
        return menus.filter(function (menu) {
          return changedMenuIndex !== menu.index;
        });
      });
    }
  }, [isMobile, menusWithIndex]);
  var handleChangeVisibleGradient = function handleChangeVisibleGradient(node) {
    var scrollRight = node.scrollWidth - Math.ceil(node.scrollLeft) - (node === null || node === void 0 ? void 0 : node.getBoundingClientRect().width);
    setIsGradientVisible(scrollRight > 5);
  };
  var handleResize = function handleResize() {
    if (!containerRef.current) return;
    var scrollWidth = containerRef.current.scrollWidth;
    var elementWidth = Math.ceil(containerRef.current.getBoundingClientRect().width);
    var overflowWidth = Math.max(scrollWidth - elementWidth, 0);
    setIsVisible(overflowWidth > 0);
  };
  useResize(containerRef, handleResize);
  useEffect(function () {
    setMoreMenus([]);
  }, [scrollableEntries]);
  useEffect(function () {
    if (isMobile) return;
    var handleScroll = function handleScroll() {
      var isScrollDown = currentClientY.current < window.scrollY;
      setIsForcePopperClosed(isScrollDown);
      currentClientY.current = window.scrollY;
    };
    var throttleScroll = throttle(handleScroll, 1000);
    window.addEventListener('scroll', throttleScroll);
    return function () {
      window.removeEventListener('scroll', throttleScroll);
    };
  }, [isMobile]);
  var MoreMenus = useMemo(function () {
    return jsx(MoreMenusContainer, {
      children: moreMenus.map(function (menu, index) {
        return jsx(StyledIntersectionObserver, _assign({
          onIntersect: function onIntersect() {
            return handleIntersect(menu, menu.index);
          }
        }, {
          children: jsx(Link, _assign({
            href: menu.href,
            onClick: function onClick() {
              handleClick(menu, menu.index);
              setIsForcePopperClosed(true);
            },
            css: [cssLink, /*#__PURE__*/css(templateObject_2$1b || (templateObject_2$1b = __makeTemplateObject(["\n                @media(hover: hover) {\n                  &:hover {\n                    color: ", ";\n                  }\n                }\n                ", "\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                @media(hover: hover) {\n                  &:hover {\n                    color: ", ";\n                  }\n                }\n                ", "\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), theme.content.primary1.basic, activeIdInMoreMenus === index && /*#__PURE__*/css(templateObject_1$1v || (templateObject_1$1v = __makeTemplateObject(["\n                  color: ", ";\n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                  color: ", ";\n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), theme.content.primary1.basic)), FOCUS(templateObject_3$11 || (templateObject_3$11 = __makeTemplateObject(["\n                  color: ", ";\n                "], ["\n                  color: ", ";\n                "])), theme.content.primary1.basic)]
          }, {
            children: menu.title
          }))
        }), menu.title);
      })
    });
  }, [theme, moreMenus, Link, activeIdInMoreMenus, handleIntersect, handleClick]);
  return {
    onChangeVisibleMenu: handleChangeVisibleMenu,
    onChangeVisibleGradient: handleChangeVisibleGradient,
    containerRef: containerRef,
    isPopperOpened: isPopperOpened,
    moreMenusComponent: isVisible ? jsx(Popper, _assign({
      isForceClosed: isForcePopperClosed,
      usePortal: false,
      style: isMobile ? {
        visibility: 'hidden'
      } : undefined,
      onChange: setIsPopperOpened,
      renderButton: function renderButton(_a) {
        var _onClick = _a.onClick,
          isOpen = _a.isOpen;
        return jsxs(Fragment$1, {
          children: [jsx(MoreButton, _assign({
            isGradientVisible: isGradientVisible,
            type: "button",
            onClick: function onClick() {
              handleOpenBottomSheet();
              _onClick();
              logMoreButtonClick();
            }
          }, {
            children: jsx(ChevronDownIcon, {
              size: 12,
              name: "chevron_down",
              fill: function fill(theme) {
                return theme.content.base1;
              }
            })
          })), isMobile && isOpen && jsx(StyledModal, _assign({
            width: 400,
            hasInteraction: true,
            hasGrabber: true,
            height: bottomSheetHeight,
            hasClosingInteraction: hasClosingInteraction,
            onBlur: handleCloseBottomSheet,
            onTouchStart: function onTouchStart(event) {
              currentClientY.current = event.changedTouches[0].clientY;
            },
            onTouchMove: handleTouchMove,
            disableBackgroundScroll: true,
            header: {
              title: '탭 선택하기',
              onClose: handleCloseBottomSheet
            },
            onTransitionEnd: function onTransitionEnd() {
              if (hasClosingInteraction) {
                _onClick();
              }
            }
          }, {
            children: jsx(SwitchTransition, {
              children: jsx(Transition, _assign({
                timeout: 200
              }, {
                children: MoreMenus
              }))
            })
          }))]
        });
      }
    }, {
      children: !isMobile && MoreMenus
    })) : null
  };
};
var cssLink = /*#__PURE__*/css(templateObject_5$H || (templateObject_5$H = __makeTemplateObject(["\n  ", "\n  display: block;\n  padding: ", " 0 ", " ", ";\n  text-align: start;\n  font-weight: 700;\n  ", "\n" + (process.env.NODE_ENV === "production" ? "" : ";label:cssLink;")], ["\n  ", "\n  display: block;\n  padding: ", " 0 ", " ", ";\n  text-align: start;\n  font-weight: 700;\n  ", "\n" + (process.env.NODE_ENV === "production" ? "" : ";label:cssLink;")])), FONT_STYLE.body1_small, pxToRem(10), pxToRem(10), pxToRem(26), MEDIA_QUERY.min('tablet', /*#__PURE__*/css(templateObject_4$T || (templateObject_4$T = __makeTemplateObject(["\n    ", ";\n    padding: 0 0 ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssLink;")], ["\n    ", ";\n    padding: 0 0 ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssLink;")])), FONT_STYLE.subTitle1, pxToRem(20))));
var MoreButton = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e1h7bema4"
} : {
  target: "e1h7bema4",
  label: "MoreButton"
})(templateObject_7$r || (templateObject_7$r = __makeTemplateObject(["\n  ", "\n  padding: 0 ", ";\n  height: 100%;\n  display: flex;\n  align-items: center;\n  position: absolute;\n  transform: translateX(-100%);\n  ", "\n"], ["\n  ", "\n  padding: 0 ", ";\n  height: 100%;\n  display: flex;\n  align-items: center;\n  position: absolute;\n  transform: translateX(-100%);\n  ", "\n"])), RESET_BUTTON, pxToRem(6), function (_a) {
  var isGradientVisible = _a.isGradientVisible,
    theme = _a.theme;
  return isGradientVisible && /*#__PURE__*/css(templateObject_6$z || (templateObject_6$z = __makeTemplateObject(["\n    &:after {\n      content: '';\n      position: absolute;\n      right: 0;\n      width: ", ";\n      height: 100%;\n      background: linear-gradient(90deg, ", " 0%, ", " 50%);\n    }\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:MoreButton;")], ["\n    &:after {\n      content: '';\n      position: absolute;\n      right: 0;\n      width: ", ";\n      height: 100%;\n      background: linear-gradient(90deg, ", " 0%, ", " 50%);\n    }\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:MoreButton;")])), pxToRem(BUTTON_WIDTH), hexToRgba(theme.background.base, 0), theme.background.base);
});
var MoreMenusContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1h7bema3"
} : {
  target: "e1h7bema3",
  label: "MoreMenusContainer"
})(templateObject_9$e || (templateObject_9$e = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  padding-top: ", ";\n  ", "\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  padding-top: ", ";\n  ", "\n"])), pxToRem(30), MEDIA_QUERY.min('tablet', /*#__PURE__*/css(templateObject_8$l || (templateObject_8$l = __makeTemplateObject(["\n    display: block;\n    min-width: ", ";\n    padding: ", " ", " 0;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:MoreMenusContainer;")], ["\n    display: block;\n    min-width: ", ";\n    padding: ", " ", " 0;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:MoreMenusContainer;")])), pxToRem(250), pxToRem(20), pxToRem(22))));
var ChevronDownIcon = /*#__PURE__*/_styled(Icon, process.env.NODE_ENV === "production" ? {
  target: "e1h7bema2"
} : {
  target: "e1h7bema2",
  label: "ChevronDownIcon"
})(templateObject_10$c || (templateObject_10$c = __makeTemplateObject(["\n  z-index: 2;\n"], ["\n  z-index: 2;\n"])));
var StyledModal = /*#__PURE__*/_styled(Modal, process.env.NODE_ENV === "production" ? {
  target: "e1h7bema1"
} : {
  target: "e1h7bema1",
  label: "StyledModal"
})(templateObject_12$4 || (templateObject_12$4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var hasClosingInteraction = _a.hasClosingInteraction;
  return hasClosingInteraction && /*#__PURE__*/css(templateObject_11$6 || (templateObject_11$6 = __makeTemplateObject(["\n    opacity: 0;\n    transition: opacity 0.3s ease-in;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:StyledModal;")], ["\n    opacity: 0;\n    transition: opacity 0.3s ease-in;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:StyledModal;")])));
});
var StyledIntersectionObserver = /*#__PURE__*/_styled(IntersectionObserver, process.env.NODE_ENV === "production" ? {
  target: "e1h7bema0"
} : {
  target: "e1h7bema0",
  label: "StyledIntersectionObserver"
})(templateObject_13$4 || (templateObject_13$4 = __makeTemplateObject(["\n  flex-basis: 50%;\n"], ["\n  flex-basis: 50%;\n"])));
var templateObject_1$1v, templateObject_2$1b, templateObject_3$11, templateObject_4$T, templateObject_5$H, templateObject_6$z, templateObject_7$r, templateObject_8$l, templateObject_9$e, templateObject_10$c, templateObject_11$6, templateObject_12$4, templateObject_13$4;

function NavigationBarSecondaryTabItem(props) {
  var onSelect = props.onSelect,
    index = props.index,
    item = props.item,
    onChangeVisibleMenu = props.onChangeVisibleMenu,
    containerRef = props.containerRef,
    primaryId = props.primaryId,
    rest = __rest(props, ["onSelect", "index", "item", "onChangeVisibleMenu", "containerRef", "primaryId"]);
  var LinkComponent = useLinkContext();
  var _a = useHover(onSelect),
    handleMouseEnter = _a[0],
    handleMouseLeave = _a[1];
  var _b = useInView({
      root: containerRef.current,
      rootMargin: "0px -".concat(BUTTON_WIDTH, "px 0px 0px"),
      initialInView: true,
      threshold: [0, 1]
    }),
    ref = _b.ref,
    entry = _b.entry;
  var _c = useNavigationLog(),
    logTabClick = _c.logTabClick,
    logTabImpression = _c.logTabImpression;
  var isHncSecondaryTabItem = primaryId === 0;
  var handleIntersect = useCallback(function () {
    if (!isHncSecondaryTabItem || !item.logId) return;
    logTabImpression === null || logTabImpression === void 0 ? void 0 : logTabImpression(item, index);
  }, [logTabImpression, item, index, isHncSecondaryTabItem]);
  useEffect(function () {
    onChangeVisibleMenu(item, index, entry === null || entry === void 0 ? void 0 : entry.intersectionRatio);
  }, [entry, item, index, onChangeVisibleMenu]);
  return jsx(IntersectionObserver, _assign({
    onIntersect: handleIntersect
  }, {
    children: jsx("div", _assign({
      ref: ref,
      css: /*#__PURE__*/css(templateObject_1$1u || (templateObject_1$1u = __makeTemplateObject(["height: inherit;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["height: inherit;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
    }, {
      children: jsx(StyledTabItem, _assign({}, rest, {
        component: LinkComponent,
        onClick: function onClick() {
          return logTabClick === null || logTabClick === void 0 ? void 0 : logTabClick(item, index, !!(isHncSecondaryTabItem && item.logId));
        },
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave
      }))
    }))
  }));
}
var StyledTabItem = /*#__PURE__*/_styled(TabItem, process.env.NODE_ENV === "production" ? {
  target: "e1w9mhmv0"
} : {
  target: "e1w9mhmv0",
  label: "StyledTabItem"
})(templateObject_6$y || (templateObject_6$y = __makeTemplateObject(["\n  height: inherit;\n  outline: none;\n  & > div > p {\n    font-weight: 700;\n  }\n  ", "\n  ", "\n"], ["\n  height: inherit;\n  outline: none;\n  & > div > p {\n    font-weight: 700;\n  }\n  ", "\n  ", "\n"])), MEDIA_QUERY.max('mobile', /*#__PURE__*/css(templateObject_2$1a || (templateObject_2$1a = __makeTemplateObject(["\n    padding: ", " ", ";\n    > div > p {\n      ", "\n    }\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:StyledTabItem;")], ["\n    padding: ", " ", ";\n    > div > p {\n      ", "\n    }\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:StyledTabItem;")])), pxToRem(11), pxToRem(5), FONT_STYLE.subTitle2)), function (_a) {
  var theme = _a.theme;
  return /*#__PURE__*/css(templateObject_5$G || (templateObject_5$G = __makeTemplateObject(["\n    ", "\n     ", "\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:StyledTabItem;")], ["\n    ", "\n     ", "\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:StyledTabItem;")])), HOVER(templateObject_3$10 || (templateObject_3$10 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), theme.content.primary1.basic), FOCUS(templateObject_4$S || (templateObject_4$S = __makeTemplateObject(["\n      * {\n        color: ", ";\n      }\n      & > div {\n        box-shadow: 0 0 0 ", " ", ";\n        border-radius: ", ";\n      }\n    "], ["\n      * {\n        color: ", ";\n      }\n      & > div {\n        box-shadow: 0 0 0 ", " ", ";\n        border-radius: ", ";\n      }\n    "])), theme.content.primary1.basic, pxToRem(3), theme.interactive.primary1.thin, pxToRem(3)));
});
var templateObject_1$1u, templateObject_2$1a, templateObject_3$10, templateObject_4$S, templateObject_5$G, templateObject_6$y;

var INITIAL_NODE_HEIGHT = 51;
function NavigationBarSecondary(props) {
  var hasItems = props.hasItems,
    isForceOpened = props.isForceOpened,
    isFallback = props.isFallback,
    right = props.right,
    menuEntries = props.menuEntries,
    activeId = props.activeId,
    onMouseEnter = props.onMouseEnter,
    _onMouseLeave = props.onMouseLeave,
    _onSelect = props.onSelect,
    primaryId = props.primaryId,
    _a = props.scrollableEntries,
    scrollableEntries = _a === void 0 ? true : _a;
  var childRef = useRef(null);
  var theme = useTheme();
  var isMobile = useResponsive().breakpoint === 'mobile';
  var nodeHeight = useNodeHeight(childRef, INITIAL_NODE_HEIGHT);
  var scrollDir = useScrollDirection();
  var shouldOpen = hasItems && scrollDir !== 'down' || isForceOpened;
  var _b = useMoreMenus({
      menus: menuEntries,
      scrollableEntries: scrollableEntries,
      activeId: activeId,
      primaryId: primaryId
    }),
    onChangeVisibleMenu = _b.onChangeVisibleMenu,
    onChangeVisibleGradient = _b.onChangeVisibleGradient,
    containerRef = _b.containerRef,
    moreMenusComponent = _b.moreMenusComponent,
    isPopperOpened = _b.isPopperOpened;
  /** Hover된 Secondary 메뉴 내 Popper가 닫히면, Secondary의 Hover상태도 없애기 위해 실행합니다. */
  useEffect(function () {
    if (isPopperOpened) return;
    _onMouseLeave === null || _onMouseLeave === void 0 ? void 0 : _onMouseLeave();
  }, [isPopperOpened, _onMouseLeave]);
  if (menuEntries.length === 0) return null;
  // NOTE: Secondary의 모바일/PC 동작은 완전히 동일합니다.
  return jsx(StyledSticky, _assign({
    className: "layout-navigation-secondary",
    css: /*#__PURE__*/css(templateObject_2$19 || (templateObject_2$19 = __makeTemplateObject(["", "" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["", "" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), isFallback && /*#__PURE__*/css(templateObject_1$1t || (templateObject_1$1t = __makeTemplateObject(["background: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["background: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), theme.background.groupedBase)),
    containerStyle: !hasItems ? {
      position: 'relative',
      top: isForceOpened ? '0' : pxToRem(-nodeHeight),
      height: '0px',
      transition: '.1s top'
    } : undefined,
    direction: "top",
    offset: shouldOpen ? 0 : -nodeHeight,
    offsetRange: [-nodeHeight, 0],
    type: "navigation",
    disableNativeSticky: true,
    disableBottom: true,
    disableHeight: !hasItems,
    forwardRef: childRef,
    zIndex: ZINDEX.appBar + 1,
    transition: 0.1,
    initialState: !hasItems ? _assign(_assign({}, DEFAULT_STICKY_STATE), {
      disabled: false,
      emulatedDisabled: false,
      offset: -nodeHeight,
      emulatedOffset: -nodeHeight
    }) : undefined,
    onMouseEnter: onMouseEnter,
    onMouseLeave: function onMouseLeave() {
      if (isPopperOpened) return;
      _onMouseLeave === null || _onMouseLeave === void 0 ? void 0 : _onMouseLeave();
    }
  }, {
    children: jsxs(StyledContainer$1, _assign({
      scrollable: scrollableEntries
    }, {
      children: [jsxs(TabContainer, _assign({
        ref: containerRef,
        scrollable: scrollableEntries
      }, {
        children: [jsx(StyledTab, _assign({
          ref: function ref(node) {
            if (!node) return;
            var throttleScroll = throttle(function () {
              return onChangeVisibleGradient(node);
            }, 100);
            node.addEventListener('scroll', throttleScroll);
          },
          scrollable: scrollableEntries,
          isMobile: isMobile
        }, {
          children: menuEntries.map(function (item, index) {
            return jsx(NavigationBarSecondaryTabItem, _assign({
              containerRef: containerRef,
              index: index,
              onChangeVisibleMenu: onChangeVisibleMenu,
              item: item,
              href: item.href,
              bullet: item.bullet,
              badge: item.badge,
              isActive: activeId === index,
              onSelect: function onSelect() {
                return _onSelect(item, index);
              },
              primaryId: primaryId
            }, {
              children: item.title
            }), item.title);
          })
        })), !scrollableEntries && moreMenusComponent]
      })), right && jsx(Right, {
        children: right
      })]
    }))
  }));
}
var StyledSticky = /*#__PURE__*/_styled(Sticky, process.env.NODE_ENV === "production" ? {
  target: "e1br7gq24"
} : {
  target: "e1br7gq24",
  label: "StyledSticky"
})(templateObject_3$$ || (templateObject_3$$ = __makeTemplateObject(["\n  background: ", ";\n  border-bottom: ", " solid ", ";\n"], ["\n  background: ", ";\n  border-bottom: ", " solid ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.background.base;
}, pxToRem(1), function (_a) {
  var theme = _a.theme;
  return theme.divider;
});
var StyledContainer$1 = /*#__PURE__*/_styled(Container$4, process.env.NODE_ENV === "production" ? {
  shouldForwardProp: function shouldForwardProp(prop) {
    return isPropValid(prop);
  },
  target: "e1br7gq23"
} : {
  shouldForwardProp: function shouldForwardProp(prop) {
    return isPropValid(prop);
  },
  target: "e1br7gq23",
  label: "StyledContainer"
})(templateObject_5$F || (templateObject_5$F = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-sizing: border-box;\n  overflow: auto;\n  ", "\n"], ["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-sizing: border-box;\n  overflow: auto;\n  ", "\n"])), function (_a) {
  var scrollable = _a.scrollable;
  return !scrollable && /*#__PURE__*/css(templateObject_4$R || (templateObject_4$R = __makeTemplateObject(["\n    overflow: initial;\n    padding-left: 0;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:StyledContainer;")], ["\n    overflow: initial;\n    padding-left: 0;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:StyledContainer;")])));
});
var StyledTab = /*#__PURE__*/_styled(Tab, process.env.NODE_ENV === "production" ? {
  shouldForwardProp: function shouldForwardProp(prop) {
    return isPropValid(prop);
  },
  target: "e1br7gq22"
} : {
  shouldForwardProp: function shouldForwardProp(prop) {
    return isPropValid(prop);
  },
  target: "e1br7gq22",
  label: "StyledTab"
})(templateObject_10$b || (templateObject_10$b = __makeTemplateObject(["\n  height: ", ";\n  ", "\n  ", "\n"], ["\n  height: ", ";\n  ", "\n  ", "\n"])), pxToRem(51), MEDIA_QUERY.max('mobile', /*#__PURE__*/css(templateObject_6$x || (templateObject_6$x = __makeTemplateObject(["\n    height: ", ";\n    justify-content: center;\n    margin: 0 ", ";\n    && > * {\n      margin: 0 ", ";\n    }\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:StyledTab;")], ["\n    height: ", ";\n    justify-content: center;\n    margin: 0 ", ";\n    && > * {\n      margin: 0 ", ";\n    }\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:StyledTab;")])), pxToRem(40), pxToRem(-2), pxToRem(2))), function (_a) {
  var scrollable = _a.scrollable,
    isMobile = _a.isMobile;
  return !scrollable && /*#__PURE__*/css(templateObject_9$d || (templateObject_9$d = __makeTemplateObject(["\n    & {\n      ", "\n    }\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:StyledTab;")], ["\n    & {\n      ", "\n    }\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:StyledTab;")])), isMobile ? /*#__PURE__*/css(templateObject_7$q || (templateObject_7$q = __makeTemplateObject(["\n        padding: 0 ", " 0 ", ";\n        justify-content: start;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:StyledTab;")], ["\n        padding: 0 ", " 0 ", ";\n        justify-content: start;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:StyledTab;")])), pxToRem(32), pxToRem(16)) : /*#__PURE__*/css(templateObject_8$k || (templateObject_8$k = __makeTemplateObject(["overflow: hidden;" + (process.env.NODE_ENV === "production" ? "" : ";label:StyledTab;")], ["overflow: hidden;" + (process.env.NODE_ENV === "production" ? "" : ";label:StyledTab;")]))));
});
var Right = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1br7gq21"
} : {
  target: "e1br7gq21",
  label: "Right"
})(templateObject_12$3 || (templateObject_12$3 = __makeTemplateObject(["\n  flex: 0 0 auto;\n  display: none;\n  ", "\n"], ["\n  flex: 0 0 auto;\n  display: none;\n  ", "\n"])), MEDIA_QUERY.min('tablet', /*#__PURE__*/css(templateObject_11$5 || (templateObject_11$5 = __makeTemplateObject(["\n    display: block;\n    margin-left: 10px;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:Right;")], ["\n    display: block;\n    margin-left: 10px;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:Right;")])))));
var TabContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1br7gq20"
} : {
  target: "e1br7gq20",
  label: "TabContainer"
})(templateObject_14$1 || (templateObject_14$1 = __makeTemplateObject(["\n  flex: 1 0 0;\n  ", "\n"], ["\n  flex: 1 0 0;\n  ", "\n"])), function (_a) {
  var scrollable = _a.scrollable;
  return !scrollable && /*#__PURE__*/css(templateObject_13$3 || (templateObject_13$3 = __makeTemplateObject(["\n    display: flex;\n    justify-content: space-between;\n    overflow: hidden;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:TabContainer;")], ["\n    display: flex;\n    justify-content: space-between;\n    overflow: hidden;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:TabContainer;")])));
});
var templateObject_1$1t, templateObject_2$19, templateObject_3$$, templateObject_4$R, templateObject_5$F, templateObject_6$x, templateObject_7$q, templateObject_8$k, templateObject_9$d, templateObject_10$b, templateObject_11$5, templateObject_12$3, templateObject_13$3, templateObject_14$1;

function NavigationBarTertiary(_a) {
  var _b;
  var item = _a.item,
    isOpen = _a.isOpen,
    onMouseEnter = _a.onMouseEnter,
    onMouseLeave = _a.onMouseLeave;
  var itemRef = useRef(item);
  if (item != null) {
    itemRef.current = item;
  }
  var currentItem = itemRef.current;
  var nodeRef = useRef(null);
  var _c = useState(null),
    top = _c[0],
    setTop = _c[1];
  useEffect(function () {
    if (!isOpen) {
      return;
    }
    if (nodeRef.current == null) {
      nodeRef.current = document.querySelector('.layout-navigation-secondary');
    }
    if (nodeRef.current) {
      setTop(nodeRef.current.getBoundingClientRect().bottom);
    }
    var timer = null;
    function handleScroll() {
      if (timer != null) {
        cancelAnimationFrame(timer);
      }
      timer = requestAnimationFrame(function () {
        timer = null;
        if (nodeRef.current) {
          setTop(nodeRef.current.getBoundingClientRect().bottom);
        }
      });
    }
    window.addEventListener('scroll', handleScroll);
    return function () {
      window.removeEventListener('scroll', handleScroll);
      if (timer != null) {
        cancelAnimationFrame(timer);
      }
    };
  }, [isOpen]);
  var show = useMemo(function () {
    return Boolean(isOpen && (item === null || item === void 0 ? void 0 : item.renderBarChild));
  }, [isOpen, item]);
  if (top == null) {
    return null;
  }
  return jsx(CSSTransition, _assign({
    timeout: 200,
    "in": show,
    appear: show,
    unmountOnExit: true,
    classNames: {
      enterActive: 'open opening',
      enterDone: 'open open-active',
      appearActive: 'open opening',
      appearDone: 'open open-active',
      exit: 'exiting'
    }
  }, {
    children: jsx("div", _assign({
      css: /*#__PURE__*/css(templateObject_1$1s || (templateObject_1$1s = __makeTemplateObject(["\n          position: fixed;\n          top: ", "px;\n          left: 0;\n          right: 0;\n          background-color: #ffffff;\n          border-bottom: 1px solid #ededed;\n          z-index: 500;\n          opacity: 0;\n          transform: translateY(-100%);\n\n          &.opening {\n            transition: .2s opacity, .2s transform;\n          }\n          &.exiting {\n            transition: .2s opacity, .2s transform;\n          }\n          &.open {\n            opacity: 1;\n            transform: none;\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          position: fixed;\n          top: ", "px;\n          left: 0;\n          right: 0;\n          background-color: #ffffff;\n          border-bottom: 1px solid #ededed;\n          z-index: 500;\n          opacity: 0;\n          transform: translateY(-100%);\n\n          &.opening {\n            transition: .2s opacity, .2s transform;\n          }\n          &.exiting {\n            transition: .2s opacity, .2s transform;\n          }\n          &.open {\n            opacity: 1;\n            transform: none;\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), top),
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    }, {
      children: (_b = currentItem === null || currentItem === void 0 ? void 0 : currentItem.renderBarChild) === null || _b === void 0 ? void 0 : _b.call(currentItem)
    }))
  }));
}
var templateObject_1$1s;

function isIconAction(action) {
  return 'icon' in action;
}
function cssBaseTextField(theme, onDimmed, _a) {
  if (onDimmed === void 0) {
    onDimmed = false;
  }
  var error = _a.error,
    focused = _a.focused,
    disabled = _a.disabled,
    readOnly = _a.readOnly;
  return /*#__PURE__*/css(templateObject_1$1r || (templateObject_1$1r = __makeTemplateObject(["\n    display: inline-flex;\n    align-items: center;\n    line-height: 0;\n    box-sizing: border-box;\n    border: ", " solid ", ";\n    border-radius: ", ";\n    &:hover {\n      background-color: ", ";\n    }\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssBaseTextField;")], ["\n    display: inline-flex;\n    align-items: center;\n    line-height: 0;\n    box-sizing: border-box;\n    border: ", " solid ", ";\n    border-radius: ", ";\n    &:hover {\n      background-color: ", ";\n    }\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssBaseTextField;")])), pxToRem(1), theme.border, pxToRem(4), theme.content.base5, disabled && "\n      border-color: ".concat(theme.content.base4, ";\n      background-color: ").concat(theme.content.base5, ";\n    "), readOnly && "\n      background-color: ".concat(theme.content.base5, ";\n    "), focused && "border-color: ".concat(theme.content.primary1.basic, ";"), error && "border-color: ".concat(theme.content.primary2.basic, ";"), onDimmed && "background-color: ".concat(theme.background.base, ";"));
}
function cssTextField(theme) {
  return /*#__PURE__*/css(templateObject_2$18 || (templateObject_2$18 = __makeTemplateObject(["\n    ", "\n    height: 100%;\n    color: ", ";\n    outline: none;\n    &::placeholder {\n      color: ", ";\n    }\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssTextField;")], ["\n    ", "\n    height: 100%;\n    color: ", ";\n    outline: none;\n    &::placeholder {\n      color: ", ";\n    }\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssTextField;")])), RESET_INPUT, theme.content.base1, theme.content.base3);
}
var templateObject_1$1r, templateObject_2$18;

var ICON_SIZE$2 = 24;
function cssContainer(size) {
  return /*#__PURE__*/css(templateObject_1$1q || (templateObject_1$1q = __makeTemplateObject(["\n    height: ", ";\n    padding: 0\n    ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssContainer;")], ["\n    height: ", ";\n    padding: 0\n    ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssContainer;")])), pxToRem(size), pxToRem({
    32: 8,
    40: 14,
    44: 16,
    50: 16
  }[size]));
}
function cssFontSize$1(size) {
  return /*#__PURE__*/css(templateObject_2$17 || (templateObject_2$17 = __makeTemplateObject(["", "" + (process.env.NODE_ENV === "production" ? "" : ";label:cssFontSize;")], ["", "" + (process.env.NODE_ENV === "production" ? "" : ";label:cssFontSize;")])), {
    32: FONT_STYLE.body2,
    40: FONT_STYLE.body1_1,
    44: FONT_STYLE.body1_1,
    50: FONT_STYLE.body1_1
  }[size]);
}
function cssIconInputPadding(size) {
  return /*#__PURE__*/css(templateObject_3$_ || (templateObject_3$_ = __makeTemplateObject(["", "" + (process.env.NODE_ENV === "production" ? "" : ";label:cssIconInputPadding;")], ["", "" + (process.env.NODE_ENV === "production" ? "" : ";label:cssIconInputPadding;")])), pxToRem({
    32: 4,
    40: 6,
    44: 6,
    50: 8
  }[size]));
}
/**
 * @deprecated ODS의 Input 컴포넌트를 사용해주세요. 만약 디자인상 ODS의 Input를 사용할 수 없는 경우, 디자인시스템 담당 디자이너에게 문의해주세요.
 */
function Input$1(_a) {
  var _onChange = _a.onChange,
    onValue = _a.onValue,
    _onFocus = _a.onFocus,
    _onBlur = _a.onBlur,
    forwardedRef = _a.forwardedRef,
    className = _a.className,
    size = _a.size,
    icon = _a.icon,
    action = _a.action,
    _b = _a.onDimmed,
    onDimmed = _b === void 0 ? false : _b,
    _c = _a.error,
    error = _c === void 0 ? false : _c,
    _d = _a.disabled,
    disabled = _d === void 0 ? false : _d,
    _e = _a.readOnly,
    readOnly = _e === void 0 ? false : _e,
    rest = __rest(_a, ["onChange", "onValue", "onFocus", "onBlur", "forwardedRef", "className", "size", "icon", "action", "onDimmed", "error", "disabled", "readOnly"]);
  var theme = useTheme();
  var _f = useState(false),
    focused = _f[0],
    setFocused = _f[1];
  var actions = Array.isArray(action) ? action : [action];
  return jsxs("div", _assign({
    className: className,
    css: [cssBaseTextField(theme, onDimmed, {
      error: error,
      focused: focused,
      disabled: disabled,
      readOnly: readOnly
    }), cssContainer(size)]
  }, {
    children: [icon && jsx(Icon, {
      size: ICON_SIZE$2,
      name: _typeof(icon) === 'object' ? icon.name : icon,
      css: /*#__PURE__*/css(templateObject_4$Q || (templateObject_4$Q = __makeTemplateObject(["\n            vertical-align: middle;\n            padding-right: ", ";\n            color: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            vertical-align: middle;\n            padding-right: ", ";\n            color: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), cssIconInputPadding(size), _typeof(icon) === 'object' ? "".concat((icon === null || icon === void 0 ? void 0 : icon.color) || theme.content.base2) : theme.content.base2)
    }), jsx(StyledInput, _assign({}, rest, {
      ref: forwardedRef,
      disabled: disabled,
      readOnly: readOnly,
      onChange: function onChange(e) {
        return onValueHandler(e, {
          onChange: _onChange,
          onValue: onValue
        });
      },
      onFocus: function onFocus(e) {
        if (_onFocus) {
          _onFocus(e);
        }
        setFocused(true);
      },
      onBlur: function onBlur(e) {
        if (_onBlur) {
          _onBlur(e);
        }
        setFocused(false);
      },
      css: [cssTextField(theme), cssFontSize$1(size), /*#__PURE__*/css(templateObject_5$E || (templateObject_5$E = __makeTemplateObject(["\n            padding-right: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            padding-right: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), cssIconInputPadding(size))]
    })), jsx("div", _assign({
      css: /*#__PURE__*/css(templateObject_6$w || (templateObject_6$w = __makeTemplateObject(["\n          display: flex;\n          align-items: center;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          display: flex;\n          align-items: center;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
    }, {
      children: actions.map(function (action, i) {
        return !!action && (isIconAction(action) ? jsx(ActionButton, _assign({
          type: action.type || 'button',
          disabled: disabled || action.disabled,
          tabIndex: action.tabIndex || 0,
          css: /*#__PURE__*/css(templateObject_7$p || (templateObject_7$p = __makeTemplateObject(["\n                  color: ", ";\n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                  color: ", ";\n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), action.color || theme.content.base2),
          onClick: function onClick(e) {
            var _a;
            e.stopPropagation();
            (_a = action.onClick) === null || _a === void 0 ? void 0 : _a.call(action, e);
          }
        }, {
          children: jsx(Icon, {
            size: ICON_SIZE$2,
            name: action.icon
          })
        }), i) : jsx(ActionTextButton, _assign({
          size: 30,
          variant: "primary1",
          type: action.type || 'button',
          disabled: disabled || action.disabled,
          tabIndex: action.tabIndex || 0,
          css: [cssFontSize$1(size)],
          onClick: function onClick(e) {
            var _a;
            e.stopPropagation();
            (_a = action.onClick) === null || _a === void 0 ? void 0 : _a.call(action, e);
          }
        }, {
          children: action.text
        }), i));
      })
    }))]
  }));
}
var StyledInput = /*#__PURE__*/_styled("input", process.env.NODE_ENV === "production" ? {
  target: "e1rynmtb2"
} : {
  target: "e1rynmtb2",
  label: "StyledInput"
})(templateObject_8$j || (templateObject_8$j = __makeTemplateObject(["\n  box-sizing: border-box;\n  flex: 1 0 0%;\n  vertical-align: middle;\n  outline: none;\n"], ["\n  box-sizing: border-box;\n  flex: 1 0 0%;\n  vertical-align: middle;\n  outline: none;\n"])));
var ActionButton = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e1rynmtb1"
} : {
  target: "e1rynmtb1",
  label: "ActionButton"
})(templateObject_9$c || (templateObject_9$c = __makeTemplateObject(["\n  ", "\n  vertical-align: middle;\n  width: ", ";\n  height: ", ";\n  outline: none;\n  margin-left: ", ";\n  &:first-of-type {\n    margin-left: 0;\n  }\n"], ["\n  ", "\n  vertical-align: middle;\n  width: ", ";\n  height: ", ";\n  outline: none;\n  margin-left: ", ";\n  &:first-of-type {\n    margin-left: 0;\n  }\n"])), RESET_BUTTON, pxToRem(ICON_SIZE$2), pxToRem(ICON_SIZE$2), pxToRem(8));
var ActionTextButton = /*#__PURE__*/_styled(TextButton, process.env.NODE_ENV === "production" ? {
  target: "e1rynmtb0"
} : {
  target: "e1rynmtb0",
  label: "ActionTextButton"
})(templateObject_10$a || (templateObject_10$a = __makeTemplateObject(["\n  flex-shrink: 0;\n  margin-left: ", ";\n  padding: 0;\n  &:first-of-type {\n    margin-left: 0;\n  }\n"], ["\n  flex-shrink: 0;\n  margin-left: ", ";\n  padding: 0;\n  &:first-of-type {\n    margin-left: 0;\n  }\n"])), pxToRem(8));
var templateObject_1$1q, templateObject_2$17, templateObject_3$_, templateObject_4$Q, templateObject_5$E, templateObject_6$w, templateObject_7$p, templateObject_8$j, templateObject_9$c, templateObject_10$a;

var Input = /*#__PURE__*/forwardRef(function (_a, ref) {
  var value = _a.value,
    placeholder = _a.placeholder,
    onChange = _a.onChange,
    onClear = _a.onClear,
    props = __rest(_a, ["value", "placeholder", "onChange", "onClear"]);
  var input = useRef(null);
  var handleChange = useCallback(function (e) {
    onChange(e.target.value);
  }, [onChange]);
  var handleClear = useCallback(function () {
    onChange('');
    onClear();
  }, [onChange, onClear]);
  useImperativeHandle(ref, function () {
    return input.current;
  });
  return jsx(Input$1, _assign({
    css: /*#__PURE__*/css(templateObject_1$1p || (templateObject_1$1p = __makeTemplateObject(["\n        width: 100%;\n        input::-ms-clear {\n          display: none;\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        width: 100%;\n        input::-ms-clear {\n          display: none;\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")]))),
    forwardedRef: input,
    type: "text",
    size: 40,
    value: value,
    placeholder: placeholder,
    icon: "search",
    action: value ? {
      icon: 'dismiss_circle',
      type: 'button',
      onClick: handleClear
    } : undefined,
    onChange: handleChange
  }, props));
});
var templateObject_1$1p;

function Search(_a) {
  var id = _a.id,
    className = _a.className,
    pageKey = _a.pageKey,
    initialQuery = _a.initialQuery,
    placeholder = _a.placeholder,
    isInputAutoFocused = _a.isInputAutoFocused,
    isListBoxAlwaysOpened = _a.isListBoxAlwaysOpened,
    renderInputRight = _a.renderInputRight,
    fetchList = _a.fetchList,
    getItemQuery = _a.getItemQuery,
    renderListBox = _a.renderListBox,
    onSubmit = _a.onSubmit,
    onSubmitItem = _a.onSubmitItem,
    onInputBlur = _a.onInputBlur,
    onClear = _a.onClear,
    props = __rest(_a, ["id", "className", "pageKey", "initialQuery", "placeholder", "isInputAutoFocused", "isListBoxAlwaysOpened", "renderInputRight", "fetchList", "getItemQuery", "renderListBox", "onSubmit", "onSubmitItem", "onInputBlur", "onClear"]);
  var input = useRef(null);
  var _b = useAutoComplete(input, {
      pageKey: pageKey,
      query: '',
      initialQuery: initialQuery,
      isAlwaysFocused: isInputAutoFocused,
      onFetch: fetchList,
      getItemQuery: getItemQuery,
      onSubmit: onSubmit,
      onSubmitItem: onSubmitItem
    }),
    items = _b.items,
    isOpened = _b.isOpened,
    shownQuery = _b.shownQuery,
    hoveredIndex = _b.hoveredIndex,
    onInputFocus = _b.onInputFocus,
    onInputClick = _b.onInputClick,
    onInputChange = _b.onInputChange,
    onInputKeyDown = _b.onInputKeyDown,
    onReset = _b.onReset,
    onListClick = _b.onListClick,
    onListMouseEnter = _b.onListMouseEnter;
  var handleInputFocus = useCallback(function (e) {
    onInputFocus(e);
    if (props.onInputFocus) props.onInputFocus(e);
  }, [onInputFocus, props]);
  var handleInputChange = useCallback(function (value) {
    onInputChange(value);
    if (props.onInputChange) props.onInputChange(value);
  }, [onInputChange, props]);
  var handleInputBlur = useCallback(function (e) {
    onInputBlur === null || onInputBlur === void 0 ? void 0 : onInputBlur(e);
  }, [onInputBlur]);
  var handleInputClear = useCallback(function () {
    onReset === null || onReset === void 0 ? void 0 : onReset();
    onClear === null || onClear === void 0 ? void 0 : onClear();
  }, [onReset, onClear]);
  return jsxs("div", _assign({
    className: className,
    css: /*#__PURE__*/css(templateObject_1$1o || (templateObject_1$1o = __makeTemplateObject(["\n        position: relative;\n        display: flex;\n        flex-direction: column;\n        height: 100%;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        position: relative;\n        display: flex;\n        flex-direction: column;\n        height: 100%;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
  }, {
    children: [jsxs("div", _assign({
      id: "".concat(id, "-combobox"),
      role: "combobox",
      "aria-expanded": isOpened,
      "aria-haspopup": "listbox",
      "aria-controls": isOpened ? "".concat(id, "-listbox") : undefined,
      css: /*#__PURE__*/css(templateObject_2$16 || (templateObject_2$16 = __makeTemplateObject(["\n          display: flex;\n          width: 100%;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          display: flex;\n          width: 100%;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
    }, {
      children: [jsx(Input, {
        css: /*#__PURE__*/css(templateObject_3$Z || (templateObject_3$Z = __makeTemplateObject(["\n            > input {\n              width: 100%;\n            }\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            > input {\n              width: 100%;\n            }\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")]))),
        ref: input,
        value: shownQuery,
        placeholder: placeholder,
        autoFocus: isInputAutoFocused,
        onFocus: handleInputFocus,
        onClick: onInputClick,
        onChange: handleInputChange,
        onKeyDown: onInputKeyDown,
        onBlur: handleInputBlur,
        onClear: handleInputClear,
        autoComplete: "off",
        "aria-autocomplete": "list"
      }), renderInputRight && renderInputRight()]
    })), (isListBoxAlwaysOpened || isOpened) && jsx("div", _assign({
      id: "".concat(id, "-listbox"),
      role: "listbox",
      css: /*#__PURE__*/css(templateObject_4$P || (templateObject_4$P = __makeTemplateObject(["\n            min-height: 0;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            min-height: 0;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
    }, {
      children: renderListBox({
        items: items,
        query: shownQuery,
        hoveredIndex: hoveredIndex,
        onItemClick: onListClick,
        onItemMouseEnter: onListMouseEnter
      })
    }))]
  }));
}
var templateObject_1$1o, templateObject_2$16, templateObject_3$Z, templateObject_4$P;

var HistoryStorageContext = /*#__PURE__*/createContext({});
var useHistoryStorage = function useHistoryStorage() {
  return useContext(HistoryStorageContext);
};
function HistoryStorageProvider(_a) {
  var children = _a.children,
    props = __rest(_a, ["children"]);
  return jsx(HistoryStorageContext.Provider, _assign({
    value: props
  }, {
    children: children
  }));
}

function cssVariant$3(theme, variant) {
  switch (variant) {
    case 'thin':
      return /*#__PURE__*/css(templateObject_1$1n || (templateObject_1$1n = __makeTemplateObject(["\n        margin: 0;\n        padding: 0;\n        height: ", ";\n        border: none;\n        background-color: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")], ["\n        margin: 0;\n        padding: 0;\n        height: ", ";\n        border: none;\n        background-color: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")])), pxToRem(1), theme.divider);
    case 'thick':
      return /*#__PURE__*/css(templateObject_2$15 || (templateObject_2$15 = __makeTemplateObject(["\n        margin: 0;\n        padding: 0;\n        height: ", ";\n        border: none;\n        background-color: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")], ["\n        margin: 0;\n        padding: 0;\n        height: ", ";\n        border: none;\n        background-color: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")])), pxToRem(10), theme.background.groupedBase);
  }
}
function Divider$1(_a) {
  var variant = _a.variant,
    rest = __rest(_a, ["variant"]);
  var theme = useTheme();
  return jsx("hr", _assign({}, rest, {
    css: cssVariant$3(theme, variant)
  }));
}
var templateObject_1$1n, templateObject_2$15;

function HighlightedText(_a) {
  var item = _a.item,
    query = _a.query;
  var highlightedDisplay = item.value.highlightedDisplay;
  if (!query) return jsx(Fragment$1, {
    children: item.query
  });
  var parts = highlightedDisplay ? highlightedDisplay.split(/<strong>|<\/strong>/gi) : item.query.split(new RegExp("(".concat(query, ")"), 'gi'));
  return jsx(Fragment$1, {
    children: parts.map(function (part, index) {
      return jsx(Fragment, {
        children: index % 2 === 1 ? jsx("strong", {
          children: part
        }) : part
      }, index);
    })
  });
}
function KeywordItem(props) {
  return jsxs("div", _assign({
    css: /*#__PURE__*/css(templateObject_1$1m || (templateObject_1$1m = __makeTemplateObject(["\n        display: flex;\n        align-items: center;\n        white-space: nowrap;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        display: flex;\n        align-items: center;\n        white-space: nowrap;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
  }, {
    children: [jsx(Icon, {
      name: "search",
      size: 18,
      fill: function fill(theme) {
        return theme.content.base1;
      },
      css: /*#__PURE__*/css(templateObject_2$14 || (templateObject_2$14 = __makeTemplateObject(["\n          width: ", ";\n          height: ", ";\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          ", "\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          width: ", ";\n          height: ", ";\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          ", "\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(32), pxToRem(32), MEDIA_QUERY.min('laptop', "\n            width: ".concat(pxToRem(24), ";\n            height: ").concat(pxToRem(24), ";\n          ")))
    }), jsx("div", _assign({
      css: /*#__PURE__*/css(templateObject_3$Y || (templateObject_3$Y = __makeTemplateObject(["\n          flex: 1;\n          text-overflow: ellipsis;\n          overflow: hidden;\n          margin-left: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          flex: 1;\n          text-overflow: ellipsis;\n          overflow: hidden;\n          margin-left: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(8))
    }, {
      children: jsx(HighlightedText, _assign({}, props))
    }))]
  }));
}
var templateObject_1$1m, templateObject_2$14, templateObject_3$Y;

function CategoryItem(props) {
  var theme = useTheme();
  return jsxs("div", _assign({
    css: /*#__PURE__*/css(templateObject_1$1l || (templateObject_1$1l = __makeTemplateObject(["\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        white-space: nowrap;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        white-space: nowrap;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
  }, {
    children: [jsxs("div", _assign({
      css: /*#__PURE__*/css(templateObject_2$13 || (templateObject_2$13 = __makeTemplateObject(["\n          display: flex;\n          align-items: center;\n          overflow: hidden;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          display: flex;\n          align-items: center;\n          overflow: hidden;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
    }, {
      children: [jsx(Icon, {
        css: /*#__PURE__*/css(templateObject_3$X || (templateObject_3$X = __makeTemplateObject(["\n            width: ", ";\n            height: ", ";\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            ", "\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            width: ", ";\n            height: ", ";\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            ", "\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(32), pxToRem(32), MEDIA_QUERY.min('laptop', "\n              width: ".concat(pxToRem(24), ";\n              height: ").concat(pxToRem(24), ";\n              min-width: ").concat(pxToRem(24), ";\n            "))),
        name: "search",
        size: 18,
        fill: function fill(theme) {
          return theme.content.base1;
        }
      }), jsx("div", _assign({
        css: /*#__PURE__*/css(templateObject_4$O || (templateObject_4$O = __makeTemplateObject(["\n            text-overflow: ellipsis;\n            overflow: hidden;\n            margin-left: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            text-overflow: ellipsis;\n            overflow: hidden;\n            margin-left: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(8))
      }, {
        children: jsx(HighlightedText, _assign({}, props))
      })), jsx("span", {
        css: /*#__PURE__*/css(templateObject_5$D || (templateObject_5$D = __makeTemplateObject(["\n            width: ", ";\n            height: ", ";\n            background: ", ";\n            margin: 0 ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            width: ", ";\n            height: ", ";\n            background: ", ";\n            margin: 0 ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(1), pxToRem(10), theme.content.base4, pxToRem(4))
      }), jsx("span", _assign({
        css: /*#__PURE__*/css(templateObject_6$v || (templateObject_6$v = __makeTemplateObject(["\n          ", "\n          margin-right: ", ";\n          color: ", ";\n          ", "\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          ", "\n          margin-right: ", ";\n          color: ", ";\n          ", "\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), FONT_STYLE.caption1, pxToRem(14), theme.content.base2, MEDIA_QUERY.min('laptop', "\n            ".concat(FONT_STYLE.caption2, "\n          ")))
      }, {
        children: "\uCE74\uD14C\uACE0\uB9AC"
      }))]
    })), jsx(Icon, {
      name: "chevron_right",
      size: 18,
      fill: function fill(theme) {
        return theme.content.base3;
      }
    })]
  }));
}
var templateObject_1$1l, templateObject_2$13, templateObject_3$X, templateObject_4$O, templateObject_5$D, templateObject_6$v;

var MAX_DEPTH = 2;
function CategoryHierarchy(_a) {
  var hierarchy = _a.hierarchy;
  var trailings = hierarchy.slice(-MAX_DEPTH);
  var theme = useTheme();
  return jsx("div", _assign({
    css: /*#__PURE__*/css(templateObject_1$1k || (templateObject_1$1k = __makeTemplateObject(["\n      display: flex;\n      flex-flow: row wrap;\n      align-items: center;\n      width: 100%;\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n      display: flex;\n      flex-flow: row wrap;\n      align-items: center;\n      width: 100%;\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
  }, {
    children: trailings.map(function (depth, index) {
      return jsxs(Fragment, {
        children: [jsx("span", _assign({
          css: /*#__PURE__*/css(templateObject_2$12 || (templateObject_2$12 = __makeTemplateObject(["\n            display: inline-block;\n            font-weight: bold;\n            line-height: 1.4;\n            &:last-of-type {\n              color: ", ";\n            }\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            display: inline-block;\n            font-weight: bold;\n            line-height: 1.4;\n            &:last-of-type {\n              color: ", ";\n            }\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), theme.content.primary1.thick)
        }, {
          children: depth
        })), index < trailings.length - 1 && jsx(Icon, {
          name: "chevron_right",
          size: 12,
          css: /*#__PURE__*/css(templateObject_3$W || (templateObject_3$W = __makeTemplateObject(["margin: 0 ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["margin: 0 ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(6))
        })]
      }, index);
    })
  }));
}
var templateObject_1$1k, templateObject_2$12, templateObject_3$W;

function HistoryItem(_a) {
  var item = _a.item,
    hovered = _a.hovered;
  var theme = useTheme();
  var query = item.query,
    value = item.value;
  var historyStorage = useHistoryStorage();
  var handleDeleteClick = function handleDeleteClick(e) {
    e.stopPropagation();
    historyStorage.remove(value);
  };
  var renderItem = function renderItem() {
    var _a;
    var elem = query;
    if (_typeof(value) === 'object' && value.type === 'category') {
      // 기존 History 데이터가 undefined 인 경우가 있어, 옵셔널 값 추가
      var orgDisplay = (_a = value.value.orgDisplay) !== null && _a !== void 0 ? _a : '';
      elem = jsx(CategoryHierarchy, {
        hierarchy: orgDisplay.split('>').map(function (value) {
          return value.trim();
        })
      });
    }
    return jsx("span", _assign({
      css: /*#__PURE__*/css(templateObject_1$1j || (templateObject_1$1j = __makeTemplateObject(["\n          text-overflow: ellipsis;\n          overflow: hidden;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          text-overflow: ellipsis;\n          overflow: hidden;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
    }, {
      children: elem
    }));
  };
  return jsxs("div", _assign({
    css: /*#__PURE__*/css(templateObject_3$V || (templateObject_3$V = __makeTemplateObject(["\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      width: 100%;\n      padding: ", " 0;\n      box-sizing: border-box;\n      ", "\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      width: 100%;\n      padding: ", " 0;\n      box-sizing: border-box;\n      ", "\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(4), MEDIA_QUERY.min('laptop', /*#__PURE__*/css(templateObject_2$11 || (templateObject_2$11 = __makeTemplateObject(["\n        padding: ", " ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        padding: ", " ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(4), pxToRem(4))))
  }, {
    children: [renderItem(), jsx("button", _assign({
      type: "button",
      onClick: handleDeleteClick,
      css: [/*#__PURE__*/css(templateObject_4$N || (templateObject_4$N = __makeTemplateObject(["\n            ", "\n            margin-right: ", ";\n            padding: ", ";\n            transition: .1s opacity;\n            font-size: 0;\n            line-height: 0;\n            border-radius: ", ";\n            outline: none;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            ", "\n            margin-right: ", ";\n            padding: ", ";\n            transition: .1s opacity;\n            font-size: 0;\n            line-height: 0;\n            border-radius: ", ";\n            outline: none;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), RESET_BUTTON, pxToRem(-6), pxToRem(6), pxToRem(2)), HOVER(templateObject_5$C || (templateObject_5$C = __makeTemplateObject(["\n            opacity: .4;\n          "], ["\n            opacity: .4;\n          "]))), FOCUS(templateObject_6$u || (templateObject_6$u = __makeTemplateObject(["\n            box-shadow: 0 0 0 ", " ", ";\n          "], ["\n            box-shadow: 0 0 0 ", " ", ";\n          "])), pxToRem(3), theme.interactive.primary1.thin)]
    }, {
      children: jsx(Icon, {
        name: "dismiss",
        size: 12,
        fill: function fill(theme) {
          return hovered ? theme.content.base2 : theme.content.base3;
        }
      })
    }))]
  }));
}
var templateObject_1$1j, templateObject_2$11, templateObject_3$V, templateObject_4$N, templateObject_5$C, templateObject_6$u;

function HorizontalImage(_a) {
  var className = _a.className,
    verticalRatio = _a.verticalRatio,
    horizontalRatio = _a.horizontalRatio,
    alt = _a.alt,
    rest = __rest(_a, ["className", "verticalRatio", "horizontalRatio", "alt"]);
  return jsx("figure", _assign({
    className: className
  }, {
    children: jsx("img", _assign({}, rest, {
      alt: alt,
      height: 0,
      css: /*#__PURE__*/css(templateObject_1$1i || (templateObject_1$1i = __makeTemplateObject(["\n          height: 0;\n          display: block;\n          visibility: hidden;\n          padding-top: ", "%;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          height: 0;\n          display: block;\n          visibility: hidden;\n          padding-top: ", "%;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), 100 / verticalRatio * horizontalRatio)
    }))
  }));
}
function VerticalImage(_a) {
  var className = _a.className,
    verticalRatio = _a.verticalRatio,
    horizontalRatio = _a.horizontalRatio,
    alt = _a.alt,
    rest = __rest(_a, ["className", "verticalRatio", "horizontalRatio", "alt"]);
  var _b = useState(0),
    clientHeight = _b[0],
    setClientHeight = _b[1];
  return jsx("figure", _assign({
    ref: function ref(el) {
      if (el) {
        setClientHeight(el.getBoundingClientRect().height);
      }
    },
    css: /*#__PURE__*/css(templateObject_2$10 || (templateObject_2$10 = __makeTemplateObject(["\n        width: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        width: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(clientHeight / horizontalRatio * verticalRatio)),
    className: className
  }, {
    children: jsx("img", _assign({}, rest, {
      alt: alt,
      width: 0,
      height: 0,
      css: /*#__PURE__*/css(templateObject_3$U || (templateObject_3$U = __makeTemplateObject(["\n          width: 0;\n          height: 0;\n          visibility: hidden;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          width: 0;\n          height: 0;\n          visibility: hidden;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
    }))
  }));
}
var templateObject_1$1i, templateObject_2$10, templateObject_3$U;

function Image(_a) {
  var _b = _a.src,
    src = _b === void 0 ? '' : _b,
    _c = _a.src2x,
    src2x = _c === void 0 ? src : _c,
    _d = _a.src3x,
    src3x = _d === void 0 ? src2x : _d,
    _e = _a.axis,
    axis = _e === void 0 ? 'width' : _e,
    _f = _a.radius,
    radius = _f === void 0 ? 0 : _f,
    aspectRatio = _a.aspectRatio,
    rest = __rest(_a, ["src", "src2x", "src3x", "axis", "radius", "aspectRatio"]);
  var _g = useState(''),
    url = _g[0],
    setUrl = _g[1];
  var imageCss = /*#__PURE__*/css(templateObject_1$1h || (templateObject_1$1h = __makeTemplateObject(["\n    display: inline-block;\n    background: no-repeat 50% / cover;\n    border-radius: ", ";\n    background-image: url(", ");\n    @media only screen and (-webkit-min-device-pixel-ratio: 2),\n      only screen and (min--moz-device-pixel-ratio: 2),\n      only screen and (-o-min-device-pixel-ratio: 2/1),\n      only screen and (min-device-pixel-ratio: 2),\n      only screen and (min-resolution: 2dppx) {\n      background-image: url(", ");\n    }\n    @media only screen and (-webkit-min-device-pixel-ratio: 3),\n      only screen and (min--moz-device-pixel-ratio: 3),\n      only screen and (-o-min-device-pixel-ratio: 3/1),\n      only screen and (min-device-pixel-ratio: 3),\n      only screen and (min-resolution: 3dppx) {\n      background-image: url(", ");\n    }\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:imageCss;")], ["\n    display: inline-block;\n    background: no-repeat 50% / cover;\n    border-radius: ", ";\n    background-image: url(", ");\n    @media only screen and (-webkit-min-device-pixel-ratio: 2),\n      only screen and (min--moz-device-pixel-ratio: 2),\n      only screen and (-o-min-device-pixel-ratio: 2/1),\n      only screen and (min-device-pixel-ratio: 2),\n      only screen and (min-resolution: 2dppx) {\n      background-image: url(", ");\n    }\n    @media only screen and (-webkit-min-device-pixel-ratio: 3),\n      only screen and (min--moz-device-pixel-ratio: 3),\n      only screen and (-o-min-device-pixel-ratio: 3/1),\n      only screen and (min-device-pixel-ratio: 3),\n      only screen and (min-resolution: 3dppx) {\n      background-image: url(", ");\n    }\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:imageCss;")])), pxToRem(radius), src, src2x, src3x);
  var _h = aspectRatio.split(':').map(function (ratio) {
      return parseInt(ratio, 10);
    }),
    verticalRatio = _h[0],
    horizontalRatio = _h[1];
  useEffect(function () {
    switch (window.devicePixelRatio) {
      case 2:
        setUrl(src2x);
        break;
      case 3:
        setUrl(src3x);
        break;
      default:
        setUrl(src);
        break;
    }
  }, [src, src2x, src3x]);
  return axis === 'width' ? jsx(HorizontalImage, _assign({}, rest, {
    src: url,
    verticalRatio: verticalRatio,
    horizontalRatio: horizontalRatio,
    css: imageCss
  })) : jsx(VerticalImage, _assign({}, rest, {
    src: url,
    verticalRatio: verticalRatio,
    horizontalRatio: horizontalRatio,
    css: imageCss
  }));
}
var templateObject_1$1h;

function CircleImage(_a) {
  var rest = __rest(_a, []);
  return jsx(Image, _assign({}, rest, {
    aspectRatio: "1:1",
    css: /*#__PURE__*/css(templateObject_1$1g || (templateObject_1$1g = __makeTemplateObject(["\n        border-radius: 50%;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        border-radius: 50%;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
  }));
}
var templateObject_1$1g;

function ConsultingItem(props) {
  var value = props.item.value;
  var theme = useTheme();
  var cta = " ".concat(value.info.cta);
  return jsxs("div", _assign({
    css: /*#__PURE__*/css(templateObject_1$1f || (templateObject_1$1f = __makeTemplateObject(["\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        white-space: nowrap;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        white-space: nowrap;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
  }, {
    children: [jsxs("div", _assign({
      css: /*#__PURE__*/css(templateObject_2$$ || (templateObject_2$$ = __makeTemplateObject(["\n          display: flex;\n          align-items: center;\n          overflow: hidden;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          display: flex;\n          align-items: center;\n          overflow: hidden;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
    }, {
      children: [jsx("div", _assign({
        css: /*#__PURE__*/css(templateObject_3$T || (templateObject_3$T = __makeTemplateObject(["\n            width: ", ";\n            height: ", ";\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            ", "\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            width: ", ";\n            height: ", ";\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            ", "\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(32), pxToRem(32), MEDIA_QUERY.min('laptop', "\n              width: ".concat(pxToRem(24), ";\n              height: ").concat(pxToRem(24), ";\n            ")))
      }, {
        children: value.info.iconFileUrl ? jsx(CircleImage, {
          src: value.info.iconFileUrl,
          css: /*#__PURE__*/css(templateObject_4$M || (templateObject_4$M = __makeTemplateObject(["\n                  width: 100%;\n                  border: ", " solid ", ";\n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                  width: 100%;\n                  border: ", " solid ", ";\n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(0.5), theme.outline)
        }) : jsx(Icon, {
          name: "search",
          size: 18,
          fill: function fill(theme) {
            return theme.content.base1;
          }
        })
      })), jsxs("div", _assign({
        css: /*#__PURE__*/css(templateObject_5$B || (templateObject_5$B = __makeTemplateObject(["\n            flex: 1;\n            white-space: nowrap;\n            text-overflow: ellipsis;\n            overflow: hidden;\n            margin-left: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            flex: 1;\n            white-space: nowrap;\n            text-overflow: ellipsis;\n            overflow: hidden;\n            margin-left: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(8))
      }, {
        children: [jsx(HighlightedText, _assign({}, props)), cta]
      }))]
    })), jsx(Icon, {
      name: "chevron_right",
      size: 18,
      fill: function fill(theme) {
        return theme.content.base3;
      }
    })]
  }));
}
var templateObject_1$1f, templateObject_2$$, templateObject_3$T, templateObject_4$M, templateObject_5$B;

function ListBoxItem(_a) {
  var item = _a.item,
    hovered = _a.hovered,
    query = _a.query,
    _b = _a.showDivider,
    showDivider = _b === void 0 ? false : _b,
    onHover = _a.onHover,
    props = __rest(_a, ["item", "hovered", "query", "showDivider", "onHover"]);
  var theme = useTheme();
  var ref = useRef(null);
  var renderItem = function renderItem() {
    switch (item.type) {
      case 'query':
        return jsx(KeywordItem, {
          item: item,
          query: query
        });
      case 'category':
        return jsx(CategoryItem, {
          item: item,
          query: query
        });
      case 'consulting':
        return jsx(ConsultingItem, {
          item: item,
          query: query
        });
      case 'history':
        return jsx(HistoryItem, {
          item: item,
          hovered: hovered
        });
      default:
        return null;
    }
  };
  useEffect(function () {
    if (!hovered || !ref.current) return;
    onHover(ref.current);
  }, [hovered, onHover]);
  return jsxs(Fragment$1, {
    children: [jsx("li", _assign({
      ref: ref,
      role: "option",
      "aria-selected": undefined,
      css: [/*#__PURE__*/css(templateObject_2$_ || (templateObject_2$_ = __makeTemplateObject(["\n            ", "\n            position: relative;\n            margin: 0;\n            padding: ", " ", ";\n            color: ", ";\n            line-height: ", ";\n            cursor: pointer;\n            border-radius: ", ";\n            outline: none;\n            strong {\n              color: ", ";\n              font-weight: 400;\n            }\n            ", "\n            ", "\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            ", "\n            position: relative;\n            margin: 0;\n            padding: ", " ", ";\n            color: ", ";\n            line-height: ", ";\n            cursor: pointer;\n            border-radius: ", ";\n            outline: none;\n            strong {\n              color: ", ";\n              font-weight: 400;\n            }\n            ", "\n            ", "\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), FONT_STYLE.subTitle1, pxToRem(8), pxToRem(16), theme.content.base1, pxToRem(21), pxToRem(2), theme.content.primary1.thick, hovered && "background: ".concat(theme.background.groupedBase, ";"), MEDIA_QUERY.min('laptop', /*#__PURE__*/css(templateObject_1$1e || (templateObject_1$1e = __makeTemplateObject(["\n              ", "\n              padding: ", ";\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              ", "\n              padding: ", ";\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), FONT_STYLE.subTitle2, pxToRem(8)))), FOCUS(templateObject_3$S || (templateObject_3$S = __makeTemplateObject(["\n          background: ", ";\n        "], ["\n          background: ", ";\n        "])), theme.background.groupedBase)],
      tabIndex: 0
    }, props, {
      children: renderItem()
    })), showDivider && jsx(Divider$1, {
      css: /*#__PURE__*/css(templateObject_4$L || (templateObject_4$L = __makeTemplateObject(["\n            margin: ", " 0;\n            ", "\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            margin: ", " 0;\n            ", "\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(8), MEDIA_QUERY.min('laptop', "\n              margin: ".concat(pxToRem(10), " 0;\n            "))),
      variant: "thin"
    })]
  });
}
var templateObject_1$1e, templateObject_2$_, templateObject_3$S, templateObject_4$L;

function filterOnlyHistoryKeyword(items) {
  return items.filter(function (item) {
    return item.type === 'history' && typeof item.value !== 'string' && item.value.type === 'query';
  });
}
function ListBox(_a) {
  var items = _a.items,
    query = _a.query,
    hoveredIndex = _a.hoveredIndex,
    isHistoryList = _a.isHistoryList,
    onItemClick = _a.onItemClick,
    onItemMouseEnter = _a.onItemMouseEnter;
  var theme = useTheme();
  var container = useRef(null);
  var log = useLogContext();
  var handleIntersect = useCallback(function () {
    if (filterOnlyHistoryKeyword(items).length > 0) {
      log({
        key: 'primary.right.search.history',
        category: 'impression',
        params: {
          type: 'keyword'
        }
      });
    }
  }, [items, log]);
  var isShowDivider = useCallback(function (item, index) {
    return index < items.length - 1 && items[index + 1].type !== item.type;
  }, [items]);
  var handleItemHover = useCallback(function (item) {
    if (!container.current) return;
    container.current.scrollTop = item.offsetTop - (container.current.offsetHeight - item.offsetHeight) / 2;
  }, []);
  var handleItemClick = useCallback(function (item, index) {
    return function () {
      return onItemClick(item, index);
    };
  }, [onItemClick]);
  var handleItemMouseEnter = useCallback(function (item, index) {
    return function () {
      return onItemMouseEnter(item, index);
    };
  }, [onItemMouseEnter]);
  return jsx(IntersectionObserver, _assign({
    onIntersect: handleIntersect
  }, {
    children: jsxs("div", _assign({
      ref: container,
      css: /*#__PURE__*/css(templateObject_1$1d || (templateObject_1$1d = __makeTemplateObject(["\n        overflow-y: auto;\n        position: relative;\n        width: 100%;\n        padding: ", " 0;\n        border: ", " solid ", ";\n        border-radius: ", ";\n        background: ", ";\n        box-shadow: 0 ", " ", " 0 ", ";\n        box-sizing: border-box;\n        ", "\n        ", "\n        ", "\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        overflow-y: auto;\n        position: relative;\n        width: 100%;\n        padding: ", " 0;\n        border: ", " solid ", ";\n        border-radius: ", ";\n        background: ", ";\n        box-shadow: 0 ", " ", " 0 ", ";\n        box-sizing: border-box;\n        ", "\n        ", "\n        ", "\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(10), pxToRem(1), theme.divider, pxToRem(4), theme.background.base, pxToRem(4), pxToRem(6), theme.shadow.basic, MEDIA_QUERY.min('laptop', "\n          position: absolute;\n          top: calc(100% + ".concat(pxToRem(4), ");\n          left: 0;\n          max-height: ").concat(pxToRem(400), ";\n        ")), MEDIA_QUERY.only('tablet', "\n          top: ".concat(pxToRem(4), ";\n          height: 100%;\n        ")), MEDIA_QUERY.only('mobile', "\n          height: 100%;\n          padding: ".concat(pxToRem(8), " 0;\n          border: 0;\n          box-shadow: none;\n        ")))
    }, {
      children: [!isHistoryList && jsx(HistoryListBoxHeader, {
        hasDeleteButton: items.length > 0
      }), items.length > 0 ? jsx("ul", _assign({
        css: /*#__PURE__*/css(templateObject_2$Z || (templateObject_2$Z = __makeTemplateObject(["\n              margin: 0;\n              padding: 0;\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              margin: 0;\n              padding: 0;\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
      }, {
        children: items.map(function (item, index) {
          return jsx(ListBoxItem, {
            item: item,
            query: query,
            hovered: hoveredIndex === index,
            showDivider: isShowDivider(item, index),
            onHover: handleItemHover,
            onClick: handleItemClick(item, index),
            onMouseEnter: handleItemMouseEnter(item, index)
          }, "".concat(item.query).concat(index));
        })
      })) : jsx("p", _assign({
        css: /*#__PURE__*/css(templateObject_3$R || (templateObject_3$R = __makeTemplateObject(["\n            margin: 0;\n            padding: ", " ", ";\n            color: ", ";\n            font-size: ", ";\n            line-height: 1.4;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            margin: 0;\n            padding: ", " ", ";\n            color: ", ";\n            font-size: ", ";\n            line-height: 1.4;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(10), pxToRem(16), theme.content.base3, pxToRem(15))
      }, {
        children: "\uCD5C\uADFC \uAC80\uC0C9\uD55C \uB0B4\uC5ED\uC774 \uC5C6\uC2B5\uB2C8\uB2E4."
      }))]
    }))
  }));
}
function HistoryListBoxHeader(_a) {
  var hasDeleteButton = _a.hasDeleteButton;
  var theme = useTheme();
  var historyStorage = useHistoryStorage();
  return jsxs("div", _assign({
    css: /*#__PURE__*/css(templateObject_4$K || (templateObject_4$K = __makeTemplateObject(["\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding: ", " ", " ", ";\n        font-size: ", ";\n        line-height: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding: ", " ", " ", ";\n        font-size: ", ";\n        line-height: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(7), pxToRem(8), pxToRem(10), pxToRem(15), pxToRem(21))
  }, {
    children: [jsx("span", _assign({
      css: /*#__PURE__*/css(templateObject_5$A || (templateObject_5$A = __makeTemplateObject(["\n          font-size: ", ";\n          color: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          font-size: ", ";\n          color: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(13), theme.content.base2)
    }, {
      children: "\uCD5C\uADFC \uAC80\uC0C9\uC5B4"
    })), hasDeleteButton && jsx("button", _assign({
      type: "button",
      onClick: historyStorage.removeAll,
      css: [/*#__PURE__*/css(templateObject_6$t || (templateObject_6$t = __makeTemplateObject(["\n              ", "\n              margin: ", ";\n              padding: ", ";\n              font-size: ", ";\n              color: ", ";\n              border-radius: ", ";\n              outline: none;\n              transition: .1s opacity;\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              ", "\n              margin: ", ";\n              padding: ", ";\n              font-size: ", ";\n              color: ", ";\n              border-radius: ", ";\n              outline: none;\n              transition: .1s opacity;\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), RESET_BUTTON, pxToRem(-2), pxToRem(2), pxToRem(12), theme.content.base2, pxToRem(2)), HOVER(templateObject_7$o || (templateObject_7$o = __makeTemplateObject(["\n              opacity: .4;\n            "], ["\n              opacity: .4;\n            "]))), FOCUS(templateObject_8$i || (templateObject_8$i = __makeTemplateObject(["\n              box-shadow: 0 0 0 ", " ", ";\n            "], ["\n              box-shadow: 0 0 0 ", " ", ";\n            "])), pxToRem(3), theme.interactive.primary1.thin)]
    }, {
      children: "\uC804\uCCB4 \uC0AD\uC81C"
    }))]
  }));
}
var templateObject_1$1d, templateObject_2$Z, templateObject_3$R, templateObject_4$K, templateObject_5$A, templateObject_6$t, templateObject_7$o, templateObject_8$i;

function getSearchPlaceholder(searchType) {
  return searchType === 'store' && '쇼핑 검색' || searchType === 'expert_user' && '시공업체 검색' || '통합검색';
}

function NavigationSearch(_a) {
  var _this = this;
  var searchType = _a.searchType,
    initialQuery = _a.initialQuery,
    onFetch = _a.onFetch,
    onSubmit = _a.onSubmit,
    onSubmitItem = _a.onSubmitItem,
    onInputFocus = _a.onInputFocus,
    historyStorage = _a.historyStorage,
    placeholder = _a.placeholder,
    props = __rest(_a, ["searchType", "initialQuery", "onFetch", "onSubmit", "onSubmitItem", "onInputFocus", "historyStorage", "placeholder"]);
  var _b = useState(null),
    pageKey = _b[0],
    setPageKey = _b[1];
  var _c = useState(initialQuery),
    manuallyTypedInputValue = _c[0],
    setManuallyTypedInputValue = _c[1];
  var fetchListFromSearchHistory = useCallback(function () {
    var history = historyStorage.get();
    return history.map(function (value) {
      return {
        type: 'history',
        value: value,
        query: typeof value === 'string' ? value : value.query
      };
    });
  }, [historyStorage]);
  var fetchList = useCallback(function (query) {
    return __awaiter(_this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        if (!manuallyTypedInputValue) {
          return [2 /*return*/, fetchListFromSearchHistory()];
        }
        return [2 /*return*/, onFetch(query)];
      });
    });
  }, [manuallyTypedInputValue, fetchListFromSearchHistory, onFetch]);
  var handleHistoryUpdate = useCallback(function () {
    setPageKey(_assign(_assign({}, window.location), {
      timestamp: new Date().getTime()
    }));
  }, []);
  var handleSubmit = useCallback(function (value) {
    historyStorage.append(value);
    if (onSubmit) onSubmit(value);
  }, [historyStorage, onSubmit]);
  var log = useLogContext();
  var logAutocompleteKeyword = useCallback(function (item, index) {
    var params = {
      type: item.type,
      index: index,
      id: item.query
    };
    if (item.type === 'history' && typeof item.value !== 'string') {
      log({
        key: 'primary.right.search.history',
        category: 'click',
        params: _assign(_assign({}, params), {
          type: item.value.type
        })
      });
    }
    if (item.type === 'category' || item.type === 'query') {
      log({
        key: "primary.right.search.autocomplete.".concat(item.type),
        category: 'click',
        params: params
      });
    }
  }, [log]);
  var handleSubmitItem = useCallback(function (item, index) {
    var value = item.type === 'history' ? item.value : item;
    historyStorage.append(value);
    if (onSubmitItem) onSubmitItem(item);
    logAutocompleteKeyword(item, index);
  }, [historyStorage, onSubmitItem, logAutocompleteKeyword]);
  var handleInputFocus = useCallback(function (e) {
    if (onInputFocus) onInputFocus(e);
    log({
      key: 'primary.right.search.input',
      category: 'click',
      params: {
        search_type: searchType
      }
    });
  }, [onInputFocus, log, searchType]);
  return jsx(HistoryStorageProvider, _assign({
    get: historyStorage.get,
    set: function set(histories) {
      historyStorage.set(histories);
      handleHistoryUpdate();
    },
    append: function append(history) {
      historyStorage.append(history);
      handleHistoryUpdate();
    },
    remove: function remove(history) {
      historyStorage.remove(history);
      handleHistoryUpdate();
    },
    removeAll: function removeAll() {
      historyStorage.removeAll();
      handleHistoryUpdate();
    }
  }, {
    children: jsx(Search, _assign({
      id: "global-search",
      pageKey: pageKey,
      initialQuery: initialQuery,
      placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : getSearchPlaceholder(searchType),
      fetchList: fetchList,
      getItemQuery: function getItemQuery(item) {
        return item.query;
      },
      renderListBox: function renderListBox(props) {
        return jsx(ListBox, _assign({}, props, {
          isHistoryList: !!manuallyTypedInputValue
        }));
      },
      onSubmit: handleSubmit,
      onSubmitItem: handleSubmitItem,
      onInputFocus: handleInputFocus,
      onInputChange: setManuallyTypedInputValue
    }, props))
  }));
}

var KEYFRAMES = {
  overlay: keyframes(templateObject_1$1c || (templateObject_1$1c = __makeTemplateObject(["\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  "], ["\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  "]))),
  drawer: keyframes(templateObject_2$Y || (templateObject_2$Y = __makeTemplateObject(["\n    from {\n      transform: translateX(-100%);\n    }\n    to {\n      transform: translateX(0);\n    }\n  "], ["\n    from {\n      transform: translateX(-100%);\n    }\n    to {\n      transform: translateX(0);\n    }\n  "])))
};
var Animation = {
  open: 'open',
  close: 'close'
};
function Drawer(_a) {
  var open = _a.open,
    _b = _a.align,
    align = _b === void 0 ? 'left' : _b,
    width = _a.width,
    padding = _a.padding,
    animationKeyframes = _a.animationKeyframes,
    containerCss = _a.containerCss,
    children = _a.children,
    onClose = _a.onClose,
    onClosed = _a.onClosed;
  var theme = useTheme();
  var scrollAvailableRef = useRef(null);
  var _c = useState(undefined),
    animation = _c[0],
    setAnimation = _c[1];
  var _d = useState(open),
    visible = _d[0],
    setVisible = _d[1];
  useEffect(function () {
    setAnimation(open ? Animation.open : Animation.close);
  }, [open]);
  useEffect(function () {
    if (open) {
      setVisible(true);
    }
  }, [open]);
  var overlayAnimation = (animationKeyframes === null || animationKeyframes === void 0 ? void 0 : animationKeyframes.overlay) || KEYFRAMES.overlay;
  var drawerAnimation = (animationKeyframes === null || animationKeyframes === void 0 ? void 0 : animationKeyframes.drawer) || KEYFRAMES.drawer;
  var handleNavigationClose = useCallback(function () {
    onClose();
  }, [onClose]);
  var handleAnimationEnd = useCallback(function () {
    if (animation === Animation.open) {
      setAnimation(undefined);
    }
    if (animation === Animation.close) {
      setVisible(false);
      onClosed === null || onClosed === void 0 ? void 0 : onClosed();
    }
  }, [animation, onClosed]);
  if (!visible) {
    return null;
  }
  return jsxs(OverlayPortal, {
    children: [jsx(ScrollLock, {
      enabled: open,
      getElement: function getElement() {
        return scrollAvailableRef.current;
      }
    }), jsx(Dim, _assign({
      ref: scrollAvailableRef,
      variant: "basic",
      onClick: handleNavigationClose,
      css: /*#__PURE__*/css(templateObject_5$z || (templateObject_5$z = __makeTemplateObject(["\n          ", "\n          ", "\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          ", "\n          ", "\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), animation === Animation.open && /*#__PURE__*/css(templateObject_3$Q || (templateObject_3$Q = __makeTemplateObject(["\n            animation: ", " .2s forwards;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            animation: ", " .2s forwards;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), overlayAnimation), animation === Animation.close && /*#__PURE__*/css(templateObject_4$J || (templateObject_4$J = __makeTemplateObject(["\n            pointer-events: none;\n            animation: ", " .2s reverse forwards;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            pointer-events: none;\n            animation: ", " .2s reverse forwards;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), overlayAnimation))
    }, {
      children: jsx("div", _assign({
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        onAnimationEnd: handleAnimationEnd,
        css: [/*#__PURE__*/css(templateObject_8$h || (templateObject_8$h = __makeTemplateObject(["\n              position: absolute;\n              overflow-y: auto;\n              top: 0;\n              bottom: 0;\n              ", ";\n              width: ", ";\n              height: 100%;\n              padding: ", ";\n              box-sizing: border-box;\n              background: ", ";\n              text-align: left;\n              ", "\n              ", "\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              position: absolute;\n              overflow-y: auto;\n              top: 0;\n              bottom: 0;\n              ", ";\n              width: ", ";\n              height: 100%;\n              padding: ", ";\n              box-sizing: border-box;\n              background: ", ";\n              text-align: left;\n              ", "\n              ", "\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), align === 'left' ? 'left: 0' : 'right: 0', width != null ? "".concat(width, "px") : '100%', padding != null ? "".concat(padding[0], " ").concat(padding[1]) : "".concat(pxToRem(26), " ").concat(pxToRem(16)), theme.background.base, animation === Animation.open && /*#__PURE__*/css(templateObject_6$s || (templateObject_6$s = __makeTemplateObject(["\n                animation: ", " .3s forwards;\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                animation: ", " .3s forwards;\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), drawerAnimation), animation === Animation.close && /*#__PURE__*/css(templateObject_7$n || (templateObject_7$n = __makeTemplateObject(["\n                animation: ", " .3s reverse forwards;\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                animation: ", " .3s reverse forwards;\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), drawerAnimation)), containerCss]
      }, {
        children: children
      }))
    }))]
  });
}
var templateObject_1$1c, templateObject_2$Y, templateObject_3$Q, templateObject_4$J, templateObject_5$z, templateObject_6$s, templateObject_7$n, templateObject_8$h;

var slideIn = keyframes(templateObject_1$1b || (templateObject_1$1b = __makeTemplateObject(["\n  from {\n    transform: translateX(50px);\n  }\n  to {\n    transform: translateX(0);\n  }\n"], ["\n  from {\n    transform: translateX(50px);\n  }\n  to {\n    transform: translateX(0);\n  }\n"])));
function SearchDrawer(_a) {
  var className = _a.className,
    onSubmit = _a.onSubmit,
    onSubmitItem = _a.onSubmitItem,
    searchProps = __rest(_a, ["className", "onSubmit", "onSubmitItem"]);
  var theme = useTheme();
  var _b = useState(false),
    open = _b[0],
    setOpen = _b[1];
  var drawerAnimation = {
    drawer: slideIn
  };
  var handleDrawerOpen = useCallback(function () {
    setOpen(true);
  }, []);
  var handleDrawerClose = useCallback(function () {
    setOpen(false);
  }, []);
  var handleSubmit = useCallback(function (value) {
    setOpen(false);
    onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(value);
  }, [onSubmit]);
  var handleSubmitItem = useCallback(function (item) {
    setOpen(false);
    onSubmitItem === null || onSubmitItem === void 0 ? void 0 : onSubmitItem(item);
  }, [onSubmitItem]);
  return jsxs("div", _assign({
    css: className
  }, {
    children: [jsx("button", _assign({
      type: "button",
      css: [/*#__PURE__*/css(templateObject_2$X || (templateObject_2$X = __makeTemplateObject(["\n            ", "\n            padding: ", ";\n            margin: ", " ", ";\n            color: ", ";\n            line-height: 0;\n            outline: none;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            ", "\n            padding: ", ";\n            margin: ", " ", ";\n            color: ", ";\n            line-height: 0;\n            outline: none;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), RESET_BUTTON, pxToRem(6), pxToRem(3), pxToRem(1), theme.content.base1), HOVER(templateObject_3$P || (templateObject_3$P = __makeTemplateObject(["\n            color: ", ";\n          "], ["\n            color: ", ";\n          "])), theme.content.primary1.basic), FOCUS(templateObject_4$I || (templateObject_4$I = __makeTemplateObject(["\n            color: ", ";\n          "], ["\n            color: ", ";\n          "])), theme.content.primary1.basic)],
      onClick: handleDrawerOpen
    }, {
      children: jsx(Icon, {
        name: "search",
        size: 24
      })
    })), jsx(Drawer, _assign({
      open: open,
      align: "right",
      onClose: handleDrawerClose,
      animationKeyframes: drawerAnimation,
      containerCss: /*#__PURE__*/css(templateObject_5$y || (templateObject_5$y = __makeTemplateObject(["\n          ", "\n          ", "\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:containerCss;")], ["\n          ", "\n          ", "\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:containerCss;")])), safeAreaInset('bottom', 'padding-bottom'), MEDIA_QUERY.min('tablet', "\n            min-width: ".concat(pxToRem(256), ";\n            max-width: ").concat(pxToRem(326), ";\n            padding: ").concat(pxToRem(30), ";\n          ")))
    }, {
      children: jsx(NavigationSearch, _assign({}, searchProps, {
        onSubmit: handleSubmit,
        onSubmitItem: handleSubmitItem,
        isInputAutoFocused: true,
        renderInputRight: function renderInputRight() {
          return jsx("button", _assign({
            type: "button",
            onClick: handleDrawerClose,
            css: [/*#__PURE__*/css(templateObject_6$r || (templateObject_6$r = __makeTemplateObject(["\n                  ", "\n                  flex-shrink: 0;\n                  margin-left: ", ";\n                  padding: ", " ", " ", ";\n                  color: ", ";\n                  font-size: ", ";\n                  line-height: 1;\n                  font-weight: 700;\n                  outline: none;\n                  ", "\n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                  ", "\n                  flex-shrink: 0;\n                  margin-left: ", ";\n                  padding: ", " ", " ", ";\n                  color: ", ";\n                  font-size: ", ";\n                  line-height: 1;\n                  font-weight: 700;\n                  outline: none;\n                  ", "\n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), RESET_BUTTON, pxToRem(15), pxToRem(9), pxToRem(5), pxToRem(10), theme.content.base1, pxToRem(15), MEDIA_QUERY.min('tablet', "\n                    display: none;\n                  ")), FOCUS(templateObject_7$m || (templateObject_7$m = __makeTemplateObject(["\n                  & > span {\n                    box-shadow: 0 0 0 ", " ", ";\n                  }\n                "], ["\n                  & > span {\n                    box-shadow: 0 0 0 ", " ", ";\n                  }\n                "])), pxToRem(3), theme.interactive.primary1.thin)]
          }, {
            children: jsx("span", _assign({
              css: /*#__PURE__*/css(templateObject_8$g || (templateObject_8$g = __makeTemplateObject(["\n                display: inline-block;\n                margin: ", ";\n                padding: ", ";\n                border-radius: ", ";\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                display: inline-block;\n                margin: ", ";\n                padding: ", ";\n                border-radius: ", ";\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(-4), pxToRem(4), pxToRem(2))
            }, {
              children: "\uCDE8\uC18C"
            }))
          }));
        }
      }))
    }))]
  }));
}
var templateObject_1$1b, templateObject_2$X, templateObject_3$P, templateObject_4$I, templateObject_5$y, templateObject_6$r, templateObject_7$m, templateObject_8$g;

function UploadDropdownContentItem(_a) {
  var href = _a.href,
    icon = _a.icon,
    title = _a.title,
    subtitle = _a.subtitle,
    logId = _a.logId;
  var theme = useTheme();
  var LinkComponent = useLinkContext();
  var log = useLogContext();
  return jsxs(LinkComponent, _assign({
    href: href,
    css: [/*#__PURE__*/css(templateObject_1$1a || (templateObject_1$1a = __makeTemplateObject(["\n          display: flex;\n          align-items: center;\n          padding: ", ";\n          background-color: ", ";\n          border-radius: ", ";\n          transition: .1s background-color;\n          word-break: keep-all;\n          white-space: nowrap;\n          font-size: ", ";\n          line-height: 0;\n          outline: none;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          display: flex;\n          align-items: center;\n          padding: ", ";\n          background-color: ", ";\n          border-radius: ", ";\n          transition: .1s background-color;\n          word-break: keep-all;\n          white-space: nowrap;\n          font-size: ", ";\n          line-height: 0;\n          outline: none;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(15), theme.background.base, pxToRem(2), pxToRem(15)), HOVER(templateObject_2$W || (templateObject_2$W = __makeTemplateObject(["\n          background-color: ", ";\n        "], ["\n          background-color: ", ";\n        "])), theme.background.groupedBase), FOCUS(templateObject_3$O || (templateObject_3$O = __makeTemplateObject(["\n          background-color: ", ";\n        "], ["\n          background-color: ", ";\n        "])), theme.background.groupedBase)],
    onClick: function onClick() {
      if (logId) {
        log({
          key: logId,
          category: 'click'
        });
      }
    }
  }, {
    children: [jsx("div", _assign({
      css: /*#__PURE__*/css(templateObject_4$H || (templateObject_4$H = __makeTemplateObject(["\n          position: relative;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          position: relative;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
    }, {
      children: icon
    })), jsxs("div", _assign({
      css: /*#__PURE__*/css(templateObject_5$x || (templateObject_5$x = __makeTemplateObject(["\n          margin-left: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          margin-left: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(12))
    }, {
      children: [jsx("div", _assign({
        css: /*#__PURE__*/css(templateObject_6$q || (templateObject_6$q = __makeTemplateObject(["\n            font-size: ", ";\n            font-weight: bold;\n            line-height: ", ";\n            color: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            font-size: ", ";\n            font-weight: bold;\n            line-height: ", ";\n            color: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(15), pxToRem(21), theme.content.base1)
      }, {
        children: title
      })), jsx("div", _assign({
        css: /*#__PURE__*/css(templateObject_7$l || (templateObject_7$l = __makeTemplateObject(["\n            margin: ", " 0 0;\n            font-size: ", ";\n            line-height: ", ";\n            color: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            margin: ", " 0 0;\n            font-size: ", ";\n            line-height: ", ";\n            color: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(4), pxToRem(12), pxToRem(16), theme.content.base2)
      }, {
        children: subtitle
      }))]
    }))]
  }));
}
var templateObject_1$1a, templateObject_2$W, templateObject_3$O, templateObject_4$H, templateObject_5$x, templateObject_6$q, templateObject_7$l;

var BUTTON_SIZE = 40;
function UploadDropdownContentButton(_a) {
  var uploadMenuLinks = _a.uploadMenuLinks;
  var theme = useTheme();
  var log = useLogContext();
  var _b = getWithIconOptions(BUTTON_SIZE),
    gap = _b.gap,
    iconSize = _b.iconSize;
  return jsx(Popper, _assign({
    usePortal: false,
    renderButton: function renderButton(_a) {
      var _onClick = _a.onClick;
      return jsxs(Button$2, _assign({
        variant: "primary1",
        size: BUTTON_SIZE,
        type: "button",
        css: [/*#__PURE__*/css(templateObject_1$19 || (templateObject_1$19 = __makeTemplateObject(["\n              outline: none;\n              overflow: hidden;\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              outline: none;\n              overflow: hidden;\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")]))), FOCUS(templateObject_2$V || (templateObject_2$V = __makeTemplateObject(["\n              box-shadow: 0 0 0 ", " ", ";\n            "], ["\n              box-shadow: 0 0 0 ", " ", ";\n            "])), pxToRem(3), theme.interactive.primary1.thin)],
        onClick: function onClick() {
          _onClick();
          log({
            key: 'primary.right.upload',
            category: 'click'
          });
        }
      }, {
        children: [jsx("span", _assign({
          css: /*#__PURE__*/css(templateObject_3$N || (templateObject_3$N = __makeTemplateObject(["\n              vertical-align: middle;\n              white-space: nowrap;\n              ", "\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              vertical-align: middle;\n              white-space: nowrap;\n              ", "\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), MEDIA_QUERY.min('laptop', "\n                margin-right: ".concat(pxToRem(gap), ";\n              ")))
        }, {
          children: "\uAE00\uC4F0\uAE30"
        })), jsx(Icon, {
          css: /*#__PURE__*/css(templateObject_4$G || (templateObject_4$G = __makeTemplateObject(["\n              vertical-align: middle;\n              display: none;\n              ", "\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              vertical-align: middle;\n              display: none;\n              ", "\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), MEDIA_QUERY.min('laptop', "\n                display: inline-block;\n              ")),
          name: "chevron_down",
          size: iconSize
        })]
      }));
    }
  }, {
    children: uploadMenuLinks && uploadMenuLinks.map(function (item) {
      return jsx(UploadDropdownContentItem, _assign({}, item), item.title);
    })
  }));
}
var templateObject_1$19, templateObject_2$V, templateObject_3$N, templateObject_4$G;

function UserDropdownContentItem(_a) {
  var bullet = _a.bullet,
    title = _a.title,
    href = _a.href,
    _onClick = _a.onClick,
    logKey = _a.logKey;
  var theme = useTheme();
  var LinkComponent = useLinkContext();
  var log = useLogContext();
  var Component = href ? LinkComponent : 'button';
  return jsxs(Component, _assign({}, Component === LinkComponent ? {
    href: href
  } : {
    type: 'button'
  }, {
    css: [/*#__PURE__*/css(templateObject_1$18 || (templateObject_1$18 = __makeTemplateObject(["\n          display: block;\n          position: relative;\n          width: 100%;\n          margin: 0;\n          padding: ", " ", " ", ";\n          box-sizing: border-box;\n          border: none;\n          background: ", ";\n          color: ", ";\n          font-family: inherit;\n          font-weight: normal;\n          font-size: ", ";\n          line-height: ", ";\n          text-decoration: none;\n          text-align: left;\n          cursor: pointer;\n          border-radius: ", ";\n          outline: none;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          display: block;\n          position: relative;\n          width: 100%;\n          margin: 0;\n          padding: ", " ", " ", ";\n          box-sizing: border-box;\n          border: none;\n          background: ", ";\n          color: ", ";\n          font-family: inherit;\n          font-weight: normal;\n          font-size: ", ";\n          line-height: ", ";\n          text-decoration: none;\n          text-align: left;\n          cursor: pointer;\n          border-radius: ", ";\n          outline: none;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(10), pxToRem(14), pxToRem(11), theme.background.base, theme.content.base1, pxToRem(15), pxToRem(21), pxToRem(2)), HOVER(templateObject_2$U || (templateObject_2$U = __makeTemplateObject(["\n          background: ", ";\n        "], ["\n          background: ", ";\n        "])), theme.background.groupedBase), FOCUS(templateObject_3$M || (templateObject_3$M = __makeTemplateObject(["\n          background: ", ";\n        "], ["\n          background: ", ";\n        "])), theme.background.groupedBase)],
    onClick: function onClick() {
      if (logKey) {
        log({
          key: logKey,
          category: 'click'
        });
      }
      if (_onClick) {
        _onClick();
      }
    }
  }, {
    children: [title, bullet === 'new' && jsx(NewIcon, {
      css: /*#__PURE__*/css(templateObject_4$F || (templateObject_4$F = __makeTemplateObject(["\n            vertical-align: middle;\n            margin: 0 1.5px 1.5px 0;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            vertical-align: middle;\n            margin: 0 1.5px 1.5px 0;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
    })]
  }));
}
var templateObject_1$18, templateObject_2$U, templateObject_3$M, templateObject_4$F;

var DEFAULT_PROFILE_URL = 'https://image.ohou.se/i/bucketplace-v2-development/uploads/users/profile_images1542987307_LkcmI.jpeg';
function UserDropdownContentButton(_a) {
  var profileUrl = _a.profileUrl,
    userMenu = _a.userMenu;
  var theme = useTheme();
  var items = useMemo(function () {
    return userMenu.filter(function (menu) {
      var _a;
      return (_a = menu.showOn) === null || _a === void 0 ? void 0 : _a.includes('bar');
    });
  }, [userMenu]);
  return jsx(Popper, _assign({
    usePortal: false,
    renderButton: function renderButton(_a) {
      var onClick = _a.onClick;
      return jsx("button", _assign({
        css: [/*#__PURE__*/css(templateObject_1$17 || (templateObject_1$17 = __makeTemplateObject(["\n              ", "\n              position: relative;\n              overflow: hidden;\n              width: ", ";\n              height: ", ";\n              border-radius: 100%;\n              outline: none;\n              &:after {\n                content: '';\n                display: none;\n                position: absolute;\n                top: 0;\n                left: 0;\n                width: 100%;\n                height: 100%;\n                border-radius: 100%;\n                border: ", " solid ", ";\n                box-sizing: border-box;\n              }\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              ", "\n              position: relative;\n              overflow: hidden;\n              width: ", ";\n              height: ", ";\n              border-radius: 100%;\n              outline: none;\n              &:after {\n                content: '';\n                display: none;\n                position: absolute;\n                top: 0;\n                left: 0;\n                width: 100%;\n                height: 100%;\n                border-radius: 100%;\n                border: ", " solid ", ";\n                box-sizing: border-box;\n              }\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), RESET_BUTTON, pxToRem(40), pxToRem(40), pxToRem(2), theme.content.primary1.basic), HOVER(templateObject_2$T || (templateObject_2$T = __makeTemplateObject(["\n              &:after {\n                display: block;\n              }\n            "], ["\n              &:after {\n                display: block;\n              }\n            "]))), FOCUS(templateObject_3$L || (templateObject_3$L = __makeTemplateObject(["\n              &:after {\n                display: block;\n              }\n            "], ["\n              &:after {\n                display: block;\n              }\n            "])))],
        type: "button",
        onClick: onClick,
        "aria-label": "\uD504\uB85C\uD544 \uBA54\uB274"
      }, {
        children: jsx(ResizeImage, {
          width: 40,
          aspect: 1,
          src: profileUrl || DEFAULT_PROFILE_URL,
          alt: "\uD504\uB85C\uD544 \uC0AC\uC9C4",
          css: /*#__PURE__*/css(templateObject_4$E || (templateObject_4$E = __makeTemplateObject(["\n              vertical-align: middle;\n              width: 100%;\n              height: 100%;\n              object-fit: cover;\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              vertical-align: middle;\n              width: 100%;\n              height: 100%;\n              object-fit: cover;\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
        })
      }));
    }
  }, {
    children: jsx("div", _assign({
      css: /*#__PURE__*/css(templateObject_5$w || (templateObject_5$w = __makeTemplateObject(["\n          width: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          width: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(184))
    }, {
      children: items.map(function (item, index) {
        return jsx(UserDropdownContentItem, _assign({}, item), index);
      })
    }))
  }));
}
var templateObject_1$17, templateObject_2$T, templateObject_3$L, templateObject_4$E, templateObject_5$w;

/**
 * @deprecated ODS의 CircleBadge 컴포넌트를 사용해 주세요.
 */
function NumberNotification(_a) {
  var count = _a.count,
    maxCount = _a.maxCount,
    rest = __rest(_a, ["count", "maxCount"]);
  return jsx(CircleBadge, _assign({}, rest, {
    size: 16,
    type: "fill",
    variant: "primary2",
    css: /*#__PURE__*/css(templateObject_1$16 || (templateObject_1$16 = __makeTemplateObject(["\n        position: absolute;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        position: absolute;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
  }, {
    children: maxCount < count ? "+".concat(maxCount) : count
  }));
}
var templateObject_1$16;

var NotificationType = {
  Dot: 'DOT',
  Number: 'NUMBER',
  None: 'NONE'
};
function IconNotification(_a) {
  var _b = _a.component,
    component = _b === void 0 ? 'div' : _b,
    iconName = _a.iconName,
    type = _a.type,
    _c = _a.count,
    count = _c === void 0 ? 0 : _c,
    restProps = __rest(_a, ["component", "iconName", "type", "count"]);
  var theme = useTheme();
  var Component = component;
  return jsxs(Component
  // FIXME: 이거 IconNotification에서 높이를 임의로 지정하면 안될 것 같아요
  // NOTE: 디자인에서는 아이콘마다 14px의 거리를 규정하고 있습니다. 즉, 각 아이콘이
  //       한 방향에서 가질 수 있는 가로 padding+margin은 7px까지입니다.
  , _assign({
    // FIXME: 이거 IconNotification에서 높이를 임의로 지정하면 안될 것 같아요
    // NOTE: 디자인에서는 아이콘마다 14px의 거리를 규정하고 있습니다. 즉, 각 아이콘이
    //       한 방향에서 가질 수 있는 가로 padding+margin은 7px까지입니다.
    css: [/*#__PURE__*/css(templateObject_1$15 || (templateObject_1$15 = __makeTemplateObject(["\n          position: relative;\n          display: inline-block;\n          padding: ", ";\n          margin: ", " ", ";\n          color: ", ";\n          line-height: 0;\n          outline: none;\n          ", "\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          position: relative;\n          display: inline-block;\n          padding: ", ";\n          margin: ", " ", ";\n          color: ", ";\n          line-height: 0;\n          outline: none;\n          ", "\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(6), pxToRem(3), pxToRem(1), theme.content.base1, MEDIA_QUERY.min('tablet', "\n            margin: ".concat(pxToRem(9), " ").concat(pxToRem(1), ";\n          "))), HOVER(templateObject_2$S || (templateObject_2$S = __makeTemplateObject(["\n          color: ", ";\n        "], ["\n          color: ", ";\n        "])), theme.content.primary1.basic), FOCUS(templateObject_3$K || (templateObject_3$K = __makeTemplateObject(["\n          color: ", ";\n        "], ["\n          color: ", ";\n        "])), theme.content.primary1.basic)]
  }, restProps, {
    children: [jsx(Icon, {
      css: /*#__PURE__*/css(templateObject_4$D || (templateObject_4$D = __makeTemplateObject(["\n          font-size: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          font-size: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(24)),
      name: iconName,
      size: 24
    }), type === NotificationType.Dot && jsx(DotNotification, {}), type === NotificationType.Number && count > 0 && jsx("span", _assign({
      css: /*#__PURE__*/css(templateObject_5$v || (templateObject_5$v = __makeTemplateObject(["\n            position: absolute;\n            top: 0;\n            right: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            position: absolute;\n            top: 0;\n            right: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(20))
    }, {
      children: jsx(NumberNotification, {
        count: count,
        maxCount: 99
      })
    }))]
  }));
}
var templateObject_1$15, templateObject_2$S, templateObject_3$K, templateObject_4$D, templateObject_5$v;

function NoLoginMenuItem(_a) {
  var _b = _a.component,
    component = _b === void 0 ? 'a' : _b,
    label = _a.label,
    href = _a.href,
    logKey = _a.logKey,
    rest = __rest(_a, ["component", "label", "href", "logKey"]);
  var theme = useTheme();
  var Component = component;
  var log = useLogContext();
  return jsx(Component, _assign({}, rest, {
    href: href,
    css: /*#__PURE__*/css(templateObject_1$14 || (templateObject_1$14 = __makeTemplateObject(["\n        ", ";\n        color: ", ";\n        padding: 0 10px;\n        border-left: 1px solid ", ";\n        &:first-of-type {\n          border-left: none;\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        ", ";\n        color: ", ";\n        padding: 0 10px;\n        border-left: 1px solid ", ";\n        &:first-of-type {\n          border-left: none;\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), FONT_STYLE.subTitle2, theme.content.base1, theme.content.base4),
    onClick: function onClick() {
      return log({
        key: logKey,
        category: 'click'
      });
    }
  }, {
    children: label
  }));
}
var templateObject_1$14;

var SELLER_USERABLE_TYPE = 'SalesUser';
var SellerButton = /*#__PURE__*/memo(function (_a) {
  var userableType = _a.userableType,
    rest = __rest(_a, ["userableType"]);
  if (userableType !== SELLER_USERABLE_TYPE) {
    return null;
  }
  return jsx(OutlineAnchorButton, _assign({
    css: /*#__PURE__*/css(templateObject_1$13 || (templateObject_1$13 = __makeTemplateObject(["\n        display: none;\n        margin-left: 8px;\n        ", "\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        display: none;\n        margin-left: 8px;\n        ", "\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), MEDIA_QUERY.min('laptop', "\n          display: flex;\n          align-items: center;\n        ")),
    variant: "base1",
    size: 40
  }, rest, {
    children: "\uD310\uB9E4\uC790 \uC804\uC6A9\uC11C\uBE44\uC2A4"
  }));
});
var templateObject_1$13;

function PrimaryRight(_a) {
  var searchProps = _a.searchProps,
    userProfile = _a.userProfile,
    userMenu = _a.userMenu,
    scrap = _a.scrap,
    cart = _a.cart,
    notification = _a.notification,
    signin = _a.signin,
    signup = _a.signup,
    cs = _a.cs,
    seller = _a.seller,
    uploadMenuLinks = _a.uploadMenuLinks;
  var LinkComponent = useLinkContext();
  var log = useLogContext();
  var _b = userProfile || {},
    userId = _b.userId,
    imageUrl = _b.imageUrl;
  var loggedIn = userId != null;
  return jsxs("div", _assign({
    css: /*#__PURE__*/css(templateObject_1$12 || (templateObject_1$12 = __makeTemplateObject(["\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n        line-height: 0;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n        line-height: 0;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
  }, {
    children: [searchProps && jsxs(Fragment$1, {
      children: [jsx(NavigationSearch, _assign({
        css: /*#__PURE__*/css(templateObject_2$R || (templateObject_2$R = __makeTemplateObject(["\n              flex: 1 1 0px;\n              min-width: 0;\n              margin-right: ", ";\n              ", "\n              ", "\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              flex: 1 1 0px;\n              min-width: 0;\n              margin-right: ", ";\n              ", "\n              ", "\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(9), MEDIA_QUERY.min('desktop', "\n                margin-right: ".concat(pxToRem(14), ";\n              ")), MEDIA_QUERY.max('tablet', "\n                display: none;\n              "))
      }, searchProps)), jsx(SearchDrawer, _assign({
        css: /*#__PURE__*/css(templateObject_3$J || (templateObject_3$J = __makeTemplateObject(["\n              ", "\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              ", "\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), MEDIA_QUERY.min('laptop', "\n                display: none;\n              "))
      }, searchProps))]
    }), scrap && jsx("div", _assign({
      css: /*#__PURE__*/css(templateObject_4$C || (templateObject_4$C = __makeTemplateObject(["\n          ", "\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          ", "\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), MEDIA_QUERY.max('mobile', "\n            display: none;\n          "))
    }, {
      children: jsx(IconNotification, {
        iconName: "scrap_outline",
        type: NotificationType.None,
        component: LinkComponent,
        "aria-label": "\uC2A4\uD06C\uB7A9\uBD81 \uD398\uC774\uC9C0 \uB9C1\uD06C \uBC84\uD2BC",
        href: scrap.href,
        onClick: function onClick() {
          return log({
            key: 'primary.right.scrap',
            category: 'click'
          });
        }
      })
    })), notification && jsx("div", _assign({
      css: /*#__PURE__*/css(templateObject_5$u || (templateObject_5$u = __makeTemplateObject(["\n            ", "\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            ", "\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), MEDIA_QUERY.max('mobile', "\n              display: none;\n            "))
    }, {
      children: jsx(IconNotification, {
        iconName: "notification_outline",
        type: NotificationType.Number,
        count: notification.count,
        component: LinkComponent,
        href: notification.href,
        "aria-label": "\uB0B4\uC18C\uC2DD \uD398\uC774\uC9C0 \uB9C1\uD06C \uBC84\uD2BC",
        onClick: function onClick() {
          return log({
            key: 'primary.right.notification',
            category: 'click'
          });
        }
      })
    })), cart && jsx(IconNotification, {
      iconName: "cart",
      type: NotificationType.Number,
      count: cart.count,
      component: LinkComponent,
      href: cart.href,
      "aria-label": "\uC7A5\uBC14\uAD6C\uB2C8 \uD398\uC774\uC9C0 \uB9C1\uD06C \uBC84\uD2BC",
      onClick: function onClick() {
        return log({
          key: 'primary.right.cart',
          category: 'click'
        });
      }
    }), jsxs("div", _assign({
      css: /*#__PURE__*/css(templateObject_6$p || (templateObject_6$p = __makeTemplateObject(["\n          display: flex;\n          align-items: center;\n          ", "\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          display: flex;\n          align-items: center;\n          ", "\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), MEDIA_QUERY.max('mobile', "\n            display: none;\n          "))
    }, {
      children: [loggedIn && jsx("div", _assign({
        css: /*#__PURE__*/css(templateObject_7$k || (templateObject_7$k = __makeTemplateObject(["\n              margin: 0 ", " 0 ", ";\n              ", "\n              ", "\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              margin: 0 ", " 0 ", ";\n              ", "\n              ", "\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(12), pxToRem(5), MEDIA_QUERY.min('laptop', "\n                margin: 0 ".concat(pxToRem(16), " 0 ").concat(pxToRem(9), ";\n              ")), MEDIA_QUERY.min('desktop', "\n                margin: 0 ".concat(pxToRem(20), " 0 ").concat(pxToRem(13), ";\n              ")))
      }, {
        children: jsx(UserDropdownContentButton, {
          profileUrl: imageUrl,
          userMenu: userMenu
        })
      })), jsxs("div", _assign({
        css: /*#__PURE__*/css(templateObject_8$f || (templateObject_8$f = __makeTemplateObject(["\n          display: flex;\n          margin: 0 10px 0 8px;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          display: flex;\n          margin: 0 10px 0 8px;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
      }, {
        children: [signin && jsx(NoLoginMenuItem, {
          label: "\uB85C\uADF8\uC778",
          href: signin.href,
          component: LinkComponent,
          logKey: "primary.right.login"
        }), signup && jsx(NoLoginMenuItem, {
          label: "\uD68C\uC6D0\uAC00\uC785",
          href: signup.href,
          component: LinkComponent,
          logKey: "primary.right.signup"
        }), cs && jsx(NoLoginMenuItem, {
          label: "\uACE0\uAC1D\uC13C\uD130",
          href: cs.href,
          component: LinkComponent,
          logKey: "primary.right.cs",
          css: /*#__PURE__*/css(templateObject_9$b || (templateObject_9$b = __makeTemplateObject(["\n                ", "\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                ", "\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), MEDIA_QUERY.max('laptop', "\n                  display: none;\n                "))
        })]
      })), uploadMenuLinks && uploadMenuLinks.length > 0 && jsx(UploadDropdownContentButton, {
        uploadMenuLinks: uploadMenuLinks
      }), seller && jsx(SellerButton, {
        href: seller.href
      })]
    }))]
  }));
}
var templateObject_1$12, templateObject_2$R, templateObject_3$J, templateObject_4$C, templateObject_5$u, templateObject_6$p, templateObject_7$k, templateObject_8$f, templateObject_9$b;

var _path, _rect, _path2, _path3;
function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
var SvgLogo$1 = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.2 25.17H9.28V20.7a1.45 1.45 0 0 0-2.9 0v4.47H1.44a1.45 1.45 0 1 0 0 2.9H14.2a1.45 1.45 0 0 0 0-2.9M4.5 9.15c0-4.6 2.08-5.28 3.33-5.28 1.24 0 3.33.69 3.33 5.28v.36c0 4.6-2.09 5.28-3.33 5.28-1.25 0-3.34-.69-3.34-5.28v-.36zm3.33 8.54c3.84 0 6.23-3.13 6.23-8.18v-.36c0-5.05-2.39-8.18-6.23-8.18-3.85 0-6.24 3.13-6.24 8.18v.36c0 5.05 2.39 8.18 6.24 8.18m25.54-7.34H17.81a1.45 1.45 0 0 0 0 2.9h15.56a1.45 1.45 0 1 0 0-2.9m-1.55 15.49c-7.08 1.84-9.45.8-10.14.26-.45-.35-.65-.8-.65-1.48v-.87h10.25c.8 0 1.46-.65 1.46-1.45v-5.08c0-.8-.65-1.45-1.46-1.45h-11.7a1.45 1.45 0 1 0 0 2.9h10.25v2.18H19.57c-.8 0-1.45.65-1.45 1.45v2.32a4.6 4.6 0 0 0 1.78 3.78c1.2.92 2.94 1.39 5.21 1.39 2.05 0 4.54-.38 7.44-1.13a1.45 1.45 0 1 0-.73-2.82M20.3 7.83h10.82a1.45 1.45 0 1 0 0-2.9h-9.36V1.44a1.45 1.45 0 1 0-2.9 0v4.93c0 .8.65 1.45 1.45 1.45z",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 15,
    x: 70,
    fill: "currentColor",
    rx: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M64.5 13.28a1.45 1.45 0 0 0 2.73-1c-.05-.13-1-2.68-3.38-4.5l3.7-4.1a1.45 1.45 0 0 0-1.09-2.42h-9.05a1.45 1.45 0 1 0 0 2.9h5.8l-6.88 7.64a1.45 1.45 0 1 0 2.16 1.95l3.41-3.8a8 8 0 0 1 2.6 3.33m5.06 13.24h-7.01a.82.82 0 0 1-.82-.82v-1.95h8.65v1.95c0 .45-.37.82-.82.82m2.27-9.37c-.8 0-1.45.65-1.45 1.45v2.25h-8.65V18.6a1.45 1.45 0 1 0-2.9 0v7.1a3.72 3.72 0 0 0 3.72 3.72h7.01a3.72 3.72 0 0 0 3.72-3.72v-7.1c0-.8-.65-1.45-1.45-1.45M42.46 3.87c2.22 0 2.33 4.24 2.33 5.08 0 .85-.11 5.09-2.33 5.09-2.21 0-2.32-4.24-2.32-5.09 0-.84.11-5.08 2.32-5.08m0 13.07c1.76 0 3.23-.93 4.14-2.62.71-1.34 1.1-3.2 1.1-5.37 0-2.16-.39-4.02-1.1-5.36A4.59 4.59 0 0 0 42.46.97c-1.75 0-3.22.93-4.13 2.62-.72 1.34-1.1 3.2-1.1 5.36 0 2.17.38 4.03 1.1 5.37a4.59 4.59 0 0 0 4.13 2.62",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M51.4.49c-.8 0-1.45.65-1.45 1.45v17.78c-1.93.6-5.75 1.12-10.38 1.12h-2.2a1.45 1.45 0 0 0 0 2.91h2.2c2.64 0 7.21-.23 10.38-1.02v4.84a1.45 1.45 0 0 0 2.9 0V1.94c0-.8-.65-1.45-1.45-1.45",
    clipRule: "evenodd"
  })));
};
var LogoIcon$1 = SvgLogo$1;

function Logo(_a) {
  var logo = _a.logo,
    children = _a.children,
    rest = __rest(_a, ["logo", "children"]);
  var theme = useTheme();
  var Link = useLinkContext();
  return jsx(Link, _assign({}, rest, {
    href: (logo === null || logo === void 0 ? void 0 : logo.href) || 'https://ohou.se',
    "aria-label": "\uC624\uB298\uC758\uC9D1 \uB85C\uACE0",
    css: [/*#__PURE__*/css(templateObject_1$11 || (templateObject_1$11 = __makeTemplateObject(["\n          ", "\n          display: inline-flex;\n          align-items: center;\n          margin: ", ";\n          padding: ", ";\n          font-size: 0;\n          line-height: 0;\n          color: ", ";\n          outline: none;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          ", "\n          display: inline-flex;\n          align-items: center;\n          margin: ", ";\n          padding: ", ";\n          font-size: 0;\n          line-height: 0;\n          color: ", ";\n          outline: none;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), RESET_BUTTON, pxToRem(-4), pxToRem(4), theme.interactive.base1), FOCUS(templateObject_2$Q || (templateObject_2$Q = __makeTemplateObject(["\n          box-shadow: 0 0 0 ", " ", ";\n          border-radius: ", ";\n        "], ["\n          box-shadow: 0 0 0 ", " ", ";\n          border-radius: ", ";\n        "])), pxToRem(3), theme.interactive.primary1.thin, pxToRem(3))]
  }, {
    children: children || (logo === null || logo === void 0 ? void 0 : logo.item) || jsx(LogoIcon$1, {
      css: /*#__PURE__*/css(templateObject_3$I || (templateObject_3$I = __makeTemplateObject(["\n          vertical-align: top;\n          height: ", ";\n          ", "\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          vertical-align: top;\n          height: ", ";\n          ", "\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(26), MEDIA_QUERY.min('tablet', "\n            height: ".concat(pxToRem(30), ";\n          ")))
    })
  }));
}
var templateObject_1$11, templateObject_2$Q, templateObject_3$I;

function useFocusedLatch(onChange) {
  var focusRef = useRef(null);
  var handleFocusIn = useCallback(function () {
    if (focusRef.current != null) {
      cancelAnimationFrame(focusRef.current);
    }
    onChange(true);
  }, [onChange]);
  var handleFocusOut = useCallback(function () {
    if (focusRef.current != null) {
      cancelAnimationFrame(focusRef.current);
    }
    focusRef.current = requestAnimationFrame(function () {
      return onChange(false);
    });
  }, [onChange]);
  return [handleFocusIn, handleFocusOut];
}

function NavigationBar(props) {
  var _a;
  var log = useLogContext();
  var logo = props.logo,
    primaryLeftmost = props.primaryLeftmost,
    menuSchema = props.menuSchema,
    fallbackMenuSchema = props.fallbackMenuSchema,
    searchOptions = props.searchOptions,
    supplementary = props.supplementary;
  var _b = useState({
      isHovered: false,
      selectedIds: null
    }),
    _c = _b[0],
    isHovered = _c.isHovered,
    selectedIds = _c.selectedIds,
    setState = _b[1];
  var setHovered = useCallback(function (value) {
    setState(function (prevState) {
      return _assign(_assign({}, prevState), {
        isHovered: value,
        selectedIds: !value ? null : prevState.selectedIds
      });
    });
  }, []);
  var _d = useFocusedLatch(setHovered),
    onMouseEnter = _d[0],
    onMouseLeave = _d[1];
  var activeIds = useMemo(function () {
    return getActiveIds(menuSchema, fallbackMenuSchema);
  }, [menuSchema, fallbackMenuSchema]);
  var currentSelectedIds = selectedIds == null ? activeIds : selectedIds;
  var primaryEntries = menuSchema;
  var activePrimaryItem = activeIds[0] != null ? primaryEntries[activeIds[0]] : null;
  var primaryItem = currentSelectedIds[0] != null ? primaryEntries[currentSelectedIds[0]] : null;
  var secondaryEntries = getSecondaryEntries({
    primary: primaryItem,
    activeIds: activeIds,
    fallbackMenuSchema: fallbackMenuSchema
  });
  var secondaryItem = currentSelectedIds[1] != null ? secondaryEntries[currentSelectedIds[1]] : null;
  var hasFallbackMenuSchema = fallbackMenuSchema != null && fallbackMenuSchema.length > 0;
  var handlePrimarySelect = useCallback(function (_, index) {
    setState(function (prevState) {
      return _assign(_assign({}, prevState), {
        selectedIds: [index]
      });
    });
  }, []);
  var handleSecondarySelect = useCallback(function (_, index) {
    setState(function (prevState) {
      return _assign(_assign({}, prevState), {
        selectedIds: [currentSelectedIds[0], index]
      });
    });
  }, [currentSelectedIds]);
  var CustomPrimaryRight = (_a = supplementary.primaryRight) !== null && _a !== void 0 ? _a : null;
  var showTertiary = selectedIds != null && selectedIds[1] != null && secondaryItem != null && secondaryItem.renderBarChild != null;
  var secondaryRightElement = supplementary.secondaryRight != null ? /*#__PURE__*/React__default.createElement(supplementary.secondaryRight) : null;
  var hasItemInActivedPrimaryItem = activePrimaryItem != null && activePrimaryItem.entries != null ? activePrimaryItem.entries.length > 0 : false;
  var hasItemInHoveredPrimaryItem = primaryItem != null && primaryItem.entries != null ? primaryItem.entries.length > 0 : false;
  return jsxs("header", {
    children: [jsx(NavigationBarPrimary, {
      leftmost: primaryLeftmost,
      left: jsx(StyledLogo, {
        logo: logo,
        onClick: function onClick() {
          log({
            key: 'logo',
            category: 'click'
          });
        }
      }),
      right: CustomPrimaryRight ? jsx(CustomPrimaryRightContainer, {
        children: jsx(CustomPrimaryRight, {})
      }) : jsx(PrimaryRight, _assign({
        searchProps: searchOptions
      }, supplementary)),
      menuEntries: primaryEntries,
      activeId: activeIds[0],
      selectedId: currentSelectedIds[0],
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onSelect: handlePrimarySelect
    }), jsx(NavigationBarSecondary, {
      right: secondaryRightElement,
      menuEntries: secondaryEntries,
      hasItems: hasItemInActivedPrimaryItem || hasItemInHoveredPrimaryItem || hasFallbackMenuSchema,
      activeId: currentSelectedIds[0] === activeIds[0] ? activeIds[1] : null,
      primaryId: currentSelectedIds[0],
      isForceOpened: isHovered && secondaryEntries.length > 0,
      isFallback: currentSelectedIds[0] == null && hasFallbackMenuSchema,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onSelect: handleSecondarySelect,
      scrollableEntries: primaryItem === null || primaryItem === void 0 ? void 0 : primaryItem.scrollableEntries
    }), showTertiary && jsx(NavigationBarTertiary, {
      item: showTertiary ? secondaryItem : null,
      isOpen: showTertiary,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    })]
  });
}
var StyledLogo = /*#__PURE__*/_styled(Logo, process.env.NODE_ENV === "production" ? {
  target: "e4qy2et1"
} : {
  target: "e4qy2et1",
  label: "StyledLogo"
})(templateObject_2$P || (templateObject_2$P = __makeTemplateObject(["\n  height: ", ";\n  ", "\n"], ["\n  height: ", ";\n  ", "\n"])), pxToRem(26), MEDIA_QUERY.min('tablet', /*#__PURE__*/css(templateObject_1$10 || (templateObject_1$10 = __makeTemplateObject(["\n    height: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:StyledLogo;")], ["\n    height: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:StyledLogo;")])), pxToRem(30))));
var CustomPrimaryRightContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e4qy2et0"
} : {
  target: "e4qy2et0",
  label: "CustomPrimaryRightContainer"
})(templateObject_4$B || (templateObject_4$B = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), MEDIA_QUERY.max('mobile', /*#__PURE__*/css(templateObject_3$H || (templateObject_3$H = __makeTemplateObject(["\n    display: none;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:CustomPrimaryRightContainer;")], ["\n    display: none;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:CustomPrimaryRightContainer;")])))));
/** Secondary 메뉴 스키마를 리턴합니다 */
function getSecondaryEntries(_a) {
  var _b;
  var primary = _a.primary,
    activeIds = _a.activeIds,
    fallbackMenuSchema = _a.fallbackMenuSchema;
  if (primary != null) {
    return (_b = primary.entries) !== null && _b !== void 0 ? _b : [];
  }
  if (activeIds[1] != null) {
    return fallbackMenuSchema !== null && fallbackMenuSchema !== void 0 ? fallbackMenuSchema : [];
  }
  return [];
}
var templateObject_1$10, templateObject_2$P, templateObject_3$H, templateObject_4$B;

function StoreCategory(_a) {
  var categories = _a.categories;
  var Link = useLinkContext();
  var log = useLogContext();
  var theme = useTheme();
  return jsx("div", _assign({
    css: /*#__PURE__*/css(templateObject_1$$ || (templateObject_1$$ = __makeTemplateObject(["overflow: auto;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["overflow: auto;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
  }, {
    children: jsx("ul", _assign({
      css: /*#__PURE__*/css(templateObject_3$G || (templateObject_3$G = __makeTemplateObject(["\n        display: flex;\n        justify-content: space-between;\n        margin: 0 auto;\n        padding: 10px 0 10px 40px;\n        box-sizing: border-box;\n        ", "\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        display: flex;\n        justify-content: space-between;\n        margin: 0 auto;\n        padding: 10px 0 10px 40px;\n        box-sizing: border-box;\n        ", "\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), MEDIA_QUERY.min('laptop', /*#__PURE__*/css(templateObject_2$O || (templateObject_2$O = __makeTemplateObject(["\n          max-width: 1276px;\n          padding: 10px 0 10px 60px;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          max-width: 1276px;\n          padding: 10px 0 10px 60px;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))))
    }, {
      children: categories.map(function (category, index) {
        return jsx("li", _assign({
          css: /*#__PURE__*/css(templateObject_5$t || (templateObject_5$t = __makeTemplateObject(["\n              flex: 0 0 auto;\n              margin: 0;\n              padding: 0 0 0 10px;\n              color: ", ";\n              &:last-of-type {\n                padding-right: 40px;\n                ", "\n              }\n              &:hover {\n                color: ", ";\n              }\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              flex: 0 0 auto;\n              margin: 0;\n              padding: 0 0 0 10px;\n              color: ", ";\n              &:last-of-type {\n                padding-right: 40px;\n                ", "\n              }\n              &:hover {\n                color: ", ";\n              }\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), category.active ? theme.content.primary1.basic : theme.content.base1, MEDIA_QUERY.min('laptop', /*#__PURE__*/css(templateObject_4$A || (templateObject_4$A = __makeTemplateObject(["\n                  padding-right: 60px;\n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                  padding-right: 60px;\n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))), theme.content.primary1.basic)
        }, {
          children: jsxs(Link, _assign({
            href: category.href,
            onClick: function onClick() {
              log({
                key: 'tertiary.store.category.item',
                category: 'click',
                params: {
                  id: category.logId,
                  index: index
                }
              });
            },
            css: /*#__PURE__*/css(templateObject_6$o || (templateObject_6$o = __makeTemplateObject(["\n                display: block;\n                padding: 10px 0;\n                font-size: 14px;\n                font-weight: bold;\n                text-align: center;\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                display: block;\n                padding: 10px 0;\n                font-size: 14px;\n                font-weight: bold;\n                text-align: center;\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
          }, {
            children: [jsx("span", _assign({
              css: /*#__PURE__*/css(templateObject_7$j || (templateObject_7$j = __makeTemplateObject(["\n                position: relative;\n                display: block;\n                width: 80px;\n                height: 80px;\n                & > img {\n                  position: absolute;\n                  top: 0;\n                  left: 0;\n                  width: 100%;\n                  border: 0;\n                }\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                position: relative;\n                display: block;\n                width: 80px;\n                height: 80px;\n                & > img {\n                  position: absolute;\n                  top: 0;\n                  left: 0;\n                  width: 100%;\n                  border: 0;\n                }\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
            }, {
              children: category.icon
            })), jsx("span", _assign({
              css: /*#__PURE__*/css(templateObject_8$e || (templateObject_8$e = __makeTemplateObject(["\n                display: block;\n                margin: 20px -10px 0;\n                line-height: 1;\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                display: block;\n                margin: 20px -10px 0;\n                line-height: 1;\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
            }, {
              children: category.title
            }))]
          }))
        }), category.title);
      })
    }))
  }));
}
var templateObject_1$$, templateObject_2$O, templateObject_3$G, templateObject_4$A, templateObject_5$t, templateObject_6$o, templateObject_7$j, templateObject_8$e;

function NavigationDrawerDivider() {
  return jsx(Divider$1, {
    variant: "thin",
    css: /*#__PURE__*/css(templateObject_1$_ || (templateObject_1$_ = __makeTemplateObject(["margin: ", " 0;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["margin: ", " 0;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(20))
  });
}
var templateObject_1$_;

function NavigationDrawerMenuAccordion(_a) {
  var children = _a.children,
    isExpanded = _a.isExpanded,
    onTransitionStart = _a.onTransitionStart,
    onTransitionEnd = _a.onTransitionEnd;
  var container = useRef(null);
  var content = useRef(null);
  var isExpanding = useRef(false);
  var isCollapsing = useRef(false);
  var expand = useCallback(function () {
    if (!container.current || !content.current) return;
    if (isExpanding.current) return;
    if (isCollapsing.current) return;
    isExpanding.current = true;
    container.current.style.display = 'block';
    container.current.style.height = "".concat(content.current.clientHeight, "px");
    onTransitionStart();
  }, [onTransitionStart]);
  var collapse = useCallback(function () {
    if (!container.current || !content.current) return;
    if (isExpanding.current) return;
    if (isCollapsing.current) return;
    isCollapsing.current = true;
    container.current.style.height = "".concat(content.current.clientHeight, "px");
    setTimeout(function () {
      if (!container.current) return;
      container.current.style.height = '0px';
      onTransitionStart();
    }, 50);
  }, [onTransitionStart]);
  var handleTransitionEnd = useCallback(function () {
    if (!container.current || !content.current) return;
    if (isExpanding.current) {
      container.current.style.height = 'auto';
      isExpanding.current = false;
    } else if (isCollapsing.current) {
      container.current.style.display = 'none';
      isCollapsing.current = false;
    }
    onTransitionEnd();
  }, [onTransitionEnd]);
  useEffect(function () {
    if (!container.current) return;
    if (!container.current.style.transition) return;
    (isExpanded ? expand : collapse)();
  }, [isExpanded, expand, collapse]);
  useEffect(function () {
    if (!container.current) return;
    container.current.style.height = isExpanded ? 'auto' : '0px';
    container.current.style.display = isExpanded ? 'block' : 'none';
    setTimeout(function () {
      if (!container.current) return;
      container.current.style.transition = 'height .3s';
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return jsx("div", _assign({
    ref: container,
    css: /*#__PURE__*/css(templateObject_1$Z || (templateObject_1$Z = __makeTemplateObject(["\n        overflow: hidden;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        overflow: hidden;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")]))),
    onTransitionEnd: handleTransitionEnd
  }, {
    children: jsx("div", _assign({
      ref: content
    }, {
      children: children
    }))
  }));
}
var templateObject_1$Z;

function NavigationDrawerMenu(_a) {
  var items = _a.items,
    indents = _a.indents,
    fontStyles = _a.fontStyles,
    onClose = _a.onClose;
  var _b = useState(function () {
      return items.findIndex(function (item) {
        return item.active;
      });
    }),
    expandedIndex = _b[0],
    setExpandedIndex = _b[1];
  return jsx("ul", _assign({
    css: /*#__PURE__*/css(templateObject_1$Y || (templateObject_1$Y = __makeTemplateObject(["\n      padding: 0;\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n      padding: 0;\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
  }, {
    children: items.map(function (item, index) {
      return jsx(NavigationDrawerMenuItem, {
        title: item.title,
        icon: item.icon,
        bullet: item.bullet,
        href: item.href,
        isActive: item.active,
        items: item.entries,
        renderChild: item.renderDrawerChild,
        indents: indents,
        fontStyles: fontStyles,
        isExpanded: index === expandedIndex,
        onExpand: function onExpand() {
          return setExpandedIndex(index);
        },
        onCollapse: function onCollapse() {
          return setExpandedIndex(-1);
        },
        onClick: function onClick() {
          var _a;
          (_a = item.onClick) === null || _a === void 0 ? void 0 : _a.call(item, {
            item: item,
            index: index
          });
          !item.entries && (onClose === null || onClose === void 0 ? void 0 : onClose());
        },
        onClose: onClose
      }, index);
    })
  }));
}
function NavigationDrawerMenuItem(_a) {
  var title = _a.title,
    icon = _a.icon,
    href = _a.href,
    bullet = _a.bullet,
    items = _a.items,
    _b = _a.indents,
    indents = _b === void 0 ? [] : _b,
    _c = _a.fontStyles,
    fontStyles = _c === void 0 ? [] : _c,
    isActive = _a.isActive,
    isExpanded = _a.isExpanded,
    onExpand = _a.onExpand,
    onCollapse = _a.onCollapse,
    renderChild = _a.renderChild,
    _onClick = _a.onClick,
    onClose = _a.onClose;
  var theme = useTheme();
  var Link = useLinkContext();
  var isAccordionTransitioning = useRef(false);
  var handleAccordionTransitionStart = useCallback(function () {
    isAccordionTransitioning.current = true;
  }, []);
  var handleAccordionTransitionEnd = useCallback(function () {
    isAccordionTransitioning.current = false;
  }, []);
  var handleAccordionToggle = useCallback(function () {
    if (isAccordionTransitioning.current) return;
    (isExpanded ? onCollapse : onExpand)();
  }, [isExpanded, onCollapse, onExpand]);
  var renderTitle = function renderTitle() {
    return jsxs("div", _assign({
      css: /*#__PURE__*/css(templateObject_2$N || (templateObject_2$N = __makeTemplateObject(["\n        display: flex;\n        flex-wrap: wrap;\n        align-items: center;\n        width: 100%;\n        height: 100%;\n        line-height: 1;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        display: flex;\n        flex-wrap: wrap;\n        align-items: center;\n        width: 100%;\n        height: 100%;\n        line-height: 1;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
    }, {
      children: [icon && jsx("span", _assign({
        css: /*#__PURE__*/css(templateObject_3$F || (templateObject_3$F = __makeTemplateObject(["\n            display: inline-block;\n            margin-right: ", ";\n            border-radius: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            display: inline-block;\n            margin-right: ", ";\n            border-radius: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(8), pxToRem(4))
      }, {
        children: icon
      })), title, bullet === 'new' && jsx(NewIcon, {
        css: /*#__PURE__*/css(templateObject_4$z || (templateObject_4$z = __makeTemplateObject(["margin-left: 1.5px" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["margin-left: 1.5px" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
      })]
    }));
  };
  var indent = indents[0];
  var _d = fontStyles[0],
    fontStyle = _d === void 0 ? {} : _d;
  return jsx("li", _assign({
    css: /*#__PURE__*/css(templateObject_5$s || (templateObject_5$s = __makeTemplateObject(["\n      margin: ", " 0 0;\n      padding: 0;\n      font-size: ", ";\n      font-weight: ", ";\n      color: ", ";\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n      margin: ", " 0 0;\n      padding: 0;\n      font-size: ", ";\n      font-weight: ", ";\n      color: ", ";\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(4), pxToRem(fontStyle.size || 14), isActive ? 'bold' : fontStyle.weight || 'normal', fontStyle.color || theme.content.base1)
  }, {
    children: items && items.length || renderChild ? jsxs(Fragment$1, {
      children: [jsxs("button", _assign({
        type: "button",
        onClick: function onClick() {
          handleAccordionToggle();
          _onClick === null || _onClick === void 0 ? void 0 : _onClick();
        },
        css: /*#__PURE__*/css(templateObject_9$a || (templateObject_9$a = __makeTemplateObject(["\n                ", "\n                overflow: hidden;\n                position: relative;\n                display: block;\n                width: 100%;\n                height: ", ";\n                margin: 0;\n                padding: 0 ", " 0 ", ";\n                color: inherit;\n                text-align: left;\n                text-overflow: ellipsis;\n                white-space: nowrap;\n                box-sizing: border-box;\n                outline: none;\n                border-radius: 4px;\n                ", "\n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                ", "\n                overflow: hidden;\n                position: relative;\n                display: block;\n                width: 100%;\n                height: ", ";\n                margin: 0;\n                padding: 0 ", " 0 ", ";\n                color: inherit;\n                text-align: left;\n                text-overflow: ellipsis;\n                white-space: nowrap;\n                box-sizing: border-box;\n                outline: none;\n                border-radius: 4px;\n                ", "\n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), RESET_BUTTON, pxToRem(40), pxToRem(40), pxToRem(indent || 14), isActive ? /*#__PURE__*/css(templateObject_7$i || (templateObject_7$i = __makeTemplateObject(["\n                    background-color: ", ";\n                    ", "\n                  " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                    background-color: ", ";\n                    ", "\n                  " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), theme.interactive.transparent, HOVER(templateObject_6$n || (templateObject_6$n = __makeTemplateObject(["\n                      background-color: ", ";\n                    "], ["\n                      background-color: ", ";\n                    "])), theme.content.base5)) : HOVER(templateObject_8$d || (templateObject_8$d = __makeTemplateObject(["\n                    background-color: ", ";\n                  "], ["\n                    background-color: ", ";\n                  "])), theme.content.base5))
      }, {
        children: [renderTitle(), jsx(Icon, {
          size: 12,
          name: isExpanded ? 'chevron_thick_up' : 'chevron_thick_down',
          css: /*#__PURE__*/css(templateObject_10$9 || (templateObject_10$9 = __makeTemplateObject(["\n                  position: absolute;\n                  top: ", ";\n                  right: ", ";\n                  color: ", ";\n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                  position: absolute;\n                  top: ", ";\n                  right: ", ";\n                  color: ", ";\n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(14), pxToRem(14), theme.content.base1)
        })]
      })), jsx(NavigationDrawerMenuAccordion, _assign({
        isExpanded: isExpanded,
        onTransitionStart: handleAccordionTransitionStart,
        onTransitionEnd: handleAccordionTransitionEnd
      }, {
        children: items && jsx(NavigationDrawerMenu, {
          items: items,
          fontStyles: fontStyles.slice(1),
          indents: indents.length > 1 ? indents.slice(1) : indents.slice(-1),
          onClose: onClose
        }) || renderChild && renderChild()
      }))]
    }) : jsx(Link, _assign({
      href: href,
      onClick: _onClick,
      css: /*#__PURE__*/css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n              overflow: hidden;\n              display: block;\n              width: 100%;\n              height: ", ";\n              padding: 0 ", " 0 ", ";\n              color: inherit;\n              text-overflow: ellipsis;\n              white-space: nowrap;\n              box-sizing: border-box;\n              outline: none;\n              border-radius: 4px;\n              ", "\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              overflow: hidden;\n              display: block;\n              width: 100%;\n              height: ", ";\n              padding: 0 ", " 0 ", ";\n              color: inherit;\n              text-overflow: ellipsis;\n              white-space: nowrap;\n              box-sizing: border-box;\n              outline: none;\n              border-radius: 4px;\n              ", "\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(40), pxToRem(14), pxToRem(indent || 14), isActive ? /*#__PURE__*/css(templateObject_12$2 || (templateObject_12$2 = __makeTemplateObject(["\n                background-color: ", ";\n                ", "\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                background-color: ", ";\n                ", "\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), theme.interactive.transparent, HOVER(templateObject_11$4 || (templateObject_11$4 = __makeTemplateObject(["\n                  background-color: ", ";\n                "], ["\n                  background-color: ", ";\n                "])), theme.content.base5)) : HOVER(templateObject_13$2 || (templateObject_13$2 = __makeTemplateObject(["\n                background-color: ", ";\n              "], ["\n                background-color: ", ";\n              "])), theme.content.base5))
    }, {
      children: renderTitle()
    }))
  }));
}
var templateObject_1$Y, templateObject_2$N, templateObject_3$F, templateObject_4$z, templateObject_5$s, templateObject_6$n, templateObject_7$i, templateObject_8$d, templateObject_9$a, templateObject_10$9, templateObject_11$4, templateObject_12$2, templateObject_13$2, templateObject_14;

/**
 * @deprecated ODS의 Avatar 컴포넌트를 사용해 주세요.
 */
function Avatar(_a) {
  var size = _a.size,
    src = _a.src,
    rest = __rest(_a, ["size", "src"]);
  if (!src) return null;
  return jsx(ResizeImage$1, _assign({}, rest, {
    src: src,
    intrinsicAspect: 1,
    objectFit: "cover",
    css: /*#__PURE__*/css(templateObject_1$X || (templateObject_1$X = __makeTemplateObject(["\n        width: ", ";\n        height: ", ";\n        border-radius: 50%;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        width: ", ";\n        height: ", ";\n        border-radius: 50%;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(size), pxToRem(size))
  }));
}
var templateObject_1$X;

function NavigationDrawerHeader(_a) {
  var logo = _a.logo,
    action = _a.action,
    supplementary = _a.supplementary;
  var log = useLogContext();
  var userProfile = supplementary.userProfile,
    signup = supplementary.signup,
    signin = supplementary.signin;
  return jsxs(Fragment$1, {
    children: [jsxs("div", _assign({
      css: /*#__PURE__*/css(templateObject_1$W || (templateObject_1$W = __makeTemplateObject(["\n        position: relative;\n        font-size: ", ";\n        line-height: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        position: relative;\n        font-size: ", ";\n        line-height: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(14), pxToRem(18))
    }, {
      children: [jsx(Logo, _assign({}, logo, {
        onClick: function onClick() {
          return log({
            key: 'drawer.logo',
            category: 'click'
          });
        }
      })), action && function (_a) {
        var text = _a.text,
          rest = __rest(_a, ["text"]);
        return jsxs(TextButton, _assign({}, rest, {
          size: 32,
          variant: "primary1",
          css: /*#__PURE__*/css(templateObject_2$M || (templateObject_2$M = __makeTemplateObject(["\n              position: absolute;\n              top: 0;\n              right: 0;\n              display: flex;\n              align-items: center;\n              outline: none;\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              position: absolute;\n              top: 0;\n              right: 0;\n              display: flex;\n              align-items: center;\n              outline: none;\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
        }, {
          children: [text, jsx(Icon, {
            name: "chevron_right",
            size: 12,
            fill: function fill(theme) {
              return theme.content.primary1.basic;
            },
            css: /*#__PURE__*/css(templateObject_3$E || (templateObject_3$E = __makeTemplateObject(["\n                margin-left: ", ";\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                margin-left: ", ";\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(4))
          })]
        }));
      }(action)]
    })), userProfile == null ? jsxs("div", _assign({
      css: /*#__PURE__*/css(templateObject_4$y || (templateObject_4$y = __makeTemplateObject(["\n          display: flex;\n          justify-content: space-between;\n          width: 100%;\n          margin: ", " 0 ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          display: flex;\n          justify-content: space-between;\n          width: 100%;\n          margin: ", " 0 ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(20), pxToRem(10))
    }, {
      children: [signin && jsx(OutlineAnchorButton, _assign({
        href: signin.href,
        size: 44,
        variant: "primary1",
        onClick: function onClick() {
          // to signIn page
        },
        css: /*#__PURE__*/css(templateObject_5$r || (templateObject_5$r = __makeTemplateObject(["\n                font-weight: bold;\n                outline: none;\n                display: flex;\n                flex: 1;\n                justify-content: center;\n                align-items: center;\n                height: ", ";\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                font-weight: bold;\n                outline: none;\n                display: flex;\n                flex: 1;\n                justify-content: center;\n                align-items: center;\n                height: ", ";\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(42))
      }, {
        children: "\uB85C\uADF8\uC778"
      })), signup && jsx(AnchorButton, _assign({
        href: signup.href,
        size: 44,
        variant: "primary1",
        onClick: function onClick() {
          // to signUp page
        },
        css: /*#__PURE__*/css(templateObject_6$m || (templateObject_6$m = __makeTemplateObject(["\n                margin-left: ", ";\n                font-weight: bold;\n                outline: none;\n                display: flex;\n                flex: 1;\n                justify-content: center;\n                align-items: center;\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                margin-left: ", ";\n                font-weight: bold;\n                outline: none;\n                display: flex;\n                flex: 1;\n                justify-content: center;\n                align-items: center;\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(8))
      }, {
        children: "\uD68C\uC6D0\uAC00\uC785"
      }))]
    })) : jsxs("div", _assign({
      css: /*#__PURE__*/css(templateObject_7$h || (templateObject_7$h = __makeTemplateObject(["\n          display: flex;\n          align-items: center;\n          margin: ", " 0 ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          display: flex;\n          align-items: center;\n          margin: ", " 0 ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(24), pxToRem(20))
    }, {
      children: [jsx(Avatar, {
        size: 20,
        src: userProfile.imageUrl
      }), jsx("p", _assign({
        css: /*#__PURE__*/css(templateObject_8$c || (templateObject_8$c = __makeTemplateObject(["\n            font-size: ", ";\n            line-height: ", ";\n            margin-left: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            font-size: ", ";\n            line-height: ", ";\n            margin-left: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(14), pxToRem(20), pxToRem(4))
      }, {
        children: userProfile.nickname
      }))]
    }))]
  });
}
var templateObject_1$W, templateObject_2$M, templateObject_3$E, templateObject_4$y, templateObject_5$r, templateObject_6$m, templateObject_7$h, templateObject_8$c;

function NavigationDrawerFooterListItem(_a) {
  var title = _a.title,
    href = _a.href,
    onClick = _a.onClick,
    onClose = _a.onClose;
  var theme = useTheme();
  var LinkComponent = useLinkContext();
  return jsx("li", _assign({
    css: [/*#__PURE__*/css(templateObject_1$V || (templateObject_1$V = __makeTemplateObject(["\n        display: inline-block;\n        padding: ", ";\n        border-radius: ", ";\n        margin: 0 0 0 ", ";\n        line-height: ", ";\n        &:first-of-type {\n          margin: 0;\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        display: inline-block;\n        padding: ", ";\n        border-radius: ", ";\n        margin: 0 0 0 ", ";\n        line-height: ", ";\n        &:first-of-type {\n          margin: 0;\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(6), pxToRem(4), pxToRem(7), pxToRem(18)), HOVER(templateObject_2$L || (templateObject_2$L = __makeTemplateObject(["\n        background-color: ", ";\n      "], ["\n        background-color: ", ";\n      "])), theme.background.groupedBase)]
  }, {
    children: href != null ? jsx(LinkComponent, _assign({
      href: href,
      css: /*#__PURE__*/css(templateObject_3$D || (templateObject_3$D = __makeTemplateObject(["\n            ", "\n            outline: none;\n            vertical-align: middle;\n            white-space: nowrap;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            ", "\n            outline: none;\n            vertical-align: middle;\n            white-space: nowrap;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), FONT_STYLE.subTitle2),
      onClick: onClose
    }, {
      children: title
    })) : jsx("button", _assign({
      css: /*#__PURE__*/css(templateObject_4$x || (templateObject_4$x = __makeTemplateObject(["\n            ", "\n            ", "\n            color: ", ";\n            outline: none;\n            cursor: pointer;\n            vertical-align: middle;\n            white-space: nowrap;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            ", "\n            ", "\n            color: ", ";\n            outline: none;\n            cursor: pointer;\n            vertical-align: middle;\n            white-space: nowrap;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), RESET_BUTTON, FONT_STYLE.subTitle2, theme.content.base1),
      onClick: onClick,
      type: "button"
    }, {
      children: title
    }))
  }));
}
function NavigationDrawerFooter(_a) {
  var items = _a.items,
    onClose = _a.onClose;
  return jsx("ul", _assign({
    css: /*#__PURE__*/css(templateObject_5$q || (templateObject_5$q = __makeTemplateObject(["\n      padding: 0;\n      margin-top: ", ";\n      display: flex;\n      align-items: center;\n      > button {\n        font-size: ", ";\n        font-weight: normal;\n      }\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n      padding: 0;\n      margin-top: ", ";\n      display: flex;\n      align-items: center;\n      > button {\n        font-size: ", ";\n        font-weight: normal;\n      }\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(14), pxToRem(14))
  }, {
    children: items.map(function (item, index) {
      return jsx(NavigationDrawerFooterListItem, _assign({
        onClose: onClose
      }, item), index);
    })
  }));
}
var templateObject_1$V, templateObject_2$L, templateObject_3$D, templateObject_4$x, templateObject_5$q;

function NavigationDrawer(_a) {
  var open = _a.open,
    logo = _a.logo,
    menuSchema = _a.menuSchema,
    supplementary = _a.supplementary,
    onClose = _a.onClose,
    onAppDownload = _a.onAppDownload,
    rest = __rest(_a, ["open", "logo", "menuSchema", "supplementary", "onClose", "onAppDownload"]);
  var userMenu = supplementary.userMenu,
    _b = supplementary.showAppDownloadButton,
    showAppDownloadButton = _b === void 0 ? true : _b;
  var log = useLogContext();
  var t = useTranslation().t;
  var drawerMenu = useMemo(function () {
    return menuSchema.map(function (mainMenu) {
      var _a;
      return _assign(_assign({}, mainMenu), {
        onClick: function onClick(_a) {
          var index = _a.index;
          log({
            key: 'drawer.main.item',
            category: 'click',
            params: {
              index: index
            }
          });
        },
        entries: (_a = mainMenu.entries) === null || _a === void 0 ? void 0 : _a.map(function (subMenu) {
          return _assign(_assign({}, subMenu), {
            onClick: function onClick(_a) {
              var href = _a.item.href,
                index = _a.index;
              log({
                key: 'drawer.sub.item',
                category: 'click',
                params: {
                  index: index,
                  href: href
                }
              });
            }
          });
        })
      });
    });
  }, [menuSchema, log]);
  var drawerUserMenu = useMemo(function () {
    return userMenu.filter(function (menu) {
      var _a;
      return (_a = menu.showOn) === null || _a === void 0 ? void 0 : _a.includes('drawer');
    }).map(function (_a) {
      var title = _a.title,
        href = _a.href,
        bullet = _a.bullet;
      return {
        title: title,
        href: href,
        bullet: bullet,
        onClick: function onClick(_a) {
          var index = _a.index;
          log({
            key: 'drawer.user.item',
            category: 'click',
            params: {
              index: index
            }
          });
        }
      };
    });
  }, [userMenu, log]);
  var drawerFooterMenu = useMemo(function () {
    return userMenu.filter(function (menu) {
      return menu.type === 'bottom';
    });
  }, [userMenu]);
  return jsxs(Drawer, _assign({
    open: open,
    width: 270,
    onClose: onClose
  }, rest, {
    children: [jsx(NavigationDrawerHeader, {
      logo: {
        logo: logo,
        onClick: function onClick() {
          return window.open((logo === null || logo === void 0 ? void 0 : logo.href) || 'https://ohou.se');
        }
      },
      action: showAppDownloadButton ? {
        text: t('COMMON__DOWNLOADAPP', '앱다운로드'),
        onClick: function onClick() {
          log({
            key: 'drawer.user.profile',
            category: 'click'
          });
          onAppDownload === null || onAppDownload === void 0 ? void 0 : onAppDownload();
        }
      } : undefined,
      supplementary: supplementary
    }), jsx(NavigationDrawerDivider, {}), jsx(NavigationDrawerMenu, {
      items: drawerMenu,
      fontStyles: [{
        size: 16,
        weight: 'bold'
      }],
      indents: [14, 42, 50],
      onClose: onClose
    }), drawerUserMenu.length > 0 && jsx(NavigationDrawerDivider, {}), jsx(NavigationDrawerMenu, {
      items: drawerUserMenu,
      onClose: onClose
    }), jsx(NavigationDrawerDivider, {}), jsx(NavigationDrawerFooter, {
      items: drawerFooterMenu,
      onClose: onClose
    })]
  }));
}

function Navigation(props) {
  var logo = props.logo,
    menuSchema = props.menuSchema,
    searchOptions = props.searchOptions,
    supplementary = props.supplementary,
    fallbackMenuSchema = props.fallbackMenuSchema,
    linkComponent = props.linkComponent,
    onLog = props.onLog,
    onAppDownload = props.onAppDownload,
    location = props.location;
  var _a = useState(false),
    isDrawerOpen = _a[0],
    setDrawerOpen = _a[1];
  var handleDrawerToggle = useCallback(function () {
    setDrawerOpen(function (v) {
      return !v;
    });
  }, []);
  var handleDrawerClose = useCallback(function () {
    setDrawerOpen(false);
  }, []);
  var isInApp = useIsInApp(location);
  if (isInApp) {
    return null;
  }
  return jsx(LinkProvider, _assign({
    linkComponent: linkComponent
  }, {
    children: jsx(LogProvider, _assign({
      onLog: onLog
    }, {
      children: jsxs(Fragment$1, {
        children: [jsx(NavigationBar, {
          logo: logo,
          menuSchema: menuSchema,
          primaryLeftmost: jsx(Button$1, _assign({
            type: "button",
            onClick: function onClick() {
              onLog({
                key: 'drawer.button',
                category: 'click'
              });
              handleDrawerToggle();
            }
          }, {
            children: jsx(Icon, {
              size: 24,
              name: "menu"
            })
          })),
          searchOptions: searchOptions,
          supplementary: supplementary,
          fallbackMenuSchema: fallbackMenuSchema
        }), jsx(NavigationDrawer, {
          open: isDrawerOpen,
          logo: logo,
          menuSchema: menuSchema,
          supplementary: supplementary,
          onOpen: handleDrawerToggle,
          onClose: handleDrawerClose,
          onAppDownload: onAppDownload
        })]
      })
    }))
  }));
}
var Button$1 = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "ebs7dy10"
} : {
  target: "ebs7dy10",
  label: "Button"
})(templateObject_1$U || (templateObject_1$U = __makeTemplateObject(["\n  ", "\n  padding: ", ";\n  margin: ", " ", ";\n  color: ", ";\n  outline: none;\n"], ["\n  ", "\n  padding: ", ";\n  margin: ", " ", ";\n  color: ", ";\n  outline: none;\n"])), RESET_BUTTON, pxToRem(6), pxToRem(3), pxToRem(1), function (_a) {
  var theme = _a.theme;
  return theme.content.base1;
});
var templateObject_1$U;

var NavigationRightButton = /*#__PURE__*/memo(function (_a) {
  var title = _a.title,
    href = _a.href;
  var theme = useTheme();
  var LinkComponent = useLinkContext();
  var log = useLogContext();
  return jsx(LinkComponent, _assign({
    href: href,
    css: [/*#__PURE__*/css(templateObject_1$T || (templateObject_1$T = __makeTemplateObject(["\n          display: flex;\n          align-items: center;\n          ", ";\n          color: ", ";\n          font-weight: 700;\n          outline: none;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          display: flex;\n          align-items: center;\n          ", ";\n          color: ", ";\n          font-weight: 700;\n          outline: none;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), FONT_STYLE.subTitle1, theme.content.primary1.basic), FOCUS(templateObject_2$K || (templateObject_2$K = __makeTemplateObject(["\n          & > span {\n            box-shadow: 0 0 0 ", " ", ";\n          }\n        "], ["\n          & > span {\n            box-shadow: 0 0 0 ", " ", ";\n          }\n        "])), pxToRem(3), theme.content.primary1.thin)],
    onClick: function onClick() {
      return log({
        key: 'secondary.interior',
        category: 'click'
      });
    }
  }, {
    children: jsxs("span", _assign({
      css: /*#__PURE__*/css(templateObject_3$C || (templateObject_3$C = __makeTemplateObject(["\n        display: inline-block;\n        padding: ", ";\n        margin: ", ";\n        border-radius: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        display: inline-block;\n        padding: ", ";\n        margin: ", ";\n        border-radius: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(4), pxToRem(-4), pxToRem(3))
    }, {
      children: [title, jsx(Icon, {
        css: /*#__PURE__*/css(templateObject_4$w || (templateObject_4$w = __makeTemplateObject(["\n          margin-left: 8px;\n          line-height: 0;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          margin-left: 8px;\n          line-height: 0;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")]))),
        name: "chevron_thick_right",
        size: 18
      })]
    }))
  }));
});
var templateObject_1$T, templateObject_2$K, templateObject_3$C, templateObject_4$w;

var TYPE_MAP = {
  'logo': function logo() {
    return {
      click: {
        bucket: {
          section: '로고'
        }
      }
    };
  },
  // primary
  'primary.item': function primaryItem(_a) {
    var index = _a.index;
    return {
      click: {
        bucket: {
          section: '메인 메뉴',
          index: index
        }
      }
    };
  },
  'primary.right.search.input': function primaryRightSearchInput(_a) {
    var search_type = _a.search_type;
    return {
      click: {
        bucket: {
          section: '검색'
        },
        amplitude: {
          type: '검색 필드 Clicked',
          search_type: search_type
        }
      }
    };
  },
  'primary.right.search.autocomplete.query': function primaryRightSearchAutocompleteQuery(_a) {
    var id = _a.id,
      type = _a.type,
      index = _a.index;
    return {
      click: {
        bucket: {
          section: '자동완성',
          id: id,
          type: type,
          index: index
        }
      }
    };
  },
  'primary.right.search.autocomplete.category': function primaryRightSearchAutocompleteCategory(_a) {
    var id = _a.id,
      type = _a.type,
      index = _a.index;
    return {
      click: {
        bucket: {
          section: '추천 카테고리',
          id: id,
          type: type,
          index: index
        }
      }
    };
  },
  'primary.right.search.history': function primaryRightSearchHistory(_a) {
    var id = _a.id,
      type = _a.type,
      index = _a.index;
    return {
      click: {
        bucket: {
          section: '최근 검색어',
          id: id,
          type: type,
          index: index
        }
      },
      impression: {
        bucket: {
          section: '최근 검색어',
          type: type
        }
      }
    };
  },
  'primary.right.scrap': function primaryRightScrap() {
    return {
      click: {
        bucket: {
          section: '스크랩북'
        },
        amplitude: {
          type: '스크랩북 Viewed',
          data: {
            source: {
              page: {
                tab: {
                  main: '스크랩북'
                }
              },
              referrer: {
                type: '바로가기'
              }
            }
          }
        }
      }
    };
  },
  'primary.right.cart': function primaryRightCart() {
    return {
      click: {
        bucket: {
          section: '장바구니'
        }
      }
    };
  },
  'primary.right.notification': function primaryRightNotification() {
    return {
      click: {
        bucket: {
          section: '알림'
        },
        amplitude: {
          type: '알림 리스트 Viewed'
        }
      }
    };
  },
  'primary.right.login': function primaryRightLogin() {
    return {
      click: {
        bucket: {
          section: '로그인'
        }
      }
    };
  },
  'primary.right.signup': function primaryRightSignup() {
    return {
      click: {
        bucket: {
          section: '회원가입'
        }
      }
    };
  },
  'primary.right.cs': function primaryRightCs() {
    return {
      click: {
        bucket: {
          section: '고객센터'
        }
      }
    };
  },
  'primary.right.mypage': function primaryRightMypage() {
    return {
      click: {
        amplitude: {
          type: '계정 Viewed'
        }
      }
    };
  },
  'primary.right.logout': function primaryRightLogout() {
    return {
      click: {
        amplitude: {
          type: '계정 Logout'
        }
      }
    };
  },
  'primary.right.upload': function primaryRightUpload() {
    return {
      click: {
        bucket: {
          section: '글쓰기'
        }
      }
    };
  },
  'primary.right.upload.photo': function primaryRightUploadPhoto() {
    return {
      click: {
        bucket: {
          section: '사진 올리기'
        }
      }
    };
  },
  // secondary
  'secondary.item': function secondaryItem(_a) {
    var index = _a.index,
      href = _a.href,
      rest = __rest(_a, ["index", "href"]);
    return {
      click: {
        bucket: _assign({
          index: index,
          url: typeof href === 'string' ? href : '/'
        }, rest)
      },
      impression: {
        bucket: _assign({
          index: index
        }, rest)
      }
    };
  },
  'secondary.interior': function secondaryInterior() {
    return {
      click: {
        bucket: {
          section: '3D인테리어'
        }
      }
    };
  },
  'secondary.more.button': function secondaryMoreButton() {
    return {
      click: {
        bucket: {
          section: '토픽',
          section_id: 'TOPIC',
          type: 'button',
          id: 'more_button'
        }
      }
    };
  },
  // tertiary
  'tertiary.store.category.item': function tertiaryStoreCategoryItem(_a) {
    var id = _a.id,
      index = _a.index;
    return {
      click: {
        bucket: {
          section: '카테고리 메뉴',
          type: 'category',
          id: id,
          index: index
        }
      }
    };
  },
  // drawer
  'drawer.logo': function drawerLogo() {
    return {
      click: {
        bucket: {
          section: 'drawer 로고'
        }
      }
    };
  },
  'drawer.button': function drawerButton() {
    return {
      click: {
        bucket: {
          section: '햄버거 메뉴'
        }
      }
    };
  },
  'drawer.main.item': function drawerMainItem(_a) {
    var index = _a.index;
    return {
      click: {
        bucket: {
          section: '메인 메뉴',
          index: index
        }
      }
    };
  },
  'drawer.sub.item': function drawerSubItem(_a) {
    var index = _a.index,
      href = _a.href;
    return {
      click: {
        bucket: {
          section: '서브 메뉴',
          index: index,
          url: typeof href === 'string' ? href : '/'
        }
      }
    };
  },
  'drawer.user.item': function drawerUserItem(_a) {
    var index = _a.index;
    return {
      click: {
        bucket: {
          section: '유저 메뉴',
          index: index
        }
      }
    };
  },
  'drawer.user.profile': function drawerUserProfile() {
    return {
      click: {
        bucket: {
          section: '유저 프로필'
        },
        amplitude: {
          type: '계정 Viewed'
        }
      }
    };
  }
};

var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "logo_svg__icon",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#35C5F0",
    d: "M16.41 0H3.59A3.59 3.59 0 0 0 0 3.59v12.82A3.59 3.59 0 0 0 3.59 20h12.82A3.59 3.59 0 0 0 20 16.41V3.59A3.59 3.59 0 0 0 16.41 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M14.75 10.34c-.74 0-1.33-.6-1.33-1.34s.6-1.34 1.33-1.34 1.32.6 1.32 1.34-.59 1.34-1.32 1.34m-1 3.53H6.12V8.75l3.82-2.7 2.2 1.55a3 3 0 0 0-.35 1.4 3 3 0 0 0 1.98 2.83v2.04zm1-7.87c-.34 0-.66.06-.97.17l-3.17-2.24a1.18 1.18 0 0 0-1.35 0L4.5 7.28a1.2 1.2 0 0 0-.51.98v6.54c0 .66.53 1.2 1.19 1.2h9.5a1.2 1.2 0 0 0 1.18-1.2v-3.02A3 3 0 0 0 17.7 9c0-1.65-1.32-3-2.96-3z"
  }))));
};
var LogoIcon = SvgLogo;

function AppDownloadPopup(_a) {
  var _b, _c, _d, _e;
  var isOpen = _a.isOpen,
    onClose = _a.onClose,
    _f = _a.onAppOpen,
    onAppOpen = _f === void 0 ? function () {
      //
    } : _f,
    localeData = _a.localeData;
  var theme = useTheme();
  var _g = useState(false),
    hasBottomPadding = _g[0],
    setHasBottomPadding = _g[1];
  var isDescriptionShown = useMemo(function () {
    return localeData == null || (localeData === null || localeData === void 0 ? void 0 : localeData.description) != null;
  }, [localeData]);
  useEffect(function () {
    if (/(?:iPad|iPhone|iPod).*Instagram/gi.test(navigator.userAgent)) {
      setHasBottomPadding(true);
    }
  }, []);
  if (!isOpen) return null;
  return jsx(Modal, _assign({
    width: 400
  }, {
    children: jsxs("div", _assign({
      css: /*#__PURE__*/css(templateObject_2$J || (templateObject_2$J = __makeTemplateObject(["\n        box-sizing: content-box;\n        max-width: ", ";\n        margin: 0 auto;\n        padding: ", " ", ";\n        text-align: left;\n        ", "\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        box-sizing: content-box;\n        max-width: ", ";\n        margin: 0 auto;\n        padding: ", " ", ";\n        text-align: left;\n        ", "\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(325), pxToRem(30), pxToRem(36), hasBottomPadding && /*#__PURE__*/css(templateObject_1$S || (templateObject_1$S = __makeTemplateObject(["\n          padding-bottom: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          padding-bottom: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(100)))
    }, {
      children: [jsxs("div", _assign({
        css: /*#__PURE__*/css(templateObject_3$B || (templateObject_3$B = __makeTemplateObject(["\n          display: flex;\n          justify-content: center;\n          margin-bottom: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          display: flex;\n          justify-content: center;\n          margin-bottom: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(28))
      }, {
        children: [jsx(LogoIcon, {
          css: /*#__PURE__*/css(templateObject_4$v || (templateObject_4$v = __makeTemplateObject(["\n              flex: 0 0 auto;\n              width: ", ";\n              height: ", ";\n              margin-right: ", ";\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              flex: 0 0 auto;\n              width: ", ";\n              height: ", ";\n              margin-right: ", ";\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(70), pxToRem(70), pxToRem(12))
        }), jsxs("div", _assign({
          css: /*#__PURE__*/css(templateObject_5$p || (templateObject_5$p = __makeTemplateObject(["\n            flex: 0 1 auto;\n            min-width: 0;\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            flex: 0 1 auto;\n            min-width: 0;\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
        }, {
          children: [jsx("div", _assign({
            "data-testid": "popup-title",
            css: /*#__PURE__*/css(templateObject_6$l || (templateObject_6$l = __makeTemplateObject(["\n                ", "\n                font-weight: 700;\n                color: ", ";\n                white-space: pre-line;\n                word-break: break-word;\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                ", "\n                font-weight: 700;\n                color: ", ";\n                white-space: pre-line;\n                word-break: break-word;\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), FONT_STYLE.title3, theme.content.base1)
          }, {
            children: (_b = localeData === null || localeData === void 0 ? void 0 : localeData.title) !== null && _b !== void 0 ? _b : '앱에서는 1초만에!\n간편하게 로그인하기'
          })), isDescriptionShown && jsxs("div", _assign({
            css: /*#__PURE__*/css(templateObject_7$g || (templateObject_7$g = __makeTemplateObject(["\n                  display: flex;\n                  align-items: center;\n                  font-size: ", ";\n                  line-height: 1;\n                  gap: ", ";\n                  margin-top: ", ";\n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                  display: flex;\n                  align-items: center;\n                  font-size: ", ";\n                  line-height: 1;\n                  gap: ", ";\n                  margin-top: ", ";\n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(11), pxToRem(2), pxToRem(8))
          }, {
            children: [jsx("div", _assign({
              css: /*#__PURE__*/css(templateObject_8$b || (templateObject_8$b = __makeTemplateObject(["\n                      display: flex;\n                      gap: ", ";\n                    " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                      display: flex;\n                      gap: ", ";\n                    " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(2))
            }, {
              children: new Array(5).fill(0).map(function (_, index) {
                return jsx(StarFilledIcon, {
                  size: 12,
                  fill: function fill(theme) {
                    return theme.content.primary1.basic;
                  }
                }, index);
              })
            })), jsx("div", _assign({
              "data-testid": "popup-description",
              css: /*#__PURE__*/css(templateObject_9$9 || (templateObject_9$9 = __makeTemplateObject(["\n                    ", "\n                    display: inline-block;\n                    color: ", ";\n                    font-weight: 400;\n                  " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                    ", "\n                    display: inline-block;\n                    color: ", ";\n                    font-weight: 400;\n                  " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), FONT_STYLE.caption2, theme.content.base2)
            }, {
              children: (_c = localeData === null || localeData === void 0 ? void 0 : localeData.description) !== null && _c !== void 0 ? _c : '특가, 쿠폰 등 앱 전용 혜택까지'
            }))]
          }))]
        }))]
      })), jsx(Button$2, _assign({
        type: "button",
        size: 44,
        variant: "primary1",
        full: true,
        onClick: onAppOpen,
        "aria-label": "\uC624\uB298\uC758\uC9D1 \uC571\uC73C\uB85C \uBCF4\uAE30"
      }, {
        children: (_d = localeData === null || localeData === void 0 ? void 0 : localeData.appDownloadButtonText) !== null && _d !== void 0 ? _d : '편리한 앱으로 보기'
      })), jsx("button", _assign({
        css: /*#__PURE__*/css(templateObject_10$8 || (templateObject_10$8 = __makeTemplateObject(["\n            ", "\n            ", "\n            color: ", ";\n            text-align: center;\n            width: 100%;\n            margin-top: ", ";\n            font-weight: 500;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            ", "\n            ", "\n            color: ", ";\n            text-align: center;\n            width: 100%;\n            margin-top: ", ";\n            font-weight: 500;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), RESET_BUTTON, FONT_STYLE.body14L18, theme.content.base2, pxToRem(12)),
        type: "button",
        onClick: function onClick() {
          onClose();
        },
        "aria-label": "\uB2EB\uAE30"
      }, {
        children: (_e = localeData === null || localeData === void 0 ? void 0 : localeData.remainWebButtonText) !== null && _e !== void 0 ? _e : '모바일 웹으로 볼래요'
      }))]
    }))
  }));
}
var templateObject_1$S, templateObject_2$J, templateObject_3$B, templateObject_4$v, templateObject_5$p, templateObject_6$l, templateObject_7$g, templateObject_8$b, templateObject_9$9, templateObject_10$8;

function AppDownloadPopupContainer(props) {
  var onCheck = props.onCheck,
    onAppOpen = props.onAppOpen,
    onClose = props.onClose,
    localeData = props.localeData;
  var _a = useState(false),
    isOpen = _a[0],
    setOpen = _a[1];
  var checked = onCheck();
  useEffect(function () {
    setOpen(checked);
  }, [checked]);
  var handleClose = useCallback(function () {
    onClose();
    setOpen(false);
  }, [onClose]);
  return jsx(AppDownloadPopup, {
    isOpen: isOpen,
    onClose: handleClose,
    onAppOpen: onAppOpen,
    localeData: localeData
  });
}

/** FIXME: imageSrc 제거 */
function MobileTopBanner(_a) {
  var _b, _c;
  var isOpen = _a.isOpen,
    onClose = _a.onClose,
    _d = _a.onAppOpen,
    onAppOpen = _d === void 0 ? function () {
      //
    } : _d;
    _a.imageSrc;
    var className = _a.className,
    localeData = _a.localeData;
  var theme = useTheme();
  if (!isOpen) return null;
  return jsxs("div", _assign({
    className: className,
    css: /*#__PURE__*/css(templateObject_1$R || (templateObject_1$R = __makeTemplateObject(["\n        ", "\n        position: relative;\n        width: 100%;\n        box-sizing: border-box;\n        z-index: ", ";\n        background-color: ", ";\n        display: none;\n        overflow: hidden;\n        padding: ", " ", " ", " 0;\n        ", "\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        ", "\n        position: relative;\n        width: 100%;\n        box-sizing: border-box;\n        z-index: ", ";\n        background-color: ", ";\n        display: none;\n        overflow: hidden;\n        padding: ", " ", " ", " 0;\n        ", "\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), RESET_BUTTON, ZINDEX.banner, theme.background.groupedBase, pxToRem(18), pxToRem(16), pxToRem(18), MEDIA_QUERY.max('mobile', "\n          display: flex;\n        "))
  }, {
    children: [jsx("button", {
      type: "button",
      css: /*#__PURE__*/css(templateObject_2$I || (templateObject_2$I = __makeTemplateObject(["\n          ", "\n          position: absolute;\n          width: 100%;\n          height: 100%;\n          top: 0;\n          left: 0;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          ", "\n          position: absolute;\n          width: 100%;\n          height: 100%;\n          top: 0;\n          left: 0;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), RESET_BUTTON),
      "aria-label": "\uC624\uB298\uC758\uC9D1 \uC571\uC73C\uB85C \uBCF4\uAE30",
      onClick: onAppOpen
    }), jsx("button", _assign({
      type: "button",
      css: /*#__PURE__*/css(templateObject_3$A || (templateObject_3$A = __makeTemplateObject(["\n          ", "\n          display: flex;\n          color: ", ";\n          width: 44px;\n          align-items: center;\n          flex-shrink: 0;\n          z-index: 1;\n          padding: 0 16px;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          ", "\n          display: flex;\n          color: ", ";\n          width: 44px;\n          align-items: center;\n          flex-shrink: 0;\n          z-index: 1;\n          padding: 0 16px;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), RESET_BUTTON, theme.content.base2),
      "aria-label": "\uB2EB\uAE30",
      onClick: function onClick(e) {
        onClose();
        e.stopPropagation();
      }
    }, {
      children: jsx(DismissIcon, {
        size: 12,
        fill: function fill(theme) {
          return theme.content.base2;
        }
      })
    })), jsxs("div", _assign({
      css: /*#__PURE__*/css(templateObject_4$u || (templateObject_4$u = __makeTemplateObject(["\n          display: flex;\n          align-items: center;\n          width: calc(100% - ", ");\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          display: flex;\n          align-items: center;\n          width: calc(100% - ", ");\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(44))
    }, {
      children: [jsx(LogoIcon, {
        css: /*#__PURE__*/css(templateObject_5$o || (templateObject_5$o = __makeTemplateObject(["\n            width: ", ";\n            height: ", ";\n            margin-right: ", ";\n            flex-shrink: 0;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            width: ", ";\n            height: ", ";\n            margin-right: ", ";\n            flex-shrink: 0;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(40), pxToRem(40), pxToRem(8))
      }), jsx("div", _assign({
        "data-testid": "banner-title",
        css: /*#__PURE__*/css(templateObject_6$k || (templateObject_6$k = __makeTemplateObject(["\n          ", "\n          color: ", ";\n          font-weight: 600;\n          white-space: pre-line;\n          word-break: break-word;\n          text-align: left;\n          flex-grow: 1;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          ", "\n          color: ", ";\n          font-weight: 600;\n          white-space: pre-line;\n          word-break: break-word;\n          text-align: left;\n          flex-grow: 1;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), FONT_STYLE.body2_small, theme.content.base1)
      }, {
        children: (_b = localeData === null || localeData === void 0 ? void 0 : localeData.title) !== null && _b !== void 0 ? _b : '앱에서 1초만에!\n간편하게 로그인하기'
      })), jsx(Button$2, _assign({
        "data-testid": "banner-button",
        size: 32,
        variant: "primary1",
        css: /*#__PURE__*/css(templateObject_7$f || (templateObject_7$f = __makeTemplateObject(["\n            font-weight: 700;\n            flex-shrink: 0;\n            margin-left: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            font-weight: 700;\n            flex-shrink: 0;\n            margin-left: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(16)),
        onClick: onAppOpen
      }, {
        children: (_c = localeData === null || localeData === void 0 ? void 0 : localeData.appDownloadButtonText) !== null && _c !== void 0 ? _c : '앱으로 보기'
      }))]
    }))]
  }));
}
var templateObject_1$R, templateObject_2$I, templateObject_3$A, templateObject_4$u, templateObject_5$o, templateObject_6$k, templateObject_7$f;

var getContentsUrl = function getContentsUrl(_a) {
  var contentId = _a.contentId,
    contentType = _a.contentType,
    contentUrl = _a.contentUrl,
    isUserLoggedIn = _a.isUserLoggedIn,
    origin = _a.origin;
  switch (contentType === null || contentType === void 0 ? void 0 : contentType.split(/(?=[A-Z])/).join('_').toLowerCase()) {
    case 'competition':
      return "".concat(origin, "/competitions/").concat(contentId);
    case 'production':
      return "".concat(origin, "/productions/").concat(contentId, "/selling");
    case 'exhibition':
      return "".concat(origin, "/exhibitions/").concat(contentId);
    case 'advice':
      return "".concat(origin, "/advices/").concat(contentId);
    case 'project':
      return "".concat(origin, "/projects/").concat(contentId, "/detail");
    case 'card_collection':
      return "".concat(origin, "/contents/card_collections/").concat(contentId);
    case 'invite_friend':
      if (!isUserLoggedIn) {
        return "".concat(origin, "/users/sign_in?redirect_to=/invite_codes/recommend_code");
      }
      return "".concat(origin, "/invite_codes/recommend_code");
    default:
      return contentUrl || '';
  }
};
function PCTopBanner(_a) {
  var className = _a.className,
    isOpen = _a.isOpen,
    onClose = _a.onClose,
    _onClick = _a.onClick,
    contentList = _a.contentList,
    linkComponent = _a.linkComponent,
    isUserLoggedIn = _a.isUserLoggedIn,
    origin = _a.origin;
  var LinkComponent = linkComponent;
  var backgroundContent = [contentList[0], contentList[contentList.length - 1]];
  if (!isOpen) return null;
  return jsxs("div", _assign({
    className: className,
    css: /*#__PURE__*/css(templateObject_1$Q || (templateObject_1$Q = __makeTemplateObject(["\n        position: relative;\n        display: none;\n        z-index: ", ";\n        ", "\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        position: relative;\n        display: none;\n        z-index: ", ";\n        ", "\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), ZINDEX.banner, MEDIA_QUERY.min('tablet', "\n          display: block;\n        "))
  }, {
    children: [backgroundContent.map(function (content, index) {
      /* 왼쪽, 오른쪽 배너의 끝 부분을 채워주기 위해 필요합니다. */
      var pcGradientColor = content.pcGradientColor;
      var url = getContentsUrl(_assign(_assign({}, content), {
        isUserLoggedIn: isUserLoggedIn,
        origin: origin
      }));
      var isFirst = index === 0;
      return jsx(LinkComponent, {
        href: url,
        "aria-label": "PC \uCD5C\uC0C1\uB2E8 \uBC30\uB108",
        onClick: function onClick() {
          return _onClick && _onClick(content, index >= 1 ? contentList.length - 1 : 0);
        },
        css: /*#__PURE__*/css(templateObject_2$H || (templateObject_2$H = __makeTemplateObject(["\n              position: absolute;\n              top: 0;\n              bottom: 0;\n              width: 50%;\n              background-color: ", ";\n              ", "\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              position: absolute;\n              top: 0;\n              bottom: 0;\n              width: 50%;\n              background-color: ", ";\n              ", "\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pcGradientColor, isFirst ? 'left: 0;' : 'right: 0;')
      }, index);
    }), jsx("div", _assign({
      css: /*#__PURE__*/css(templateObject_3$z || (templateObject_3$z = __makeTemplateObject(["\n          display: flex;\n          max-width: ", ";\n          margin: 0 auto;\n          padding: 0 ", ";\n          ", "\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          display: flex;\n          max-width: ", ";\n          margin: 0 auto;\n          padding: 0 ", ";\n          ", "\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(1156), pxToRem(40), MEDIA_QUERY.min('laptop', "\n            padding: 0 ".concat(pxToRem(60), ";\n          ")))
    }, {
      children: contentList.map(function (content, index) {
        var coverImageUrl = content.coverImageUrl,
          pcGradientColor = content.pcGradientColor;
        var url = getContentsUrl(_assign(_assign({}, content), {
          isUserLoggedIn: isUserLoggedIn,
          origin: origin
        }));
        return jsx(LinkComponent, {
          href: url,
          onClick: function onClick() {
            return _onClick && _onClick(content, index);
          },
          "aria-label": "PC \uCD5C\uC0C1\uB2E8 \uBC30\uB108",
          css: /*#__PURE__*/css(templateObject_4$t || (templateObject_4$t = __makeTemplateObject(["\n                  flex: 1 0 0;\n                  background-image: url(", ");\n                  background-color: ", ";\n                  position: relative;\n                  height: ", ";\n                  background-size: auto 100%;\n                  background-repeat: no-repeat;\n                  background-position: center;\n                  z-index: 1;\n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                  flex: 1 0 0;\n                  background-image: url(", ");\n                  background-color: ", ";\n                  position: relative;\n                  height: ", ";\n                  background-size: auto 100%;\n                  background-repeat: no-repeat;\n                  background-position: center;\n                  z-index: 1;\n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), coverImageUrl, pcGradientColor, pxToRem(50))
        }, index);
      })
    })), jsx("button", _assign({
      css: /*#__PURE__*/css(templateObject_5$n || (templateObject_5$n = __makeTemplateObject(["\n          ", "\n          position: absolute;\n          top: 50%;\n          right: ", ";\n          display: block;\n          margin: -", " 0 0;\n          padding: ", ";\n          color: white;\n          width: ", ";\n          height: ", ";\n          box-sizing: border-box;\n          font-size: 0;\n          line-height: 0;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          ", "\n          position: absolute;\n          top: 50%;\n          right: ", ";\n          display: block;\n          margin: -", " 0 0;\n          padding: ", ";\n          color: white;\n          width: ", ";\n          height: ", ";\n          box-sizing: border-box;\n          font-size: 0;\n          line-height: 0;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), RESET_BUTTON, pxToRem(8), pxToRem(25), pxToRem(12), pxToRem(48), pxToRem(48)),
      type: "button",
      "aria-label": "\uB2EB\uAE30",
      onClick: function onClick() {
        onClose();
      }
    }, {
      children: jsx(Icon, {
        size: 24,
        name: "dismiss_thick",
        fill: function fill(theme) {
          return theme.background.base;
        }
      })
    }))]
  }));
}
var templateObject_1$Q, templateObject_2$H, templateObject_3$z, templateObject_4$t, templateObject_5$n;

function TopBannerContainer(props) {
  var pathname = props.pathname,
    isVisible = props.isVisible,
    onCheck = props.onCheck,
    onClose = props.onClose,
    ssrCheckLiteral = props.ssrCheckLiteral,
    ssrClassName = props.ssrClassName,
    children = props.children;
  /**
   * isOpen과 isUnsure은 무엇인가요? ...
   * React에서 자체적으로 배너 상태를 관리하고 있긴 하지만, 유저가 오늘의집에 들어와서 로딩하는
   * 시점에는 아직 React가 로딩되지 않은 상황이기 때문에, 이 때 layout shift를 최소화하기
   * 위해 배너의 동작을 <script> 태그를 통해서 제어하고 있습니다.
   *
   * script 태그 안에서는 유저가 앱 다운로드 팝업을 봤는지, 배너를 닫았는지 등 여러가지를
   * 판단해서 배너가 보여져야 하는지, 아니면 숨겨져야 하는지 결정해서, 만약 숨겨져야 한다면
   * style 태그를 추가해서 노드를 숨겨버립니다.
   *
   * 문제는 이 style 태그는 지워지지 않기 때문에, React에서 다시 배너를 표출하려고 할 때
   * 이슈가 생기게 됩니다.
   * PC 배너와 달리, 모바일 배너는 앱 다운로드 팝업을 닫고, 유저가 다른 페이지로 이동했을 때
   * 다시 보여지는데요, 다른 페이지로 이동하는 것의 인식을 'pathname'을 통해서 하고 있습니다.
   *
   * 즉, 실제 reload가 아닌, SPA 안에서 페이지가 바뀌어도 배너가 보여져야 합니다. 하지만
   * 이 때 페이지 진입 시 배너를 강제로 숨겨버렸기 때문에, React에서 다시 배너를 보여줄 수
   * 없는 상황이 되어버립니다.
   *
   * 이를 해결하기 위해, SSR 시점의 배너 로직은 순전히 SSR 과정중 layout shift를 막는
   * 용도로만 쓰고, React가 로딩되고 나면 이 스타일에 영향받지 않도록 구성하면 됩니다.
   *
   * 이를 위해 "isUnsure" 플래그가 추가되었습니다. 아직 리액트가 렌더링되지 않은 상황에서는
   * isUnsure가 true라서 클래스 네임이 입력되겠지만, 리액트가 초기화된 뒤에는 리액트가
   * 자유롭게 제어할 수 있도록 클래스 네임을 해제합니다.
   */
  var _a = useState({
      isOpen: false,
      isUnsure: true
    }),
    _b = _a[0],
    isOpen = _b.isOpen,
    isUnsure = _b.isUnsure,
    setState = _a[1];
  useEffect(function () {
    setState({
      isOpen: onCheck(),
      isUnsure: false
    });
  }, [pathname, onCheck]);
  var handleClose = useCallback(function () {
    setState({
      isOpen: false,
      isUnsure: false
    });
    onClose();
  }, [onClose]);
  return jsxs(Fragment$1, {
    children: [ssrCheckLiteral && jsx("script", {
      dangerouslySetInnerHTML: {
        __html: "(function() {\n  if (!(".concat(ssrCheckLiteral, ")) {\n    var style = document.createElement('style');\n    style.append('.").concat(ssrClassName, " { display: none !important; }');\n    document.head.appendChild(style);\n  }\n})();")
      }
    }), children({
      className: isUnsure ? ssrClassName : '',
      isOpen: isVisible && (isOpen || isUnsure),
      onClose: handleClose
    })]
  });
}

// TODO: I'm putting all marketing-specific code in here
function isMarketingHidden(search) {
  var triggered = false;
  try {
    triggered = sessionStorage.marketingHiddenTriggered === 'yes';
  } catch (e) {
    //
  }
  var searchObj = parse(search.slice(1));
  if (triggered || searchObj.pro_app != null) {
    try {
      sessionStorage.marketingHiddenTriggered = 'yes';
    } catch (e) {
      //
    }
    return true;
  }
  return false;
}
function isMobile() {
  if (typeof window === 'undefined') return false;
  if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
    return true;
  }
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
}
function getCookie(name) {
  if (typeof window !== 'undefined') {
    var cookies = (document.cookie || '').split('; ');
    for (var i = 0; i < cookies.length; i += 1) {
      var match = /([^=]+)=(.+)/.exec(cookies[i]);
      if (match && match[1] === name) {
        return match[2];
      }
    }
  }
  return null;
}
function setCookie(name, value, delay, domain) {
  var cookieStr = "".concat(name, "=").concat(value, "; path=/; ") + "expires=".concat(new Date(Date.now() + delay).toUTCString(), ";");
  if (domain) {
    cookieStr += " domain=".concat(domain);
  }
  document.cookie = cookieStr;
}
function NavigationTopBanner(props) {
  var location = props.location,
    _onAppOpen = props.onAppOpen,
    mobileImageSrc = props.mobileImageSrc,
    _a = props.pcContentList,
    pcContentList = _a === void 0 ? [] : _a,
    linkComponent = props.linkComponent,
    onLog = props.onLog,
    isUserLoggedIn = props.isUserLoggedIn,
    onClosePCTopBanner = props.onClosePCTopBanner,
    onCloseMobileTopBanner = props.onCloseMobileTopBanner,
    onCloseAppDownloadPopup = props.onCloseAppDownloadPopup,
    localeData = props.localeData;
  var cookieDomain = location.origin ? ".".concat(location.origin.split(/\.|\/\//).slice(-2).join('.')) : '.ohou.se';
  var isInApp = useIsInApp(location);
  var hiddenAppBanner = isInApp || APP_BANNER_PATHNAME_BLACKLIST.test(location.pathname) || APP_BANNER_SEARCH_BLACKLIST.test(location.search);
  return jsxs(Fragment$1, {
    children: [jsx(TopBannerContainer, _assign({
      pathname: location.pathname,
      isVisible: !isInApp && pcContentList.length > 0,
      onCheck: function onCheck() {
        return getCookie('ohsTopBannerClosed') !== 'yes' && !isMarketingHidden(location.search);
      },
      onClose: function onClose() {
        onLog('banner.top.pc.close', {});
        setCookie('ohsTopBannerClosed', 'yes', 24 * 3600 * 1000, cookieDomain);
        onClosePCTopBanner === null || onClosePCTopBanner === void 0 ? void 0 : onClosePCTopBanner();
      },
      ssrClassName: "gnb-pc-top-banner--unsure",
      // eslint-disable-next-line max-len
      ssrCheckLiteral: "!/(^|;)ohsTopBannerClosed=yes($|;)/.test(document.cookie)"
    }, {
      children: function children(props) {
        return jsx(PCTopBanner, _assign({}, props, {
          contentList: pcContentList,
          linkComponent: linkComponent,
          onClick: function onClick(content, index) {
            onLog('banner.top.pc.click', {
              content: content,
              index: index
            });
          },
          isUserLoggedIn: isUserLoggedIn,
          origin: location.origin || 'https://ohou.se'
        }));
      }
    })), jsx(TopBannerContainer, _assign({
      pathname: location.pathname,
      isVisible: !hiddenAppBanner,
      onCheck: function onCheck() {
        return getCookie('ohsAppDownloadPopupClosed') === 'yes' && getCookie('ohsTopBannerClosed') !== 'yes' && !isMarketingHidden(location.search);
      },
      onClose: function onClose() {
        onLog('banner.top.mobile.close', {});
        setCookie('ohsTopBannerClosed', 'yes', 12 * 3600 * 1000, cookieDomain);
        onCloseMobileTopBanner === null || onCloseMobileTopBanner === void 0 ? void 0 : onCloseMobileTopBanner();
      },
      ssrClassName: "gnb-mobile-top-banner--unsure",
      ssrCheckLiteral: '/(^|;)ohsAppDownloadPopupClosed=yes($|;)/.test(document.cookie) ' + '&& !/(^|;)ohsTopBannerClosed=yes($|;)/.test(document.cookie)'
    }, {
      children: function children(props) {
        return jsx(MobileTopBanner, _assign({}, props, {
          imageSrc: mobileImageSrc,
          onAppOpen: function onAppOpen() {
            onLog('banner.top.mobile.click', {});
            _onAppOpen('banner.top.mobile.click');
          },
          localeData: localeData === null || localeData === void 0 ? void 0 : localeData.mobileBanner
        }));
      }
    })), jsx(AppDownloadPopupContainer, {
      onCheck: function onCheck() {
        return isMobile() && !hiddenAppBanner && getCookie('ohsAppDownloadPopupClosed') !== 'yes' && !isMarketingHidden(location.search);
      },
      onClose: function onClose() {
        onLog('banner.bottom.mobile.close', {});
        setCookie('ohsAppDownloadPopupClosed', 'yes', 12 * 3600 * 1000, cookieDomain);
        onCloseAppDownloadPopup === null || onCloseAppDownloadPopup === void 0 ? void 0 : onCloseAppDownloadPopup();
      },
      onAppOpen: function onAppOpen() {
        onLog('banner.bottom.mobile.click', {});
        _onAppOpen('banner.bottom.mobile.click');
      },
      localeData: localeData === null || localeData === void 0 ? void 0 : localeData.mobilePopup
    })]
  });
}

function NotSupportedBrowserBanner(_a) {
  var buttons = _a.buttons;
  var theme = useTheme();
  return jsx(Sticky, _assign({
    direction: "top",
    offset: 0,
    zIndex: ZINDEX.appBar + 3,
    disableNativeSticky: true,
    disableBottom: true
  }, {
    children: jsxs("div", _assign({
      css: /*#__PURE__*/css(templateObject_1$P || (templateObject_1$P = __makeTemplateObject(["\n          display: flex;\n          flex-wrap: wrap;\n          align-items: center;\n          justify-content: center;\n          width: 100%;\n          padding: ", ";\n          box-sizing: border-box;\n          background: ", "\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          display: flex;\n          flex-wrap: wrap;\n          align-items: center;\n          justify-content: center;\n          width: 100%;\n          padding: ", ";\n          box-sizing: border-box;\n          background: ", "\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(18), theme.content.base4)
    }, {
      children: [jsx("p", _assign({
        css: [FONT_STYLE.body1_1, /*#__PURE__*/css(templateObject_2$G || (templateObject_2$G = __makeTemplateObject(["\n              margin: ", " ", ";\n              color: ", ";\n              font-weight: 500;\n              text-align: center;\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              margin: ", " ", ";\n              color: ", ";\n              font-weight: 500;\n              text-align: center;\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(6), pxToRem(12), theme.content.base1), MEDIA_QUERY.max('mobile', /*#__PURE__*/css(templateObject_3$y || (templateObject_3$y = __makeTemplateObject(["\n              white-space: pre-wrap;\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              white-space: pre-wrap;\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")]))))]
      }, {
        children: '이 브라우저는 지원이 종료되었습니다.\n다른 브라우저를 이용해 주세요.'
      })), jsx("div", _assign({
        css: /*#__PURE__*/css(templateObject_4$s || (templateObject_4$s = __makeTemplateObject(["\n            margin: ", " ", ";\n            text-align: center;\n            line-height: 0;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            margin: ", " ", ";\n            text-align: center;\n            line-height: 0;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(2), pxToRem(12))
      }, {
        children: buttons.map(function (button) {
          return jsx(Button$2, _assign({
            variant: "base1",
            size: 32,
            onClick: button.onClick,
            css: /*#__PURE__*/css(templateObject_5$m || (templateObject_5$m = __makeTemplateObject(["\n                margin: ", ";\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                margin: ", ";\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(4))
          }, {
            children: button.text
          }), button.id);
        })
      }))]
    }))
  }));
}
var templateObject_1$P, templateObject_2$G, templateObject_3$y, templateObject_4$s, templateObject_5$m;

function NotSupportedBrowserPopup(_a) {
  var buttons = _a.buttons,
    onClose = _a.onClose;
  var isMobile = useResponsive().breakpoint === 'mobile';
  var modalWidthProps = useMemo(function () {
    return isMobile ? {
      width: 300,
      isPopupInMobile: true
    } : {
      width: 400
    };
  }, [isMobile]);
  return jsx(Modal, _assign({}, modalWidthProps, {
    header: {
      title: '브라우저 지원 종료 안내',
      onClose: onClose
    },
    footer: {
      // IE flex 버그 때문에 height 고정
      style: /*#__PURE__*/css(templateObject_1$O || (templateObject_1$O = __makeTemplateObject(["\n          height: ", ";\n          box-sizing: border-box;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:style;")], ["\n          height: ", ";\n          box-sizing: border-box;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:style;")])), pxToRem(76)),
      action: {
        secondary: [buttons[0], buttons[1]]
      }
    }
  }, {
    children: jsx("p", _assign({
      css: /*#__PURE__*/css(templateObject_2$F || (templateObject_2$F = __makeTemplateObject(["\n          padding: ", " ", ";\n          word-break: keep-all;\n          white-space: pre-wrap;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          padding: ", " ", ";\n          word-break: keep-all;\n          white-space: pre-wrap;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(10), pxToRem(16))
    }, {
      children: '이 브라우저(인터넷 익스플로러)는\n서비스 지원이 종료되었습니다.\n다른 브라우저로 오늘의집을 이용해 주세요.'
    }))
  }));
}
var templateObject_1$O, templateObject_2$F;

var POPUP_CLOSED_FLAG_SESSION_KEY = 'ohsNotSupportedBrowserPopupClosed';
function NotSupportedBrowser() {
  var _a = useState(false),
    isPopupOpened = _a[0],
    setPopupOpened = _a[1];
  var isWindowsOS = useWindowsOSDetector();
  useEffect(function () {
    setPopupOpened(window.sessionStorage.getItem(POPUP_CLOSED_FLAG_SESSION_KEY) !== 'true');
  }, []);
  var buttons = useMemo(function () {
    return [{
      id: 'chrome',
      text: '크롬 설치하기',
      onClick: function onClick() {
        window.location.href = 'https://www.google.co.kr/chrome';
      }
    }, {
      id: 'edge',
      text: isWindowsOS ? '엣지로 열기' : '엣지 설치하기',
      onClick: isWindowsOS ? function () {
        window.location.href = 'microsoft-edge:https://ohou.se';
      } : function () {
        window.location.href = 'https://www.microsoft.com/edge';
      }
    }];
  }, [isWindowsOS]);
  var handlePopupClose = useCallback(function () {
    window.sessionStorage.setItem(POPUP_CLOSED_FLAG_SESSION_KEY, 'true');
    setPopupOpened(false);
  }, []);
  return jsxs(Fragment$1, {
    children: [jsx(NotSupportedBrowserBanner, {
      buttons: buttons
    }), isPopupOpened && jsx(NotSupportedBrowserPopup, {
      buttons: buttons,
      onClose: handlePopupClose
    })]
  });
}

function Hint(_a) {
  var children = _a.children,
    error = _a.error,
    rest = __rest(_a, ["children", "error"]);
  var theme = useTheme();
  return jsxs("div", _assign({}, rest, {
    css: /*#__PURE__*/css(templateObject_1$N || (templateObject_1$N = __makeTemplateObject(["\n        ", "\n        color: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        ", "\n        color: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), FONT_STYLE.caption1, error ? theme.content.primary2.thick : theme.content.base2)
  }, {
    children: [error && jsx(Icon, {
      name: "alert",
      size: 18,
      css: /*#__PURE__*/css(templateObject_2$E || (templateObject_2$E = __makeTemplateObject(["\n            vertical-align: middle;\n            margin-right: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            vertical-align: middle;\n            margin-right: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(6))
    }), children]
  }));
}
var templateObject_1$N, templateObject_2$E;

function CounterHint(_a) {
  var children = _a.children,
    count = _a.count,
    maxCount = _a.maxCount,
    rest = __rest(_a, ["children", "count", "maxCount"]);
  return jsxs(Hint, _assign({}, rest, {
    css: /*#__PURE__*/css(templateObject_1$M || (templateObject_1$M = __makeTemplateObject(["\n        display: flex;\n        white-space: nowrap;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        display: flex;\n        white-space: nowrap;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
  }, {
    children: [jsx("span", _assign({
      css: /*#__PURE__*/css(templateObject_2$D || (templateObject_2$D = __makeTemplateObject(["\n          flex: 1;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          flex: 1;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
    }, {
      children: children
    })), jsxs("span", _assign({
      css: /*#__PURE__*/css(templateObject_3$x || (templateObject_3$x = __makeTemplateObject(["\n          text-align: right;\n          padding-left: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          text-align: right;\n          padding-left: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(10))
    }, {
      children: [count, "/", maxCount]
    }))]
  }));
}
var templateObject_1$M, templateObject_2$D, templateObject_3$x;

function DimLoading(_a) {
  var className = _a.className,
    rest = __rest(_a, ["className"]);
  var theme = useTheme();
  return jsx(BodyPortal, {
    children: jsx(Dim, {
      children: jsx("div", _assign({
        className: className,
        css: /*#__PURE__*/css(templateObject_1$L || (templateObject_1$L = __makeTemplateObject(["\n            position: relative;\n            display: inline-block;\n            vertical-align: middle;\n            width: ", ";\n            height: ", ";\n            border-radius: ", ";\n            background-color: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            position: relative;\n            display: inline-block;\n            vertical-align: middle;\n            width: ", ";\n            height: ", ";\n            border-radius: ", ";\n            background-color: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(80), pxToRem(80), pxToRem(8), theme.dim.basic)
      }, {
        children: jsx(Loading, _assign({}, rest, {
          css: /*#__PURE__*/css(templateObject_2$C || (templateObject_2$C = __makeTemplateObject(["\n              position: absolute;\n              top: ", ";\n              left: ", ";\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              position: absolute;\n              top: ", ";\n              left: ", ";\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(28), pxToRem(28))
        }))
      }))
    })
  });
}
var templateObject_1$L, templateObject_2$C;

var ICON_SIZE$1 = 24;
var SELECT_PADDING = {
  32: 13,
  40: 13,
  44: 15,
  50: 15
};
function Select(_a) {
  var _onChange = _a.onChange,
    onValue = _a.onValue,
    error = _a.error,
    size = _a.size,
    value = _a.value,
    options = _a.options,
    className = _a.className,
    placeholder = _a.placeholder,
    forwardedRef = _a.forwardedRef,
    rest = __rest(_a, ["onChange", "onValue", "error", "size", "value", "options", "className", "placeholder", "forwardedRef"]);
  var theme = useTheme();
  return jsxs("div", _assign({
    className: className,
    css: /*#__PURE__*/css(templateObject_1$K || (templateObject_1$K = __makeTemplateObject(["\n        position: relative;\n        display: inline-block;\n        line-height: 0;\n        &:hover {\n          background-color: ", ";\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        position: relative;\n        display: inline-block;\n        line-height: 0;\n        &:hover {\n          background-color: ", ";\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), theme.interactive.transparent)
  }, {
    children: [jsx(Icon, {
      size: ICON_SIZE$1,
      name: "dropdown",
      css: /*#__PURE__*/css(templateObject_2$B || (templateObject_2$B = __makeTemplateObject(["\n          position: absolute;\n          top: ", ";\n          right: ", ";\n          color: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          position: absolute;\n          top: ", ";\n          right: ", ";\n          color: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(size / 2 - ICON_SIZE$1 / 2), pxToRem(SELECT_PADDING[size]), theme.content.base2)
    }), jsxs("select", _assign({}, rest, {
      value: value,
      ref: forwardedRef,
      onChange: function onChange(e) {
        return onValueHandler(e, {
          onChange: _onChange,
          onValue: onValue
        });
      },
      css: [/*#__PURE__*/css(templateObject_3$w || (templateObject_3$w = __makeTemplateObject(["\n            ", "\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            ", "\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), RESET_INPUT), size === 32 ? FONT_STYLE.body2 : FONT_STYLE.subTitle1, /*#__PURE__*/css(templateObject_4$r || (templateObject_4$r = __makeTemplateObject(["\n            position: relative;\n            appearance: none;\n            width: 100%;\n            height: ", ";\n            border-radius: ", ";\n            border: ", " solid ", ";\n            color: ", ";\n            padding-left: ", ";\n            padding-right: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            position: relative;\n            appearance: none;\n            width: 100%;\n            height: ", ";\n            border-radius: ", ";\n            border: ", " solid ", ";\n            color: ", ";\n            padding-left: ", ";\n            padding-right: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(size), pxToRem(4), pxToRem(1), theme.border, value !== '' ? theme.content.base1 : theme.content.base3, pxToRem(SELECT_PADDING[size]), pxToRem(ICON_SIZE$1 + SELECT_PADDING[size])), error ? /*#__PURE__*/css(templateObject_5$l || (templateObject_5$l = __makeTemplateObject(["border-color: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["border-color: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), theme.content.primary2.basic) : /*#__PURE__*/css(templateObject_6$j || (templateObject_6$j = __makeTemplateObject(["\n                &:disabled {\n                  background-color: ", ";\n                }\n                &:focus {\n                  border-color: ", ";\n                }\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                &:disabled {\n                  background-color: ", ";\n                }\n                &:focus {\n                  border-color: ", ";\n                }\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), theme.interactive.transparent, theme.content.primary1.basic)]
    }, {
      children: [placeholder && jsx("option", _assign({
        value: "",
        hidden: true,
        disabled: true
      }, {
        children: placeholder
      })), options.map(function (option) {
        return typeof option === 'number' || typeof option === 'string' ? jsx("option", _assign({
          value: option
        }, {
          children: option
        }), option) : jsx("option", _assign({
          value: option.value
        }, {
          children: option.text
        }), option.value);
      })]
    }))]
  }));
}
var templateObject_1$K, templateObject_2$B, templateObject_3$w, templateObject_4$r, templateObject_5$l, templateObject_6$j;

function cssBaseIconButton(size) {
  return /*#__PURE__*/css(templateObject_1$J || (templateObject_1$J = __makeTemplateObject(["\n    width: ", ";\n    padding: 0;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssBaseIconButton;")], ["\n    width: ", ";\n    padding: 0;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssBaseIconButton;")])), pxToRem(size));
}
var templateObject_1$J;

/**
 * @deprecated ODS의 IconButton을 사용해주세요. 만약 디자인상 ODS의 IconButton을 사용할 수 없는 경우, 디자인시스템 담당 디자이너에게 문의해주세요.
 */
function OutlineIconButton(_a) {
  var size = _a.size,
    icon = _a.icon,
    rest = __rest(_a, ["size", "icon"]);
  return jsx(OutlineButton, _assign({}, rest, {
    size: size,
    css: cssBaseIconButton(size)
  }, {
    children: jsx(Icon, {
      size: 18,
      name: icon
    })
  }));
}

var SIZE = 32;
var GAP = 10;

function PageButton(_a) {
  var page = _a.page,
    selected = _a.selected,
    onClick = _a.onClick;
  var pageButtonCss = /*#__PURE__*/css(templateObject_1$I || (templateObject_1$I = __makeTemplateObject(["\n    width: ", ";\n    padding: 0;\n    vertical-align: middle;\n    margin-right: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:pageButtonCss;")], ["\n    width: ", ";\n    padding: 0;\n    vertical-align: middle;\n    margin-right: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:pageButtonCss;")])), pxToRem(SIZE), pxToRem(GAP));
  return selected ? jsx(Button$2, _assign({
    size: SIZE,
    variant: "primary1",
    onClick: onClick,
    css: pageButtonCss
  }, {
    children: page
  })) : jsx(TextButton, _assign({
    size: SIZE,
    variant: "base1",
    onClick: onClick,
    css: pageButtonCss
  }, {
    children: page
  }));
}
var templateObject_1$I;

function firstPage(page, lastPage, pageCount) {
  var halfPage = Math.floor(pageCount / 2);
  if (page <= halfPage) {
    return 1;
  }
  if (lastPage < page + halfPage) {
    return lastPage - pageCount + 1;
  }
  return page - halfPage;
}
function Pagination$1(_a) {
  var page = _a.page,
    total = _a.total,
    _b = _a.pageCount,
    pageCount = _b === void 0 ? 10 : _b,
    onPageChange = _a.onPageChange,
    _c = _a.row,
    row = _c === void 0 ? 10 : _c,
    rowOptions = _a.rowOptions,
    onRowChange = _a.onRowChange,
    rest = __rest(_a, ["page", "total", "pageCount", "onPageChange", "row", "rowOptions", "onRowChange"]);
  var lastPage = Math.ceil(total / row);
  var actualPageCount = Math.min(lastPage, pageCount);
  useEffect(function () {
    if (lastPage < page) {
      onPageChange(Math.max(lastPage, 1));
    }
  }, [page, lastPage, onPageChange]);
  return jsxs("div", _assign({}, rest, {
    children: [rowOptions && onRowChange && jsx(Select, {
      size: SIZE,
      value: row,
      options: rowOptions,
      onValue: function onValue(value) {
        return onRowChange(parseInt(value));
      },
      css: /*#__PURE__*/css(templateObject_1$H || (templateObject_1$H = __makeTemplateObject(["\n            vertical-align: middle;\n            margin-right: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            vertical-align: middle;\n            margin-right: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(16))
    }), jsx(OutlineIconButton, {
      disabled: page === 1,
      size: SIZE,
      variant: "base1",
      icon: "chevron_left",
      css: /*#__PURE__*/css(templateObject_2$A || (templateObject_2$A = __makeTemplateObject(["\n          vertical-align: middle;\n          margin-right: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          vertical-align: middle;\n          margin-right: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(GAP)),
      onClick: function onClick() {
        return onPageChange(page - 1);
      }
    }), Array(actualPageCount).fill(firstPage(page, lastPage, actualPageCount)).map(function (v, i) {
      return v + i;
    }).map(function (pageNumber) {
      return jsx(PageButton, {
        page: pageNumber,
        selected: page === pageNumber,
        onClick: function onClick() {
          return onPageChange(pageNumber);
        }
      }, pageNumber);
    }), jsx(OutlineIconButton, {
      disabled: page === lastPage,
      size: SIZE,
      variant: "base1",
      icon: "chevron_right",
      css: /*#__PURE__*/css(templateObject_3$v || (templateObject_3$v = __makeTemplateObject(["\n          vertical-align: middle;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          vertical-align: middle;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")]))),
      onClick: function onClick() {
        return onPageChange(page + 1);
      }
    })]
  }));
}
var templateObject_1$H, templateObject_2$A, templateObject_3$v;

function withHint(Component) {
  return function (_a) {
    var className = _a.className,
      hint = _a.hint,
      error = _a.error,
      rest = __rest(_a, ["className", "hint", "error"]);
    return jsxs("div", _assign({
      className: className
    }, {
      children: [jsx(Component, _assign({}, rest, {
        error: error,
        css: /*#__PURE__*/css(templateObject_1$G || (templateObject_1$G = __makeTemplateObject(["width: 100%;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["width: 100%;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
      })), hint && jsx(Hint, _assign({
        error: error,
        css: /*#__PURE__*/css(templateObject_2$z || (templateObject_2$z = __makeTemplateObject(["margin-top: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["margin-top: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(8))
      }, {
        children: hint
      }))]
    }));
  };
}
var templateObject_1$G, templateObject_2$z;

var SelectWithHint = withHint(Select);

/**
 * @deprecated ODS의 Input 컴포넌트를 사용해주세요. 만약 디자인상 ODS의 Input를 사용할 수 없는 경우, 디자인시스템 담당 디자이너에게 문의해주세요.
 */
var InputWithHint = withHint(Input$1);

function withCountHint(Component) {
  return function (_a) {
    var className = _a.className,
      value = _a.value,
      hint = _a.hint,
      error = _a.error,
      maxCount = _a.maxCount,
      rest = __rest(_a, ["className", "value", "hint", "error", "maxCount"]);
    var data = typeof value === 'string' ? value.substring(0, maxCount) : value;
    return jsxs("div", _assign({
      className: className
    }, {
      children: [jsx(Component, _assign({}, rest, {
        error: error,
        value: data,
        css: /*#__PURE__*/css(templateObject_1$F || (templateObject_1$F = __makeTemplateObject(["width: 100%;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["width: 100%;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
      })), jsx(CounterHint, _assign({
        error: error,
        count: data ? "".concat(data).length : 0,
        maxCount: maxCount,
        css: /*#__PURE__*/css(templateObject_2$y || (templateObject_2$y = __makeTemplateObject(["margin-top: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["margin-top: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(8))
      }, {
        children: hint
      }))]
    }));
  };
}
var templateObject_1$F, templateObject_2$y;

/**
 * @deprecated ODS의 Input 컴포넌트를 사용해주세요. 만약 디자인상 ODS의 Input를 사용할 수 없는 경우, 디자인시스템 담당 디자이너에게 문의해주세요.
 */
var InputWithCountHint = withCountHint(Input$1);

function withThumbnail(Component) {
  return function (_a) {
    var className = _a.className,
      _b = _a.error,
      error = _b === void 0 ? false : _b,
      _c = _a.disabled,
      disabled = _c === void 0 ? false : _c,
      _d = _a.readOnly,
      readOnly = _d === void 0 ? false : _d,
      _e = _a.onDimmed,
      onDimmed = _e === void 0 ? false : _e,
      thumbnail = _a.thumbnail,
      onThumbnailDelete = _a.onThumbnailDelete,
      props = __rest(_a, ["className", "error", "disabled", "readOnly", "onDimmed", "thumbnail", "onThumbnailDelete"]);
    var _f = useState(false),
      focused = _f[0],
      setFocused = _f[1];
    var theme = useTheme();
    return jsxs("div", _assign({
      className: className,
      css: [cssBaseTextField(theme, onDimmed, {
        error: error,
        disabled: disabled,
        readOnly: readOnly,
        focused: focused
      }), /*#__PURE__*/css(templateObject_1$E || (templateObject_1$E = __makeTemplateObject(["\n            display: block;\n            padding: ", " ", ";\n            cursor: text;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            display: block;\n            padding: ", " ", ";\n            cursor: text;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(0), pxToRem(16))]
    }, {
      children: [jsx(Component, _assign({}, props, {
        size: 44,
        error: error,
        disabled: disabled,
        readOnly: readOnly,
        onFocus: function onFocus(e) {
          var _a;
          setFocused(true);
          (_a = props.onFocus) === null || _a === void 0 ? void 0 : _a.call(props, e);
        },
        onBlur: function onBlur(e) {
          var _a;
          setFocused(false);
          (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props, e);
        },
        css: /*#__PURE__*/css(templateObject_2$x || (templateObject_2$x = __makeTemplateObject(["\n            width: 100%;\n            padding: 0;\n            border: 0;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            width: 100%;\n            padding: 0;\n            border: 0;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
      })), thumbnail && jsx("div", _assign({
        css: /*#__PURE__*/css(templateObject_3$u || (templateObject_3$u = __makeTemplateObject(["margin-bottom: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["margin-bottom: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(12))
      }, {
        children: jsxs("span", _assign({
          css: /*#__PURE__*/css(templateObject_4$q || (templateObject_4$q = __makeTemplateObject(["\n                overflow: hidden;\n                position: relative;\n                display: inline-block;\n                width: ", ";\n                height: ", ";\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                overflow: hidden;\n                position: relative;\n                display: inline-block;\n                width: ", ";\n                height: ", ";\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(100), pxToRem(100))
        }, {
          children: [jsx(Image, {
            aspectRatio: "1:1",
            src: thumbnail,
            radius: 4,
            css: /*#__PURE__*/css(templateObject_5$k || (templateObject_5$k = __makeTemplateObject(["\n                  width: 100%;\n                  height: 100%;\n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                  width: 100%;\n                  height: 100%;\n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
          }), jsx("button", _assign({
            type: "button",
            title: "\uC0AD\uC81C",
            css: /*#__PURE__*/css(templateObject_6$i || (templateObject_6$i = __makeTemplateObject(["\n                  position: absolute;\n                  top: 0;\n                  right: 0;\n                  width: ", ";\n                  height: ", ";\n                  margin: 0;\n                  padding: 0;\n                  border: 0;\n                  background: none;\n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                  position: absolute;\n                  top: 0;\n                  right: 0;\n                  width: ", ";\n                  height: ", ";\n                  margin: 0;\n                  padding: 0;\n                  border: 0;\n                  background: none;\n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(32), pxToRem(32)),
            onClick: function onClick(e) {
              e.stopPropagation();
              onThumbnailDelete === null || onThumbnailDelete === void 0 ? void 0 : onThumbnailDelete();
            }
          }, {
            children: jsx(Icon, {
              name: "dismiss_circle",
              size: 18,
              fill: function fill(theme) {
                return theme.content.base1;
              }
            })
          }))]
        }))
      }))]
    }));
  };
}
var templateObject_1$E, templateObject_2$x, templateObject_3$u, templateObject_4$q, templateObject_5$k, templateObject_6$i;

var InputWithThumbnail = withThumbnail(Input$1);

var ContentEditable = /*#__PURE__*/forwardRef(function (_a, ref) {
  var className = _a.className,
    _b = _a.value,
    value = _b === void 0 ? '' : _b,
    disabled = _a.disabled,
    readOnly = _a.readOnly,
    placeholder = _a.placeholder,
    _onCut = _a.onCut,
    _onPaste = _a.onPaste,
    _onInput = _a.onInput,
    onValue = _a.onValue,
    onFocus = _a.onFocus,
    onBlur = _a.onBlur,
    props = __rest(_a, ["className", "value", "disabled", "readOnly", "placeholder", "onCut", "onPaste", "onInput", "onValue", "onFocus", "onBlur"]);
  var theme = useTheme();
  var node = useRef(null);
  useImperativeHandle(ref, function () {
    return node.current;
  });
  var innerValue = useRef('');
  var handleUpdate = useCallback(function () {
    var _a;
    var newValue = ((_a = node.current) === null || _a === void 0 ? void 0 : _a.innerHTML) || '';
    innerValue.current = newValue;
    onValue === null || onValue === void 0 ? void 0 : onValue(newValue);
  }, [onValue]);
  useEffect(function () {
    if (!node.current) return;
    if (innerValue.current !== value) {
      node.current.innerHTML = value;
      handleUpdate();
    }
  }, [value, handleUpdate]);
  useEffect(function () {
    if (!node.current) return;
    var observer = new MutationObserver(function (mutations) {
      for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
        var mutation = mutations_1[_i];
        if (mutation.type === 'childList') {
          handleUpdate();
        }
      }
    });
    observer.observe(node.current, {
      childList: true,
      subtree: true
    });
    return function () {
      observer.disconnect();
    };
  }, [handleUpdate]);
  return jsx("div", _assign({
    ref: node,
    contentEditable: !readOnly && !disabled,
    onCut: function onCut(e) {
      handleUpdate();
      _onCut === null || _onCut === void 0 ? void 0 : _onCut(e);
    },
    onPaste: function onPaste(e) {
      handleUpdate();
      _onPaste === null || _onPaste === void 0 ? void 0 : _onPaste(e);
    },
    onInput: function onInput(e) {
      handleUpdate();
      _onInput === null || _onInput === void 0 ? void 0 : _onInput(e);
    },
    onFocus: onFocus,
    onBlur: onBlur,
    "data-placeholder": placeholder,
    className: className,
    css: /*#__PURE__*/css(templateObject_1$D || (templateObject_1$D = __makeTemplateObject(["\n        word-break: break-word;\n        cursor: ", ";\n        &&:empty:before {\n          content: attr(data-placeholder);\n          color: ", ";\n          pointer-events: none;\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        word-break: break-word;\n        cursor: ", ";\n        &&:empty:before {\n          content: attr(data-placeholder);\n          color: ", ";\n          pointer-events: none;\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), disabled ? 'default' : 'text', theme.content.base3)
  }, props));
});
var templateObject_1$D;

function cssTextareaField(theme, _a) {
  var autoHeight = _a.autoHeight,
    height = _a.height;
  return /*#__PURE__*/css(templateObject_2$w || (templateObject_2$w = __makeTemplateObject(["\n    ", "\n    ", "\n    overflow-y: auto;\n    flex: 1 0 0%;\n    height: ", ";\n    min-height: ", ";\n    margin: ", " 0;\n    box-sizing: border-box;\n    resize: none;\n    vertical-align: top;\n    ", "\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssTextareaField;")], ["\n    ", "\n    ", "\n    overflow-y: auto;\n    flex: 1 0 0%;\n    height: ", ";\n    min-height: ", ";\n    margin: ", " 0;\n    box-sizing: border-box;\n    resize: none;\n    vertical-align: top;\n    ", "\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssTextareaField;")])), cssTextField(theme), FONT_STYLE.body1_1, pxToRem(78), pxToRem(24), pxToRem(9), autoHeight && /*#__PURE__*/css(templateObject_1$C || (templateObject_1$C = __makeTemplateObject(["\n      height: ", ";\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:cssTextareaField;")], ["\n      height: ", ";\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:cssTextareaField;")])), pxToRem(height)));
}
function Textarea(_a) {
  var _b;
  var className = _a.className,
    _c = _a.autoHeight,
    autoHeight = _c === void 0 ? false : _c,
    maxRows = _a.maxRows,
    _d = _a.disabled,
    disabled = _d === void 0 ? false : _d,
    _e = _a.readOnly,
    readOnly = _e === void 0 ? false : _e,
    _f = _a.error,
    error = _f === void 0 ? false : _f,
    value = _a.value,
    action = _a.action,
    onValue = _a.onValue,
    useContentEditable = _a.useContentEditable,
    _g = _a.onDimmed,
    onDimmed = _g === void 0 ? false : _g,
    rest = __rest(_a, ["className", "autoHeight", "maxRows", "disabled", "readOnly", "error", "value", "action", "onValue", "useContentEditable", "onDimmed"]);
  var theme = useTheme();
  var _h = useState(null),
    element = _h[0],
    setElement = _h[1];
  var _j = useState(0),
    height = _j[0],
    setHeight = _j[1];
  var _k = useState(false),
    focused = _k[0],
    setFocused = _k[1];
  var actions = Array.isArray(action) ? action : [action];
  var updateHeight = useCallback(function (element) {
    var _a, _b;
    element.style.height = '0';
    if (maxRows) {
      var lineHeight = window.getComputedStyle(element).lineHeight;
      var maxHeight = maxRows * parseInt(lineHeight, 10);
      setHeight(Math.min(element.scrollHeight, maxHeight));
    } else {
      setHeight(element.scrollHeight);
    }
    element.style.height = (_b = (_a = rest.style) === null || _a === void 0 ? void 0 : _a.height) !== null && _b !== void 0 ? _b : null;
  }, [maxRows, (_b = rest.style) === null || _b === void 0 ? void 0 : _b.height]);
  var handleValue = useCallback(function (value) {
    if (autoHeight && element) {
      updateHeight(element);
    }
    onValue === null || onValue === void 0 ? void 0 : onValue(value);
  }, [autoHeight, element, updateHeight, onValue]);
  useEffect(function () {
    if (!value) return;
    handleValue(value);
  }, [value, handleValue]);
  return jsxs("div", _assign({
    className: className,
    css: [cssBaseTextField(theme, onDimmed, {
      error: error,
      focused: focused,
      disabled: disabled,
      readOnly: readOnly
    }), /*#__PURE__*/css(templateObject_3$t || (templateObject_3$t = __makeTemplateObject(["\n          align-items: flex-start;\n          padding: ", " ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          align-items: flex-start;\n          padding: ", " ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(6), pxToRem(15))]
  }, {
    children: [!useContentEditable ? function () {
      var _a = rest,
        forwardedRef = _a.forwardedRef,
        _onFocus = _a.onFocus,
        _onBlur = _a.onBlur,
        _onChange = _a.onChange,
        assertedRest = __rest(_a, ["forwardedRef", "onFocus", "onBlur", "onChange"]);
      return jsx("textarea", _assign({}, assertedRest, {
        ref: function ref(el) {
          setElement(el);
          if (forwardedRef) {
            if (typeof forwardedRef === 'function') {
              forwardedRef(el);
            } else {
              forwardedRef.current = el;
            }
          }
        },
        value: value,
        disabled: disabled,
        readOnly: readOnly,
        onFocus: function onFocus(e) {
          if (_onFocus) {
            _onFocus(e);
          }
          setFocused(true);
        },
        onBlur: function onBlur(e) {
          if (_onBlur) {
            _onBlur(e);
          }
          setFocused(false);
        },
        onChange: function onChange(e) {
          return onValueHandler(e, {
            onChange: _onChange,
            onValue: handleValue
          });
        },
        css: cssTextareaField(theme, {
          autoHeight: autoHeight,
          height: height
        })
      }));
    }() : function () {
      var _a = rest,
        forwardedRef = _a.forwardedRef,
        _onFocus2 = _a.onFocus,
        _onBlur2 = _a.onBlur,
        assertedRest = __rest(_a, ["forwardedRef", "onFocus", "onBlur"]);
      return jsx(ContentEditable, _assign({}, assertedRest, {
        ref: function ref(el) {
          setElement(el);
          if (forwardedRef) {
            if (typeof forwardedRef === 'function') {
              forwardedRef(el);
            } else {
              forwardedRef.current = el;
            }
          }
        },
        value: value,
        disabled: disabled,
        readOnly: readOnly,
        onFocus: function onFocus(e) {
          if (_onFocus2) {
            _onFocus2(e);
          }
          setFocused(true);
        },
        onBlur: function onBlur(e) {
          if (_onBlur2) {
            _onBlur2(e);
          }
          setFocused(false);
        },
        onValue: handleValue,
        css: [cssTextareaField(theme, {
          autoHeight: autoHeight,
          height: height
        }), /*#__PURE__*/css(templateObject_4$p || (templateObject_4$p = __makeTemplateObject(["\n                  min-width: ", ";\n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                  min-width: ", ";\n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(100))]
      }));
    }(), jsx("div", _assign({
      css: /*#__PURE__*/css(templateObject_5$j || (templateObject_5$j = __makeTemplateObject(["\n          box-sizing: border-box;\n          display: flex;\n          align-items: center;\n          height: ", ";\n          padding: ", " 0;\n          &:not(:empty) {\n            margin-left: ", ";\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          box-sizing: border-box;\n          display: flex;\n          align-items: center;\n          height: ", ";\n          padding: ", " 0;\n          &:not(:empty) {\n            margin-left: ", ";\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(42), pxToRem(9), pxToRem(8))
    }, {
      children: actions.map(function (action, i) {
        return !!action && (isIconAction(action) ? jsx("button", _assign({
          type: action.type || 'button',
          disabled: disabled || action.disabled,
          css: /*#__PURE__*/css(templateObject_6$h || (templateObject_6$h = __makeTemplateObject(["\n                  ", ";\n                  vertical-align: top;\n                  width: ", ";\n                  height: ", ";\n                  margin-left: ", ";\n                  &:first-of-type {\n                    margin-left: 0;\n                  }\n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                  ", ";\n                  vertical-align: top;\n                  width: ", ";\n                  height: ", ";\n                  margin-left: ", ";\n                  &:first-of-type {\n                    margin-left: 0;\n                  }\n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), RESET_BUTTON, pxToRem(24), pxToRem(24), pxToRem(12)),
          onClick: function onClick(e) {
            var _a;
            e.stopPropagation();
            (_a = action.onClick) === null || _a === void 0 ? void 0 : _a.call(action, e);
          }
        }, {
          children: jsx(Icon, {
            size: 24,
            name: action.icon,
            css: /*#__PURE__*/css(templateObject_7$e || (templateObject_7$e = __makeTemplateObject(["\n                    color: ", ";\n                  " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                    color: ", ";\n                  " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), action.color || theme.content.base2)
          })
        }), i) : jsx(TextButton, _assign({
          size: 30,
          variant: "primary1",
          type: action.type || 'button',
          disabled: disabled || action.disabled,
          css: /*#__PURE__*/css(templateObject_8$a || (templateObject_8$a = __makeTemplateObject(["\n                  flex-shrink: 0;\n                  margin-left: ", ";\n                  padding: 0;\n                  &:first-of-type {\n                    margin-left: 0;\n                  }\n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                  flex-shrink: 0;\n                  margin-left: ", ";\n                  padding: 0;\n                  &:first-of-type {\n                    margin-left: 0;\n                  }\n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(12)),
          onClick: function onClick(e) {
            var _a;
            e.stopPropagation();
            (_a = action.onClick) === null || _a === void 0 ? void 0 : _a.call(action, e);
          }
        }, {
          children: action.text
        }), i));
      })
    }))]
  }));
}
var templateObject_1$C, templateObject_2$w, templateObject_3$t, templateObject_4$p, templateObject_5$j, templateObject_6$h, templateObject_7$e, templateObject_8$a;

var TextareaWithHint = withHint(Textarea);

var TextareaWithCountHint = withCountHint(Textarea);

var TextareaWithThumbnail = withThumbnail(Textarea);

function Table(_a) {
  var header = _a.header,
    body = _a.body,
    footer = _a.footer,
    rest = __rest(_a, ["header", "body", "footer"]);
  return jsxs("table", _assign({}, rest, {
    css: [FONT_STYLE.subTitle1, /*#__PURE__*/css(templateObject_1$B || (templateObject_1$B = __makeTemplateObject(["\n          width: 100%;\n          border-collapse: collapse;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          width: 100%;\n          border-collapse: collapse;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))]
  }, {
    children: [header && jsx("thead", {
      children: header
    }), body && jsx("tbody", {
      children: body
    }), footer && jsx("tfoot", {
      children: footer
    })]
  }));
}
var templateObject_1$B;

var TABLE_HEADER_CLASS_NAME = 'bucketplace-table-header';
var TABLE_DATA_CLASS_NAME = 'bucketplace-table-data';

/**
 * 테이블 강조 표시 방법에 따른 스타일
 */
var TABLE_HIGHLIGHT_STYLE = {
  none: function none(theme) {
    return /*#__PURE__*/css(templateObject_1$A || (templateObject_1$A = __makeTemplateObject(["" + (process.env.NODE_ENV === "production" ? "" : ";label:none;")], ["" + (process.env.NODE_ENV === "production" ? "" : ";label:none;")])));
  },
  "default": function _default(theme) {
    return /*#__PURE__*/css(templateObject_2$v || (templateObject_2$v = __makeTemplateObject(["\n    background-color: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:default;")], ["\n    background-color: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:default;")])), theme.colors.backgroundWeak);
  },
  emphasis: function emphasis(theme) {
    return /*#__PURE__*/css(templateObject_3$s || (templateObject_3$s = __makeTemplateObject(["\n    background-color: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:emphasis;")], ["\n    background-color: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:emphasis;")])), theme.colors.backgroundEmphasisWeak);
  },
  critical: function critical(theme) {
    return /*#__PURE__*/css(templateObject_4$o || (templateObject_4$o = __makeTemplateObject(["\n    background-color: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:critical;")], ["\n    background-color: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:critical;")])), theme.colors.backgroundCriticalWeak);
  },
  attention: function attention(theme) {
    return /*#__PURE__*/css(templateObject_5$i || (templateObject_5$i = __makeTemplateObject(["\n    background-color: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:attention;")], ["\n    background-color: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:attention;")])), theme.colors.backgroundAttentionWeak);
  }
};
function TableRowImpl(_a, ref) {
  var emphasized = _a.emphasized,
    children = _a.children,
    _b = _a.highlight,
    highlight = _b === void 0 ? emphasized ? 'default' : 'none' : _b,
    rest = __rest(_a, ["emphasized", "children", "highlight"]);
  var theme = useTheme();
  return jsx("tr", _assign({}, rest, {
    ref: ref,
    css: [/*#__PURE__*/css(templateObject_6$g || (templateObject_6$g = __makeTemplateObject(["\n          > .", ", > .", " {\n            color: ", ";\n            border: ", " solid ", ";\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          > .", ", > .", " {\n            color: ", ";\n            border: ", " solid ", ";\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), TABLE_HEADER_CLASS_NAME, TABLE_DATA_CLASS_NAME, theme.content.base1, pxToRem(1), theme.content.base4), TABLE_HIGHLIGHT_STYLE[highlight](theme)]
  }, {
    children: children
  }));
}
var TableRow = /*#__PURE__*/forwardRef(TableRowImpl);
var templateObject_1$A, templateObject_2$v, templateObject_3$s, templateObject_4$o, templateObject_5$i, templateObject_6$g;

function TableHeader(_a) {
  var className = _a.className,
    children = _a.children,
    rest = __rest(_a, ["className", "children"]);
  var theme = useTheme();
  return jsx("th", _assign({}, rest, {
    className: spaces(className, TABLE_HEADER_CLASS_NAME),
    css: /*#__PURE__*/css(templateObject_1$z || (templateObject_1$z = __makeTemplateObject(["\n        text-align: left;\n        font-weight: 700;\n        height: ", ";\n        padding: 0 ", ";\n        background-color: ", ";\n        &:hover {\n          background-color: ", ";\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        text-align: left;\n        font-weight: 700;\n        height: ", ";\n        padding: 0 ", ";\n        background-color: ", ";\n        &:hover {\n          background-color: ", ";\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(56), pxToRem(16), theme.content.base5, theme.interactive.base5)
  }, {
    children: children
  }));
}
var templateObject_1$z;

var ACTION_BUTTON_SIZE = 18;
function TableHeaderWithAction(_a) {
  var text = _a.text,
    action = _a.action,
    rest = __rest(_a, ["text", "action"]);
  var theme = useTheme();
  return jsxs(TableHeader, _assign({}, rest, {
    children: [jsx("span", _assign({
      css: /*#__PURE__*/css(templateObject_1$y || (templateObject_1$y = __makeTemplateObject(["\n          margin-right: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          margin-right: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(6))
    }, {
      children: text
    })), jsx("button", _assign({
      type: "button",
      css: /*#__PURE__*/css(templateObject_2$u || (templateObject_2$u = __makeTemplateObject(["\n          ", ";\n          width: ", ";\n          height: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          ", ";\n          width: ", ";\n          height: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), RESET_BUTTON, pxToRem(ACTION_BUTTON_SIZE), pxToRem(ACTION_BUTTON_SIZE)),
      onClick: action.onClick
    }, {
      children: jsx(Icon, {
        size: ACTION_BUTTON_SIZE,
        name: action.icon,
        css: /*#__PURE__*/css(templateObject_3$r || (templateObject_3$r = __makeTemplateObject(["\n            color: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            color: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), theme.content.base1)
      })
    }))]
  }));
}
var templateObject_1$y, templateObject_2$u, templateObject_3$r;

function TableDataImpl(_a, ref) {
  var className = _a.className,
    children = _a.children,
    rest = __rest(_a, ["className", "children"]);
  var theme = useTheme();
  return jsx("td", _assign({}, rest, {
    ref: ref,
    className: spaces(className, TABLE_DATA_CLASS_NAME),
    css: /*#__PURE__*/css(templateObject_1$x || (templateObject_1$x = __makeTemplateObject(["\n        height: ", ";\n        padding: 0 ", ";\n\n        @media (hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        height: ", ";\n        padding: 0 ", ";\n\n        @media (hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(52), pxToRem(16), theme.colors.backgroundOverlay)
  }, {
    children: children
  }));
}
var TableData = /*#__PURE__*/forwardRef(TableDataImpl);
var templateObject_1$x;

var THUMBNAIL_LEFT_MARGIN = 4;
var calcSidePadding = function calcSidePadding(size) {
  switch (size) {
    case 32:
      return 12;
    case 38:
      return 14;
    case 48:
      return 16;
    default:
      return 0;
  }
};
var calcThumbnailRightMargin = function calcThumbnailRightMargin(size) {
  switch (size) {
    case 32:
      return 4;
    case 38:
      return 6;
    case 48:
      return 8;
    default:
      return 0;
  }
};
var getFontStyle = function getFontStyle(size) {
  if (size === 48) {
    return FONT_STYLE.subTitle1;
  }
  return FONT_STYLE.subTitle2;
};
var getChipSpacing = function getChipSpacing(size) {
  return /*#__PURE__*/css(templateObject_1$w || (templateObject_1$w = __makeTemplateObject(["\n    margin-left: -", ";\n    margin-right: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:getChipSpacing;")], ["\n    margin-left: -", ";\n    margin-right: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:getChipSpacing;")])), pxToRem(calcSidePadding(size) - THUMBNAIL_LEFT_MARGIN), pxToRem(calcThumbnailRightMargin(size)));
};
function cssBaseChip(size) {
  return /*#__PURE__*/css(templateObject_2$t || (templateObject_2$t = __makeTemplateObject(["\n    display: inline-block;\n    position: relative;\n    height: ", ";\n    border-radius: ", ";\n    padding-left: ", ";\n    padding-right: ", ";\n    line-height: 0;\n    &::before {\n      content: \"\";\n      height: 100%;\n      display: inline-block;\n      vertical-align: middle;\n    }\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssBaseChip;")], ["\n    display: inline-block;\n    position: relative;\n    height: ", ";\n    border-radius: ", ";\n    padding-left: ", ";\n    padding-right: ", ";\n    line-height: 0;\n    &::before {\n      content: \"\";\n      height: 100%;\n      display: inline-block;\n      vertical-align: middle;\n    }\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssBaseChip;")])), pxToRem(size), pxToRem(size / 2), pxToRem(calcSidePadding(size)), pxToRem(calcSidePadding(size)));
}
function Text(_a) {
  var size = _a.size,
    children = _a.children,
    rest = __rest(_a, ["size", "children"]);
  return jsx("span", _assign({}, rest, {
    css: [getFontStyle(size), /*#__PURE__*/css(templateObject_3$q || (templateObject_3$q = __makeTemplateObject(["\n          vertical-align: middle;\n          white-space: nowrap;\n          cursor: inherit;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          vertical-align: middle;\n          white-space: nowrap;\n          cursor: inherit;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))]
  }, {
    children: children
  }));
}
function Checkbox(_a) {
  var checked = _a.checked,
    _onChange = _a.onChange,
    onCheck = _a.onCheck,
    rest = __rest(_a, ["checked", "onChange", "onCheck"]);
  return jsx("input", _assign({}, rest, {
    type: "checkbox",
    css: /*#__PURE__*/css(templateObject_4$n || (templateObject_4$n = __makeTemplateObject(["\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 0;\n        height: 0;\n        opacity: 0;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 0;\n        height: 0;\n        opacity: 0;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")]))),
    checked: checked,
    onChange: function onChange(e) {
      return onCheckHandler(e, {
        onChange: _onChange,
        onCheck: onCheck
      });
    }
  }));
}
function Thumbnail(_a) {
  var size = _a.size,
    rest = __rest(_a, ["size"]);
  return jsx(CircleImage, _assign({}, rest, {
    css: [getChipSpacing(size), /*#__PURE__*/css(templateObject_5$h || (templateObject_5$h = __makeTemplateObject(["\n          width: ", ";\n          vertical-align: middle;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          width: ", ";\n          vertical-align: middle;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(size - 8))]
  }));
}
function RemoveButton(_a) {
  var fill = _a.fill;
    _a.size;
    var rest = __rest(_a, ["fill", "size"]);
  var theme = useTheme();
  return jsx("button", _assign({}, rest, {
    type: "button",
    css: /*#__PURE__*/css(templateObject_6$f || (templateObject_6$f = __makeTemplateObject(["\n        ", "\n        width: ", ";\n        height: ", ";\n        margin-left: ", ";\n        margin-right: ", ";\n        vertical-align: middle;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        ", "\n        width: ", ";\n        height: ", ";\n        margin-left: ", ";\n        margin-right: ", ";\n        vertical-align: middle;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), RESET_BUTTON, pxToRem(12), pxToRem(12), pxToRem(4), pxToRem(-4))
  }, {
    children: jsx(Icon, {
      size: 12,
      name: "dismiss",
      css: /*#__PURE__*/css(templateObject_7$d || (templateObject_7$d = __makeTemplateObject(["\n          vertical-align: top;\n          color: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          vertical-align: top;\n          color: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), theme.content[fill])
    })
  }));
}
var templateObject_1$w, templateObject_2$t, templateObject_3$q, templateObject_4$n, templateObject_5$h, templateObject_6$f, templateObject_7$d;

function cssVariant$2(_a) {
  var theme = _a.theme,
    variant = _a.variant,
    hasInteraction = _a.hasInteraction;
  switch (variant) {
    case 'default':
      return /*#__PURE__*/css(templateObject_2$s || (templateObject_2$s = __makeTemplateObject(["\n        color: ", ";\n        background-color: ", ";\n        ", "\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")], ["\n        color: ", ";\n        background-color: ", ";\n        ", "\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")])), theme.content.base1, theme.content.base5, hasInteraction && /*#__PURE__*/css(templateObject_1$v || (templateObject_1$v = __makeTemplateObject(["\n          &:hover {\n            background-color: ", ";\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")], ["\n          &:hover {\n            background-color: ", ";\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")])), theme.interactive.base5));
    case 'outline':
      return /*#__PURE__*/css(templateObject_4$m || (templateObject_4$m = __makeTemplateObject(["\n        color: ", ";\n        border: ", " solid ", ";\n        ", "\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")], ["\n        color: ", ";\n        border: ", " solid ", ";\n        ", "\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")])), theme.content.base1, pxToRem(1), theme.border, hasInteraction && /*#__PURE__*/css(templateObject_3$p || (templateObject_3$p = __makeTemplateObject(["\n          &:hover {\n            background-color: ", ";\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")], ["\n          &:hover {\n            background-color: ", ";\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")])), theme.interactive.transparent));
    case 'primary1':
    case 'primary3':
    case 'primary4':
      return /*#__PURE__*/css(templateObject_6$e || (templateObject_6$e = __makeTemplateObject(["\n        color: ", ";\n        background-color: ", ";\n        ", "\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")], ["\n        color: ", ";\n        background-color: ", ";\n        ", "\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")])), theme.content.white, theme.content[variant].basic, hasInteraction && /*#__PURE__*/css(templateObject_5$g || (templateObject_5$g = __makeTemplateObject(["\n          &:hover {\n            background-color: ", ";\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")], ["\n          &:hover {\n            background-color: ", ";\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")])), theme.interactive[variant].basic));
  }
}
/**
 * @deprecated ODS의 Chip 컴포넌트를 사용해 주세요. 만약 디자인상 ODS의 Chip 컴포넌트를 사용할 수 없는 경우, 디자인시스템 담당 디자이너에게 문의해주세요.
 */
function Chip(_a) {
  var children = _a.children,
    size = _a.size,
    _b = _a.variant,
    variant = _b === void 0 ? 'default' : _b,
    thumbnail = _a.thumbnail,
    onRemove = _a.onRemove,
    onClick = _a.onClick,
    rest = __rest(_a, ["children", "size", "variant", "thumbnail", "onRemove", "onClick"]);
  var theme = useTheme();
  return jsxs("div", _assign({
    css: [cssBaseChip(size), cssVariant$2({
      theme: theme,
      variant: variant,
      hasInteraction: !!onClick
    }), /*#__PURE__*/css(templateObject_7$c || (templateObject_7$c = __makeTemplateObject(["cursor: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["cursor: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), onClick ? 'pointer' : 'default')],
    onClick: onClick
  }, rest, {
    children: [thumbnail && jsx(Thumbnail, {
      src: thumbnail,
      size: size
    }), jsx(Text, _assign({
      size: size
    }, {
      children: children
    })), onRemove && jsx(RemoveButton, {
      size: size,
      fill: {
        "default": 'base2',
        outline: 'base2',
        primary1: 'white',
        primary3: 'white',
        primary4: 'white'
      }[variant],
      onClick: onRemove
    })]
  }));
}
var templateObject_1$v, templateObject_2$s, templateObject_3$p, templateObject_4$m, templateObject_5$g, templateObject_6$e, templateObject_7$c;

/**
 * @deprecated ODS에서는 더이상 사용되지 않는 컴포넌트입니다. 디자이너에 문의해주세요.
 */
function InputChip(_a) {
  var className = _a.className,
    prefix = _a.prefix,
    value = _a.value,
    placeholder = _a.placeholder,
    _onChange = _a.onChange,
    onValue = _a.onValue,
    _onFocus = _a.onFocus,
    _onBlur = _a.onBlur,
    onRemove = _a.onRemove,
    rest = __rest(_a, ["className", "prefix", "value", "placeholder", "onChange", "onValue", "onFocus", "onBlur", "onRemove"]);
  var theme = useTheme();
  var ref = useRef(null);
  var _b = useState(0),
    width = _b[0],
    setWidth = _b[1];
  var _c = useState(false),
    focused = _c[0],
    setFocused = _c[1];
  useEffect(function () {
    if (ref.current) {
      ref.current.style.width = '0';
      setWidth(ref.current.scrollWidth);
      ref.current.removeAttribute('style');
    }
  }, [value, placeholder]);
  return jsxs("div", _assign({
    className: className,
    css: [FONT_STYLE.subTitle2, cssBaseChip(32), /*#__PURE__*/css(templateObject_1$u || (templateObject_1$u = __makeTemplateObject(["\n          position: relative;\n          white-space: nowrap;\n          color: ", ";\n          border: ", " solid\n            ", ";\n          background-color: ", ";\n          &:hover {\n            border-color: ", ";\n            background-color: ", ";\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          position: relative;\n          white-space: nowrap;\n          color: ", ";\n          border: ", " solid\n            ", ";\n          background-color: ", ";\n          &:hover {\n            border-color: ", ";\n            background-color: ", ";\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), theme.content.base1, pxToRem(1), focused ? theme.content.primary1.basic : theme.content.base5, theme.content.base5, focused ? theme.content.primary1.basic : theme.interactive.base5, theme.interactive.base5)]
  }, {
    children: [jsx("span", _assign({
      ref: ref,
      css: /*#__PURE__*/css(templateObject_2$r || (templateObject_2$r = __makeTemplateObject(["\n          position: absolute;\n          display: inline-block;\n          white-space: pre;\n          visibility: hidden;\n          top: 0;\n          left: 0;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          position: absolute;\n          display: inline-block;\n          white-space: pre;\n          visibility: hidden;\n          top: 0;\n          left: 0;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
    }, {
      children: value || placeholder
    })), prefix && jsx(Text, _assign({
      size: 32,
      css: /*#__PURE__*/css(templateObject_3$o || (templateObject_3$o = __makeTemplateObject(["\n            margin-right: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            margin-right: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(1))
    }, {
      children: prefix
    })), jsx("input", _assign({}, rest, {
      value: value,
      placeholder: placeholder,
      onFocus: function onFocus(e) {
        if (_onFocus) {
          _onFocus(e);
        }
        setFocused(true);
      },
      onBlur: function onBlur(e) {
        if (_onBlur) {
          _onBlur(e);
        }
        setFocused(false);
      },
      onChange: function onChange(e) {
        return onValueHandler(e, {
          onChange: _onChange,
          onValue: onValue
        });
      },
      css: /*#__PURE__*/css(templateObject_4$l || (templateObject_4$l = __makeTemplateObject(["\n          ", "\n          width: ", ";\n          font: inherit;\n          color: inherit;\n          vertical-align: middle;\n          &::placeholder {\n            color: ", ";\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          ", "\n          width: ", ";\n          font: inherit;\n          color: inherit;\n          vertical-align: middle;\n          &::placeholder {\n            color: ", ";\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), RESET_INPUT, pxToRem(width), theme.content.base3)
    })), onRemove && jsx(RemoveButton, {
      fill: "base2",
      onClick: onRemove
    })]
  }));
}
var templateObject_1$u, templateObject_2$r, templateObject_3$o, templateObject_4$l;

function cssVariant$1(theme, variant) {
  switch (variant) {
    case 'primary1':
    case 'primary3':
      return /*#__PURE__*/css(templateObject_1$t || (templateObject_1$t = __makeTemplateObject(["\n        color: ", ";\n        background-color: ", ";\n        @media (hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")], ["\n        color: ", ";\n        background-color: ", ";\n        @media (hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")])), theme.content.white, theme.content[variant].basic, theme.interactive[variant].basic);
    case 'primary4':
      return /*#__PURE__*/css(templateObject_2$q || (templateObject_2$q = __makeTemplateObject(["\n        color: ", ";\n        background-color: ", ";\n        @media (hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")], ["\n        color: ", ";\n        background-color: ", ";\n        @media (hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")])), theme.content.white, theme.content.primary4.thick, theme.interactive.primary4.thick);
    case 'base1':
      return /*#__PURE__*/css(templateObject_3$n || (templateObject_3$n = __makeTemplateObject(["\n        color: ", ";\n        background-color: ", ";\n        @media (hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")], ["\n        color: ", ";\n        background-color: ", ";\n        @media (hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")])), theme.content.white, theme.content[variant], theme.interactive[variant]);
  }
}
/**
 * @deprecated ODS에서는 더이상 사용되지 않는 컴포넌트입니다. 디자이너에 문의해주세요.
 */
function SelectChip(_a) {
  var id = _a.id,
    children = _a.children,
    className = _a.className,
    size = _a.size,
    variant = _a.variant,
    thumbnail = _a.thumbnail,
    extraText = _a.extraText,
    checked = _a.checked,
    onChange = _a.onChange,
    onCheck = _a.onCheck,
    rest = __rest(_a, ["id", "children", "className", "size", "variant", "thumbnail", "extraText", "checked", "onChange", "onCheck"]);
  var theme = useTheme();
  return jsxs("label", _assign({
    className: className,
    htmlFor: id,
    css: [cssBaseChip(size), checked ? cssVariant$1(theme, variant) : /*#__PURE__*/css(templateObject_4$k || (templateObject_4$k = __makeTemplateObject(["\n              color: ", ";\n              background-color: ", ";\n              &:hover {\n                background-color: ", ";\n              }\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              color: ", ";\n              background-color: ", ";\n              &:hover {\n                background-color: ", ";\n              }\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), theme.content.base1, theme.content.base5, theme.interactive.base5), /*#__PURE__*/css(templateObject_5$f || (templateObject_5$f = __makeTemplateObject(["cursor: pointer;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["cursor: pointer;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))]
  }, {
    children: [jsx(Checkbox, _assign({}, rest, {
      id: id,
      checked: checked,
      onCheck: onCheck,
      onChange: onChange
    })), thumbnail && jsx(Thumbnail, {
      src: thumbnail,
      size: size
    }), jsx(Text, _assign({
      size: size
    }, {
      children: children
    })), extraText && jsx(Text, _assign({
      size: size,
      css: [checked ? /*#__PURE__*/css(templateObject_6$d || (templateObject_6$d = __makeTemplateObject(["\n                  color: ", ";\n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                  color: ", ";\n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), theme.content.white) : /*#__PURE__*/css(templateObject_7$b || (templateObject_7$b = __makeTemplateObject(["\n                  color: ", ";                  \n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                  color: ", ";                  \n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), variant === 'base1' ? theme.content.base1 : theme.content[variant].thick), /*#__PURE__*/css(templateObject_8$9 || (templateObject_8$9 = __makeTemplateObject(["\n              margin-left: ", ";\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              margin-left: ", ";\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(2))]
    }, {
      children: extraText
    }))]
  }));
}
var templateObject_1$t, templateObject_2$q, templateObject_3$n, templateObject_4$k, templateObject_5$f, templateObject_6$d, templateObject_7$b, templateObject_8$9;

function cssVariant(theme, variant) {
  switch (variant) {
    case 'primary1':
    case 'primary4':
      return /*#__PURE__*/css(templateObject_1$s || (templateObject_1$s = __makeTemplateObject(["\n        color: ", ";\n        background-color: ", ";\n        border: ", " solid ", ";\n        @media(hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")], ["\n        color: ", ";\n        background-color: ", ";\n        border: ", " solid ", ";\n        @media(hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")])), theme.content[variant].thick, theme.content[variant].thin, pxToRem(1), theme.content[variant].thick, theme.interactive[variant].thin);
    case 'primary3':
      return /*#__PURE__*/css(templateObject_2$p || (templateObject_2$p = __makeTemplateObject(["\n        color: ", ";\n        background-color: ", ";\n        border: ", " solid ", ";\n        @media(hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")], ["\n        color: ", ";\n        background-color: ", ";\n        border: ", " solid ", ";\n        @media(hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")])), theme.content[variant].basic, theme.content[variant].thin, pxToRem(1), theme.content[variant].basic, theme.interactive[variant].thin);
    case 'base1':
      return /*#__PURE__*/css(templateObject_3$m || (templateObject_3$m = __makeTemplateObject(["\n        color: ", ";\n        background-color: ", ";\n        border: ", " solid ", ";\n        @media(hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")], ["\n        color: ", ";\n        background-color: ", ";\n        border: ", " solid ", ";\n        @media(hover: hover) and (pointer: fine) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssVariant;")])), theme.content.base1, theme.content.base5, pxToRem(1), theme.content.base1, theme.interactive.base5);
  }
}
/**
 * @deprecated ODS에서는 더이상 사용되지 않는 컴포넌트입니다. 디자이너에 문의해주세요.
 */
function OutlineSelectChip(_a) {
  var id = _a.id,
    children = _a.children,
    size = _a.size,
    variant = _a.variant,
    thumbnail = _a.thumbnail,
    extraText = _a.extraText,
    _b = _a.checked,
    checked = _b === void 0 ? false : _b,
    onChange = _a.onChange,
    onCheck = _a.onCheck,
    className = _a.className,
    rest = __rest(_a, ["id", "children", "size", "variant", "thumbnail", "extraText", "checked", "onChange", "onCheck", "className"]);
  var theme = useTheme();
  return jsxs("label", _assign({
    className: className,
    htmlFor: id,
    css: [cssBaseChip(size), checked ? cssVariant(theme, variant) : /*#__PURE__*/css(templateObject_4$j || (templateObject_4$j = __makeTemplateObject(["\n              color: ", ";\n              border: ", " solid ", ";\n              @media(hover: hover) and (pointer: fine) {\n                &:hover {\n                  background-color: ", ";\n                }\n              }\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              color: ", ";\n              border: ", " solid ", ";\n              @media(hover: hover) and (pointer: fine) {\n                &:hover {\n                  background-color: ", ";\n                }\n              }\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), theme.content.base1, pxToRem(1), theme.border, theme.interactive.base5), /*#__PURE__*/css(templateObject_5$e || (templateObject_5$e = __makeTemplateObject(["cursor: pointer;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["cursor: pointer;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))]
  }, {
    children: [jsx(Checkbox, _assign({}, rest, {
      id: id,
      checked: checked,
      onCheck: onCheck,
      onChange: onChange
    })), thumbnail && jsx(Thumbnail, {
      src: thumbnail,
      size: size
    }), jsx(Text, _assign({
      size: size
    }, {
      children: children
    })), extraText && jsx(Text, _assign({
      size: size,
      css: [/*#__PURE__*/css(templateObject_6$c || (templateObject_6$c = __makeTemplateObject(["color: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["color: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), variant === 'primary3' ? theme.content[variant].basic : variant !== 'base1' ? theme.content[variant].thick : theme.content[variant]), /*#__PURE__*/css(templateObject_7$a || (templateObject_7$a = __makeTemplateObject(["\n              margin-left: ", ";\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              margin-left: ", ";\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(2))]
    }, {
      children: extraText
    }))]
  }));
}
var templateObject_1$s, templateObject_2$p, templateObject_3$m, templateObject_4$j, templateObject_5$e, templateObject_6$c, templateObject_7$a;

/**
 * @deprecated ODS에서는 더이상 사용되지 않는 컴포넌트입니다. 디자이너에 문의해주세요.
 */
function FillOutlineSelectChip(props) {
  var checked = props.checked;
  return checked ? jsx(SelectChip, _assign({}, props)) : jsx(OutlineSelectChip, _assign({}, props));
}

var cat1x1 = "https://assets.ohou.se/design-system/4115b98dcf15cece.png";

var cat1x2 = "https://assets.ohou.se/design-system/0d544e95b1db25b2.png";

var cat1x3 = "https://assets.ohou.se/design-system/266288958944af51.png";

var man1x1 = "https://assets.ohou.se/design-system/23babe1bcb31c86f.png";

var man1x2 = "https://assets.ohou.se/design-system/b3ed77dde9be5229.png";

var man1x3 = "https://assets.ohou.se/design-system/5a7ef2ef9bba815e.png";

function EmptyImage(_a) {
  var image = _a.image;
  return jsx(Image, {
    aspectRatio: "1:1",
    css: /*#__PURE__*/css(templateObject_1$r || (templateObject_1$r = __makeTemplateObject(["\n        width: ", ";\n        vertical-align: top;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        width: ", ";\n        vertical-align: top;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(100)),
    src: {
      cat1: cat1x1,
      man1: man1x1
    }[image],
    src2x: {
      cat1: cat1x2,
      man1: man1x2
    }[image],
    src3x: {
      cat1: cat1x3,
      man1: man1x3
    }[image]
  });
}
var templateObject_1$r;

/**
 * @deprecated ODS의 Empty 컴포넌트를 사용해 주세요. 만약 디자인상 ODS의 Empty 컴포넌트를 사용할 수 없는 경우, 디자인시스템 담당 디자이너에게 문의해주세요.
 */
function EmptyPage(_a) {
  var image = _a.image,
    title = _a.title,
    description = _a.description,
    action = _a.action,
    subAction = _a.subAction,
    rest = __rest(_a, ["image", "title", "description", "action", "subAction"]);
  var theme = useTheme();
  return jsxs("div", _assign({}, rest, {
    css: /*#__PURE__*/css(templateObject_1$q || (templateObject_1$q = __makeTemplateObject(["\n        width: ", ";\n        margin: 0 auto;\n        text-align: center;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        width: ", ";\n        margin: 0 auto;\n        text-align: center;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(343))
  }, {
    children: [image && jsx("div", _assign({
      css: /*#__PURE__*/css(templateObject_2$o || (templateObject_2$o = __makeTemplateObject(["\n            margin-bottom: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            margin-bottom: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(10))
    }, {
      children: jsx(EmptyImage, {
        image: image
      })
    })), title && jsx("p", _assign({
      css: [FONT_STYLE.title1, /*#__PURE__*/css(templateObject_3$l || (templateObject_3$l = __makeTemplateObject(["\n            color: ", ";\n            white-space: pre-wrap;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            color: ", ";\n            white-space: pre-wrap;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), theme.content.base1)]
    }, {
      children: title
    })), description && jsx("p", _assign({
      css: [FONT_STYLE.body1_1, /*#__PURE__*/css(templateObject_4$i || (templateObject_4$i = __makeTemplateObject(["\n            margin-top: ", ";\n            color: ", ";\n            white-space: pre-wrap;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            margin-top: ", ";\n            color: ", ";\n            white-space: pre-wrap;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(10), theme.content.base2)]
    }, {
      children: description
    })), action && jsx("div", _assign({
      css: /*#__PURE__*/css(templateObject_5$d || (templateObject_5$d = __makeTemplateObject(["\n            margin-top: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            margin-top: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(10))
    }, {
      children: jsx(Button$2, _assign({
        size: 44,
        variant: "primary1",
        onClick: action.onClick
      }, {
        children: action.text
      }))
    })), subAction && jsx("div", _assign({
      css: /*#__PURE__*/css(templateObject_6$b || (templateObject_6$b = __makeTemplateObject(["\n            margin-top: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            margin-top: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(3))
    }, {
      children: jsx(TextButton, _assign({
        size: 32,
        variant: "primary1",
        onClick: subAction.onClick
      }, {
        children: subAction.text
      }))
    }))]
  }));
}
var templateObject_1$q, templateObject_2$o, templateObject_3$l, templateObject_4$i, templateObject_5$d, templateObject_6$b;

function SocialLink(_a) {
  var type = _a.type,
    href = _a.href;
  var theme = useTheme();
  return jsx("a", _assign({
    href: href,
    target: "_blank",
    css: /*#__PURE__*/css(templateObject_1$p || (templateObject_1$p = __makeTemplateObject(["\n        display: inline-block;\n        margin-right: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        display: inline-block;\n        margin-right: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(12)),
    rel: "noreferrer",
    "data-testid": "SocialLink-".concat(type)
  }, {
    children: jsxs("svg", _assign({
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      css: /*#__PURE__*/css(templateObject_2$n || (templateObject_2$n = __makeTemplateObject(["\n        vertical-align: top;\n        color: ", ";\n        &:hover {\n          color: ", ";\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        vertical-align: top;\n        color: ", ";\n        &:hover {\n          color: ", ";\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), theme.content.base2, theme.interactive.base2)
    }, {
      children: [type === 'KakaoStory' && jsx(KakaoStorySvg, {}), type === 'Facebook' && jsx(FacebookSvg, {}), type === 'Instagram' && jsx(InstagramSvg, {}), type === 'NaverPost' && jsx(NaverPostSvg, {}), type === 'Youtube' && jsx(YoutubeSvg, {}), type === 'Pinterest' && jsx(PinterestSvg, {}), type === 'TikTok' && jsx(TikTokSvg, {})]
    }))
  }));
}
function KakaoStorySvg() {
  return jsxs(Fragment$1, {
    children: [jsx("circle", {
      cx: "12",
      cy: "12",
      r: "11",
      fill: "currentColor"
    }), jsx("path", {
      d: "M14.6548 6.5H9.34617C8.98953 6.5 8.70036 6.77492 8.70036 7.11427V12.4991C8.70036 12.8382 8.98953 13.1132 9.34617 13.1132H11.7936C11.7768 13.7122 11.5225 14.3691 11.1359 14.9432C10.7632 15.4965 10.1507 16.0415 9.81838 16.3021C9.80983 16.3089 9.80136 16.3154 9.79337 16.3217C9.72167 16.3871 9.66939 16.4632 9.66826 16.5686C9.66714 16.6486 9.71075 16.7105 9.75928 16.7761L9.77173 16.7896L11.4662 18.6074C11.4662 18.6074 11.549 18.6908 11.6175 18.7066C11.6948 18.7243 11.7823 18.7265 11.8429 18.6818C14.7987 16.5067 15.2256 13.7794 15.2999 12.3034C15.3001 12.295 15.3004 7.11427 15.3004 7.11427C15.3004 6.77492 15.0114 6.5 14.6548 6.5Z",
      fill: "white"
    })]
  });
}
function FacebookSvg() {
  return jsxs(Fragment$1, {
    children: [jsxs("g", _assign({
      clipPath: "url(#clip0_21132_87052)"
    }, {
      children: [jsx("path", {
        d: "M23 12C23 5.92486 18.0751 1 12 1C5.92486 1 1 5.92486 1 12C1 17.4903 5.02252 22.0412 10.2812 22.8664V15.1797H7.48828V12H10.2812V9.57656C10.2812 6.81969 11.9235 5.29688 14.4361 5.29688C15.6397 5.29688 16.8984 5.51172 16.8984 5.51172V8.21875H15.5114C14.145 8.21875 13.7188 9.06674 13.7188 9.93664V12H16.7695L16.2818 15.1797H13.7188V22.8664C18.9775 22.0412 23 17.4905 23 12Z",
        fill: "currentColor"
      }), jsx("path", {
        d: "M16.2818 15.1797L16.7695 12H13.7188V9.93664C13.7188 9.06674 14.145 8.21875 15.5114 8.21875H16.8984V5.51172C16.8984 5.51172 15.6397 5.29688 14.4361 5.29688C11.9235 5.29688 10.2812 6.81969 10.2812 9.57656V12H7.48828V15.1797H10.2812V22.8664C10.8413 22.9542 11.4152 23 12 23C12.5848 23 13.1587 22.9542 13.7188 22.8664V15.1797H16.2818Z",
        fill: "white"
      })]
    })), jsx("defs", {
      children: jsx("clipPath", _assign({
        id: "clip0_21132_87052"
      }, {
        children: jsx("rect", {
          width: "22",
          height: "22",
          fill: "white",
          transform: "translate(1 1)"
        })
      }))
    })]
  });
}
function InstagramSvg() {
  return jsxs(Fragment$1, {
    children: [jsx("circle", {
      cx: "12",
      cy: "12",
      r: "11",
      fill: "currentColor"
    }), jsx("path", {
      d: "M9.10061 5.04896C8.3558 5.0841 7.84718 5.20296 7.40253 5.37768C6.94235 5.55702 6.5523 5.79768 6.16422 6.18717C5.77614 6.57665 5.53715 6.96698 5.35907 7.42786C5.18673 7.87349 5.06997 8.38253 5.03707 9.12776C5.00417 9.87299 4.99689 10.1125 5.00053 12.0135C5.00417 13.9144 5.01257 14.1527 5.04869 14.8995C5.08425 15.6441 5.20269 16.1526 5.37741 16.5974C5.55703 17.0576 5.79742 17.4475 6.18704 17.8357C6.57666 18.2239 6.96671 18.4624 7.42871 18.6407C7.87392 18.8128 8.3831 18.9301 9.12819 18.9627C9.87328 18.9953 10.1131 19.0029 12.0135 18.9993C13.9139 18.9956 14.1531 18.9872 14.8997 18.9518C15.6464 18.9164 16.1522 18.7971 16.5971 18.6232C17.0573 18.4432 17.4475 18.2032 17.8354 17.8134C18.2234 17.4237 18.4622 17.0331 18.6402 16.5719C18.8126 16.1267 18.9298 15.6175 18.9622 14.873C18.9948 14.1258 19.0025 13.8872 18.9988 11.9866C18.9952 10.0859 18.9867 9.84765 18.9513 9.10116C18.9158 8.35467 18.7972 7.84773 18.6227 7.40266C18.4428 6.94248 18.2027 6.55285 17.8132 6.16435C17.4237 5.77584 17.0328 5.53714 16.5718 5.35962C16.1263 5.18728 15.6174 5.06982 14.8723 5.03762C14.1272 5.00542 13.8874 4.99716 11.9863 5.0008C10.0852 5.00444 9.84724 5.01256 9.10061 5.04896ZM9.18237 17.7034C8.49986 17.6737 8.12928 17.5603 7.88232 17.4654C7.55527 17.3394 7.32231 17.1871 7.07619 16.9433C6.83007 16.6996 6.67886 16.4658 6.55118 16.1394C6.45528 15.8925 6.33978 15.5223 6.30786 14.8398C6.27314 14.1021 6.26586 13.8807 6.2618 12.0118C6.25774 10.1429 6.26488 9.92171 6.29722 9.18376C6.32634 8.50181 6.44044 8.13081 6.53522 7.88399C6.66122 7.55652 6.81299 7.32398 7.05729 7.078C7.30159 6.83201 7.53469 6.68053 7.86132 6.55285C8.108 6.45653 8.47816 6.34201 9.16039 6.30953C9.89862 6.27453 10.1198 6.26753 11.9884 6.26347C13.857 6.25941 14.0788 6.26641 14.8173 6.29889C15.4992 6.32857 15.8704 6.44155 16.1169 6.53689C16.4441 6.66289 16.6769 6.81423 16.9229 7.05896C17.1689 7.30368 17.3205 7.53594 17.4482 7.86327C17.5447 8.10925 17.6592 8.47927 17.6914 9.16192C17.7265 9.90015 17.7345 10.1215 17.7379 11.9899C17.7412 13.8584 17.7346 14.0803 17.7023 14.818C17.6725 15.5005 17.5594 15.8712 17.4643 16.1184C17.3383 16.4454 17.1864 16.6785 16.9419 16.9243C16.6975 17.1701 16.4647 17.3216 16.1379 17.4493C15.8915 17.5455 15.5209 17.6603 14.8393 17.6928C14.101 17.7275 13.8798 17.7348 12.0105 17.7388C10.1412 17.7429 9.92074 17.7353 9.18251 17.7034M14.889 8.25877C14.8898 8.72273 15.2664 9.09822 15.7304 9.09738C16.1943 9.09654 16.5698 8.71993 16.569 8.25597C16.5681 7.792 16.1915 7.41652 15.7276 7.41736C15.7276 7.41736 15.7274 7.41736 15.7273 7.41736C15.2635 7.41834 14.8881 7.79494 14.889 8.25877ZM8.4055 12.007C8.40942 13.9922 10.0217 15.5979 12.0065 15.5941C13.9913 15.5904 15.5981 13.9782 15.5943 11.993C15.5905 10.0078 13.9778 8.40171 11.9928 8.40563C10.0077 8.40955 8.40172 10.0221 8.4055 12.007ZM9.66635 12.0045C9.66383 10.7158 10.7064 9.669 11.9951 9.66648C13.2839 9.66396 14.3306 10.7066 14.3332 11.9953C14.3357 13.284 13.2931 14.3308 12.0044 14.3333C10.7158 14.336 9.66901 13.2936 9.66635 12.0051V12.0045Z",
      fill: "white"
    })]
  });
}
function NaverPostSvg() {
  return jsxs(Fragment$1, {
    children: [jsx("circle", {
      cx: "12",
      cy: "12",
      r: "11",
      fill: "currentColor"
    }), jsx("path", {
      d: "M7.96631 5.76685H16.033V13.8335H7.96631V5.76685ZM12.5913 8.24889V9.81433L11.4126 8.24889H10.1381V11.3515H11.4082V9.78601L12.5872 11.3515H13.8612V8.24889H12.5913Z",
      fill: "white"
    }), jsx("path", {
      d: "M7.96631 14.454H16.033L14.5204 16.3156H9.47869L7.96631 14.454Z",
      fill: "white"
    }), jsx("path", {
      d: "M9.98281 16.9361H14.0161L11.9993 19.4181L9.98281 16.9361Z",
      fill: "white"
    })]
  });
}
function YoutubeSvg() {
  return jsxs(Fragment$1, {
    children: [jsx("circle", {
      cx: "12",
      cy: "12",
      r: "11",
      fill: "currentColor"
    }), jsx("path", {
      d: "M18.7086 8.63031C18.5472 8.02758 18.0736 7.55392 17.4709 7.39258C16.3783 7.09985 12.0002 7.09985 12.0002 7.09985C12.0002 7.09985 7.62199 7.09985 6.53062 7.39258C5.92789 7.55392 5.45423 8.02758 5.29289 8.63031C5.00016 9.72168 5.00016 12.0001 5.00016 12.0001C5.00016 12.0001 5.00016 14.2785 5.29289 15.3699C5.45423 15.9726 5.92789 16.4462 6.53062 16.6076C7.62199 16.9003 12.0002 16.9003 12.0002 16.9003C12.0002 16.9003 16.3783 16.9003 17.4697 16.6076C18.0724 16.4462 18.5461 15.9726 18.7074 15.3699C19.0002 14.2785 19.0002 12.0001 19.0002 12.0001C19.0002 12.0001 19.0002 9.72168 18.7074 8.63031H18.7086Z",
      fill: "white"
    }), jsx("path", {
      d: "M10.6013 14.0994L14.2396 11.9997L10.6013 9.8999V14.0994Z",
      fill: "currentColor"
    })]
  });
}
function PinterestSvg() {
  return jsx("g", _assign({
    id: "mdi:pinterest"
  }, {
    children: jsx("path", {
      id: "Vector",
      d: "M8.744 22.494C9.8 22.813 10.867 23 12 23C14.9174 23 17.7153 21.8411 19.7782 19.7782C21.8411 17.7153 23 14.9174 23 12C23 10.5555 22.7155 9.12506 22.1627 7.79048C21.6099 6.4559 20.7996 5.24327 19.7782 4.22183C18.7567 3.20038 17.5441 2.39013 16.2095 1.83733C14.8749 1.28452 13.4445 1 12 1C10.5555 1 9.12506 1.28452 7.79048 1.83733C6.4559 2.39013 5.24327 3.20038 4.22183 4.22183C2.15893 6.28473 1 9.08262 1 12C1 16.675 3.937 20.69 8.084 22.274C7.985 21.416 7.886 19.997 8.084 19.018L9.349 13.584C9.349 13.584 9.03 12.946 9.03 11.934C9.03 10.416 9.976 9.283 11.054 9.283C12 9.283 12.44 9.976 12.44 10.867C12.44 11.813 11.813 13.166 11.494 14.464C11.307 15.542 12.066 16.488 13.166 16.488C15.124 16.488 16.642 14.398 16.642 11.45C16.642 8.81 14.75 7.006 12.033 7.006C8.931 7.006 7.105 9.316 7.105 11.747C7.105 12.693 7.413 13.65 7.919 14.277C8.018 14.343 8.018 14.431 7.985 14.596L7.666 15.795C7.666 15.982 7.545 16.048 7.358 15.916C5.95 15.3 5.136 13.298 5.136 11.681C5.136 8.205 7.6 5.048 12.352 5.048C16.136 5.048 19.084 7.765 19.084 11.373C19.084 15.157 16.741 18.193 13.386 18.193C12.319 18.193 11.274 17.621 10.9 16.95L10.163 19.557C9.91 20.503 9.217 21.768 8.744 22.527V22.494Z",
      fill: "currentColor"
    })
  }));
}
function TikTokSvg() {
  return jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM14.9105 4.41289V4.40002H12.3471V14.4163C12.3471 14.8779 12.2999 15.2892 12.2051 15.6499C11.3685 17.4927 8.97015 17.2094 8.38751 15.9032C7.74726 14.4685 8.5531 12.4646 10.9619 12.8189C10.9619 11.4282 10.9615 11.4283 10.9611 11.4284C10.9607 11.4285 10.9603 11.4286 10.9603 10.0384C5.12937 9.11658 3.19974 17.7295 9.00693 19.4666C10.015 19.6869 10.6155 19.6726 11.2824 19.5463C13.6628 19.095 14.9342 16.855 14.9027 14.571L14.9067 9.52692C16.1836 10.6659 18.2357 10.8143 18.5 10.7985C18.5 9.5631 18.4996 9.62598 18.4992 9.69178C18.4988 9.76398 18.4984 9.83969 18.4984 8.20747C14.9792 7.99822 14.9112 4.64478 14.9105 4.41289Z",
    fill: "currentColor"
  });
}
var templateObject_1$p, templateObject_2$n;

var CUSTOMER_CENTER_EMAIL = 'cs@bucketplace.net';
function ServiceCenter(_a) {
  var phone = _a.phone,
    openingHour = _a.openingHour,
    ohouseFooterLinks = _a.ohouseFooterLinks;
  var openKakaoChat = useKakaoChat().openKakaoChat;
  var isApp = getDeviceInfo().isApp;
  return jsxs(ServiceCenterContainer, {
    children: [jsxs(ServiceCenterAnchorContainer, {
      children: [jsx(ServiceCenterAnchor, _assign({
        href: ohouseFooterLinks === null || ohouseFooterLinks === void 0 ? void 0 : ohouseFooterLinks.serviceCenter
      }, {
        children: "\uACE0\uAC1D\uC13C\uD130"
      })), jsx(Icon, {
        name: "chevron_thick_right",
        size: 12
      })]
    }), jsxs(ServiceCenterInfo, {
      children: [jsx(ServiceCenterNumberAnchor, _assign({
        href: "tel:".concat(phone)
      }, {
        children: phone
      })), jsx(ServiceCenterTime, _assign({
        dateTime: openingHour.start
      }, {
        children: openingHour.start
      })), "~", jsx(ServiceCenterTime, _assign({
        dateTime: openingHour.end
      }, {
        children: openingHour.end
      }))]
    }), jsxs(ServiceCenterDescription, {
      children: [jsx(WorkingDay, {
        children: "\uD3C9\uC77C: \uC804\uCCB4 \uBB38\uC758 \uC0C1\uB2F4"
      }), jsx(WorkingDay, {
        children: "\uD1A0\uC694\uC77C, \uACF5\uD734\uC77C: \uC624\uB298\uC758\uC9D1 \uC9C1\uC811\uBC30\uC1A1 \uC8FC\uBB38\uAC74 \uC0C1\uB2F4"
      }), jsx(WorkingDay, {
        children: "\uC77C\uC694\uC77C: \uD734\uBB34"
      })]
    }), jsxs(AnchorContainer, {
      children: [jsx(OutlineButton, _assign({
        variant: "base1",
        size: 32,
        onClick: openKakaoChat,
        css: cssServiceButton
      }, {
        children: "\uCE74\uD1A1 \uC0C1\uB2F4(\uD3C9\uC77C 09:00~18:00)"
      })), jsx(OutlineAnchorButton, _assign({
        href: !isApp || isHigherAppVersion({
          AOS: '0',
          iOS: '8.8'
        }) ? ohouseFooterLinks === null || ohouseFooterLinks === void 0 ? void 0 : ohouseFooterLinks.voiceOfCustomer : "mailto:".concat(CUSTOMER_CENTER_EMAIL),
        variant: "base1",
        size: 32,
        css: cssServiceButton
      }, {
        children: "\uC774\uBA54\uC77C \uBB38\uC758"
      }))]
    })]
  });
}
var ServiceCenterContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e18sae9p8"
} : {
  target: "e18sae9p8",
  label: "ServiceCenterContainer"
})(templateObject_1$o || (templateObject_1$o = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.content.base1;
});
var ServiceCenterAnchor = /*#__PURE__*/_styled("a", process.env.NODE_ENV === "production" ? {
  target: "e18sae9p7"
} : {
  target: "e18sae9p7",
  label: "ServiceCenterAnchor"
})(templateObject_2$m || (templateObject_2$m = __makeTemplateObject(["\n  ", "\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n"], ["\n  ", "\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n"])), FONT_STYLE.title3);
var ServiceCenterNumberAnchor = /*#__PURE__*/_styled("a", process.env.NODE_ENV === "production" ? {
  target: "e18sae9p6"
} : {
  target: "e18sae9p6",
  label: "ServiceCenterNumberAnchor"
})(templateObject_3$k || (templateObject_3$k = __makeTemplateObject(["\n  ", "\n  font-weight: 700;\n  white-space: nowrap;\n  margin-right: ", ";\n"], ["\n  ", "\n  font-weight: 700;\n  white-space: nowrap;\n  margin-right: ", ";\n"])), FONT_STYLE.subTitle1, pxToRem(6));
var ServiceCenterInfo = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e18sae9p5"
} : {
  target: "e18sae9p5",
  label: "ServiceCenterInfo"
})(templateObject_4$h || (templateObject_4$h = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  margin: ", " 0 ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  margin: ", " 0 ", ";\n"])), pxToRem(20), pxToRem(8));
var ServiceCenterTime = /*#__PURE__*/_styled("time", process.env.NODE_ENV === "production" ? {
  target: "e18sae9p4"
} : {
  target: "e18sae9p4",
  label: "ServiceCenterTime"
})(templateObject_5$c || (templateObject_5$c = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), FONT_STYLE.body2);
var ServiceCenterDescription = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e18sae9p3"
} : {
  target: "e18sae9p3",
  label: "ServiceCenterDescription"
})(templateObject_6$a || (templateObject_6$a = __makeTemplateObject(["\n  ", "\n  white-space: pre-wrap;\n  margin-bottom: ", ";\n  ", "\n"], ["\n  ", "\n  white-space: pre-wrap;\n  margin-bottom: ", ";\n  ", "\n"])), FONT_STYLE.body3, pxToRem(12), MEDIA_QUERY.min('desktop', "\n    padding-right: ".concat(pxToRem(10), ";\n  ")));
var AnchorContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e18sae9p2"
} : {
  target: "e18sae9p2",
  label: "AnchorContainer"
})(templateObject_7$9 || (templateObject_7$9 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n  margin-top: ", ";\n  ", "\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n  margin-top: ", ";\n  ", "\n"])), pxToRem(12), pxToRem(12), MEDIA_QUERY.max('mobile', "\n    flex-direction: row;\n  "));
var cssServiceButton = /*#__PURE__*/css(templateObject_8$8 || (templateObject_8$8 = __makeTemplateObject(["\n  width: fit-content;\n  white-space: nowrap;\n  ", "\n" + (process.env.NODE_ENV === "production" ? "" : ";label:cssServiceButton;")], ["\n  width: fit-content;\n  white-space: nowrap;\n  ", "\n" + (process.env.NODE_ENV === "production" ? "" : ";label:cssServiceButton;")])), MEDIA_QUERY.max('mobile', "\n    white-space: normal;\n  "));
var ServiceCenterAnchorContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e18sae9p1"
} : {
  target: "e18sae9p1",
  label: "ServiceCenterAnchorContainer"
})(templateObject_9$8 || (templateObject_9$8 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n"])), pxToRem(2));
var WorkingDay = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e18sae9p0"
} : {
  target: "e18sae9p0",
  label: "WorkingDay"
})(templateObject_10$7 || (templateObject_10$7 = __makeTemplateObject(["\n  position: relative;\n  padding-left: ", ";\n  &:before {\n    content: '\u2022';\n    position: absolute;\n    font-size: ", ";\n    left: ", ";\n  }\n"], ["\n  position: relative;\n  padding-left: ", ";\n  &:before {\n    content: '\\u2022';\n    position: absolute;\n    font-size: ", ";\n    left: ", ";\n  }\n"])), pxToRem(20), pxToRem(10), pxToRem(7));
var templateObject_1$o, templateObject_2$m, templateObject_3$k, templateObject_4$h, templateObject_5$c, templateObject_6$a, templateObject_7$9, templateObject_8$8, templateObject_9$8, templateObject_10$7;

function Certification(_a) {
  var certification = _a.certification;
  var img = certification.imgSrc && jsx(Img, {
    src: certification.imgSrc,
    width: 32,
    height: 32,
    alt: "".concat(certification.id, " \uC778\uC99D \uB9C8\uD06C")
  });
  return jsxs(Container$3, {
    children: [certification.imgLink && img ? jsx("a", _assign({
      href: certification.imgLink,
      target: "_blank",
      rel: "noreferrer"
    }, {
      children: img
    })) : img, (certification.title || certification.date) && jsxs(Description, {
      children: [certification.title, jsx("br", {}), certification.date]
    })]
  });
}
var Container$3 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eqedtio2"
} : {
  target: "eqedtio2",
  label: "Container"
})(templateObject_1$n || (templateObject_1$n = __makeTemplateObject(["\n  display: flex;\n  height: ", ";\n  padding: 0 ", ";\n  gap: ", ";\n  align-items: center;\n  justify-content: center;\n  border: ", " solid ", ";\n"], ["\n  display: flex;\n  height: ", ";\n  padding: 0 ", ";\n  gap: ", ";\n  align-items: center;\n  justify-content: center;\n  border: ", " solid ", ";\n"])), pxToRem(40), pxToRem(6), pxToRem(6), pxToRem(1), function (_a) {
  var theme = _a.theme;
  return theme.outline;
});
var Img = /*#__PURE__*/_styled("img", process.env.NODE_ENV === "production" ? {
  target: "eqedtio1"
} : {
  target: "eqedtio1",
  label: "Img"
})(templateObject_2$l || (templateObject_2$l = __makeTemplateObject(["\n  border: none;\n"], ["\n  border: none;\n"])));
var Description = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eqedtio0"
} : {
  target: "eqedtio0",
  label: "Description"
})(templateObject_3$j || (templateObject_3$j = __makeTemplateObject(["\n  ", "\n  color: ", ";\n"], ["\n  ", "\n  color: ", ";\n"])), FONT_STYLE.caption2, function (_a) {
  var theme = _a.theme;
  return theme.content.base2;
});
var templateObject_1$n, templateObject_2$l, templateObject_3$j;

function Responsive(_a) {
  var mobile = _a.mobile,
    _b = _a.tablet,
    tablet = _b === void 0 ? mobile : _b,
    _c = _a.laptop,
    laptop = _c === void 0 ? tablet : _c,
    _d = _a.desktop,
    desktop = _d === void 0 ? laptop : _d,
    defaultBreakpoint = _a.defaultBreakpoint,
    preventSyncOnInitialRender = _a.preventSyncOnInitialRender;
  var breakpoint = useResponsive({
    fallbackBreakpoint: defaultBreakpoint !== null && defaultBreakpoint !== void 0 ? defaultBreakpoint : 'mobile',
    preventSyncOnInitialRender: preventSyncOnInitialRender
  }).breakpoint;
  return jsxs(Fragment$1, {
    children: [breakpoint === 'mobile' && mobile, breakpoint === 'tablet' && tablet, breakpoint === 'laptop' && laptop, breakpoint === 'desktop' && desktop]
  });
}

function CompanyInfo(_a) {
  var companyInfo = _a.companyInfo;
  var _b = useState(false),
    isOpenCompanyInfo = _b[0],
    setOpenCompanyInfo = _b[1];
  return jsx(Responsive, {
    mobile: jsxs(Fragment$1, {
      children: [jsxs(Button, _assign({
        type: "button",
        onClick: function onClick() {
          return setOpenCompanyInfo(function (isOpenCompanyInfo) {
            return !isOpenCompanyInfo;
          });
        }
      }, {
        children: [companyInfo['상호명'], jsx(Icon, {
          name: isOpenCompanyInfo ? 'chevron_thick_up' : 'chevron_thick_down',
          size: 12
        })]
      })), isOpenCompanyInfo && jsx("div", _assign({
        css: /*#__PURE__*/css(templateObject_1$m || (templateObject_1$m = __makeTemplateObject(["margin-top: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["margin-top: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(12))
      }, {
        children: Object.keys(companyInfo).map(function (key) {
          return key !== '상호명' && jsx(CompanyInfoItem, {
            children: companyInfo[key]
          }, key);
        })
      }))]
    }),
    tablet: jsx("div", _assign({
      css: /*#__PURE__*/css(templateObject_2$k || (templateObject_2$k = __makeTemplateObject(["margin-left: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["margin-left: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(-9))
    }, {
      children: Object.keys(companyInfo).map(function (key) {
        return jsxs(CompanyInfoItem, {
          children: [jsx("span", _assign({
            css: /*#__PURE__*/css(templateObject_3$i || (templateObject_3$i = __makeTemplateObject(["margin: 0 ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["margin: 0 ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(4))
          }, {
            children: "|"
          })), companyInfo[key]]
        }, key);
      })
    }))
  });
}
var CompanyInfoItem = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1jtu31t1"
} : {
  target: "e1jtu31t1",
  label: "CompanyInfoItem"
})(templateObject_4$g || (templateObject_4$g = __makeTemplateObject(["\n  ", "\n  display: inline-block;\n  white-space: nowrap;\n  ", "\n"], ["\n  ", "\n  display: inline-block;\n  white-space: nowrap;\n  ", "\n"])), FONT_STYLE.body3, MEDIA_QUERY.max('mobile', "\n    display: block;\n  "));
var Button = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e1jtu31t0"
} : {
  target: "e1jtu31t0",
  label: "Button"
})(templateObject_5$b || (templateObject_5$b = __makeTemplateObject(["\n  ", "\n  ", "\n  color: ", ";\n  font-weight: 700;\n  display: flex;\n  gap: ", ";\n  align-items: center;\n"], ["\n  ", "\n  ", "\n  color: ", ";\n  font-weight: 700;\n  display: flex;\n  gap: ", ";\n  align-items: center;\n"])), RESET_BUTTON, FONT_STYLE.caption1, function (_a) {
  var theme = _a.theme;
  return theme.content.base1;
}, pxToRem(2));
var templateObject_1$m, templateObject_2$k, templateObject_3$i, templateObject_4$g, templateObject_5$b;

function Footer(_a) {
  var copyright = _a.copyright,
    serviceCenter = _a.serviceCenter,
    socialLinks = _a.socialLinks,
    companyLinks = _a.companyLinks,
    companyInfo = _a.companyInfo,
    responsibilityInfo = _a.responsibilityInfo,
    paymentGuarantee = _a.paymentGuarantee,
    certifications = _a.certifications,
    rest = __rest(_a, ["copyright", "serviceCenter", "socialLinks", "companyLinks", "companyInfo", "responsibilityInfo", "paymentGuarantee", "certifications"]);
  return jsx(FooterComponenet, _assign({}, rest, {
    children: jsxs(StyledContainer, {
      children: [serviceCenter && jsx(ServiceCenter, _assign({}, serviceCenter)), jsx(Divider, {
        css: /*#__PURE__*/css(templateObject_1$l || (templateObject_1$l = __makeTemplateObject(["\n          ", "\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          ", "\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), MEDIA_QUERY.max('mobile', "\n            grid-column-start: 1;\n            grid-column-end: 2;\n            width: 100%;\n            height: ".concat(pxToRem(1), ";\n          ")))
      }), companyLinks && jsx(CompanyLinksContainer, {
        children: companyLinks.map(function (_a) {
          var text = _a.text,
            href = _a.href,
            target = _a.target,
            isBold = _a.isBold;
          return jsx(CompanyLink, _assign({
            href: href,
            target: target || '_self',
            isBold: !!isBold
          }, {
            children: text
          }), text);
        })
      }), jsx(Divider, {
        css: /*#__PURE__*/css(templateObject_2$j || (templateObject_2$j = __makeTemplateObject(["\n          ", "\n          ", "" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          ", "\n          ", "" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), MEDIA_QUERY.max('tablet', "\n            grid-column-start: 1;\n            grid-column-end: 4;\n            width: 100%;\n            height: ".concat(pxToRem(1), ";\n          ")), MEDIA_QUERY.max('mobile', "\n            grid-column-start: 1;\n            grid-column-end: 2;\n          "))
      }), jsxs(InfoContainer, {
        children: [companyInfo && jsx("div", _assign({
          css: /*#__PURE__*/css(templateObject_3$h || (templateObject_3$h = __makeTemplateObject(["overflow-x: hidden;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["overflow-x: hidden;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
        }, {
          children: jsx(CompanyInfo, {
            companyInfo: companyInfo
          })
        })), paymentGuarantee && jsx("div", {
          children: paymentGuarantee
        }), certifications && jsx(CertificationContainer, {
          children: certifications.map(function (certification) {
            return jsx(Certification, {
              certification: certification
            }, certification.id);
          })
        }), responsibilityInfo && jsx("div", {
          children: responsibilityInfo
        }), socialLinks && jsx("div", {
          children: socialLinks.map(function (socialLink) {
            return jsx(SocialLink, _assign({}, socialLink), socialLink.href);
          })
        }), copyright && jsx("p", {
          children: copyright
        })]
      })]
    })
  }));
}
var FooterComponenet = /*#__PURE__*/_styled("footer", process.env.NODE_ENV === "production" ? {
  target: "e1nsvcrd6"
} : {
  target: "e1nsvcrd6",
  label: "FooterComponenet"
})(templateObject_4$f || (templateObject_4$f = __makeTemplateObject(["\n  padding: ", " 0;\n  background-color: ", ";\n  ", "\n  & a:hover {\n    text-decoration: underline;\n  }\n"], ["\n  padding: ", " 0;\n  background-color: ", ";\n  ", "\n  & a:hover {\n    text-decoration: underline;\n  }\n"])), pxToRem(40), function (_a) {
  var theme = _a.theme;
  return theme.content.base5;
}, MEDIA_QUERY.max('mobile', "\n    padding: ".concat(pxToRem(30), " 0;\n  ")));
var StyledContainer = /*#__PURE__*/_styled(Container$4, process.env.NODE_ENV === "production" ? {
  target: "e1nsvcrd5"
} : {
  target: "e1nsvcrd5",
  label: "StyledContainer"
})(templateObject_5$a || (templateObject_5$a = __makeTemplateObject(["\n  ", ";\n  display: grid;\n  grid-template-columns: ", " 1px ", " 1px 2fr;\n  grid-column-gap: ", ";\n\n  ", "\n\n  ", "\n"], ["\n  ", ";\n  display: grid;\n  grid-template-columns: ", " 1px ", " 1px 2fr;\n  grid-column-gap: ", ";\n\n  ", "\n\n  ", "\n"])), FONT_STYLE.caption1, pxToRem(256), pxToRem(256), pxToRem(24), MEDIA_QUERY.max('tablet', "\n    grid-template-columns: 1fr 1px 1fr;\n    grid-row-gap: ".concat(pxToRem(24), ";\n  ")), MEDIA_QUERY.max('mobile', "\n    padding: 0 ".concat(pxToRem(16), ";\n    grid-template-columns: 1fr;\n    grid-row-gap: ").concat(pxToRem(20), ";\n  ")));
var InfoContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1nsvcrd4"
} : {
  target: "e1nsvcrd4",
  label: "InfoContainer"
})(templateObject_6$9 || (templateObject_6$9 = __makeTemplateObject(["\n  ", "\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n  color: ", ";\n  ", "\n  ", "\n"], ["\n  ", "\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n  color: ", ";\n  ", "\n  ", "\n"])), FONT_STYLE.caption2, pxToRem(12), function (_a) {
  var theme = _a.theme;
  return theme.content.base2;
}, MEDIA_QUERY.max('tablet', "\n    grid-column-start: 1;\n    grid-column-end: 4;\n  "), MEDIA_QUERY.max('mobile', "\n    grid-column-start: 1;\n    grid-column-end: 2;\n  "));
var CompanyLinksContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1nsvcrd3"
} : {
  target: "e1nsvcrd3",
  label: "CompanyLinksContainer"
})(templateObject_7$8 || (templateObject_7$8 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-template-rows: repeat(6, min-content);\n  grid-auto-flow: column;\n  grid-column-gap: ", ";\n  grid-row-gap: ", ";\n\n  ", "\n"], ["\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-template-rows: repeat(6, min-content);\n  grid-auto-flow: column;\n  grid-column-gap: ", ";\n  grid-row-gap: ", ";\n\n  ", "\n"])), pxToRem(8), pxToRem(20), MEDIA_QUERY.max('mobile', "\n    display: block;\n    grid-column-gap: ".concat(pxToRem(10), ";\n  ")));
var CompanyLink = /*#__PURE__*/_styled("a", process.env.NODE_ENV === "production" ? {
  target: "e1nsvcrd2"
} : {
  target: "e1nsvcrd2",
  label: "CompanyLink"
})(templateObject_8$7 || (templateObject_8$7 = __makeTemplateObject(["\n  ", "\n  display: inline-block;\n  color: ", ";\n  white-space: nowrap;\n  font-weight: ", ";\n  ", "\n"], ["\n  ", "\n  display: inline-block;\n  color: ", ";\n  white-space: nowrap;\n  font-weight: ", ";\n  ", "\n"])), FONT_STYLE.caption1, function (_a) {
  var theme = _a.theme;
  return theme.content.base1;
}, function (_a) {
  var isBold = _a.isBold;
  return isBold && '700';
}, MEDIA_QUERY.max('mobile', "\n    margin: ".concat(pxToRem(8), " ").concat(pxToRem(12), " ").concat(pxToRem(8), " 0;\n  ")));
var CertificationContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1nsvcrd1"
} : {
  target: "e1nsvcrd1",
  label: "CertificationContainer"
})(templateObject_9$7 || (templateObject_9$7 = __makeTemplateObject(["\n  display: grid;\n  grid-column-gap: ", ";\n  grid-template-columns: max-content minmax(min-content, ", ") minmax(min-content, ", ");\n  ", "\n"], ["\n  display: grid;\n  grid-column-gap: ", ";\n  grid-template-columns: max-content minmax(min-content, ", ") minmax(min-content, ", ");\n  ", "\n"])), pxToRem(6), pxToRem(116), pxToRem(116), MEDIA_QUERY.max('mobile', "\n    grid-template-columns: 1fr;\n  "));
var Divider = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1nsvcrd0"
} : {
  target: "e1nsvcrd0",
  label: "Divider"
})(templateObject_10$6 || (templateObject_10$6 = __makeTemplateObject(["\n  width: ", ";\n  background-color: ", ";\n"], ["\n  width: ", ";\n  background-color: ", ";\n"])), pxToRem(1), function (_a) {
  var theme = _a.theme;
  return theme.divider;
});
var templateObject_1$l, templateObject_2$j, templateObject_3$h, templateObject_4$f, templateObject_5$a, templateObject_6$9, templateObject_7$8, templateObject_8$7, templateObject_9$7, templateObject_10$6;

var markIsmsSrc = "https://assets.ohou.se/design-system/8f5b2c2e98ea1196.png";

var markIso27001Src = "https://assets.ohou.se/design-system/d5fb816a58bb6a06.png";

var markPcrSrc = "https://assets.ohou.se/design-system/ad1cf869a6c58058.png";

var PHONE_NUMBER = '1670-0876';
var ADDRESS = '서울 서초구 서초대로74길 4 삼성생명서초타워 25층, 27층';
var COPYRIGHT_TEXT = 'Copyright 2014. bucketplace, Co., Ltd. All rights reserved.';
var BUCKETPLACE_HOMEPAGE_URL = 'https://www.bucketplace.com';
var OPENING_HOUR = {
  START: '09:00',
  END: '18:00'
};
var EMAIL = {
  CS: 'cs@bucketplace.net',
  CONTACT: 'contact@bucketplace.net'
};
/**
 * ohouse 서비스 도메인과 연결된 link schema를 create합니다.
 * @param ohs prod, stage 등 환경에 따른 `ohou.se` url
 * @param pro prod, stage 등 환경에 따른 `o2o-partner.ohou.se` url (pro.ohou.se deprecated)
 * @returns 서비스 도메인과 연결된 link schema
 */
function createOhouseFooterLinkSchema(_a) {
  var ohs = _a.ohs,
    pro = _a.pro;
  return {
    serviceCenter: "".concat(ohs, "/customer_center"),
    usepolicy: "".concat(ohs, "/usepolicy"),
    privacy: "".concat(ohs, "/privacy"),
    partnerPrivacy: "".concat(ohs, "/partner_privacy"),
    notice: "".concat(ohs, "/customer_notices"),
    inquiry: "".concat(ohs, "/contacts/new?type=request"),
    voiceOfCustomer: "".concat(ohs, "/contacts/new"),
    pro: "".concat(pro, "/intro?utm_source=ohouse&utm_medium=web&utm_campaign=prosignup&utm_content=footer")
  };
}
function OhouseFooter(props) {
  var ohouseFooterLinks = props.ohouseFooterLinks,
    restProps = __rest(props, ["ohouseFooterLinks"]);
  var theme = useTheme();
  var isMobile = useResponsive().breakpoint === 'mobile';
  var paymentGuarantee = jsxs(Fragment$1, {
    children: [jsx("span", {
      children: "\uACE0\uAC1D\uB2D8\uC774 \uD604\uAE08\uACB0\uC81C\uD55C \uAE08\uC561\uC5D0 \uB300\uD574 \uC6B0\uB9AC\uC740\uD589\uACFC \uCC44\uBB34\uC9C0\uAE09\uBCF4\uC99D \uACC4\uC57D\uC744 \uCCB4\uACB0\uD558\uC5EC \uC548\uC804\uAC70\uB798\uB97C \uBCF4\uC7A5\uD558\uACE0 \uC788\uC2B5\uB2C8\uB2E4."
    }), ' ', jsx("a", _assign({
      target: "_blank",
      href: "https://ohouse.notion.site/da111ffbfc7c45a0a1327e23a7bd5dde",
      css: /*#__PURE__*/css(templateObject_1$k || (templateObject_1$k = __makeTemplateObject(["\n            font-weight: 700;\n            color: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            font-weight: 700;\n            color: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), theme.content.base2),
      rel: "noreferrer"
    }, {
      children: "\uC11C\uBE44\uC2A4\uAC00\uC785\uC0AC\uC2E4\uD655\uC778"
    }))]
  });
  var iso27001 = {
    id: 'iso27001',
    imgSrc: markIso27001Src
  };
  var isms = {
    id: 'isms',
    imgSrc: markIsmsSrc,
    title: jsx("span", {
      children: "\uC624\uB298\uC758\uC9D1 \uC11C\uBE44\uC2A4 \uC6B4\uC601"
    }),
    date: '2024. 09. 08 ~ 2027. 09. 07'
  };
  var pcr = {
    id: 'pcr',
    imgSrc: markPcrSrc,
    imgLink: 'https://www.pipc.go.kr/np/cop/bbs/selectBoardArticle.do?bbsId=BS213&mCode=C040050000&nttId=8926'
  };
  return jsx(Footer, _assign({}, restProps, {
    copyright: COPYRIGHT_TEXT,
    serviceCenter: {
      phone: PHONE_NUMBER,
      openingHour: {
        start: OPENING_HOUR.START,
        end: OPENING_HOUR.END
      },
      ohouseFooterLinks: ohouseFooterLinks
    },
    socialLinks: [{
      type: 'Youtube',
      href: 'https://www.youtube.com/channel/UCBKtitA1RwY7F32rCniV1dA'
    }, {
      type: 'Instagram',
      href: 'https://www.instagram.com/todayhouse'
    }, {
      type: 'Facebook',
      href: 'https://www.facebook.com/interiortoday'
    }, {
      type: 'KakaoStory',
      href: 'https://story.kakao.com/ch/bucketplace'
    }, {
      type: 'NaverPost',
      href: 'https://naver.me/51ckkDZh'
    }],
    companyLinks: [{
      text: '회사소개',
      href: BUCKETPLACE_HOMEPAGE_URL
    }, {
      text: '채용정보',
      href: "".concat(BUCKETPLACE_HOMEPAGE_URL, "/careers")
    }, {
      text: '이용약관',
      href: ohouseFooterLinks.usepolicy
    }, {
      text: '개인정보 처리방침',
      href: ohouseFooterLinks.privacy,
      isBold: true
    }, {
      text: '공지사항',
      href: ohouseFooterLinks.notice
    }, {
      text: '안전거래센터',
      href: 'https://safetybucketplace.zendesk.com/hc/ko',
      target: 'blank'
    }, {
      text: '입점신청',
      href: 'https://partnerbucketplace.zendesk.com/hc/ko/articles/19259629646361-오늘의집-입점안내'
    }, {
      text: '제휴/광고 문의',
      href: ohouseFooterLinks.inquiry
    }, {
      text: '시공파트너 안내',
      href: ohouseFooterLinks.pro
    }, {
      text: '파트너 개인정보 처리방침',
      href: ohouseFooterLinks.partnerPrivacy,
      isBold: true
    }, {
      text: '상품광고 소개',
      href: 'https://ohouse-ad.oopy.io'
    }, {
      text: '고객의 소리',
      href: ohouseFooterLinks.voiceOfCustomer
    }],
    companyInfo: {
      상호명: '(주)버킷플레이스',
      대표이사: '대표이사 이승재',
      주소: jsx("address", _assign({
        css: /*#__PURE__*/css(templateObject_2$i || (templateObject_2$i = __makeTemplateObject(["\n              display: inline-block;\n              font-style: normal;\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              display: inline-block;\n              font-style: normal;\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
      }, {
        children: ADDRESS
      })),
      이메일: jsx("a", _assign({
        href: "mailto:contact@bucketplace.net"
      }, {
        children: EMAIL.CONTACT
      })),
      사업자등록번호: jsxs(Fragment$1, {
        children: [jsx("span", {
          children: "\uC0AC\uC5C5\uC790\uB4F1\uB85D\uBC88\uD638 119-86-91245"
        }), jsxs("a", _assign({
          target: "_blank",
          href: "https://www.ftc.go.kr/bizCommPop.do?wrkr_no=1198691245",
          css: /*#__PURE__*/css(templateObject_3$g || (templateObject_3$g = __makeTemplateObject(["\n                font-weight: 700;\n                color: ", ";\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                font-weight: 700;\n                color: ", ";\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), theme.content.base2),
          rel: "noreferrer"
        }, {
          children: [' ', "\uC0AC\uC5C5\uC790\uC815\uBCF4\uD655\uC778"]
        }))]
      }),
      통신판매업신고번호: jsx("span", {
        children: "\uD1B5\uC2E0\uD310\uB9E4\uC5C5\uC2E0\uACE0\uBC88\uD638 \uC81C2018-\uC11C\uC6B8\uC11C\uCD08-0580\uD638"
      })
    },
    responsibilityInfo: "(\uC8FC)\uBC84\uD0B7\uD50C\uB808\uC774\uC2A4\uB294 \uD1B5\uC2E0\uD310\uB9E4\uC911\uAC1C\uC790\uB85C \uAC70\uB798 \uB2F9\uC0AC\uC790\uAC00 \uC544\uB2C8\uBBC0\uB85C, \uD310\uB9E4\uC790\uAC00 \uB4F1\uB85D\uD55C \uC0C1\uD488\uC815\uBCF4 \uBC0F \uAC70\uB798 \uB4F1\uC5D0 \uB300\uD574 \uCC45\uC784\uC744 \uC9C0\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uB2E8, (\uC8FC)\uBC84\uD0B7\uD50C\uB808\uC774\uC2A4\uAC00 \uD310\uB9E4\uC790\uB85C \uB4F1\uB85D \uD310\uB9E4\uD55C \uC0C1\uD488\uC740 \uD310\uB9E4\uC790\uB85C\uC11C \uCC45\uC784\uC744 \uBD80\uB2F4\uD569\uB2C8\uB2E4.",
    paymentGuarantee: paymentGuarantee,
    certifications: !isMobile ? [isms, iso27001, pcr] : undefined
  }));
}
var templateObject_1$k, templateObject_2$i, templateObject_3$g;

function ListItem(_a) {
  var _b = _a.size,
    size = _b === void 0 ? 'basic' : _b,
    selected = _a.selected,
    disabled = _a.disabled,
    forwardedRef = _a.forwardedRef,
    children = _a.children,
    props = __rest(_a, ["size", "selected", "disabled", "forwardedRef", "children"]);
  var theme = useTheme();
  return jsx("div", _assign({
    ref: forwardedRef,
    css: /*#__PURE__*/css(templateObject_1$j || (templateObject_1$j = __makeTemplateObject(["\n        padding: ", " ", ";\n        color: ", ";\n        ", "\n        transition: background-color .2s ease-in-out;\n        ", "\n        &:hover, &:focus {\n          background-color: ", ";\n        }\n        ", "\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        padding: ", " ", ";\n        color: ", ";\n        ", "\n        transition: background-color .2s ease-in-out;\n        ", "\n        &:hover, &:focus {\n          background-color: ", ";\n        }\n        ", "\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem({
      basic: 16,
      compact: 11
    }[size]), pxToRem(16), theme.content.base1, FONT_STYLE.subTitle1, disabled && "\n          color: ".concat(theme.content.base3, ";\n        "), theme.content.base5, selected && "\n          background-color: ".concat(theme.content.base5, ";\n        "))
  }, props, {
    children: children
  }));
}
var templateObject_1$j;

function DividerListItem(_a) {
  var _b = _a.variant,
    variant = _b === void 0 ? 'thin' : _b,
    props = __rest(_a, ["variant"]);
  return jsxs(Fragment$1, {
    children: [jsx(ListItem, _assign({}, props)), jsx(Divider$1, {
      variant: variant
    })]
  });
}

var Dropdown = function Dropdown(_a) {
  var dropdownRef = _a.dropdownRef,
    title = _a.title,
    items = _a.items,
    _onClick = _a.onClick,
    onCloseDropdown = _a.onCloseDropdown,
    onClose = _a.onClose,
    _b = _a.selectedItemId,
    selectedItemId = _b === void 0 ? -1 : _b,
    _c = _a.isPopupInMobile,
    isPopupInMobile = _c === void 0 ? false : _c;
  var isMobile = useResponsive().breakpoint === 'mobile';
  var listItemRef = useRef(null);
  var listItemHeight = useNodeHeight(listItemRef);
  // PC의 경우 최대 10.5개의 아이템 노출
  var maxDropdownHeight = useMemo(function () {
    return listItemHeight * 10.5;
  }, [listItemHeight]);
  var modalWidthProps = useMemo(function () {
    return isMobile && isPopupInMobile ? {
      width: 300,
      isPopupInMobile: true
    } : {
      width: 600
    };
  }, [isMobile, isPopupInMobile]);
  return jsx("div", _assign({
    ref: dropdownRef,
    onClick: function onClick(e) {
      return onCloseDropdown(e);
    }
  }, {
    children: isMobile ? jsx(Modal, _assign({}, modalWidthProps, {
      onBlur: onClose,
      header: {
        title: title,
        onClose: onClose
      }
    }, {
      children: jsx(ListItemWrapper, {
        children: items.map(function (item) {
          return jsx(Item, _assign({
            size: "basic",
            onClick: function onClick() {
              return _onClick(item.id);
            },
            selected: item.id === selectedItemId
          }, {
            children: item.value
          }), item.id);
        })
      })
    })) : jsx(Container$2, _assign({
      maxDropdownHeight: maxDropdownHeight
    }, {
      children: items.map(function (item) {
        return (
          // TODO: disabled 기능 추가
          jsx(Item, _assign({
            size: "basic",
            onClick: function onClick() {
              return _onClick(item.id);
            },
            forwardedRef: listItemRef,
            selected: item.id === selectedItemId
          }, {
            children: item.value
          }), item.id)
        );
      })
    }))
  }));
};
var Container$2 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1uoa6tb2"
} : {
  target: "e1uoa6tb2",
  label: "Container"
})(templateObject_2$h || (templateObject_2$h = __makeTemplateObject(["\n  border-radius: ", ";\n  max-height: ", ";\n  overflow-y: auto;\n  z-index: 1;\n  ", "\n"], ["\n  border-radius: ", ";\n  max-height: ", ";\n  overflow-y: auto;\n  z-index: 1;\n  ", "\n"])), pxToRem(4), function (_a) {
  var maxDropdownHeight = _a.maxDropdownHeight;
  return pxToRem(maxDropdownHeight);
}, function (_a) {
  var theme = _a.theme;
  return /*#__PURE__*/css(templateObject_1$i || (templateObject_1$i = __makeTemplateObject(["\n    border: ", " solid ", ";\n    background-color: ", ";\n    box-shadow: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:Container;")], ["\n    border: ", " solid ", ";\n    background-color: ", ";\n    box-shadow: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:Container;")])), pxToRem(1), theme.content.base4, theme.background.elevated, theme.shadow.thin);
});
var ListItemWrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1uoa6tb1"
} : {
  target: "e1uoa6tb1",
  label: "ListItemWrapper"
})(templateObject_3$f || (templateObject_3$f = __makeTemplateObject(["\n  overflow-y: auto;\n"], ["\n  overflow-y: auto;\n"])));
var Item = /*#__PURE__*/_styled(ListItem, process.env.NODE_ENV === "production" ? {
  target: "e1uoa6tb0"
} : {
  target: "e1uoa6tb0",
  label: "Item"
})(templateObject_4$e || (templateObject_4$e = __makeTemplateObject(["\n  cursor: pointer;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  text-align: left; \n  &:active {\n    font-weight: 700;\n  };\n"], ["\n  cursor: pointer;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  text-align: left; \n  &:active {\n    font-weight: 700;\n  };\n"])));
var templateObject_1$i, templateObject_2$h, templateObject_3$f, templateObject_4$e;

var ICON_SIZE = 24;
function SimpleFooter(_a) {
  var companyLinks = _a.companyLinks,
    socialLinks = _a.socialLinks,
    localeSelection = _a.localeSelection;
  var dropdownRef = useRef(null);
  var _b = useState(false),
    isDropdownOpen = _b[0],
    setIsDropdownOpen = _b[1];
  var _c = useState(-1),
    selectedItemId = _c[0],
    setSelectedItemId = _c[1];
  var dropdownItems = React__default.useMemo(function () {
    return localeSelection ? localeSelection.locales.map(function (item, index) {
      return {
        id: index,
        value: item.text
      };
    }) : [];
  }, [localeSelection]);
  var currentLocaleText = React__default.useMemo(function () {
    var _a;
    return (_a = localeSelection === null || localeSelection === void 0 ? void 0 : localeSelection.locales[selectedItemId]) === null || _a === void 0 ? void 0 : _a.text;
  }, [localeSelection, selectedItemId]);
  var getLocaleByDropdownItemId = function getLocaleByDropdownItemId(id) {
    return localeSelection === null || localeSelection === void 0 ? void 0 : localeSelection.locales[id].locale;
  };
  var handleLocaleButtonClick = function handleLocaleButtonClick() {
    setIsDropdownOpen(!isDropdownOpen);
  };
  var handleCloseDropdown = function handleCloseDropdown() {
    setIsDropdownOpen(false);
  };
  var handleClick = function handleClick(id) {
    setIsDropdownOpen(false);
    if (selectedItemId === id) return;
    setSelectedItemId(id);
    var locale = getLocaleByDropdownItemId(id);
    if (locale) localeSelection === null || localeSelection === void 0 ? void 0 : localeSelection.onLocaleChange(locale);
  };
  useEffect(function () {
    if (localeSelection === null || localeSelection === void 0 ? void 0 : localeSelection.initialLocale) {
      setSelectedItemId(localeSelection.locales.findIndex(function (item) {
        return item.locale === localeSelection.initialLocale;
      }));
    }
  }, [localeSelection]);
  return jsxs(FooterContainer, {
    children: [jsxs(CompanyLinksAndLocaleContainer, {
      children: [localeSelection && jsx(LocaleContainer, {
        children: jsxs(LocaleButton, _assign({
          onClick: handleLocaleButtonClick
        }, {
          children: [currentLocaleText, jsx(ArrowIcon, {
            size: ICON_SIZE,
            name: "dropdown"
          }), isDropdownOpen && jsx(DropdownWrapper, {
            children: jsx(Dropdown, {
              title: "",
              dropdownRef: dropdownRef,
              items: dropdownItems,
              onCloseDropdown: handleCloseDropdown,
              onClose: function onClose() {
                return setIsDropdownOpen(false);
              },
              onClick: handleClick,
              selectedItemId: selectedItemId
            })
          })]
        }))
      }), companyLinks === null || companyLinks === void 0 ? void 0 : companyLinks.map(function (_a) {
        var text = _a.text,
          href = _a.href,
          target = _a.target,
          isBold = _a.isBold;
        return jsx(GlobalCompanyLink, _assign({
          href: href,
          target: target || '_self',
          isBold: !!isBold
        }, {
          children: text
        }), text);
      })]
    }), socialLinks && jsx(SocialLinkContainer, {
      children: socialLinks.map(function (socialLink) {
        return jsx(SocialLink, _assign({}, socialLink), socialLink.href);
      })
    })]
  });
}
var FooterContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1blcm897"
} : {
  target: "e1blcm897",
  label: "FooterContainer"
})(templateObject_4$d || (templateObject_4$d = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: ", ";\n  ", " \n  ", " \n  ", " \n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: ", ";\n  ", " \n  ", " \n  ", " \n"])), function (_a) {
  var theme = _a.theme;
  return theme.background.groupedBase;
}, MEDIA_QUERY.only('mobile', /*#__PURE__*/css(templateObject_1$h || (templateObject_1$h = __makeTemplateObject(["\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 28px 16px;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:FooterContainer;")], ["\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 28px 16px;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:FooterContainer;")])))), MEDIA_QUERY.only('tablet', /*#__PURE__*/css(templateObject_2$g || (templateObject_2$g = __makeTemplateObject(["\n    flex-direction: row;\n    gap: ", ";\n    padding: 40px;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:FooterContainer;")], ["\n    flex-direction: row;\n    gap: ", ";\n    padding: 40px;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:FooterContainer;")])), pxToRem(10))), MEDIA_QUERY.min('laptop', /*#__PURE__*/css(templateObject_3$e || (templateObject_3$e = __makeTemplateObject(["\n    flex-direction: row;\n    gap: ", ";\n    padding: 40px 60px;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:FooterContainer;")], ["\n    flex-direction: row;\n    gap: ", ";\n    padding: 40px 60px;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:FooterContainer;")])), pxToRem(10))));
var SocialLinkContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1blcm896"
} : {
  target: "e1blcm896",
  label: "SocialLinkContainer"
})(templateObject_5$9 || (templateObject_5$9 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -12px;\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -12px;\n"])));
var CompanyLinksAndLocaleContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1blcm895"
} : {
  target: "e1blcm895",
  label: "CompanyLinksAndLocaleContainer"
})(templateObject_7$7 || (templateObject_7$7 = __makeTemplateObject(["\n  ", "\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  padding: 4px 0px;\n  color: ", ";\n  gap:  ", " ", ";\n  ", " \n"], ["\n  ", "\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  padding: 4px 0px;\n  color: ", ";\n  gap:  ", " ", ";\n  ", " \n"])), FONT_STYLE.caption1, function (_a) {
  var theme = _a.theme;
  return theme.content.base1;
}, pxToRem(10), pxToRem(20), MEDIA_QUERY.only('mobile', /*#__PURE__*/css(templateObject_6$8 || (templateObject_6$8 = __makeTemplateObject(["\n    margin-bottom: 16px;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:CompanyLinksAndLocaleContainer;")], ["\n    margin-bottom: 16px;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:CompanyLinksAndLocaleContainer;")])))));
var LocaleContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1blcm894"
} : {
  target: "e1blcm894",
  label: "LocaleContainer"
})(templateObject_9$6 || (templateObject_9$6 = __makeTemplateObject(["\n  ", "\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  color: ", ";\n  ", "\n"], ["\n  ", "\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  color: ", ";\n  ", "\n"])), FONT_STYLE.caption1, function (_a) {
  var theme = _a.theme;
  return theme.content.base1;
}, MEDIA_QUERY.min('tablet', /*#__PURE__*/css(templateObject_8$6 || (templateObject_8$6 = __makeTemplateObject(["\n    gap: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:LocaleContainer;")], ["\n    gap: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:LocaleContainer;")])), pxToRem(20))));
var LocaleButton = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1blcm893"
} : {
  target: "e1blcm893",
  label: "LocaleButton"
})(templateObject_10$5 || (templateObject_10$5 = __makeTemplateObject(["\n  display: flex;\n  position: relative;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  &:hover {\n    background-color: ", ";\n  }\n"], ["\n  display: flex;\n  position: relative;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  &:hover {\n    background-color: ", ";\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.interactive.transparent;
});
var ArrowIcon = /*#__PURE__*/_styled(Icon, process.env.NODE_ENV === "production" ? {
  target: "e1blcm892"
} : {
  target: "e1blcm892",
  label: "ArrowIcon"
})(templateObject_11$3 || (templateObject_11$3 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.content.base2;
});
var DropdownWrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1blcm891"
} : {
  target: "e1blcm891",
  label: "DropdownWrapper"
})(templateObject_12$1 || (templateObject_12$1 = __makeTemplateObject(["\n  position: absolute;\n  bottom: calc(100%);\n  left: 0px;\n"], ["\n  position: absolute;\n  bottom: calc(100%);\n  left: 0px;\n"])));
var GlobalCompanyLink = /*#__PURE__*/_styled("a", process.env.NODE_ENV === "production" ? {
  target: "e1blcm890"
} : {
  target: "e1blcm890",
  label: "GlobalCompanyLink"
})(templateObject_13$1 || (templateObject_13$1 = __makeTemplateObject(["\n  ", "\n  display: inline-block;\n  color: ", ";\n  white-space: nowrap;\n  font-weight: ", ";\n"], ["\n  ", "\n  display: inline-block;\n  color: ", ";\n  white-space: nowrap;\n  font-weight: ", ";\n"])), FONT_STYLE.caption1, function (_a) {
  var theme = _a.theme;
  return theme.content.base1;
}, function (_a) {
  var isBold = _a.isBold;
  return isBold && '700';
});
var templateObject_1$h, templateObject_2$g, templateObject_3$e, templateObject_4$d, templateObject_5$9, templateObject_6$8, templateObject_7$7, templateObject_8$6, templateObject_9$6, templateObject_10$5, templateObject_11$3, templateObject_12$1, templateObject_13$1;

/**
 * @deprecated ODS의 CautionBox 컴포넌트를 사용해 주세요.
 */
function Callout(_a) {
  var title = _a.title,
    _b = _a.type,
    type = _b === void 0 ? 'notice' : _b,
    icon = _a.icon,
    children = _a.children,
    rest = __rest(_a, ["title", "type", "icon", "children"]);
  var theme = useTheme();
  return jsxs("div", _assign({}, rest, {
    css: /*#__PURE__*/css(templateObject_1$g || (templateObject_1$g = __makeTemplateObject(["\n        color: ", ";\n        padding: ", ";\n        border-radius: ", ";\n        background-color: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        color: ", ";\n        padding: ", ";\n        border-radius: ", ";\n        background-color: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), theme.content.base1, pxToRem(16), pxToRem(4), {
      notice: theme.content.base5,
      confirm: theme.content.base5,
      alert: theme.content.primary2.thin
    }[type])
  }, {
    children: [jsxs("div", _assign({
      css: FONT_STYLE.subTitle1
    }, {
      children: [icon && jsx(Icon, {
        size: 18,
        name: icon,
        css: /*#__PURE__*/css(templateObject_2$f || (templateObject_2$f = __makeTemplateObject(["\n              vertical-align: middle;\n              margin-right: ", ";\n              color: ", ";\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              vertical-align: middle;\n              margin-right: ", ";\n              color: ", ";\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(6), {
          notice: theme.content.base1,
          confirm: theme.content.primary1.basic,
          alert: theme.content.primary2.thick
        }[type])
      }), jsx("span", _assign({
        css: /*#__PURE__*/css(templateObject_3$d || (templateObject_3$d = __makeTemplateObject(["\n            font-weight: 700;\n            vertical-align: middle;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            font-weight: 700;\n            vertical-align: middle;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
      }, {
        children: title
      }))]
    })), children && jsx("div", _assign({
      css: [FONT_STYLE.body1_1, /*#__PURE__*/css(templateObject_4$c || (templateObject_4$c = __makeTemplateObject(["margin-top: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["margin-top: ", ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(12))]
    }, {
      children: children
    }))]
  }));
}
var templateObject_1$g, templateObject_2$f, templateObject_3$d, templateObject_4$c;

function cssSize$2(size) {
  return /*#__PURE__*/css(templateObject_4$b || (templateObject_4$b = __makeTemplateObject(["\n    ", "\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;")], ["\n    ", "\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;")])), {
    small: /*#__PURE__*/css(templateObject_1$f || (templateObject_1$f = __makeTemplateObject(["\n      padding: ", " ", ";\n      font-size: ", ";\n      height: ", ";\n      border-radius: ", ";\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:small;")], ["\n      padding: ", " ", ";\n      font-size: ", ";\n      height: ", ";\n      border-radius: ", ";\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:small;")])), pxToRem(4), pxToRem(8), pxToRem(12), pxToRem(24), pxToRem(12)),
    medium: /*#__PURE__*/css(templateObject_2$e || (templateObject_2$e = __makeTemplateObject(["\n      padding: ", " ", ";\n      font-size: ", ";\n      height: ", ";\n      border-radius: ", ";\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:medium;")], ["\n      padding: ", " ", ";\n      font-size: ", ";\n      height: ", ";\n      border-radius: ", ";\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:medium;")])), pxToRem(4), pxToRem(10), pxToRem(14), pxToRem(26), pxToRem(13)),
    large: /*#__PURE__*/css(templateObject_3$c || (templateObject_3$c = __makeTemplateObject(["\n      padding: ", " ", ";\n      font-size: ", ";\n      height: ", ";\n      border-radius: ", ";\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:large;")], ["\n      padding: ", " ", ";\n      font-size: ", ";\n      height: ", ";\n      border-radius: ", ";\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:large;")])), pxToRem(4), pxToRem(12), pxToRem(16), pxToRem(28), pxToRem(14))
  }[size]);
}
function cssDimmed(dimmed, theme) {
  return /*#__PURE__*/css(templateObject_7$6 || (templateObject_7$6 = __makeTemplateObject(["\n    ", "\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssDimmed;")], ["\n    ", "\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssDimmed;")])), {
    basic: /*#__PURE__*/css(templateObject_5$8 || (templateObject_5$8 = __makeTemplateObject(["\n      background-color: ", ";\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:basic;")], ["\n      background-color: ", ";\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:basic;")])), theme.dim.basic),
    thick: /*#__PURE__*/css(templateObject_6$7 || (templateObject_6$7 = __makeTemplateObject(["\n      background-color: ", ";\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:thick;")], ["\n      background-color: ", ";\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:thick;")])), theme.dim.thick)
  }[dimmed]);
}
function cssFontWeight(fontWeight) {
  return /*#__PURE__*/css(templateObject_10$4 || (templateObject_10$4 = __makeTemplateObject(["\n    ", "\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssFontWeight;")], ["\n    ", "\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssFontWeight;")])), {
    regular: /*#__PURE__*/css(templateObject_8$5 || (templateObject_8$5 = __makeTemplateObject(["\n      font-weight: 400;\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:regular;")], ["\n      font-weight: 400;\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:regular;")]))),
    bold: /*#__PURE__*/css(templateObject_9$5 || (templateObject_9$5 = __makeTemplateObject(["\n      font-weight: 700;\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:bold;")], ["\n      font-weight: 700;\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:bold;")])))
  }[fontWeight]);
}
function IndicatorNumber(_a) {
  var _b = _a.currentPage,
    currentPage = _b === void 0 ? 1 : _b,
    _c = _a.maxPage,
    maxPage = _c === void 0 ? 1 : _c,
    _d = _a.size,
    size = _d === void 0 ? 'small' : _d,
    _e = _a.dimmed,
    dimmed = _e === void 0 ? 'basic' : _e,
    _f = _a.fontWeight,
    fontWeight = _f === void 0 ? 'regular' : _f,
    children = _a.children,
    rest = __rest(_a, ["currentPage", "maxPage", "size", "dimmed", "fontWeight", "children"]);
  var theme = useTheme();
  return jsx("span", _assign({
    css: [cssSize$2(size), cssDimmed(dimmed, theme), cssFontWeight(fontWeight), /*#__PURE__*/css(templateObject_11$2 || (templateObject_11$2 = __makeTemplateObject(["\n          display: inline-flex;\n          align-items: center;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n          word-wrap: normal;\n          line-height: 0;\n          overflow: hidden;\n          max-width: 100%;\n          color: ", ";\n          box-sizing: border-box;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          display: inline-flex;\n          align-items: center;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n          word-wrap: normal;\n          line-height: 0;\n          overflow: hidden;\n          max-width: 100%;\n          color: ", ";\n          box-sizing: border-box;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), theme.content.white)]
  }, rest, {
    children: children || "".concat(currentPage, "/").concat(maxPage)
  }));
}
var templateObject_1$f, templateObject_2$e, templateObject_3$c, templateObject_4$b, templateObject_5$8, templateObject_6$7, templateObject_7$6, templateObject_8$5, templateObject_9$5, templateObject_10$4, templateObject_11$2;

function getGap(size) {
  return {
    small: 2,
    medium: 2,
    large: 4
  }[size];
}
function getIconSize(size) {
  return {
    small: 12,
    medium: 12,
    large: 18
  }[size];
}
function getIconName(fontWeight) {
  return {
    regular: 'add',
    bold: 'add_thick'
  }[fontWeight];
}
function cssSize$1(size) {
  return /*#__PURE__*/css(templateObject_4$a || (templateObject_4$a = __makeTemplateObject(["\n    ", "\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;")], ["\n    ", "\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;")])), {
    small: /*#__PURE__*/css(templateObject_1$e || (templateObject_1$e = __makeTemplateObject(["\n      padding: ", " ", " ", " ", ";\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:small;")], ["\n      padding: ", " ", " ", " ", ";\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:small;")])), pxToRem(4), pxToRem(6), pxToRem(4), pxToRem(8)),
    medium: /*#__PURE__*/css(templateObject_2$d || (templateObject_2$d = __makeTemplateObject(["\n      padding: ", " ", " ", " ", ";\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:medium;")], ["\n      padding: ", " ", " ", " ", ";\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:medium;")])), pxToRem(4), pxToRem(8), pxToRem(4), pxToRem(10)),
    large: /*#__PURE__*/css(templateObject_3$b || (templateObject_3$b = __makeTemplateObject(["\n      padding: ", " ", " ", " ", ";\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:large;")], ["\n      padding: ", " ", " ", " ", ";\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:large;")])), pxToRem(4), pxToRem(8), pxToRem(4), pxToRem(12))
  }[size]);
}
function cssIcon(size) {
  return /*#__PURE__*/css(templateObject_8$4 || (templateObject_8$4 = __makeTemplateObject(["\n  ", "\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssIcon;")], ["\n  ", "\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssIcon;")])), {
    small: /*#__PURE__*/css(templateObject_5$7 || (templateObject_5$7 = __makeTemplateObject(["\n      vertical-align: middle;\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:small;")], ["\n      vertical-align: middle;\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:small;")]))),
    medium: /*#__PURE__*/css(templateObject_6$6 || (templateObject_6$6 = __makeTemplateObject(["\n      vertical-align: middle;\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:medium;")], ["\n      vertical-align: middle;\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:medium;")]))),
    large: /*#__PURE__*/css(templateObject_7$5 || (templateObject_7$5 = __makeTemplateObject(["" + (process.env.NODE_ENV === "production" ? "" : ";label:large;")], ["" + (process.env.NODE_ENV === "production" ? "" : ";label:large;")])))
  }[size]);
}
function IndicatorNumberWithIcon(_a) {
  var currentPage = _a.currentPage,
    maxPage = _a.maxPage,
    _b = _a.size,
    size = _b === void 0 ? 'small' : _b,
    _c = _a.fontWeight,
    fontWeight = _c === void 0 ? 'regular' : _c,
    rest = __rest(_a, ["currentPage", "maxPage", "size", "fontWeight"]);
  return jsxs(IndicatorNumber, _assign({
    size: size,
    currentPage: currentPage,
    maxPage: maxPage,
    fontWeight: fontWeight,
    css: [cssSize$1(size), /*#__PURE__*/css(templateObject_9$4 || (templateObject_9$4 = __makeTemplateObject(["\n          cursor: pointer;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          cursor: pointer;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))]
  }, rest, {
    children: [jsxs("span", _assign({
      css: /*#__PURE__*/css(templateObject_10$3 || (templateObject_10$3 = __makeTemplateObject(["\n          vertical-align: middle;\n          margin-right: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          vertical-align: middle;\n          margin-right: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(getGap(size)))
    }, {
      children: [currentPage, "/", maxPage]
    })), jsx(Icon, {
      name: getIconName(fontWeight),
      size: getIconSize(size),
      css: cssIcon(size)
    })]
  }));
}
var templateObject_1$e, templateObject_2$d, templateObject_3$b, templateObject_4$a, templateObject_5$7, templateObject_6$6, templateObject_7$5, templateObject_8$4, templateObject_9$4, templateObject_10$3;

var visibleCount = 6;
function dotSize(index, maxPage, activeIndex) {
  var isLeftEnd = activeIndex < visibleCount / 2;
  var isRightEnd = activeIndex > maxPage - visibleCount / 2;
  var getVisibleCount = isLeftEnd || isRightEnd ? visibleCount : visibleCount + 1 ;
  var visibleStartIndex = function () {
    if (isLeftEnd) {
      return 0;
    } else if (isRightEnd) {
      return maxPage - getVisibleCount;
    } else {
      return activeIndex - Math.floor(getVisibleCount / 2);
    }
  }();
  var visibleLastIndex = visibleStartIndex + getVisibleCount - 1;
  var isCurrentDot = index === activeIndex;
  if (isCurrentDot) {
    return 8;
  }
  var isHiddenDot = index < visibleStartIndex || visibleLastIndex < index;
  if (isHiddenDot) {
    return 0;
  }
  var isMoreDot = isLeftEnd ? index === visibleLastIndex : isRightEnd ? index === visibleStartIndex : index === visibleStartIndex || index === visibleLastIndex;
  if (isMoreDot) {
    return 4;
  }
  return 6;
}
/**
 * ODS의 IndicatorDots 컴포넌트를 사용해 주세요.
 */
function IndicatorDots(_a) {
  var _b = _a.variant,
    variant = _b === void 0 ? 'basic' : _b,
    rest = __rest(_a, ["variant"]);
  var theme = useTheme();
  return makeIndicatorDots({
    dotSize: dotSize,
    dotBackgroundColor: variant === 'basic' ? theme.content.base3 : theme.dim.onDark.thick,
    activeDotBackgroundColor: variant === 'basic' ? theme.content.base1 : theme.content.white,
    boxShadow: variant === 'onDimmed' ? "".concat(pxToRem(0), " ").concat(pxToRem(1), " ").concat(pxToRem(6), " ").concat(theme.shadow.basic) : ''
  })(rest);
}

function MoreAnchor(_a) {
  var rest = __rest(_a, []);
  var theme = useTheme();
  return jsxs("a", _assign({
    css: [/*#__PURE__*/css(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["\n          color: ", ";\n          display: inline-block;\n          font-weight: 500;\n          padding: ", " ", ";\n          &:hover{\n            & > div:first-of-type {\n              background-color: ", ";\n            }\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          color: ", ";\n          display: inline-block;\n          font-weight: 500;\n          padding: ", " ", ";\n          &:hover{\n            & > div:first-of-type {\n              background-color: ", ";\n            }\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), theme.content.base1, pxToRem(6), pxToRem(16), theme.interactive.base4)]
  }, rest, {
    children: [jsx("div", _assign({
      css: /*#__PURE__*/css(templateObject_2$c || (templateObject_2$c = __makeTemplateObject(["\n        width: ", ";\n        height: ", ";\n        border-radius: ", ";\n        background-color: ", ";\n        margin-bottom: ", ";\n        position: relative;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        width: ", ";\n        height: ", ";\n        border-radius: ", ";\n        background-color: ", ";\n        margin-bottom: ", ";\n        position: relative;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(40), pxToRem(40), pxToRem(20), theme.content.base4, pxToRem(6))
    }, {
      children: jsx(Icon, {
        name: "arrow_right",
        size: 18,
        css: /*#__PURE__*/css(templateObject_3$a || (templateObject_3$a = __makeTemplateObject(["\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%, -50%);\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%, -50%);\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
      })
    })), jsx("div", _assign({
      css: FONT_STYLE.body2
    }, {
      children: "\uB354\uBCF4\uAE30"
    }))]
  }));
}
var templateObject_1$d, templateObject_2$c, templateObject_3$a;

function cssSize(size) {
  return /*#__PURE__*/css(templateObject_3$9 || (templateObject_3$9 = __makeTemplateObject(["\n  ", "\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;")], ["\n  ", "\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssSize;")])), {
    72: /*#__PURE__*/css(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n      border-radius: ", ";\n    "], ["\n      border-radius: ", ";\n    "])), pxToRem(24)),
    100: /*#__PURE__*/css(templateObject_2$b || (templateObject_2$b = __makeTemplateObject(["\n      border-radius: ", ";\n    "], ["\n      border-radius: ", ";\n    "])), pxToRem(32))
  }[size]);
}
function cssLabel(size) {
  return /*#__PURE__*/css(templateObject_4$9 || (templateObject_4$9 = __makeTemplateObject(["\n  ", "\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssLabel;")], ["\n  ", "\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssLabel;")])), {
    72: FONT_STYLE.subTitle2,
    100: FONT_STYLE.subTitle1
  }[size]);
}
function ThumbnailAnchor(_a) {
  var thumbnail = _a.thumbnail,
    size = _a.size,
    label = _a.label,
    _b = _a.hasHoverEffect,
    hasHoverEffect = _b === void 0 ? true : _b,
    _c = _a.hasBorder,
    hasBorder = _c === void 0 ? true : _c,
    active = _a.active,
    children = _a.children,
    rest = __rest(_a, ["thumbnail", "size", "label", "hasHoverEffect", "hasBorder", "active", "children"]);
  var theme = useTheme();
  return jsxs("a", _assign({
    css: [/*#__PURE__*/css(templateObject_5$6 || (templateObject_5$6 = __makeTemplateObject(["\n          display: flex;\n          flex-direction: column;\n          margin-top: ", ";\n          max-width: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          display: flex;\n          flex-direction: column;\n          margin-top: ", ";\n          max-width: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(12), pxToRem(size)), hasHoverEffect && HOVER(templateObject_6$5 || (templateObject_6$5 = __makeTemplateObject(["\n          & > div:first-of-type:after {\n            border: ", " solid ", ";\n          }\n          & > div:first-of-type > figure {\n            transition: transform ease-in-out 0.2s;\n            transform: scale(1.05);\n          }\n        "], ["\n          & > div:first-of-type:after {\n            border: ", " solid ", ";\n          }\n          & > div:first-of-type > figure {\n            transition: transform ease-in-out 0.2s;\n            transform: scale(1.05);\n          }\n        "])), pxToRem(2), theme.content.primary1.basic), active && /*#__PURE__*/css(templateObject_7$4 || (templateObject_7$4 = __makeTemplateObject(["\n          & > div:first-of-type:after {\n            border: ", " solid ", ";\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          & > div:first-of-type:after {\n            border: ", " solid ", ";\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(2), theme.content.primary1.basic)]
  }, rest, {
    children: [jsx("div", _assign({
      css: [/*#__PURE__*/css(templateObject_8$3 || (templateObject_8$3 = __makeTemplateObject(["\n            overflow: hidden;\n            position: relative;\n            box-sizing: border-box;\n            width: ", ";\n            height: ", ";\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            overflow: hidden;\n            position: relative;\n            box-sizing: border-box;\n            width: ", ";\n            height: ", ";\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(size), pxToRem(size)), hasBorder && /*#__PURE__*/css(templateObject_9$3 || (templateObject_9$3 = __makeTemplateObject(["\n            &:after {\n              content: \"\";\n              position: absolute;\n              top: 0;\n              left: 0;\n              right: 0;\n              bottom: 0;\n              border-radius: inherit;\n              border: ", " solid ", ";\n            }\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            &:after {\n              content: \"\";\n              position: absolute;\n              top: 0;\n              left: 0;\n              right: 0;\n              bottom: 0;\n              border-radius: inherit;\n              border: ", " solid ", ";\n            }\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(1), theme.outline), cssSize(size)]
    }, {
      children: jsx(Image, {
        src: thumbnail,
        aspectRatio: "1:1",
        css: /*#__PURE__*/css(templateObject_10$2 || (templateObject_10$2 = __makeTemplateObject(["\n            box-sizing: border-box;\n            border-radius: inherit;\n            width: ", ";\n            height: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            box-sizing: border-box;\n            border-radius: inherit;\n            width: ", ";\n            height: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(size), pxToRem(size))
      })
    })), label && jsx("div", _assign({
      css: [cssLabel(size), /*#__PURE__*/css(templateObject_11$1 || (templateObject_11$1 = __makeTemplateObject(["\n            text-align: center;\n            margin-top: ", ";\n            color: ", ";\n            overflow: hidden;\n            word-break: break-all;\n            text-overflow: ellipsis;\n            display: -webkit-box;\n            -webkit-line-clamp: 2;\n            -webkit-box-orient: vertical;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            text-align: center;\n            margin-top: ", ";\n            color: ", ";\n            overflow: hidden;\n            word-break: break-all;\n            text-overflow: ellipsis;\n            display: -webkit-box;\n            -webkit-line-clamp: 2;\n            -webkit-box-orient: vertical;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(10), theme.content.base1)]
    }, {
      children: label
    })), children]
  }));
}
var templateObject_1$c, templateObject_2$b, templateObject_3$9, templateObject_4$9, templateObject_5$6, templateObject_6$5, templateObject_7$4, templateObject_8$3, templateObject_9$3, templateObject_10$2, templateObject_11$1;

function cssBadgePosition(badgePosition) {
  if (badgePosition === void 0) {
    badgePosition = 'right';
  }
  return /*#__PURE__*/css(templateObject_3$8 || (templateObject_3$8 = __makeTemplateObject(["\n  ", "\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssBadgePosition;")], ["\n  ", "\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:cssBadgePosition;")])), {
    center: /*#__PURE__*/css(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n      top: ", ";\n      left: 50%;\n      transform: translateX(-50%);\n      position: absolute;\n      display: flex;\n      min-width: fit-content;\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:center;")], ["\n      top: ", ";\n      left: 50%;\n      transform: translateX(-50%);\n      position: absolute;\n      display: flex;\n      min-width: fit-content;\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:center;")])), pxToRem(-12)),
    right: /*#__PURE__*/css(templateObject_2$a || (templateObject_2$a = __makeTemplateObject(["\n      top: 0;\n      right: 0;\n      position: absolute;\n      display: flex;\n      min-width: fit-content;\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:right;")], ["\n      top: 0;\n      right: 0;\n      position: absolute;\n      display: flex;\n      min-width: fit-content;\n    " + (process.env.NODE_ENV === "production" ? "" : ";label:right;")])))
  }[badgePosition]);
}
function withBadge(Component, cssBadgeVariant) {
  return function (_a) {
    var rest = __rest(_a, []);
    var badge = rest.badge,
      props = __rest(rest, ["badge"]);
    return jsxs(Component, _assign({}, props, {
      css: /*#__PURE__*/css(templateObject_4$8 || (templateObject_4$8 = __makeTemplateObject(["position: relative;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["position: relative;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
    }, {
      children: [badge.component === 'SquareBadge' && jsx(SquareBadge, _assign({
        size: 24
      }, badge, {
        css: [cssBadgePosition(badge.position), cssBadgeVariant(rest)]
      }, {
        children: badge.label
      })), badge.component === 'PillBadge' && jsx(PillBadge, _assign({
        size: 24
      }, badge, {
        css: [cssBadgePosition(badge.position), cssBadgeVariant(rest)]
      }, {
        children: badge.label
      }))]
    }));
  };
}
var templateObject_1$b, templateObject_2$a, templateObject_3$8, templateObject_4$8;

function cssBadgeVariant(size, position) {
  if (position === void 0) {
    position = 'right';
  }
  return /*#__PURE__*/css(templateObject_5$5 || (templateObject_5$5 = __makeTemplateObject(["\n  ", "" + (process.env.NODE_ENV === "production" ? "" : ";label:cssBadgeVariant;")], ["\n  ", "" + (process.env.NODE_ENV === "production" ? "" : ";label:cssBadgeVariant;")])), {
    center: /*#__PURE__*/css(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["" + (process.env.NODE_ENV === "production" ? "" : ";label:center;")], ["" + (process.env.NODE_ENV === "production" ? "" : ";label:center;")]))),
    right: /*#__PURE__*/css(templateObject_4$7 || (templateObject_4$7 = __makeTemplateObject(["\n  ", "" + (process.env.NODE_ENV === "production" ? "" : ";label:right;")], ["\n  ", "" + (process.env.NODE_ENV === "production" ? "" : ";label:right;")])), {
      72: /*#__PURE__*/css(templateObject_2$9 || (templateObject_2$9 = __makeTemplateObject(["\n    top: ", ";\n    right: ", ";\n  "], ["\n    top: ", ";\n    right: ", ";\n  "])), pxToRem(-8), pxToRem(-8)),
      100: /*#__PURE__*/css(templateObject_3$7 || (templateObject_3$7 = __makeTemplateObject(["\n    top: ", ";\n    right: ", ";\n  "], ["\n    top: ", ";\n    right: ", ";\n  "])), pxToRem(-6), pxToRem(-6))
    }[size])
  }[position]);
}
var ThumbnailAnchorWithBadge = withBadge(ThumbnailAnchor, function (_a) {
  var size = _a.size,
    badge = _a.badge;
  return cssBadgeVariant(size, badge.position);
});
var templateObject_1$a, templateObject_2$9, templateObject_3$7, templateObject_4$7, templateObject_5$5;

var DEFAULT_AUTO_PLAY_INTERVAL = 3000;

/**
 * 현재 캐러셀에서 가능한 currentOffset의 범위를 계산합니다.
 * @return [가능한 currentOffset의 최솟값, 가능한 currentOffset의 최댓값]
 */
var getCurrentOffsetBounds = function getCurrentOffsetBounds(_a) {
  var align = _a.align,
    _b = _a.itemRatio,
    itemRatio = _b === void 0 ? 1 : _b,
    _c = _a.edgeSpaceRatio,
    edgeSpaceRatio = _c === void 0 ? 0 : _c,
    childrenLength = _a.childrenLength;
  var visibleChildrenCount = 1 / itemRatio;
  switch (align) {
    case 'centerConstrained':
      {
        var left = (visibleChildrenCount - 1) / 2;
        return [left - edgeSpaceRatio, Math.max(0, childrenLength - visibleChildrenCount) + left + edgeSpaceRatio];
      }
    case 'left':
      return [0, Math.max(0, childrenLength - visibleChildrenCount)];
    case 'center':
      return [0, Math.max(0, childrenLength - 1)];
    default:
      return [0, 0];
  }
};

function useOffset(_a) {
  var loop = _a.loop,
    childrenLength = _a.childrenLength,
    align = _a.align,
    _b = _a.itemRatio,
    itemRatio = _b === void 0 ? 1 : _b,
    _c = _a.edgeSpaceRatio,
    edgeSpaceRatio = _c === void 0 ? 0 : _c;
  var _d = useMemo(function () {
      return getCurrentOffsetBounds({
        align: align,
        itemRatio: itemRatio,
        edgeSpaceRatio: edgeSpaceRatio,
        childrenLength: childrenLength
      });
    }, [align, edgeSpaceRatio, itemRatio, childrenLength]),
    minCurrentOffset = _d[0],
    maxCurrentOffset = _d[1];
  var getLimitOffset = useCallback(function (offset) {
    if (!loop) {
      return Math.min(maxCurrentOffset, Math.max(minCurrentOffset, offset));
    }
    return offset;
  }, [loop, minCurrentOffset, maxCurrentOffset]);
  var getLimitOffsetData = useCallback(function (prevOffset, newOffset) {
    var fromOffset = getLimitOffset(prevOffset);
    var toOffset = typeof newOffset === 'number' ? getLimitOffset(newOffset) : null;
    return {
      currentOffset: fromOffset,
      fromOffset: fromOffset,
      toOffset: toOffset
    };
  }, [getLimitOffset]);
  var getMinMaxOffset = function getMinMaxOffset(offsetData) {
    var currentOffset = offsetData.currentOffset,
      fromOffset = offsetData.fromOffset,
      toOffset = offsetData.toOffset;
    var offset = currentOffset;
    var newToOffset = toOffset;
    if (!loop) {
      offset = Math.min(maxCurrentOffset, Math.max(minCurrentOffset, offset));
      if (newToOffset !== null) {
        newToOffset = Math.min(maxCurrentOffset, Math.max(minCurrentOffset, newToOffset));
      }
    }
    var minOffset = offset;
    var maxOffset = offset;
    if (newToOffset !== null && fromOffset !== null) {
      minOffset = Math.min(offset, fromOffset, newToOffset);
      maxOffset = Math.max(offset, fromOffset, newToOffset);
    }
    return [minOffset, maxOffset];
  };
  var offsetMargin = useMemo(function () {
    if (['center', 'centerConstrained'].includes(align)) {
      return (1 - itemRatio) / (2 * itemRatio);
    }
    return 0;
  }, [align, itemRatio]);
  return {
    getLimitOffset: getLimitOffset,
    getLimitOffsetData: getLimitOffsetData,
    getMinMaxOffset: getMinMaxOffset,
    offsetMargin: offsetMargin
  };
}

function useInteract(_a) {
  var align = _a.align,
    _b = _a.itemRatio,
    itemRatio = _b === void 0 ? 1 : _b,
    _c = _a.edgeSpaceRatio,
    edgeSpaceRatio = _c === void 0 ? 0 : _c,
    loop = _a.loop,
    disableSwipe = _a.disableSwipe,
    childrenLength = _a.childrenLength,
    setOffsetData = _a.setOffsetData,
    onDrag = _a.onDrag,
    onEnd = _a.onEnd;
  var interactRef = useRef(null);
  var lastVelocityX = useRef(0);
  var baseProps = {
    align: align,
    loop: loop,
    itemRatio: itemRatio,
    edgeSpaceRatio: edgeSpaceRatio,
    childrenLength: childrenLength
  };
  var _d = getCurrentOffsetBounds(baseProps),
    minCurrentOffset = _d[0],
    maxCurrentOffset = _d[1];
  var getLimitOffsetData = useOffset(baseProps).getLimitOffsetData;
  var handlePan = useCallback(function (event) {
    onDrag === null || onDrag === void 0 ? void 0 : onDrag(event);
    setOffsetData(function (_a) {
      var _b, _c;
      var fromOffset = _a.fromOffset,
        currentOffset = _a.currentOffset;
      if (fromOffset === null) {
        return {
          currentOffset: currentOffset,
          fromOffset: fromOffset,
          toOffset: null
        };
      }
      var _d = ((_c = (_b = interactRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect()) !== null && _c !== void 0 ? _c : {}).width,
        width = _d === void 0 ? 0 : _d;
      var dx = event.dx,
        velocityX = event.velocityX;
      var newOffset = fromOffset - dx / width / itemRatio;
      lastVelocityX.current = velocityX;
      return {
        currentOffset: newOffset,
        fromOffset: fromOffset,
        toOffset: null
      };
    });
  }, [itemRatio, onDrag, setOffsetData]);
  var handlePanEnd = useCallback(function (event) {
    onEnd === null || onEnd === void 0 ? void 0 : onEnd(event);
    setOffsetData(function (_a) {
      var fromOffset = _a.fromOffset,
        currentOffset = _a.currentOffset;
      if (fromOffset === null) {
        return {
          currentOffset: currentOffset,
          fromOffset: fromOffset,
          toOffset: null
        };
      }
      var velocity = event.velocity;
      var newOffset = Math.round(currentOffset);
      var direction = velocity.x < 0 ? 'right' : 'left';
      if (Math.abs(lastVelocityX.current) > 0.5 || Math.abs(event.velocityX) > 0.5) {
        newOffset = direction === 'left' ? Math.floor(currentOffset) : Math.ceil(currentOffset);
      }
      var offsetDelta;
      if (!loop) {
        if (currentOffset < minCurrentOffset) {
          offsetDelta = -Math.log(-currentOffset + minCurrentOffset + 1) / Math.log(8);
        } else if (currentOffset > maxCurrentOffset) {
          offsetDelta = Math.log(currentOffset - maxCurrentOffset + 1) / Math.log(8);
        }
      }
      lastVelocityX.current = 0;
      return getLimitOffsetData(currentOffset, newOffset, offsetDelta);
    });
  }, [getLimitOffsetData, loop, maxCurrentOffset, minCurrentOffset, onEnd, setOffsetData]);
  var handleInteract = useCallback(function (event) {
    var isScrolling = Math.abs(event.dy) > Math.abs(event.dx);
    if (isScrolling) {
      event.preventDefault();
      handlePanEnd(event);
      return;
    }
    switch (event.type) {
      case 'dragstart':
        setOffsetData(function (_a) {
          var currentOffset = _a.currentOffset;
          return getLimitOffsetData(currentOffset, null);
        });
        break;
      case 'dragmove':
        handlePan(event);
        break;
      case 'dragend':
        handlePanEnd(event);
        break;
    }
  }, [getLimitOffsetData, handlePan, handlePanEnd, setOffsetData]);
  useEffect(function () {
    if (disableSwipe) return;
    var node = interactRef.current;
    if (node) {
      interact(node).draggable({
        onstart: function onstart(event) {
          return handleInteract(event);
        },
        onmove: function onmove(event) {
          return handleInteract(event);
        },
        onend: function onend(event) {
          return handleInteract(event);
        },
        startAxis: 'x'
      });
    }
    return function () {
      if (node) {
        interact(node).unset();
      }
      lastVelocityX.current = 0;
    };
  }, [disableSwipe, handleInteract]);
  return {
    interactRef: interactRef
  };
}

function useAutoPlay(_a) {
  var autoPlay = _a.autoPlay,
    autoPlayInterval = _a.autoPlayInterval,
    move = _a.move;
  var autoPlayRef = useRef(null);
  var cleanupAutoPlay = useCallback(function () {
    if (autoPlayRef.current) {
      window.clearInterval(autoPlayRef.current);
      autoPlayRef.current = null;
    }
  }, []);
  var setupAutoPlay = useCallback(function () {
    if (!autoPlayRef.current) {
      autoPlayRef.current = window.setInterval(function () {
        return move('right');
      }, autoPlayInterval);
    }
  }, [autoPlayInterval, move]);
  useEffect(function () {
    if (autoPlay) {
      setupAutoPlay();
    }
    return function () {
      return cleanupAutoPlay();
    };
  }, [autoPlay, cleanupAutoPlay, setupAutoPlay]);
  return {
    cleanupAutoPlay: cleanupAutoPlay,
    setupAutoPlay: setupAutoPlay
  };
}

var Carousel = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _a = props.itemRatio,
    initialItemRatio = _a === void 0 ? 1 : _a,
    _b = props.edgeSpaceRatio,
    edgeSpaceRatio = _b === void 0 ? 0 : _b,
    _c = props.duration,
    initialDuration = _c === void 0 ? 350 : _c,
    _d = props.loop,
    loop = _d === void 0 ? false : _d,
    _e = props.autoPlay,
    autoPlay = _e === void 0 ? false : _e,
    _f = props.autoPlayInterval,
    autoPlayInterval = _f === void 0 ? DEFAULT_AUTO_PLAY_INTERVAL : _f,
    _g = props.align,
    align = _g === void 0 ? 'center' : _g,
    children = props.children,
    renderControl = props.renderControl,
    renderPagination = props.renderPagination,
    className = props.className,
    initialOffset = props.initialOffset,
    onOffsetChange = props.onOffsetChange,
    _h = props.disableSwipe,
    disableSwipe = _h === void 0 ? false : _h,
    renderEdgeDecoration = props.renderEdgeDecoration,
    nodeRef = props.nodeRef,
    length = props.length,
    _j = props.preloadCount,
    preloadCount = _j === void 0 ? 0 : _j,
    onRowsRendered = props.onRowsRendered;
  var _k = useState({
      // 현재 offset
      currentOffset: initialOffset !== null && initialOffset !== void 0 ? initialOffset : 0,
      // duration 시작 전 offset
      fromOffset: null,
      // duration 끝나고 최종적으로 변경될 offset
      toOffset: null
    }),
    offsetData = _k[0],
    setOffsetData = _k[1];
  var _l = useState(0),
    progressOffset = _l[0],
    setProgressOffset = _l[1];
  var _m = useState(initialDuration),
    duration = _m[0],
    setDuration = _m[1];
  var currentOffset = offsetData.currentOffset,
    fromOffset = offsetData.fromOffset,
    toOffset = offsetData.toOffset;
  var childrenList = React__default.Children.toArray(children);
  if (!loop && renderEdgeDecoration) {
    childrenList = __spreadArray(__spreadArray([renderEdgeDecoration(0)], childrenList, true), [renderEdgeDecoration(childrenList.length + 1)], false);
  }
  var childrenLength = length !== null && length !== void 0 ? length : childrenList.length;
  var itemRatio = initialItemRatio === 0 ? 1 : Math.min(initialItemRatio, 1);
  var visibleChildrenCount = 1 / itemRatio;
  var baseProps = {
    align: align,
    loop: loop,
    itemRatio: itemRatio,
    edgeSpaceRatio: edgeSpaceRatio,
    childrenLength: childrenLength
  };
  var _o = getCurrentOffsetBounds(baseProps),
    minCurrentOffset = _o[0],
    maxCurrentOffset = _o[1];
  var _p = useOffset(baseProps),
    getLimitOffset = _p.getLimitOffset,
    getLimitOffsetData = _p.getLimitOffsetData,
    getMinMaxOffset = _p.getMinMaxOffset,
    offsetMargin = _p.offsetMargin;
  var centerOffset = loop ? (Math.round(currentOffset) % childrenLength + childrenLength) % childrenLength : Math.round(currentOffset);
  var move = useCallback(function (direction, delta) {
    if (delta === void 0) {
      delta = 1;
    }
    setDuration(null);
    setOffsetData(function (_a) {
      var currentOffset = _a.currentOffset;
      var deltaOffset = Math.abs(delta) * (direction === 'right' ? 1 : -1);
      var newOffset = Math.round(currentOffset + deltaOffset);
      return getLimitOffsetData(currentOffset, newOffset);
    });
  }, [getLimitOffsetData]);
  var _q = useAutoPlay({
      autoPlay: autoPlay,
      autoPlayInterval: autoPlayInterval,
      move: move
    }),
    cleanupAutoPlay = _q.cleanupAutoPlay,
    setupAutoPlay = _q.setupAutoPlay;
  var isDragging = useRef(false);
  var handleDrag = useCallback(function () {
    isDragging.current = true;
    setDuration(null);
    if (autoPlay) {
      cleanupAutoPlay();
    }
  }, [autoPlay, cleanupAutoPlay]);
  var handleDragEnd = useCallback(function () {
    if (autoPlay) {
      setupAutoPlay();
    }
    setTimeout(function () {
      isDragging.current = false;
    });
  }, [autoPlay, setupAutoPlay]);
  var interactRef = useInteract(_assign(_assign({}, baseProps), {
    disableSwipe: disableSwipe,
    setOffsetData: setOffsetData,
    onDrag: handleDrag,
    onEnd: handleDragEnd
  })).interactRef;
  var _r = getMinMaxOffset(offsetData),
    minOffset = _r[0],
    maxOffset = _r[1];
  var baseOffset = minOffset - offsetMargin - preloadCount;
  var startIndex = Math.floor(baseOffset);
  var renderedItemCount = useMemo(function () {
    return Math.ceil(baseOffset + visibleChildrenCount + (maxOffset - minOffset) + 2 * preloadCount) - startIndex;
  }, [baseOffset, maxOffset, minOffset, startIndex, preloadCount, visibleChildrenCount]);
  var isOverflow = useCallback(function (offset) {
    return !loop && (offset < 0 || offset > childrenLength - 1);
  }, [childrenLength, loop]);
  var virtualChildren = useMemo(function () {
    if (onRowsRendered) {
      onRowsRendered(startIndex, startIndex + renderedItemCount - 1);
    }
    return Array.from({
      length: Math.ceil(renderedItemCount)
    }).map(function (_, renderedIndex) {
      /** 전체 캐러셀 아이템 중 기준 아이템(baseOffset이 0) 위치 기준으로 측정된 index
       * @example
       * 전체 캐러셀 아이템이 10개 이고, 화면에 노출 중인 아이템 2개, preload count가 2이라면
       * |--preload 아이템--|--preload 아이템--|--노출 중인 아이템--|--노출 중인 아이템--|--preload 아이템--|--preload 아이템--|
       *  actualIndex: -2   actualIndex: -1   actualIndex: 0   actualIndex: 1   actualIndex: 2   actualIndex: 3
       *  index: 8          index: 9         index: 0          index: 1          index: 2         index: 3
       */
      var actualIndex = startIndex + renderedIndex;
      /** 전체 캐러셀 아이템 리스트에서 몇 번째 인지 */
      var index = (startIndex % childrenLength + childrenLength + renderedIndex) % childrenLength;
      return jsx(CarouselListItem, _assign({
        css: /*#__PURE__*/css(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["width: ", "%;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["width: ", "%;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), itemRatio * 100),
        role: "group",
        "aria-roledescription": "slide",
        "aria-label": "".concat(index, " of ").concat(childrenLength),
        onClickCapture: function onClickCapture(e) {
          if (isDragging.current) {
            e.preventDefault();
            e.stopPropagation();
          }
        }
      }, {
        children: !isOverflow(actualIndex) && childrenList[index]
      }), actualIndex);
    });
  }, [renderedItemCount, startIndex, childrenLength, childrenList, itemRatio, isOverflow, onRowsRendered]);
  var set = function set(targetOffset) {
    var deltaOffset = currentOffset - targetOffset;
    var direction = deltaOffset <= 0 ? 'right' : 'left';
    move(direction, deltaOffset);
  };
  var getProgress = useCallback(function () {
    var offset = loop ? currentOffset : Math.min(maxCurrentOffset, Math.max(minCurrentOffset, currentOffset));
    var baseOffset = minOffset - offsetMargin;
    var progressOffset = (baseOffset - startIndex + (offset - minOffset)) * itemRatio;
    return progressOffset;
  }, [itemRatio, currentOffset, loop, minOffset, minCurrentOffset, maxCurrentOffset, offsetMargin, startIndex]);
  var handleTransitionEnd = function handleTransitionEnd() {
    if (onOffsetChange) {
      onOffsetChange(currentOffset);
    }
    setOffsetData(function (_a) {
      var currentOffset = _a.currentOffset;
      return {
        currentOffset: currentOffset,
        fromOffset: null,
        toOffset: null
      };
    });
    setDuration(null);
  };
  useEffect(function () {
    if (loop) {
      return;
    }
    setOffsetData(function (_a) {
      var currentOffset = _a.currentOffset,
        toOffset = _a.toOffset;
      return getLimitOffsetData(currentOffset, toOffset);
    });
  }, [align, getLimitOffsetData, loop]);
  useEffect(function () {
    var animationId = requestAnimationFrame(function () {
      if (toOffset === null) {
        return;
      }
      setDuration(initialDuration);
      setOffsetData(function (_a) {
        var toOffset = _a.toOffset,
          currentOffset = _a.currentOffset;
        return {
          currentOffset: toOffset !== null && toOffset !== void 0 ? toOffset : currentOffset,
          fromOffset: fromOffset,
          toOffset: toOffset
        };
      });
    });
    return function () {
      return cancelAnimationFrame(animationId);
    };
  }, [toOffset, currentOffset, fromOffset, initialDuration]);
  useLayoutEffect(function () {
    var progress = getProgress();
    setProgressOffset(progress);
  }, [currentOffset, toOffset, getProgress]);
  useImperativeHandle(ref, function () {
    return {
      set: set
    };
  });
  var controlProps = {
    prev: function prev(countOfSlides) {
      return move('left', countOfSlides);
    },
    next: function next(countOfSlides) {
      return move('right', countOfSlides);
    },
    set: set,
    offset: getLimitOffset(centerOffset),
    length: childrenLength,
    isLeftEnd: !loop && getLimitOffset(fromOffset !== null && fromOffset !== void 0 ? fromOffset : currentOffset) === minCurrentOffset,
    isRightEnd: !loop && getLimitOffset(fromOffset !== null && fromOffset !== void 0 ? fromOffset : currentOffset) === maxCurrentOffset
  };
  var paginationProps = {
    currentPage: Math.floor(currentOffset) % childrenLength + 1,
    maxPage: childrenLength,
    onClick: function onClick(index) {
      return set(index);
    }
  };
  return jsxs(Container$1, _assign({
    role: "region",
    "aria-roledescription": "carousel",
    className: className,
    ref: function ref(node) {
      if (nodeRef) {
        nodeRef(node);
      }
    }
  }, {
    children: [jsx(CarouselListWrapper, _assign({
      ref: interactRef
    }, {
      children: jsx(CarouselList, _assign({
        style: {
          transform: "translateX(".concat(progressOffset * -100, "%)"),
          transition: "".concat(duration ? "transform ".concat(duration, "ms") : '')
        },
        onTransitionEnd: handleTransitionEnd,
        "aria-live": autoPlay ? 'off' : 'polite'
      }, {
        children: virtualChildren
      }))
    })), renderControl && renderControl(controlProps), renderPagination && jsx(Pagination, _assign({
      css: renderPagination(paginationProps).props.variant === 'onDimmed' ? {
        top: "".concat(pxToRem(-18))
      } : undefined
    }, {
      children: renderPagination(paginationProps)
    }))]
  }));
});
var Container$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ec0uc7i4"
} : {
  target: "ec0uc7i4",
  label: "Container"
})(templateObject_2$8 || (templateObject_2$8 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var CarouselListWrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ec0uc7i3"
} : {
  target: "ec0uc7i3",
  label: "CarouselListWrapper"
})(templateObject_3$6 || (templateObject_3$6 = __makeTemplateObject(["\n  overflow: hidden;\n"], ["\n  overflow: hidden;\n"])));
var CarouselList = /*#__PURE__*/_styled("ul", process.env.NODE_ENV === "production" ? {
  target: "ec0uc7i2"
} : {
  target: "ec0uc7i2",
  label: "CarouselList"
})(templateObject_4$6 || (templateObject_4$6 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: stretch;\n  min-height: 100%;\n  padding: 0;\n  margin: 0;\n"], ["\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: stretch;\n  min-height: 100%;\n  padding: 0;\n  margin: 0;\n"])));
var CarouselListItem = /*#__PURE__*/_styled("li", process.env.NODE_ENV === "production" ? {
  target: "ec0uc7i1"
} : {
  target: "ec0uc7i1",
  label: "CarouselListItem"
})(templateObject_5$4 || (templateObject_5$4 = __makeTemplateObject(["\n  flex: 0 0 auto;\n  -moz-user-select: -moz-none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0;\n  margin: 0;\n  * {\n    -webkit-user-drag: none;\n    -khtml-user-drag: none;\n    -moz-user-drag: none;\n    -o-user-drag: none;\n    user-drag: none;\n  }\n"], ["\n  flex: 0 0 auto;\n  -moz-user-select: -moz-none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0;\n  margin: 0;\n  * {\n    -webkit-user-drag: none;\n    -khtml-user-drag: none;\n    -moz-user-drag: none;\n    -o-user-drag: none;\n    user-drag: none;\n  }\n"])));
var Pagination = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ec0uc7i0"
} : {
  target: "ec0uc7i0",
  label: "Pagination"
})(templateObject_6$4 || (templateObject_6$4 = __makeTemplateObject(["\n  position: relative;\n  top: ", ";\n"], ["\n  position: relative;\n  top: ", ";\n"])), pxToRem(18));
var templateObject_1$9, templateObject_2$8, templateObject_3$6, templateObject_4$6, templateObject_5$4, templateObject_6$4;

/**
 * @deprecated ODS의 IconButton을 사용해주세요. 만약 디자인상 ODS의 IconButton을 사용할 수 없는 경우, 디자인시스템 담당 디자이너에게 문의해주세요.
 */
function IconButton(_a) {
  var _b;
  var size = _a.size,
    icon = _a.icon,
    rest = __rest(_a, ["size", "icon"]);
  return jsx(Button$2, _assign({}, rest, {
    size: size,
    css: cssBaseIconButton(size)
  }, {
    children: jsx(Icon, {
      size: (_b = icon.size) !== null && _b !== void 0 ? _b : 18,
      name: icon.name,
      fill: icon === null || icon === void 0 ? void 0 : icon.fill
    })
  }));
}

function cssButton(theme, variant) {
  switch (variant) {
    case 'basic':
      return /*#__PURE__*/css(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n        border-radius: ", ";\n        background-color: ", ";\n        box-shadow: 0 ", " ", " ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssButton;")], ["\n        border-radius: ", ";\n        background-color: ", ";\n        box-shadow: 0 ", " ", " ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssButton;")])), pxToRem(24), theme.content.base6, pxToRem(2), pxToRem(5), theme.shadow.basic);
    case 'onContents':
      return /*#__PURE__*/css(templateObject_2$7 || (templateObject_2$7 = __makeTemplateObject(["\n        border-radius: ", ";\n        background-color: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssButton;")], ["\n        border-radius: ", ";\n        background-color: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssButton;")])), pxToRem(24), theme.dim.thin);
    case 'list':
      return /*#__PURE__*/css(templateObject_3$5 || (templateObject_3$5 = __makeTemplateObject(["\n        background-color: ", ";\n        border: ", " solid ", ";\n        border-radius: 0;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssButton;")], ["\n        background-color: ", ";\n        border: ", " solid ", ";\n        border-radius: 0;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:cssButton;")])), theme.content.base6, pxToRem(1), theme.content.base4);
  }
}
function cssHoverButton(theme, variant) {
  switch (variant) {
    case 'basic':
      return HOVER(templateObject_4$5 || (templateObject_4$5 = __makeTemplateObject(["\n          background-color: ", ";\n      "], ["\n          background-color: ", ";\n      "])), theme.interactive.transparent);
    case 'onContents':
      return HOVER(templateObject_5$3 || (templateObject_5$3 = __makeTemplateObject(["\n        background-color: ", ";\n      "], ["\n        background-color: ", ";\n      "])), theme.dim.basic);
    case 'list':
      return HOVER(templateObject_6$3 || (templateObject_6$3 = __makeTemplateObject(["\n        background-color: ", ";\n      "], ["\n        background-color: ", ";\n      "])), theme.interactive.transparent);
  }
}
function cssFont(theme, variant) {
  switch (variant) {
    case 'basic':
      return theme.content.base1;
    case 'onContents':
      return theme.content.white;
    case 'list':
      return theme.content.base1;
  }
}
function CarouselControlButton(_a) {
  var iconName = _a.iconName,
    position = _a.position,
    _b = _a.hidden,
    hidden = _b === void 0 ? false : _b,
    _c = _a.variant,
    variant = _c === void 0 ? 'basic' : _c,
    className = _a.className,
    rest = __rest(_a, ["iconName", "position", "hidden", "variant", "className"]);
  var theme = useTheme();
  return jsx("div", _assign({
    css: [/*#__PURE__*/css(templateObject_7$3 || (templateObject_7$3 = __makeTemplateObject(["\n          position: absolute;\n          top: 50%;\n          transform: translate(-50%, -50%);\n          left: ", "%;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          position: absolute;\n          top: 50%;\n          transform: translate(-50%, -50%);\n          left: ", "%;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), position === 'left' ? '0' : '100'), hidden && /*#__PURE__*/css(templateObject_8$2 || (templateObject_8$2 = __makeTemplateObject(["display: none;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["display: none;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))],
    className: className
  }, {
    children: jsx(IconButton, _assign({
      type: "button",
      size: 50,
      variant: "primary1",
      icon: {
        name: iconName,
        size: 24,
        fill: function fill(theme) {
          return cssFont(theme, variant);
        }
      },
      css: [/*#__PURE__*/css(templateObject_9$2 || (templateObject_9$2 = __makeTemplateObject(["\n            width: ", ";\n            height: ", ";\n            display: flex;\n            align-items: center;\n            justify-content:center;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            width: ", ";\n            height: ", ";\n            display: flex;\n            align-items: center;\n            justify-content:center;\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(48), pxToRem(48)), cssButton(theme, variant), cssHoverButton(theme, variant)]
    }, rest))
  }));
}
var templateObject_1$8, templateObject_2$7, templateObject_3$5, templateObject_4$5, templateObject_5$3, templateObject_6$3, templateObject_7$3, templateObject_8$2, templateObject_9$2;

function CarouselControl(_a) {
  var prev = _a.prev,
    next = _a.next,
    variant = _a.variant,
    _b = _a.isLeftEnd,
    isLeftEnd = _b === void 0 ? false : _b,
    _c = _a.isRightEnd,
    isRightEnd = _c === void 0 ? false : _c;
  return jsxs(Fragment$1, {
    children: [jsx(CarouselControlButton, {
      iconName: "chevron_left",
      position: "left",
      onClick: function onClick() {
        return prev();
      },
      "aria-label": "\uC774\uC804",
      variant: variant,
      hidden: isLeftEnd
    }), jsx(CarouselControlButton, {
      iconName: "chevron_right",
      position: "right",
      onClick: function onClick() {
        return next();
      },
      "aria-label": "\uB2E4\uC74C",
      variant: variant,
      hidden: isRightEnd
    })]
  });
}

var CarouselScrollControl = /*#__PURE__*/React__default.forwardRef(function (_a, ref) {
  var contentRef = _a.contentRef,
    children = _a.children,
    _b = _a.gradation,
    gradation = _b === void 0 ? true : _b,
    _c = _a.gap,
    gap = _c === void 0 ? 8 : _c,
    _d = _a.fixed,
    fixed = _d === void 0 ? false : _d,
    _e = _a.variant,
    variant = _e === void 0 ? 'basic' : _e,
    _f = _a.hiddenBreakpoints,
    hiddenBreakpoints = _f === void 0 ? ['mobile', 'tablet'] : _f,
    className = _a.className,
    contentClassName = _a.contentClassName,
    itemClassName = _a.itemClassName,
    buttonClassName = _a.buttonClassName,
    rest = __rest(_a, ["contentRef", "children", "gradation", "gap", "fixed", "variant", "hiddenBreakpoints", "className", "contentClassName", "itemClassName", "buttonClassName"]);
  var _g = useState({
      startIdx: 0,
      endIdx: 0
    }),
    fullVisibleItem = _g[0],
    setFullVisibleItem = _g[1];
  var _h = useState(false),
    hovered = _h[0],
    setHovered = _h[1];
  var animateRef = useRef(null);
  var carouselRef = useRef(null);
  var carouselItemRefs = useRef([]);
  var breakpoint = useResponsive().breakpoint;
  var matches = useMatchMedia('(pointer: coarse)').matches;
  var isHidden = matches || hiddenBreakpoints.some(function (hiddenBreakpoint) {
    return hiddenBreakpoint === breakpoint;
  });
  var theme = useTheme();
  var childrenCount = React__default.Children.count(children);
  var updatePosition = useCallback(function () {
    var carousel = carouselRef.current;
    if (!carousel) return;
    var carouselRect = carousel.getBoundingClientRect();
    var carouselStartX = carouselRect.left;
    var carouselEndX = carouselStartX + carouselRect.width;
    var startItemIdx;
    var endItemIdx;
    for (var i = 0; i < childrenCount; i += 1) {
      var item = carouselItemRefs.current[i];
      var itemRect = (item === null || item === void 0 ? void 0 : item.getBoundingClientRect()) || {
        left: 0,
        width: 0
      };
      var itemStartX = itemRect.left;
      var itemEndX = itemStartX + itemRect.width;
      var isFullVisibleItem = item && Math.floor(carouselStartX) <= Math.floor(itemStartX) && Math.floor(itemEndX) <= Math.floor(carouselEndX);
      if (isFullVisibleItem) {
        if (startItemIdx === undefined) {
          startItemIdx = i;
        }
        endItemIdx = i;
      }
    }
    setFullVisibleItem({
      startIdx: startItemIdx !== null && startItemIdx !== void 0 ? startItemIdx : 0,
      endIdx: endItemIdx !== null && endItemIdx !== void 0 ? endItemIdx : 0
    });
  }, [setFullVisibleItem, childrenCount]);
  var scrollToOffset = useCallback(function (targetOffset) {
    if (animateRef.current) {
      cancelAnimationFrame(animateRef.current);
    }
    var startTime = Date.now();
    var carousel = carouselRef.current;
    if (!carousel) return;
    var currentCarouselStartX = carousel.scrollLeft;
    var lastCarouselStartX = carousel.scrollWidth - carousel.offsetWidth;
    var nextCarouselStartX = Math.max(0, Math.min(lastCarouselStartX, targetOffset));
    var handleScroll = function handleScroll() {
      var elapsed = Date.now() - startTime;
      var progress = Math.min(elapsed / 350, 1);
      var carousel = carouselRef.current;
      if (carousel) {
        carousel.scrollLeft = currentCarouselStartX + (nextCarouselStartX - currentCarouselStartX) * quadInOut(progress);
      }
      if (progress < 1) {
        animateRef.current = requestAnimationFrame(handleScroll);
      }
    };
    animateRef.current = requestAnimationFrame(handleScroll);
  }, []);
  var moveRight = useCallback(function (basis) {
    var _a, _b;
    var startItemIdx = basis !== null && basis !== void 0 ? basis : fullVisibleItem.endIdx + 1;
    if (startItemIdx >= childrenCount) return;
    if (!carouselRef.current) return;
    var startItem = carouselItemRefs.current[startItemIdx];
    if (!startItem) return;
    var carouselWidth = carouselRef.current.offsetWidth;
    var endItemIdx = startItemIdx;
    var endItemOffsetRight = 0;
    while (endItemIdx < childrenCount) {
      var item = carouselItemRefs.current[endItemIdx];
      var itemOffsetRight = ((_a = item === null || item === void 0 ? void 0 : item.offsetLeft) !== null && _a !== void 0 ? _a : 0) + ((_b = item === null || item === void 0 ? void 0 : item.offsetWidth) !== null && _b !== void 0 ? _b : 0);
      var carouselOffsetRight = startItem.offsetLeft + carouselWidth;
      var isNotFullVisibleItem = !item || carouselOffsetRight < itemOffsetRight;
      if (isNotFullVisibleItem || !item) break;
      endItemOffsetRight = (item === null || item === void 0 ? void 0 : item.offsetLeft) + (item === null || item === void 0 ? void 0 : item.offsetWidth);
      endItemIdx += 1;
    }
    endItemIdx -= 1;
    var carouselOffsetLeft = (startItem.offsetLeft + endItemOffsetRight) / 2 - carouselWidth / 2;
    scrollToOffset(carouselOffsetLeft);
    setFullVisibleItem({
      startIdx: startItemIdx,
      endIdx: endItemIdx
    });
  }, [fullVisibleItem, childrenCount, scrollToOffset]);
  var moveLeft = useCallback(function (basis) {
    var endItemIdx = basis !== null && basis !== void 0 ? basis : fullVisibleItem.startIdx - 1;
    if (endItemIdx < 0) return;
    if (!carouselRef.current) return;
    var endItem = carouselItemRefs.current[endItemIdx];
    if (!endItem) return;
    var endItemOffsetRight = endItem.offsetLeft + endItem.offsetWidth;
    var carouselWidth = carouselRef.current.offsetWidth;
    var startItemIdx = endItemIdx;
    var startItemOffsetLeft = 0;
    while (startItemIdx >= 0) {
      var item = carouselItemRefs.current[startItemIdx];
      var carouselOffsetLeft_1 = endItemOffsetRight - carouselWidth;
      var isNotFullVisibleItem = !item || item.offsetLeft < carouselOffsetLeft_1;
      if (isNotFullVisibleItem || !item) break;
      startItemOffsetLeft = item.offsetLeft;
      startItemIdx -= 1;
    }
    startItemIdx += 1;
    var carouselOffsetLeft = (startItemOffsetLeft + endItemOffsetRight) / 2 - carouselWidth / 2;
    scrollToOffset(carouselOffsetLeft);
    setFullVisibleItem({
      startIdx: startItemIdx,
      endIdx: endItemIdx
    });
  }, [fullVisibleItem, scrollToOffset]);
  var scrollTo = useCallback(function (index) {
    if (index < fullVisibleItem.startIdx) {
      moveRight(index);
    } else if (index > fullVisibleItem.endIdx) {
      moveLeft(index);
    } else ;
  }, [fullVisibleItem, moveLeft, moveRight]);
  var getFullVisibleItem = useCallback(function () {
    return fullVisibleItem;
  }, [fullVisibleItem]);
  useImperativeHandle(ref, function () {
    return {
      getFullVisibleItem: getFullVisibleItem,
      scrollTo: scrollTo,
      moveLeft: moveLeft,
      moveRight: moveRight
    };
  });
  useEffect(function () {
    updatePosition();
    var resizeAnimationId = null;
    var handleResize = function handleResize() {
      if (resizeAnimationId) {
        cancelAnimationFrame(resizeAnimationId);
      }
      resizeAnimationId = requestAnimationFrame(function () {
        resizeAnimationId = null;
        updatePosition();
      });
    };
    var resizeObserver = null;
    var carousel = carouselRef.current;
    if (window.ResizeObserver && carousel) {
      resizeObserver = new ResizeObserver(handleResize);
      resizeObserver.observe(carousel);
    } else {
      window.addEventListener('resize', handleResize);
    }
    return function () {
      if (animateRef.current) {
        cancelAnimationFrame(animateRef.current);
      }
      if (resizeAnimationId) {
        cancelAnimationFrame(resizeAnimationId);
      }
      if (resizeObserver) {
        resizeObserver.disconnect();
      } else {
        window.removeEventListener('resize', handleResize);
      }
    };
  }, [updatePosition]);
  var isLeftEnd = fullVisibleItem.startIdx === 0;
  var isRightEnd = fullVisibleItem.endIdx === childrenCount - 1;
  return jsxs("div", _assign({
    css: /*#__PURE__*/css(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n        position: relative;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        position: relative;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")]))),
    onMouseEnter: function onMouseEnter() {
      return setHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHovered(false);
    },
    className: className
  }, rest, {
    children: [jsx("div", _assign({
      css: /*#__PURE__*/css(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject(["\n          position: relative;\n          z-index: 0;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          position: relative;\n          z-index: 0;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
    }, {
      children: jsx("ul", _assign({
        onScroll: updatePosition,
        className: contentClassName,
        ref: function ref(node) {
          carouselRef.current = node;
          if (contentRef) {
            contentRef(node);
          }
        },
        css: [/*#__PURE__*/css(templateObject_3$4 || (templateObject_3$4 = __makeTemplateObject(["\n              display: flex;\n              margin: 0;\n              padding: 0;\n              overflow: hidden;\n              & > li:last-of-type {\n                margin-right: 0;\n              }\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              display: flex;\n              margin: 0;\n              padding: 0;\n              overflow: hidden;\n              & > li:last-of-type {\n                margin-right: 0;\n              }\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")]))), isHidden && /*#__PURE__*/css(templateObject_4$4 || (templateObject_4$4 = __makeTemplateObject(["\n              scroll-snap-type: x mandatory;\n              overflow: auto;\n              -ms-overflow-style: none;\n              scrollbar-width: none;\n              &::-webkit-scrollbar {\n                display: none;\n              }\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              scroll-snap-type: x mandatory;\n              overflow: auto;\n              -ms-overflow-style: none;\n              scrollbar-width: none;\n              &::-webkit-scrollbar {\n                display: none;\n              }\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")]))), !isRightEnd && gradation && /*#__PURE__*/css(templateObject_5$2 || (templateObject_5$2 = __makeTemplateObject(["\n            &:after {\n              content:'';\n              position: absolute;\n              top: 0;\n              right: -1px;\n              width: 100px;\n              height: 100%;\n              background: ", ";\n              pointer-events: none;\n              padding: 0;\n              margin: 0;\n            }\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            &:after {\n              content:'';\n              position: absolute;\n              top: 0;\n              right: -1px;\n              width: 100px;\n              height: 100%;\n              background: ", ";\n              pointer-events: none;\n              padding: 0;\n              margin: 0;\n            }\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), "linear-gradient(90deg, ".concat(hexToRgba(theme.background.base, 0), " 0%, ").concat(theme.background.base, " 100%)"))]
      }, {
        children: Children.map(children, function (child, index) {
          return jsx("li", _assign({
            className: itemClassName,
            css: /*#__PURE__*/css(templateObject_7$2 || (templateObject_7$2 = __makeTemplateObject(["\n                margin: 0 ", " 0 0;\n                padding: 0;\n                flex-shrink: 0;\n                scroll-snap-align: start;\n                ", "\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                margin: 0 ", " 0 0;\n                padding: 0;\n                flex-shrink: 0;\n                scroll-snap-align: start;\n                ", "\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(gap), MEDIA_QUERY.min('tablet', /*#__PURE__*/css(templateObject_6$2 || (templateObject_6$2 = __makeTemplateObject(["\n                  @media(hover: hover) {\n                    &:hover {\n                      z-index: 1;\n                    }\n                  }\n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                  @media(hover: hover) {\n                    &:hover {\n                      z-index: 1;\n                    }\n                  }\n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")]))))),
            ref: function ref(node) {
              carouselItemRefs.current[index] = node;
            }
          }, {
            children: child
          }), _typeof(child) === 'object' && child != null && 'key' in child ? child.key : undefined);
        })
      }))
    })), (fixed || hovered) && jsxs(Fragment$1, {
      children: [jsx(CarouselControlButton, {
        iconName: "chevron_left",
        position: "left",
        onClick: function onClick() {
          return moveLeft();
        },
        "aria-label": "\uC774\uC804",
        hidden: isHidden || isLeftEnd,
        variant: variant,
        className: buttonClassName
      }), jsx(CarouselControlButton, {
        iconName: "chevron_right",
        position: "right",
        onClick: function onClick() {
          return moveRight();
        },
        "aria-label": "\uB2E4\uC74C",
        hidden: isHidden || isRightEnd,
        variant: variant,
        className: buttonClassName
      })]
    })]
  }));
});
var templateObject_1$7, templateObject_2$6, templateObject_3$4, templateObject_4$4, templateObject_5$2, templateObject_6$2, templateObject_7$2;

function Ranking(_a) {
  var number = _a.number,
    variant = _a.variant,
    props = __rest(_a, ["number", "variant"]);
  var theme = useTheme();
  return jsxs("div", _assign({}, props, {
    css: /*#__PURE__*/css(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n        position: relative;\n        display: inline-block;\n        font-size: 0;\n        line-height: 1;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        position: relative;\n        display: inline-block;\n        font-size: 0;\n        line-height: 1;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
  }, {
    children: [jsx("svg", _assign({
      width: 26,
      height: 30,
      fill: "none"
    }, {
      children: jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m13 24.25-13 5V0h26v29.25l-13-5Z",
        fill: function () {
          switch (variant) {
            case 'primary1':
              return hexToRgba(theme.content.primary1.basic, 0.86);
            case 'dim':
              return theme.dim.basic;
            default:
              return;
          }
        }()
      })
    })), jsx("span", _assign({
      css: /*#__PURE__*/css(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n          position: absolute;\n          top: ", ";\n          left: 0;\n          right: 0;\n          ", ";\n          font-weight: 700;\n          color: ", ";\n          text-align: center;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          position: absolute;\n          top: ", ";\n          left: 0;\n          right: 0;\n          ", ";\n          font-weight: 700;\n          color: ", ";\n          text-align: center;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(4), FONT_STYLE.body3, theme.content.white)
    }, {
      children: number
    }))]
  }));
}
var templateObject_1$6, templateObject_2$5;

function SectionTitle(_a) {
  var className = _a.className,
    size = _a.size,
    title = _a.title,
    caption = _a.caption,
    badge = _a.badge,
    count = _a.count,
    moreButton = _a.moreButton,
    customButton = _a.customButton,
    hasArrow = _a.hasArrow,
    _onClick = _a.onClick;
  var theme = useTheme();
  var isMobile = useResponsive().breakpoint === 'mobile';
  var handleClickChild = function handleClickChild(e) {
    if (!_onClick) return;
    e.stopPropagation();
    _onClick(e);
  };
  return jsxs("div", _assign({
    className: className,
    onClick: function onClick() {
      if (!isMobile) return;
      _onClick === null || _onClick === void 0 ? void 0 : _onClick();
    },
    css: [/*#__PURE__*/css(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n          display: flex;\n          align-items: center;\n          justify-content: space-between;\n          width: 100%;\n          padding: ", " 0;\n          font-size: 0;\n          line-height: 1;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          display: flex;\n          align-items: center;\n          justify-content: space-between;\n          width: 100%;\n          padding: ", " 0;\n          font-size: 0;\n          line-height: 1;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(20))]
  }, {
    children: [!!badge && jsx(CircleBadge, _assign({
      type: "fill",
      variant: "primary2",
      size: 24,
      css: /*#__PURE__*/css(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n            margin-right: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            margin-right: ", ";\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(8))
    }, {
      children: badge
    })), jsxs("div", _assign({
      css: /*#__PURE__*/css(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject(["\n          flex: 1;\n          display: flex;\n          align-items: flex-start;\n          flex-direction: column;\n          min-width: 0;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          flex: 1;\n          display: flex;\n          align-items: flex-start;\n          flex-direction: column;\n          min-width: 0;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
    }, {
      children: [jsxs("div", _assign({
        onClick: handleClickChild,
        css: [/*#__PURE__*/css(templateObject_4$3 || (templateObject_4$3 = __makeTemplateObject(["\n              display: inline-flex;\n              align-items: center;\n              max-width: 100%;\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              display: inline-flex;\n              align-items: center;\n              max-width: 100%;\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")]))), _onClick && cssClickable]
      }, {
        children: [jsx("strong", _assign({
          css: [/*#__PURE__*/css(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n                overflow: hidden;\n                display: inline-block;\n                font-weight: 700;\n                color: ", ";\n                letter-spacing: ", ";\n                white-space: nowrap;\n                text-overflow: ellipsis;\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                overflow: hidden;\n                display: inline-block;\n                font-weight: 700;\n                color: ", ";\n                letter-spacing: ", ";\n                white-space: nowrap;\n                text-overflow: ellipsis;\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), theme.content.base1, pxToRem(-0.3)), cssFontSize(size)]
        }, {
          children: title
        })), !!count && jsx("span", _assign({
          css: [/*#__PURE__*/css(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject(["\n                  display: inline-block;\n                  margin-left: ", ";\n                  ", ";\n                  ", ";\n                  font-weight: 700;\n                  color: ", ";\n                  letter-spacing: ", ";\n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                  display: inline-block;\n                  margin-left: ", ";\n                  ", ";\n                  ", ";\n                  font-weight: 700;\n                  color: ", ";\n                  letter-spacing: ", ";\n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(6), size === 'large' && FONT_STYLE.title2, size === 'small' && FONT_STYLE.title3, theme.content.primary1.basic, pxToRem(-0.3)), cssFontSize(size)]
        }, {
          children: count
        }))]
      })), caption && jsxs("div", _assign({
        onClick: function onClick(e) {
          if (!caption.onClick) return;
          e.stopPropagation();
          caption.onClick(e);
        },
        css: [/*#__PURE__*/css(templateObject_7$1 || (templateObject_7$1 = __makeTemplateObject(["\n                display: inline-flex;\n                align-items: center;\n                max-width: 100%;\n                margin-top: ", ";\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                display: inline-flex;\n                align-items: center;\n                max-width: 100%;\n                margin-top: ", ";\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(4)), caption.onClick && cssClickable]
      }, {
        children: [jsx("span", _assign({
          css: /*#__PURE__*/css(templateObject_8$1 || (templateObject_8$1 = __makeTemplateObject(["\n                overflow: hidden;\n                display: inline-block;\n                ", ";\n                font-weight: 400;\n                color: ", ";\n                letter-spacing: ", ";\n                white-space: nowrap;\n                text-overflow: ellipsis;\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                overflow: hidden;\n                display: inline-block;\n                ", ";\n                font-weight: 400;\n                color: ", ";\n                letter-spacing: ", ";\n                white-space: nowrap;\n                text-overflow: ellipsis;\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), FONT_STYLE.subTitle2, theme.content.base1, pxToRem(-0.3))
        }, {
          children: caption.text
        })), caption.icon && jsx(Icon, {
          name: caption.icon,
          size: 18,
          css: /*#__PURE__*/css(templateObject_9$1 || (templateObject_9$1 = __makeTemplateObject(["\n                  margin-left: ", ";\n                  color: ", ";\n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                  margin-left: ", ";\n                  color: ", ";\n                " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(2), theme.content.base1)
        })]
      }))]
    })), jsxs("div", _assign({
      css: /*#__PURE__*/css(templateObject_10$1 || (templateObject_10$1 = __makeTemplateObject(["\n          display: flex;\n          align-items: center;\n          height: 0;\n          margin-left: ", ";\n          &:empty {\n            margin-left: 0;\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          display: flex;\n          align-items: center;\n          height: 0;\n          margin-left: ", ";\n          &:empty {\n            margin-left: 0;\n          }\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(10))
    }, {
      children: [moreButton && jsx("button", _assign({
        type: "button",
        onClick: handleClickChild,
        css: [/*#__PURE__*/css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n                ", "\n                ", "\n                font-weight: 700;\n                color: ", ";\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n                ", "\n                ", "\n                font-weight: 700;\n                color: ", ";\n              " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), RESET_BUTTON, FONT_STYLE.subTitle1, theme.content.primary1.basic), cssClickable]
      }, {
        children: _typeof(moreButton) === 'object' && moreButton.text || '더보기'
      })), customButton && function () {
        var component = customButton.component,
          props = __rest(customButton, ["component"]);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var CustomButton = component;
        return jsx(CustomButton, _assign({}, props, {
          size: 32,
          onClick: handleClickChild
        }));
      }(), hasArrow && jsx(Icon, {
        size: 24,
        name: "chevron_thick_right",
        fill: function fill(theme) {
          return theme.content.base1;
        },
        onClick: handleClickChild,
        css: /*#__PURE__*/css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n              cursor: pointer;\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              cursor: pointer;\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
      })]
    }))]
  }));
}
var cssFontSize = function cssFontSize(size) {
  switch (size) {
    case 'large':
      return FONT_STYLE.title2;
    case 'small':
      return FONT_STYLE.title3;
    default:
      return;
  }
};
var cssClickable = /*#__PURE__*/css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  cursor: pointer;\n  @media(hover: hover) {\n    &:hover {\n      opacity: .5;\n    }\n  }\n" + (process.env.NODE_ENV === "production" ? "" : ";label:cssClickable;")], ["\n  cursor: pointer;\n  @media(hover: hover) {\n    &:hover {\n      opacity: .5;\n    }\n  }\n" + (process.env.NODE_ENV === "production" ? "" : ";label:cssClickable;")])));
var templateObject_1$5, templateObject_2$4, templateObject_3$3, templateObject_4$3, templateObject_5$1, templateObject_6$1, templateObject_7$1, templateObject_8$1, templateObject_9$1, templateObject_10$1, templateObject_11, templateObject_12, templateObject_13;

function ImageUploadButtonImpl(_a, ref) {
  var multiple = _a.multiple,
    _b = _a.type,
    type = _b === void 0 ? 'button' : _b,
    _c = _a.accept,
    accept = _c === void 0 ? 'image/*' : _c,
    onFileSelected = _a.onFileSelected,
    onButtonClick = _a.onClick,
    buttonProps = __rest(_a, ["multiple", "type", "accept", "onFileSelected", "onClick"]);
  var inputRef = useRef(null);
  var theme = useTheme();
  var handleClickButton = function handleClickButton(ev) {
    var _a;
    (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    onButtonClick === null || onButtonClick === void 0 ? void 0 : onButtonClick(ev);
  };
  return jsxs("button", _assign({
    ref: ref,
    onClick: handleClickButton,
    css: /*#__PURE__*/css(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n        ", ";\n        ", ";\n        width: ", ";\n        height: ", ";\n        font-weight: 700;\n        text-align: center;\n        border-radius: ", ";\n        color: ", ";\n        border: ", " solid ", ";\n        cursor: pointer;\n        ", ";\n        &:disabled {\n          color: ", ";\n          pointer-events: none;\n          background-color: ", ";\n          border: none;\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        ", ";\n        ", ";\n        width: ", ";\n        height: ", ";\n        font-weight: 700;\n        text-align: center;\n        border-radius: ", ";\n        color: ", ";\n        border: ", " solid ", ";\n        cursor: pointer;\n        ", ";\n        &:disabled {\n          color: ", ";\n          pointer-events: none;\n          background-color: ", ";\n          border: none;\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), RESET_BUTTON, FONT_STYLE.body3, pxToRem(72), pxToRem(72), pxToRem(4), theme.content.base1, pxToRem(1), theme.border, HOVER(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n          background-color: ", ";\n        "], ["\n          background-color: ", ";\n        "])), theme.interactive.transparent), theme.content.base3, theme.content.base4),
    type: type
  }, buttonProps, {
    children: [jsx("input", {
      hidden: true,
      ref: inputRef,
      type: "file",
      multiple: multiple,
      accept: accept,
      onChange: onFileSelected
    }), jsx(Icon, {
      size: 24,
      css: /*#__PURE__*/css(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["  \n          margin-bottom: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["  \n          margin-bottom: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(6.5)),
      name: "camera"
    }), jsx("span", _assign({
      css: /*#__PURE__*/css(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject(["display: block;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["display: block;" + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])))
    }, {
      children: "\uC0AC\uC9C4 \uC62C\uB9AC\uAE30"
    }))]
  }));
}
var ImageUploadButton = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(ImageUploadButtonImpl));
var templateObject_1$4, templateObject_2$3, templateObject_3$2, templateObject_4$2;

function ImageAttachedItem(_a) {
  var imageUrl = _a.imageUrl,
    onDelete = _a.onDelete,
    _b = _a.deletable,
    deletable = _b === void 0 ? true : _b,
    className = _a.className,
    alt = _a.alt;
  var theme = useTheme();
  return jsxs("figure", _assign({
    className: className,
    css: /*#__PURE__*/css(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n        width: ", ";\n        height: ", ";\n        display: inline-block;\n        vertical-align: bottom;\n        position: relative;\n        overflow: hidden;\n        &:after {\n          position: absolute;\n          content: \"\";\n          top: 0;\n          left: 0;\n          right: 0;\n          bottom: 0;\n          border-radius: ", ";\n          border: ", " solid ", ";\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        width: ", ";\n        height: ", ";\n        display: inline-block;\n        vertical-align: bottom;\n        position: relative;\n        overflow: hidden;\n        &:after {\n          position: absolute;\n          content: \"\";\n          top: 0;\n          left: 0;\n          right: 0;\n          bottom: 0;\n          border-radius: ", ";\n          border: ", " solid ", ";\n        }\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(72), pxToRem(72), pxToRem(4), pxToRem(1), theme.outline)
  }, {
    children: [jsx(ResizeImage$1, {
      src: imageUrl,
      intrinsicAspect: 1,
      intrinsicInitialHeight: 72,
      quality: 70,
      objectFit: "cover",
      alt: alt,
      css: /*#__PURE__*/css(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n          box-sizing: border-box;\n          width: ", ";\n          height: ", ";\n          border-radius: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n          box-sizing: border-box;\n          width: ", ";\n          height: ", ";\n          border-radius: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), pxToRem(72), pxToRem(72), pxToRem(4))
    }), deletable && jsx("button", _assign({
      css: /*#__PURE__*/css(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n            ", ";\n            display: flex;\n            z-index: 3;\n            align-items: center;\n            justify-content: center;\n            position: absolute;\n            top: ", ";\n            right: ", ";\n            cursor: pointer;\n            &:hover {\n              opacity: 0.6;\n            }\n            &:before {\n              content: '';\n              position: absolute;;\n              background-color: ", ";\n              border-radius: 50%;\n              width: ", ";\n              height: ", ";\n            }\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n            ", ";\n            display: flex;\n            z-index: 3;\n            align-items: center;\n            justify-content: center;\n            position: absolute;\n            top: ", ";\n            right: ", ";\n            cursor: pointer;\n            &:hover {\n              opacity: 0.6;\n            }\n            &:before {\n              content: '';\n              position: absolute;;\n              background-color: ", ";\n              border-radius: 50%;\n              width: ", ";\n              height: ", ";\n            }\n          " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), RESET_BUTTON, pxToRem(6), pxToRem(6), theme.content.white, pxToRem(15), pxToRem(15)),
      onClick: onDelete
    }, {
      children: jsx(DismissCircleIcon, {
        css: /*#__PURE__*/css(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n              color: ", ";\n              border-radius: 50%;\n              position:relative;\n           " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n              color: ", ";\n              border-radius: 50%;\n              position:relative;\n           " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), theme.content.base1),
        size: 24
      })
    }))]
  }));
}
var templateObject_1$3, templateObject_2$2, templateObject_3$1, templateObject_4$1;

function LinearProgressBar(_a) {
  var total = _a.total,
    variant = _a.variant,
    currentStep = _a.currentStep,
    width = _a.width,
    className = _a.className;
  var theme = useTheme();
  var progress = Math.max(Math.min(currentStep / total * 100, 100), 0);
  return jsx("div", _assign({
    className: className,
    css: /*#__PURE__*/css(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n        background-color: ", ";\n        width: ", ";\n        height: ", ";\n        margin-top: auto;\n        margin-bottom: auto;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")], ["\n        background-color: ", ";\n        width: ", ";\n        height: ", ";\n        margin-top: auto;\n        margin-bottom: auto;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:css;")])), theme.content.base5, typeof width === 'number' ? pxToRem(width) : '100%', pxToRem(6))
  }, {
    children: jsx(StyledDiv, {
      progress: progress,
      variant: variant
    })
  }));
}
var StyledDiv = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e80j02f0"
} : {
  target: "e80j02f0",
  label: "StyledDiv"
})(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n  transform: scaleX(", ");\n  transform-origin: center left;\n  transition: transform 1.5s ease;\n  background-color: ", ";\n  border-top-right-radius: ", ";\n  border-bottom-right-radius: ", ";\n  height: 100%;\n  transition-duration: 0.2s;\n  transition-timing-function: ease-in-out;\n"], ["\n  transform: scaleX(", ");\n  transform-origin: center left;\n  transition: transform 1.5s ease;\n  background-color: ", ";\n  border-top-right-radius: ", ";\n  border-bottom-right-radius: ", ";\n  height: 100%;\n  transition-duration: 0.2s;\n  transition-timing-function: ease-in-out;\n"])), function (_a) {
  var progress = _a.progress;
  return progress / 100;
}, function (_a) {
  var theme = _a.theme,
    variant = _a.variant;
  return theme.content[variant].basic;
}, pxToRem(10), pxToRem(10));
var templateObject_1$2, templateObject_2$1;

var FETCH_STATUS = {
  LOADED: 'loaded',
  NON_LOAD: 'non-load'
};

var createScrollStorage = function createScrollStorage(tabId) {
  var sessionKey = "scroll-".concat(tabId);
  return {
    get: function get() {
      var scrollInfo = sessionStorage.getItem(sessionKey);
      return scrollInfo ? JSON.parse(scrollInfo) : undefined;
    },
    set: function set(value) {
      sessionStorage.setItem(sessionKey, value);
    },
    reset: function reset() {
      sessionStorage.removeItem(sessionKey);
    }
  };
};
/**
 * @param length
 * @returns length개의 null을 채운 배열
 */
var createNullArray = function createNullArray(length) {
  return Array.from({
    length: length
  }).map(function (_) {
    return null;
  });
};
/**
 * findPageByIndex
 * index보다 작으면서 가장 가까운 배열 요소의 index(page)를 찾아서 반환합니다.
 * @param {number[]} array 각 page의 offset이 담긴 배열
 * @param {number} index 찾고자 하는 아이템 index
 */
var findPageByIndex = function findPageByIndex(array, index) {
  var start = 0;
  var end = array.length - 1;
  while (start <= end) {
    var mid = Math.floor((start + end) / 2);
    var isLastItem = array.length - 1 === mid;
    var currValue = array[mid];
    var nextValue = isLastItem ? Number.MAX_SAFE_INTEGER : array[mid + 1];
    if (index < currValue) {
      end = mid - 1;
    } else if (currValue <= index && index < nextValue) {
      return mid;
    } else {
      start = mid + 1;
    }
  }
  return 0;
};

var MIN_PAGE$1 = 1;
/**
 * info의 개수가 per보다 큰 경우, info를 per개씩 나누어 저장한 pageInfo를 리턴합니다.
 */
var formatPageInfo = function formatPageInfo(_a) {
  var page = _a.page,
    info = _a.info,
    per = _a.per;
  var itemStatus = info.itemStatus,
    items = info.items,
    hasNext = info.hasNext;
  var pageCount = items.length !== 0 ? Math.ceil(items.length / per) : 0;
  var formattedPageInfo = {};
  Array.from({
    length: pageCount
  }).forEach(function (_, index) {
    var _a;
    var isLastPage = index === pageCount - 1;
    formattedPageInfo = _assign(_assign({}, formattedPageInfo), (_a = {}, _a[page + index] = {
      itemStatus: itemStatus,
      items: items.slice(index * per, (index + 1) * per),
      hasNext: isLastPage ? hasNext : true
    }, _a));
  });
  return formattedPageInfo;
};
var getInitialDataInfo = function getInitialDataInfo(initialData, per) {
  if (!initialData) return {};
  var page = initialData.page,
    pageInfo = __rest(initialData, ["page"]);
  return formatPageInfo({
    page: page,
    info: _assign({
      itemStatus: FETCH_STATUS.LOADED
    }, pageInfo),
    per: per
  });
};
function usePageInfo(_a) {
  var per = _a.per,
    tabId = _a.tabId,
    originalInitialData = _a.initialData;
  var _b = useState(getInitialDataInfo(originalInitialData, per)),
    pageInfo = _b[0],
    setPageInfo = _b[1];
  var maxPage = useRef(null);
  useEffect(function () {
    var actualMaxPage = maxPage.current;
    if (actualMaxPage == null) return;
    var isPageInfoAlreadyFiltered = Number(findLastKey(pageInfo)) <= actualMaxPage;
    if (isPageInfoAlreadyFiltered) return;
    setPageInfo(function (pageInfo) {
      var pageList = Object.keys(pageInfo);
      var omittedPageList = pageList.filter(function (page) {
        return Number(page) > actualMaxPage;
      }).map(function (page) {
        return Number(page);
      });
      return omit(pageInfo, omittedPageList);
    });
  }, [pageInfo]);
  var sessionScrollStorage = useMemo(function () {
    return createScrollStorage(tabId);
  }, [tabId]);
  var count = useMemo(function () {
    return Object.values(pageInfo).reduce(function (prev, _a) {
      var items = _a.items;
      return prev + items.length;
    }, 0);
  }, [pageInfo]);
  var getPageInfo = useCallback(function (page) {
    return pageInfo[page];
  }, [pageInfo]);
  var resetPageInfo = useCallback(function () {
    setPageInfo({});
  }, []);
  var addPageInfo = useCallback(function (_a) {
    var page = _a.page,
      info = _a.info;
    setPageInfo(function (pageInfo) {
      var _a;
      return _assign(_assign({}, pageInfo), (_a = {}, _a[page] = info, _a));
    });
  }, []);
  var getPageFromIndex = useCallback(function (index) {
    var page = 1;
    for (var i = 0; i < Object.values(pageInfo).length; i++) {
      var items = Object.values(pageInfo)[i].items;
      if (index + 1 <= items.length) break;
      index -= items.length;
      page++;
    }
    return {
      page: page,
      pageIndex: index
    };
  }, [pageInfo]);
  var getInitialPageInfo = useCallback(function () {
    if (originalInitialData === null) return {};
    return getInitialDataInfo(originalInitialData, per);
  }, [originalInitialData, per]);
  var createNonLoadPageInfo = useCallback(function (itemCount) {
    return formatPageInfo({
      page: MIN_PAGE$1,
      info: {
        itemStatus: FETCH_STATUS.NON_LOAD,
        items: createNullArray(itemCount),
        hasNext: true
      },
      per: per
    });
  }, [per]);
  /**
   * 스크롤 복귀할 page index와 initialData의 마지막 page index를 비교한 후
   * 더 큰 page까지 non-load로 데이터를 채워 반환합니다.
   */
  var getInitialNonLoadPageInfo = useCallback(function () {
    var _a;
    var initialLastPage = (_a = originalInitialData === null || originalInitialData === void 0 ? void 0 : originalInitialData.page) !== null && _a !== void 0 ? _a : 1;
    var scrollInfo = sessionScrollStorage.get();
    if (!(scrollInfo === null || scrollInfo === void 0 ? void 0 : scrollInfo.scrollEndItemIndex)) {
      return createNonLoadPageInfo(initialLastPage * per);
    }
    var scrollItemIndex = Number(scrollInfo.scrollEndItemIndex);
    var scrollPage = Math.floor(scrollItemIndex / per) + 1;
    return createNonLoadPageInfo(Math.max(scrollPage, initialLastPage) * per);
  }, [originalInitialData, sessionScrollStorage, createNonLoadPageInfo, per]);
  var initPageInfo = useCallback(function () {
    var initialPageInfo = getInitialPageInfo();
    var initialNonLoadPageInfo = getInitialNonLoadPageInfo();
    maxPage.current = null;
    setPageInfo(_assign(_assign({}, initialNonLoadPageInfo), initialPageInfo));
  }, [getInitialNonLoadPageInfo, getInitialPageInfo]);
  return {
    maxPage: maxPage,
    count: count,
    getPageInfo: getPageInfo,
    addPageInfo: addPageInfo,
    resetPageInfo: resetPageInfo,
    initPageInfo: initPageInfo,
    getPageFromIndex: getPageFromIndex
  };
}

function useLoadingPageList() {
  var loadingPageList = useRef(new Set());
  var addLoadingPage = useCallback(function (newPage) {
    loadingPageList.current.add(newPage);
  }, []);
  var removeLoadingPage = useCallback(function (targetPage) {
    loadingPageList.current["delete"](targetPage);
  }, []);
  var isLoadingPage = useCallback(function (page) {
    return loadingPageList.current.has(page);
  }, []);
  return {
    addLoadingPage: addLoadingPage,
    removeLoadingPage: removeLoadingPage,
    isLoadingPage: isLoadingPage
  };
}

function usePagedInfiniteList(_a) {
  var _this = this;
  var initialData = _a.initialData,
    initialDataPending = _a.initialDataPending,
    per = _a.per,
    tabId = _a.tabId,
    getItemList = _a.getItemList;
  var _b = useState(),
    error = _b[0],
    setError = _b[1];
  var shouldInit = useRef(true);
  var tabIdChanged = useChanged(tabId);
  var initialDataChanged = useChanged(initialData, isEqual);
  if (tabIdChanged || initialDataChanged) {
    shouldInit.current = true;
  }
  var _c = usePageInfo({
      per: per,
      tabId: tabId,
      initialData: initialData
    }),
    maxPage = _c.maxPage,
    count = _c.count,
    getPageInfo = _c.getPageInfo,
    addPageInfo = _c.addPageInfo,
    initPageInfo = _c.initPageInfo,
    getPageFromIndex = _c.getPageFromIndex;
  var _d = useLoadingPageList(),
    addLoadingPage = _d.addLoadingPage,
    removeLoadingPage = _d.removeLoadingPage,
    isLoadingPage = _d.isLoadingPage;
  /**
   * @param page fetch 할 페이지
   * @param fetchStatus fetch하는 status(non-load/loaded)
   */
  var fetchPageItemList = useCallback(function (_a) {
    var page = _a.page,
      _b = _a.fetchStatus,
      fetchStatus = _b === void 0 ? FETCH_STATUS.LOADED : _b;
    return __awaiter(_this, void 0, void 0, function () {
      var _c, _d, items, hasNext, error_1;
      var _e;
      return __generator(this, function (_f) {
        switch (_f.label) {
          case 0:
            if (error == null) {
              addPageInfo({
                page: page,
                info: {
                  itemStatus: FETCH_STATUS.NON_LOAD,
                  items: createNullArray(per),
                  hasNext: true
                }
              });
            }
            if (fetchStatus === FETCH_STATUS.NON_LOAD) return [2 /*return*/];
            addLoadingPage(page);
            _f.label = 1;
          case 1:
            _f.trys.push([1, 3, 4, 5]);
            return [4 /*yield*/, getItemList(page, per)];
          case 2:
            _c = _f.sent(), _d = _c.items, items = _d === void 0 ? [] : _d, hasNext = _c.hasNext;
            addPageInfo({
              page: page,
              info: {
                itemStatus: FETCH_STATUS.LOADED,
                items: items,
                hasNext: hasNext
              }
            });
            if (hasNext === false) {
              maxPage.current = Math.min((_e = maxPage.current) !== null && _e !== void 0 ? _e : Number.MAX_SAFE_INTEGER, page);
            }
            if (page === (error === null || error === void 0 ? void 0 : error.errorPage)) {
              setError(undefined);
            }
            return [3 /*break*/, 5];
          case 3:
            error_1 = _f.sent();
            setError({
              error: error_1,
              errorPage: page
            });
            return [3 /*break*/, 5];
          case 4:
            removeLoadingPage(page);
            return [7 /*endfinally*/];
          case 5:
            return [2 /*return*/];
        }
      });
    });
  }, [addLoadingPage, addPageInfo, error, getItemList, maxPage, per, removeLoadingPage]);
  var handleLoadItemList = useCallback(function (_a) {
    var startItemIndex = _a.startItemIndex,
      _b = _a.endItemIndex,
      endItemIndex = _b === void 0 ? startItemIndex : _b,
      _c = _a.fetchStatus,
      fetchStatus = _c === void 0 ? FETCH_STATUS.LOADED : _c;
    return __awaiter(_this, void 0, void 0, function () {
      var startItemPage, endItemPage, pageCount;
      return __generator(this, function (_d) {
        if (startItemIndex > endItemIndex) return [2 /*return*/];
        startItemPage = getPageFromIndex(startItemIndex).page;
        endItemPage = getPageFromIndex(endItemIndex).page;
        pageCount = endItemPage - startItemPage + 1;
        Array.from({
          length: pageCount
        }).forEach(function (_, index) {
          var _a;
          var page = index + startItemPage;
          var isPageAlreadyFetched = ((_a = getPageInfo(page)) === null || _a === void 0 ? void 0 : _a.itemStatus) === FETCH_STATUS.LOADED;
          var isPageLoading = isLoadingPage(page);
          var isPageNotInRange = page < MIN_PAGE$1 || maxPage.current != null && page > maxPage.current;
          if (isPageAlreadyFetched || isPageLoading || isPageNotInRange || error) return;
          fetchPageItemList({
            page: page,
            fetchStatus: fetchStatus
          });
        });
        return [2 /*return*/];
      });
    });
  }, [error, fetchPageItemList, getPageFromIndex, getPageInfo, isLoadingPage, maxPage]);
  var handleReloadErrorPage = useCallback(function () {
    if (!error) return;
    fetchPageItemList({
      page: error.errorPage
    });
  }, [error, fetchPageItemList]);
  var handleGetItem = useCallback(function (index) {
    var _a;
    var _b = getPageFromIndex(index),
      page = _b.page,
      pageIndex = _b.pageIndex;
    return (_a = getPageInfo(page)) === null || _a === void 0 ? void 0 : _a.items[pageIndex];
  }, [getPageFromIndex, getPageInfo]);
  /**
   * 기존 데이터를 reset하고, initial 데이터와 현재 스크롤 위치에서의 데이터를 reFetching합니다.
   * 중간 데이터들은 전부 non-load로 처리합니다.
   */
  var handleReloadItemList = useCallback(function () {
    initPageInfo();
  }, [initPageInfo]);
  useEffect(function () {
    if (initialDataPending || !initialData || !shouldInit.current) return;
    initPageInfo();
    shouldInit.current = false;
  }, [initPageInfo, initialData, initialDataPending]);
  return {
    count: count,
    loadItemList: handleLoadItemList,
    reloadItemList: handleReloadItemList,
    reloadError: handleReloadErrorPage,
    getItem: handleGetItem,
    error: error === null || error === void 0 ? void 0 : error.error
  };
}

var MIN_PAGE = 0;
var getInitialCursorInfo = function getInitialCursorInfo(initialData) {
  var _a;
  if (initialData === null) return {};
  return _a = {}, _a[MIN_PAGE] = _assign({
    itemStatus: FETCH_STATUS.LOADED,
    offset: 0,
    cursor: null
  }, initialData), _a;
};
function useCursorInfo(_a) {
  var initialData = _a.initialData;
  var _b = useState(getInitialCursorInfo(initialData)),
    cursorInfo = _b[0],
    setCursorInfo = _b[1];
  var _c = useMemo(function () {
      var _a;
      var lastCursorInfo = (_a = findLast(cursorInfo)) !== null && _a !== void 0 ? _a : {
        offset: 0,
        items: [],
        nextCursor: null,
        itemStatus: FETCH_STATUS.NON_LOAD
      };
      var count = lastCursorInfo.offset + lastCursorInfo.items.length;
      var nextCursor = lastCursorInfo.nextCursor || null;
      var hasNext = !(lastCursorInfo.itemStatus === 'loaded' && nextCursor === null);
      return {
        count: count,
        nextCursor: nextCursor,
        hasNext: hasNext
      };
    }, [cursorInfo]),
    count = _c.count,
    nextCursor = _c.nextCursor,
    hasNext = _c.hasNext;
  var lastPage = useMemo(function () {
    var _a;
    return Number((_a = findLastKey(cursorInfo)) !== null && _a !== void 0 ? _a : 0);
  }, [cursorInfo]);
  var getCursorInfo = useCallback(function (page) {
    return cursorInfo[page];
  }, [cursorInfo]);
  var resetCursorInfo = useCallback(function () {
    setCursorInfo({});
  }, []);
  var addCursorInfo = useCallback(function (_a) {
    var page = _a.page,
      info = _a.info;
    var prevCursorInfo = cursorInfo[page - 1];
    var offset = prevCursorInfo ? prevCursorInfo.offset + prevCursorInfo.items.length : 0;
    setCursorInfo(function (cursorInfo) {
      var _a;
      return _assign(_assign({}, cursorInfo), (_a = {}, _a[page] = _assign(_assign({}, info), {
        offset: offset
      }), _a));
    });
  }, [cursorInfo]);
  var getPageFromIndex = useCallback(function (index) {
    var offsetArray = __spreadArray(__spreadArray([], Object.values(cursorInfo).map(function (_a) {
      var offset = _a.offset;
      return offset;
    }), true), [count], false);
    var page = findPageByIndex(offsetArray, index);
    var isOverCount = page === size(cursorInfo);
    if (isOverCount) return null;
    return page;
  }, [cursorInfo, count]);
  var removeCursorInfo = useCallback(function (page) {
    setCursorInfo(function (cursorInfo) {
      return omit(cursorInfo, page);
    });
  }, []);
  var initCursorInfo = useCallback(function () {
    if (!initialData) return;
    var initialCursorInfo = getInitialCursorInfo(initialData);
    setCursorInfo(initialCursorInfo);
  }, [initialData]);
  return {
    nextCursor: nextCursor,
    count: count,
    lastPage: lastPage,
    hasNext: hasNext,
    getCursorInfo: getCursorInfo,
    addCursorInfo: addCursorInfo,
    removeCursorInfo: removeCursorInfo,
    resetCursorInfo: resetCursorInfo,
    initCursorInfo: initCursorInfo,
    getPageFromIndex: getPageFromIndex
  };
}

function usePagedCursorInfiniteList(_a) {
  var _this = this;
  var initialData = _a.initialData,
    initialDataPending = _a.initialDataPending,
    per = _a.per,
    tabId = _a.tabId,
    getItemList = _a.getItemList;
  var _b = useState(),
    error = _b[0],
    setError = _b[1];
  var _c = useState(null),
    scrollTargetIndex = _c[0],
    setScrollTargetIndex = _c[1];
  var shouldInit = useRef(true);
  var tabIdChanged = useChanged(tabId);
  var initialDataChanged = useChanged(initialData, isEqual);
  if (tabIdChanged || initialDataChanged) {
    shouldInit.current = true;
  }
  var sessionScrollStorage = useMemo(function () {
    return createScrollStorage(tabId);
  }, [tabId]);
  var _d = useCursorInfo({
      initialData: initialData
    }),
    targetCursor = _d.nextCursor,
    count = _d.count,
    lastPage = _d.lastPage,
    hasNext = _d.hasNext,
    getCursorInfo = _d.getCursorInfo,
    addCursorInfo = _d.addCursorInfo,
    removeCursorInfo = _d.removeCursorInfo,
    initCursorInfo = _d.initCursorInfo,
    getPageFromIndex = _d.getPageFromIndex;
  var _e = useLoadingPageList(),
    addLoadingPage = _e.addLoadingPage,
    removeLoadingPage = _e.removeLoadingPage,
    isLoadingPage = _e.isLoadingPage;
  var visibleCount = useMemo(function () {
    if (hasNext && scrollTargetIndex !== null) {
      return Math.max(count, scrollTargetIndex + 1);
    }
    return count;
  }, [count, hasNext, scrollTargetIndex]);
  var fetchCursorItemList = useCallback(function (_a) {
    var page = _a.page,
      cursor = _a.cursor;
    return __awaiter(_this, void 0, void 0, function () {
      var _b, _c, items, hasNext_1, nextCursor, error_1;
      return __generator(this, function (_d) {
        switch (_d.label) {
          case 0:
            if (!cursor || !initialData) return [2 /*return*/];
            addCursorInfo({
              page: page,
              info: {
                itemStatus: FETCH_STATUS.NON_LOAD,
                items: createNullArray(per !== null && per !== void 0 ? per : initialData.items.length),
                hasNext: true,
                nextCursor: null,
                cursor: cursor
              }
            });
            addLoadingPage(page);
            _d.label = 1;
          case 1:
            _d.trys.push([1, 3, 4, 5]);
            return [4 /*yield*/, getItemList(cursor, per)];
          case 2:
            _b = _d.sent(), _c = _b.items, items = _c === void 0 ? [] : _c, hasNext_1 = _b.hasNext, nextCursor = _b.nextCursor;
            addCursorInfo({
              page: page,
              info: {
                itemStatus: FETCH_STATUS.LOADED,
                items: items,
                hasNext: hasNext_1,
                nextCursor: nextCursor,
                cursor: cursor
              }
            });
            if ((error === null || error === void 0 ? void 0 : error.errorPage) === page) {
              setError(undefined);
            }
            return [3 /*break*/, 5];
          case 3:
            error_1 = _d.sent();
            setError({
              error: error_1,
              errorPage: page
            });
            return [3 /*break*/, 5];
          case 4:
            removeLoadingPage(page);
            return [7 /*endfinally*/];
          case 5:
            return [2 /*return*/];
        }
      });
    });
  }, [initialData, addCursorInfo, per, addLoadingPage, getItemList, error === null || error === void 0 ? void 0 : error.errorPage, removeLoadingPage]);
  var handleLoadItemList = useCallback(function (_a) {
    var endItemIndex = _a.endItemIndex;
    return __awaiter(_this, void 0, void 0, function () {
      var targetPage;
      return __generator(this, function (_b) {
        targetPage = lastPage + 1;
        if (!targetCursor || isLoadingPage(targetPage) || endItemIndex < count) return [2 /*return*/];
        fetchCursorItemList({
          page: targetPage,
          cursor: targetCursor
        });
        return [2 /*return*/];
      });
    });
  }, [count, fetchCursorItemList, isLoadingPage, lastPage, targetCursor]);
  var handleReloadErrorPage = useCallback(function () {
    var _a;
    if (!error) return;
    setError(undefined);
    removeCursorInfo(error.errorPage);
    var cursorData = getCursorInfo(error.errorPage);
    var errorCursor = (_a = cursorData === null || cursorData === void 0 ? void 0 : cursorData.cursor) !== null && _a !== void 0 ? _a : null;
    fetchCursorItemList({
      page: error.errorPage,
      cursor: errorCursor
    });
  }, [error, fetchCursorItemList, getCursorInfo, removeCursorInfo]);
  var handleGetItem = useCallback(function (index) {
    var page = getPageFromIndex(index);
    if (page === null) return null;
    var cursorInfo = getCursorInfo(page);
    if (!cursorInfo) return null;
    var itemIndexInPage = index - cursorInfo.offset;
    return cursorInfo.items[itemIndexInPage];
  }, [getCursorInfo, getPageFromIndex]);
  var initScrollTarget = useCallback(function () {
    var scrollInfo = sessionScrollStorage.get();
    if (!(scrollInfo === null || scrollInfo === void 0 ? void 0 : scrollInfo.scrollEndItemIndex)) {
      setScrollTargetIndex(0);
      return;
    }
    var scrollEndItemIndex = Number(scrollInfo.scrollEndItemIndex);
    setScrollTargetIndex(scrollEndItemIndex);
  }, [sessionScrollStorage]);
  var handleReloadItemList = useCallback(function () {
    initCursorInfo();
    initScrollTarget();
  }, [initCursorInfo, initScrollTarget]);
  useEffect(function () {
    if (!shouldInit.current || initialDataPending || !initialData) return;
    initCursorInfo();
    initScrollTarget();
    shouldInit.current = false;
  }, [initCursorInfo, initScrollTarget, initialData, initialDataPending]);
  return {
    count: visibleCount,
    // 이슈 대응을 위해 임시로 필드를 추가 반환합니다. (DESYSWEB-428 참조)
    itemCount: count,
    loadItemList: handleLoadItemList,
    reloadItemList: handleReloadItemList,
    reloadError: handleReloadErrorPage,
    getItem: handleGetItem,
    error: error === null || error === void 0 ? void 0 : error.error
  };
}

var SCROLL_THROTTLE_MILLISECONDS = 500;
/**
 * useVirtualizedScroll
 * 페이지를 벗어날 때 스크롤 위치를 저장하고, 페이지 재접근 시 스크롤 위치를 복귀시키는 역할을 수행합니다.
 */
var useVirtualizedScroll = function useVirtualizedScroll(_a) {
  var tabId = _a.tabId,
    columnCount = _a.columnCount,
    containerRef = _a.containerRef,
    renderedRowList = _a.renderedRowList,
    disableSaveScroll = _a.disableSaveScroll;
  var _b = useState(null),
    targetScrollTop = _b[0],
    setTargetScrollTop = _b[1];
  var scrollIntervalId = useRef(null);
  var scrollDone = useRef(false);
  var sessionScrollStorage = useMemo(function () {
    return createScrollStorage(tabId);
  }, [tabId]);
  /**
   * 현재 scroll 위치 정보를 sessionStorage에 저장합니다.
   */
  var saveScrollInfo = useCallback(function () {
    var _a, _b, _c;
    if (!scrollDone.current || !containerRef.current || !renderedRowList.current || renderedRowList.current.length === 0 || disableSaveScroll) return;
    var offsetTop = (_b = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.offsetTop) !== null && _b !== void 0 ? _b : 0;
    /** 화면 최상단에서부터 scrollTop */
    var scrollTop = document.documentElement.scrollTop;
    /** 현재 보이는 화면 "상단" 선 기준 VirtualizedList 컴포넌트 최상단에서부터의 scrollTop */
    var scrollTopFromStart = scrollTop - offsetTop;
    /** 현재 보이는 화면 "하단" 선 기준 VirtualizedList 컴포넌트 최상단에서부터의 scrollTop */
    var scrollBottomFromStart = scrollTopFromStart + window.innerHeight;
    var lastRenderedRow = renderedRowList.current[renderedRowList.current.length - 1];
    var visibleEndRowIndex = ((_c = renderedRowList.current.find(function (_a) {
      var offset = _a.offset,
        size = _a.size;
      return offset <= scrollBottomFromStart && scrollBottomFromStart < offset + size;
    })) !== null && _c !== void 0 ? _c : lastRenderedRow).index;
    /** 화면에 보이는 마지막 아이템 item */
    var endItemIndex = (visibleEndRowIndex + 1) * columnCount - 1;
    var scrollInfo = {
      scrollTop: scrollTop,
      scrollEndItemIndex: endItemIndex
    };
    var bottom = containerRef.current.getBoundingClientRect().bottom;
    var isScrollAfterList = bottom < 0;
    if (isScrollAfterList) {
      var prevScrollInfo = sessionScrollStorage.get();
      var prevEndItemIndex = prevScrollInfo === null || prevScrollInfo === void 0 ? void 0 : prevScrollInfo.scrollEndItemIndex;
      if (prevEndItemIndex) {
        scrollInfo.scrollEndItemIndex = Math.max(prevEndItemIndex, endItemIndex);
      }
    }
    sessionScrollStorage.set(JSON.stringify(scrollInfo));
  }, [columnCount, containerRef, disableSaveScroll, renderedRowList, sessionScrollStorage]);
  useEffect(function () {
    var scrollInfo = sessionScrollStorage.get();
    if ((scrollInfo === null || scrollInfo === void 0 ? void 0 : scrollInfo.scrollTop) == null) {
      scrollDone.current = true;
      return;
    }
    scrollDone.current = false;
    setTargetScrollTop(scrollInfo.scrollTop);
  }, [sessionScrollStorage]);
  useEffect(function () {
    if (scrollIntervalId.current) {
      clearInterval(scrollIntervalId.current);
    }
    if (scrollDone.current) return;
    var intervalId = setInterval(function () {
      if (targetScrollTop == null) return;
      var scrollTop = document.documentElement.scrollTop;
      var isClearInterval = scrollTop !== 0 && scrollTop <= targetScrollTop || scrollTop === targetScrollTop;
      if (isClearInterval) {
        scrollDone.current = true;
        clearInterval(intervalId);
        return;
      }
      window.scrollTo({
        top: targetScrollTop
      });
    }, 10);
    scrollIntervalId.current = intervalId;
    return function () {
      clearInterval(intervalId);
    };
  }, [targetScrollTop]);
  useEffect(function () {
    var throttleSaveScrollInfo = throttle(saveScrollInfo, SCROLL_THROTTLE_MILLISECONDS);
    window.addEventListener('scroll', throttleSaveScrollInfo);
    if (disableSaveScroll) {
      window.removeEventListener('scroll', throttleSaveScrollInfo);
    }
    return function () {
      window.removeEventListener('scroll', throttleSaveScrollInfo);
    };
  }, [saveScrollInfo, disableSaveScroll, sessionScrollStorage]);
};

var DEFAULT_FAST_SCROLLING_VELOCITY = 4000; // (px/s)
var DEFAULT_OVERSCAN_HEIGHT = 500;
/**
 * Grid 컴포넌트는 autoHeight와 연동되지 않으므로,
 * List의 한 row당 grid만큼의 아이템을 가질 수 있도록 그리드 형태를 구현
 */
function VirtualizedList(_a) {
  var _this = this;
  var _b = _a.initialBreakpoint,
    initialBreakpoint = _b === void 0 ? 'desktop' : _b,
    grid = _a.grid,
    tabId = _a.tabId,
    count = _a.count,
    loadItemList = _a.loadItemList,
    _c = _a.disableSaveScroll,
    disableSaveScroll = _c === void 0 ? false : _c,
    _d = _a.disableUseWindowScroll,
    disableUseWindowScroll = _d === void 0 ? false : _d,
    _e = _a.overscanHeight,
    overscanHeight = _e === void 0 ? DEFAULT_OVERSCAN_HEIGHT : _e,
    _f = _a.insertedItemList,
    insertedItemList = _f === void 0 ? [] : _f,
    renderItem = _a.renderItem,
    _g = _a.fastScrollingVelocity,
    fastScrollingVelocity = _g === void 0 ? DEFAULT_FAST_SCROLLING_VELOCITY : _g,
    props = __rest(_a, ["initialBreakpoint", "grid", "tabId", "count", "loadItemList", "disableSaveScroll", "disableUseWindowScroll", "overscanHeight", "insertedItemList", "renderItem", "fastScrollingVelocity"]);
  var containerRef = useRef(null);
  var renderedRowList = useRef([]);
  var _h = useState(false),
    isFastScrolling = _h[0],
    setIsFastScrolling = _h[1];
  var breakpoint = useResponsive().breakpoint;
  var columnCount = useMemo(function () {
    return grid[breakpoint !== null && breakpoint !== void 0 ? breakpoint : initialBreakpoint];
  }, [breakpoint, grid, initialBreakpoint]);
  var itemRowCount = useMemo(function () {
    return Math.ceil(count / columnCount);
  }, [columnCount, count]);
  var insertedItemObject = useMemo(function () {
    return insertedItemList.reduce(function (prev, curr) {
      var _a;
      return _assign(_assign({}, prev), (_a = {}, _a[curr.rowIndex] = curr, _a));
    }, {});
  }, [insertedItemList]);
  var insertedItemRowCount = useMemo(function () {
    var _a;
    return (_a = Object.keys(insertedItemObject).length) !== null && _a !== void 0 ? _a : 0;
  }, [insertedItemObject]);
  useVirtualizedScroll({
    tabId: tabId,
    columnCount: columnCount,
    containerRef: containerRef,
    renderedRowList: renderedRowList,
    disableSaveScroll: disableSaveScroll
  });
  /**
   * grid개의 아이템을 포함한 index번째 row를 생성합니다.
   */
  var createRowContent = useCallback(function (rowIndex) {
    var hasInsertedItem = Object.keys(insertedItemObject).includes("".concat(rowIndex));
    if (hasInsertedItem) {
      return jsx(Row, {
        children: insertedItemObject[rowIndex].component
      });
    }
    // 현재 rowIndex 보다 위에 존재하는 insertedItem의 개수
    var nowInsertedItemCount = Object.keys(insertedItemObject).filter(function (embedIndex) {
      return Number(embedIndex) < rowIndex;
    }).length;
    return jsx(Row, _assign({
      columnCount: columnCount
    }, {
      children: Array.from({
        length: columnCount
      }).map(function (_, columnIndex) {
        var index = columnCount * (rowIndex - nowInsertedItemCount) + columnIndex;
        var lastItemIndex = count - 1;
        if (index > lastItemIndex) return null;
        return jsx(Fragment, {
          children: renderItem(index, rowIndex, isFastScrolling)
        }, "item".concat(index));
      })
    }));
  }, [insertedItemObject, columnCount, count, isFastScrolling, renderItem]);
  var fetchItemList = useCallback(function (renderedRowList, isFastScrolling) {
    return __awaiter(_this, void 0, void 0, function () {
      var startRow, endRow, startItemIndex, endItemIndex;
      return __generator(this, function (_a) {
        if (renderedRowList.length < 1 || !loadItemList) return [2 /*return*/];
        startRow = renderedRowList[0].index;
        endRow = renderedRowList[renderedRowList.length - 1].index;
        startItemIndex = startRow * columnCount;
        endItemIndex = (endRow + 1) * columnCount;
        loadItemList({
          startItemIndex: startItemIndex,
          endItemIndex: endItemIndex,
          fetchStatus: isFastScrolling ? FETCH_STATUS.NON_LOAD : FETCH_STATUS.LOADED
        });
        return [2 /*return*/];
      });
    });
  }, [columnCount, loadItemList]);
  var handleItemsRendered = useCallback(function (items) {
    if (items.length < 1) return;
    renderedRowList.current = items;
    fetchItemList(items, isFastScrolling);
  }, [fetchItemList, isFastScrolling]);
  return jsx("div", _assign({
    ref: containerRef,
    style: disableUseWindowScroll ? {
      height: '100%',
      overflow: 'hidden'
    } : {}
  }, {
    children: jsx(Virtuoso, _assign({}, props, {
      itemContent: createRowContent,
      totalCount: itemRowCount + insertedItemRowCount,
      useWindowScroll: !disableUseWindowScroll,
      itemsRendered: handleItemsRendered,
      initialItemCount: itemRowCount,
      scrollSeekConfiguration: {
        enter: function enter(velocity) {
          setIsFastScrolling(Math.abs(velocity) > fastScrollingVelocity);
          return false;
        },
        exit: function exit(velocity) {
          setIsFastScrolling(Math.abs(velocity) > fastScrollingVelocity);
          return false;
        }
      },
      isScrolling: function isScrolling(_isScrolling) {
        if (_isScrolling) return;
        setIsFastScrolling(false);
        fetchItemList(renderedRowList.current, false);
      },
      increaseViewportBy: {
        top: overscanHeight,
        bottom: overscanHeight
      },
      style: disableUseWindowScroll ? {
        height: '100%'
      } : {
        height: 'fit-content'
      }
    }))
  }));
}
var Row = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1qabbed0"
} : {
  target: "e1qabbed0",
  label: "Row"
})(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  & > * {\n    width: ", "%;\n  }\n"], ["\n  width: 100%;\n  display: flex;\n  & > * {\n    width: ", "%;\n  }\n"])), function (_a) {
  var _b = _a.columnCount,
    columnCount = _b === void 0 ? 1 : _b;
  return 100 / columnCount;
});
var templateObject_1$1;

var TOOLTIP_MIN_WIDTH = 92;
var TOOLTIP_MIN_HEIGHT = 36;
var TOOLTIP_MARGIN = 8;
var ARROW_SIZE = {
  width: 14,
  height: 10
};
var Tooltip = function Tooltip(_a) {
  var _b;
  var arrow = _a.arrow,
    variant = _a.variant,
    _c = _a.hasRoundBorder,
    hasRoundBorder = _c === void 0 ? false : _c,
    _d = _a.isTwoLine,
    isTwoLine = _d === void 0 ? false : _d,
    children = _a.children,
    onClose = _a.onClose;
  var options = {
    arrow: arrow,
    variant: variant
  };
  var placement = arrow.placement;
  var tooltipRef = useRef(null);
  var tooltipWidth = ((_b = useNodeSize(tooltipRef, [TOOLTIP_MIN_WIDTH, TOOLTIP_MIN_HEIGHT])) === null || _b === void 0 ? void 0 : _b[0]) || 0;
  var tooltipHeight = useNodeHeight(tooltipRef) || 0;
  // arrow 방향에 따라 width || height 값을 넘겨줌
  var tooltipSize = placement === 'bottom' || placement === 'top' ? tooltipWidth : tooltipHeight;
  return jsxs(Container, {
    children: [jsxs(Content, _assign({
      variant: variant,
      hasRoundBorder: hasRoundBorder,
      isTwoLine: isTwoLine,
      ref: tooltipRef
    }, {
      children: [children, onClose && jsx(CloseButton, {
        type: "button",
        size: 32,
        icon: {
          name: 'dismiss',
          size: 16
        },
        onClick: onClose,
        isTwoLine: isTwoLine,
        variant: "base1"
      })]
    })), jsx(ArrowContainer, {
      options: options,
      tooltipSize: tooltipSize
    })]
  });
};
var Container = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1rflc093"
} : {
  target: "e1rflc093",
  label: "Container"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  letter-spacing: ", ";\n  position: relative;\n  gap: ", ";\n  display: inline-block;\n"], ["\n  ", ";\n  letter-spacing: ", ";\n  position: relative;\n  gap: ", ";\n  display: inline-block;\n"])), FONT_STYLE.body2, pxToRem(-0.3), pxToRem(10));
var cssBackgroundColor = function cssBackgroundColor(theme, variant) {
  switch (variant) {
    case 'dark':
      return theme.layer.dark;
    case 'light':
      return theme.layer.light;
  }
};
var cssFontColor = function cssFontColor(theme, variant) {
  switch (variant) {
    case 'dark':
      return theme.content.white;
    case 'light':
      return theme.content.base1;
  }
};
var Content = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1rflc092"
} : {
  target: "e1rflc092",
  label: "Content"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: ", " ", ";\n  border-radius: ", ";\n  color: ", ";\n  background-color: ", ";\n  align-items: ", ";\n  margin: auto;\n  white-space: pre-line;\n  display: flex;\n  flex-direction: row;\n"], ["\n  padding: ", " ", ";\n  border-radius: ", ";\n  color: ", ";\n  background-color: ", ";\n  align-items: ", ";\n  margin: auto;\n  white-space: pre-line;\n  display: flex;\n  flex-direction: row;\n"])), pxToRem(8), pxToRem(12), function (_a) {
  var hasRoundBorder = _a.hasRoundBorder;
  return hasRoundBorder ? pxToRem(20) : pxToRem(4);
}, function (_a) {
  var theme = _a.theme,
    variant = _a.variant;
  return cssFontColor(theme, variant);
}, function (_a) {
  var theme = _a.theme,
    variant = _a.variant;
  return cssBackgroundColor(theme, variant);
}, function (_a) {
  var isTwoLine = _a.isTwoLine;
  return isTwoLine ? 'flex-start' : 'center';
});
var CloseButton = /*#__PURE__*/_styled(IconButton, process.env.NODE_ENV === "production" ? {
  shouldForwardProp: function shouldForwardProp(props) {
    return props !== 'isTwoLine';
  },
  target: "e1rflc091"
} : {
  shouldForwardProp: function shouldForwardProp(props) {
    return props !== 'isTwoLine';
  },
  target: "e1rflc091",
  label: "CloseButton"
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-top: ", ";\n  margin-right: ", ";\n  cursor: pointer;\n"], ["\n  margin-top: ", ";\n  margin-right: ", ";\n  cursor: pointer;\n"])), function (_a) {
  var isTwoLine = _a.isTwoLine;
  return isTwoLine && "".concat(pxToRem(-6));
}, pxToRem(-8));
var createArrowShape = function createArrowShape(theme, options) {
  var arrow = options.arrow,
    variant = options.variant;
  switch (arrow.placement) {
    case 'top':
      return /*#__PURE__*/css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        border-bottom: ", " solid ", ";\n        border-left: ", " solid transparent;\n        border-right: ", " solid transparent;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:createArrowShape;")], ["\n        border-bottom: ", " solid ", ";\n        border-left: ", " solid transparent;\n        border-right: ", " solid transparent;\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:createArrowShape;")])), pxToRem(ARROW_SIZE.height), cssBackgroundColor(theme, variant), pxToRem(ARROW_SIZE.width / 2), pxToRem(ARROW_SIZE.width / 2));
    case 'left':
      return /*#__PURE__*/css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n        border-right: ", " solid ", ";\n        border-bottom: ", " solid transparent;\n        border-top: ", " solid transparent;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:createArrowShape;")], ["\n        border-right: ", " solid ", ";\n        border-bottom: ", " solid transparent;\n        border-top: ", " solid transparent;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:createArrowShape;")])), pxToRem(ARROW_SIZE.height), cssBackgroundColor(theme, variant), pxToRem(ARROW_SIZE.width / 2), pxToRem(ARROW_SIZE.width / 2));
    case 'right':
      return /*#__PURE__*/css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n        border-left: ", " solid ", ";\n        border-bottom: ", " solid transparent;\n        border-top: ", " solid transparent; \n        " + (process.env.NODE_ENV === "production" ? "" : ";label:createArrowShape;")], ["\n        border-left: ", " solid ", ";\n        border-bottom: ", " solid transparent;\n        border-top: ", " solid transparent; \n        " + (process.env.NODE_ENV === "production" ? "" : ";label:createArrowShape;")])), pxToRem(ARROW_SIZE.height), cssBackgroundColor(theme, variant), pxToRem(ARROW_SIZE.width / 2), pxToRem(ARROW_SIZE.width / 2));
    case 'bottom':
      return /*#__PURE__*/css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n        border-top: ", " solid ", ";\n        border-left: ", " solid transparent;\n        border-right: ", " solid transparent;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:createArrowShape;")], ["\n        border-top: ", " solid ", ";\n        border-left: ", " solid transparent;\n        border-right: ", " solid transparent;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:createArrowShape;")])), pxToRem(ARROW_SIZE.height), cssBackgroundColor(theme, variant), pxToRem(ARROW_SIZE.width / 2), pxToRem(ARROW_SIZE.width / 2));
  }
};
var createArrowPlacement = function createArrowPlacement(tooltipSize, options) {
  var arrow = options.arrow;
  var placement = arrow.placement,
    align = arrow.align,
    alignLocation = arrow.alignLocation;
  var bottomHeight = placement === 'bottom' ? ARROW_SIZE.height : 0;
  var arrowLocation = align === 'center' ? 'left' : align;
  var arrowAlign = align !== 'center' && alignLocation ? Math.min(alignLocation, tooltipSize) : tooltipSize / 2 - TOOLTIP_MARGIN;
  switch (placement) {
    case 'top':
    case 'bottom':
      return /*#__PURE__*/css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n        ", ": ", ";\n        ", ": ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:createArrowPlacement;")], ["\n        ", ": ", ";\n        ", ": ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:createArrowPlacement;")])), placement, pxToRem(-10 + bottomHeight), arrowLocation, pxToRem(arrowAlign));
    case 'right':
    case 'left':
      return /*#__PURE__*/css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n        top: ", ";\n        ", ": ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:createArrowPlacement;")], ["\n        top: ", ";\n        ", ": ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:createArrowPlacement;")])), pxToRem(arrowAlign), placement, pxToRem(-10));
  }
};
var ArrowContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1rflc090"
} : {
  target: "e1rflc090",
  label: "ArrowContainer"
})(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  &::after {\n    content: '';\n    position: absolute;\n    ", "\n    ", "\n  }\n"], ["\n  width: ", ";\n  height: ", ";\n  &::after {\n    content: '';\n    position: absolute;\n    ", "\n    ", "\n  }\n"])), pxToRem(ARROW_SIZE.width), pxToRem(ARROW_SIZE.height), function (_a) {
  var theme = _a.theme,
    options = _a.options;
  return createArrowShape(theme, options);
}, function (_a) {
  var tooltipSize = _a.tooltipSize,
    options = _a.options;
  return createArrowPlacement(tooltipSize, options);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;

var SEARCH_TYPE = {
  TOTAL: 'total',
  STORE: 'store',
  EXPERT: 'expert_user'
};

export { ADDRESS, AnchorButton, AnchorButtonWithIcon, Animation, AppDownloadPopup, AppDownloadPopupContainer, Avatar, BUCKETPLACE_HOMEPAGE_URL, Breadcrumb, Button$2 as Button, ButtonWithIcon, COLUMN_PRESET, COPYRIGHT_TEXT, Callout, Carousel, CarouselControl, CarouselControlButton, CarouselScrollControl, Checkbox$1 as Checkbox, CheckboxWithText, Chip, CircleBadge, CircleImage, Column, CompanyLink, Container$4 as Container, CounterHint, DEFAULT_GAP, Dim, DimLoading, Divider$1 as Divider, DividerListItem, DotNotification, Drawer, Dropdown, EMAIL, EmptyPage, ExtendedFab, ExtendedFabWithIcon, FETCH_STATUS, Fab, FileButton, FileButtonWithIcon, FileInputLabel, FillOutlineSelectChip, FixedTab, Footer, FooterComponenet, Grid, GridItem, Hint, Icon, IconFab, IconNotification, Image, ImageAttachedItem, ImageUploadButton, IndicatorDots, IndicatorNumber, IndicatorNumberWithIcon, Input$1 as Input, InputChip, InputWithCountHint, InputWithHint, InputWithThumbnail, LinearProgressBar, LinkContext, LinkProvider, ListItem, Loading, MobileTopBanner, Modal, MoreAnchor, NaverPostSvg, Navigation, NavigationBar, NavigationDrawer, NavigationRightButton, NavigationSearch, NavigationTopBanner, NotSupportedBrowser, NotificationType, NumberNotification, OPENING_HOUR, OhouseFooter, OutlineAnchorButton, OutlineAnchorButtonWithIcon, OutlineButton, OutlineButtonWithIcon, OutlineFileButton, OutlineFileButtonWithIcon, OutlineSelectChip, PCTopBanner, PHONE_NUMBER, Pagination$1 as Pagination, PillBadge, PinterestSvg, Popper, PrimaryRight, Radio, RadioWithText, Ranking, Responsive, Row$1 as Row, SEARCH_TYPE, Search, SectionTitle, Select, SelectButton, SelectChip, SelectWithHint, SimpleFooter, SocialLink, SquareBadge, StoreCategory, TABLE_HIGHLIGHT_STYLE, TOGGLE_SIZE, TOTAL_COLUMN, TYPE_MAP, Tab, TabItem, Table, TableData, TableDataImpl, TableHeader, TableHeaderWithAction, TableRow, TextButton, TextButtonWithIcon, Textarea, TextareaWithCountHint, TextareaWithHint, TextareaWithThumbnail, ThumbnailAnchor, ThumbnailAnchorWithBadge, TikTokSvg, Toggle, ToggleButton, Tooltip, TopBannerContainer, UploadDropdownContentButton, UploadDropdownContentItem, UserDropdownContentButton, UserDropdownContentItem, VirtualizedList, YoutubeSvg, createOhouseFooterLinkSchema, createScrollStorage, cssBaseButton, cssDimmed, cssFontWeight, cssSize$2 as cssSize, dotSize, getTextButtonWithIconOptions, getWithIconOptions, setCookie, useLinkContext, usePagedCursorInfiniteList, usePagedInfiniteList };
//# sourceMappingURL=bds.js.map
